import React, { useState, useEffect, useCallback, useMemo } from "react";
import "./admin.css";
import {  } from "firebase/firestore";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from "xlsx";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  query,
  orderBy,
  limit,
  where,
  serverTimestamp,
  arrayUnion,
  runTransaction,

} from "firebase/firestore";

import html2canvas from 'html2canvas';

import { FaBell, FaCalendarCheck, FaUserFriends, FaBirthdayCake, FaEye, FaEnvelope, FaFileInvoice, FaClock, FaPhone, FaMapMarkerAlt, FaUser } from 'react-icons/fa';
import { format, parseISO, differenceInDays } from 'date-fns';



import { db } from "../FirebaseComp/firebase"; // adjust your path
import { saveAs } from 'file-saver';

import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title } from 'chart.js';

// Register ChartJS components
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title);









function SuperAdminPanel() {
const [openMenu, setOpenMenu] = useState(null); 

  const [selectedOption, setSelectedOption] = useState("dashboard");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpenStock, setDropdownOpenStock] = useState(false);
  const [dropdownOpenSupplier, setDropdownOpenSupplier] = useState(false);
  const [dropdownOpenReport, setDropdownOpenReport] = useState(false);
  const [dropdownOpenInvoice, setDropdownOpenInvoice] = useState(false);




// ✅ State variables MUST come first
const [suppliers, setSuppliers] = useState([]);
const [lensList, setLensList] = useState([]);
const [frameList, setFrameList] = useState([]);
const [supplierName, setSupplierName] = useState("");
const [purchaseOrderNo, setPurchaseOrderNo] = useState("");


//fetch all the eye exam report
const [eyeExamRecords, setEyeExamRecords] = useState([]);
const [selectedRecord, setSelectedRecord] = useState(null);

// State variables
const [searchTerm, setSearchTerm] = useState("");
//search function in view eye report
const [filterOption, setFilterOption] = useState('all');
const [lens, setLens] = useState("");


// Add Service states
const [serviceDescription, setServiceDescription] = useState("");

const [serviceAmount, setServiceAmount] = useState("");

const [servicePaymentType, setServicePaymentType] = useState("full");


const [purchaseOrders, setPurchaseOrders] = useState([]);

const [purchaseDate, setPurchaseDate] = useState("");
const [items, setItems] = useState([]);

const [nextBalanceInvoiceNo, setNextBalanceInvoiceNo] = useState('');



useEffect(() => {
  const close = () => setOpenMenu(null);
  document.addEventListener("click", close);
  return () => document.removeEventListener("click", close);
}, []);


  const handleSelect = (option) => {
    setSelectedOption(option);
    setDropdownOpen(false);
  };

    const handleSelectStock = (optionstock) => {
    setSelectedOption(optionstock);
    setDropdownOpenStock(false);
  };


    const handleSelectSupplier = (optionsupplier) => {
    setSelectedOption(optionsupplier);
    setDropdownOpenSupplier(false);
  };



      const handleSelectInvoice = (optioninvoice) => {
    setSelectedOption(optioninvoice);
    setDropdownOpenInvoice(false);
  };



  
    const handleSelectReport = (optionsReport) => {
    setSelectedOption(optionsReport);
    setDropdownOpenReport(false);
  };







///////////////////////////////////////////// lens price ///////////////////////////////////////////////////
const lensData = {


STANDARD: {

  SV: [
  
    {
      name: "Single Vision Blue Cut",
      pairPrice: 12000.00
    },
    {
      name: "Single Vision Blue Cut Photochromic",
      pairPrice: 15000.00
    },



    {
      name: "Single Vision CR 39 (Plano)",
      pairPrice: 2500.00
    },
    {
      name: "Single Vision CR 39 (0.25 to 2.00) SPH",
      pairPrice: 3000.00
    },
    {
      name: "Single Vision CR 39 (2.25 to 4.00) SPH",
      pairPrice: 3500.00
    },
    {
      name: "Single Vision CR 39 (4.25 to 6.00) SPH",
      pairPrice: 4000.00
    },
    {
      name: "Single Vision CR 39 (6.25 to 8.00) SPH",
      pairPrice: 4000.00
    },
    {
      name: "Single Vision CR 39 (8.25 to 10.00) SPH",
      pairPrice: 4500.00
    },
    {
      name: "Single Vision CR 39 TORIC 2/2",
      pairPrice: 3500.00
    },
    {
      name: "Single Vision CR 39 TORIC 4/2",
      pairPrice: 4000.00
    },
    {
      name: "Single Vision CR 39 TORIC 6/2",
      pairPrice: 4000.00
    },
    {
      name: "Single Vision CR 39 TORIC 8/2",
      pairPrice: 4500.00
    },
    {
      name: "Single Vision CR 39 TORIC 10/2",
      pairPrice: 5000.00
    },
    {
      name: "Single Vision CR 39 TORIC 2/4",
      pairPrice: 4500.00
    },
    {
      name: "Single Vision CR 39 TORIC 4/4",
      pairPrice: 4500.00
    },
    {
      name: "Single Vision CR 39 TORIC 6/4",
      pairPrice: 6500.00
    },
    {
      name: "EXCEED ABOVE POWERS EXTRA",
      pairPrice: 700.00
    },
    {
      name: "Single Vision HMC 1.56 (4.00 DS / 4/2 DC)",
      pairPrice: 4800.00
    },
    {
      name: "Single Vision HMC 1.56 (8.00 DS / 8/2 DC)",
      pairPrice: 5800.00
    },
    {
      name: "Single Vision HMC 1.56 (10.00 DS / 10/2 DC)",
      pairPrice: 7300.00
    },
    {
      name: "Single Vision Bluecut 1.56 Rx 4.00 DS / 4/2 DC",
      pairPrice: 6300.00
    },
    {
      name: "Single Vision Bluecut 1.56 Rx 8.00 DS / 8/2 DC",
      pairPrice: 7300.00
    },
    {
      name: "Single Vision Bluecut 1.56 Rx 10.00 DS / 10/2 DC",
      pairPrice: 8800.00
    },
    {
      name: "Single Vision HMC Transition Grey L.Out Side",
      pairPrice: 13000.00
    },
    {
      name: "Single Vision HMC Photo Grey 2.00 DS",
      pairPrice: 8500.00
    },
    {
      name: "Single Vision HMC Photo Grey 4.00 DS",
      pairPrice: 9000.00
    },
    {
      name: "Single Vision HMC Photo Grey 6.00 DS",
      pairPrice: 13000.00
    },
    {
      name: "Single Vision HMC Photo Grey 2/2 DC",
      pairPrice: 9000.00
    },
    {
      name: "Single Vision HMC Photo Grey 4/2 DC",
      pairPrice: 10000.00
    },
    {
      name: "Single Vision HMC Photo Grey 6/2 DC",
      pairPrice: 12500.00
    },
    {
      name: "Single Vision Bluecut Photo Grey 2.00 DS",
      pairPrice: 12000.00
    },
    {
      name: "Single Vision Bluecut Photo Grey 4.00 DS",
      pairPrice: 13000.00
    },
    {
      name: "Single Vision Bluecut Photo Grey 2/2 DC",
      pairPrice: 13000.00
    },
    {
      name: "Single Vision Bluecut Photo Grey 4/2 DC",
      pairPrice: 13000.00
    },
    {
      name: "Single Vision Bluecut Photo Grey 6/2 DC",
      pairPrice: 15000.00
    }
  ],

  BF: [


    {
      name: "Bifocal Roundtop Blue Cut",
      pairPrice: 7000.00
    },
    {
      name: "Bifocal Roundtop Blue Cut Photochromic",
      pairPrice: 9000.00
    },


    {
      name: "Bifocal Roundtop Stock",
      pairPrice: 3500.00
    },
    {
      name: "Bifocal Roundtop Grinding SPH",
      pairPrice: 4000.00
    },
    {
      name: "Bifocal Roundtop Grinding Toric",
      pairPrice: 4500.00
    },
    {
      name: "Bifocal Roundtop HMC Photo Grey",
      pairPrice: 12000.00
    },
    {
      name: "Bifocal Flattop Grinding SPH",
      pairPrice: 4500.00
    },
    {
      name: "Bifocal Flattop Grinding Toric",
      pairPrice: 4500.00
    },
    {
      name: "Bifocal Flattop Photo Grey Grinding",
      pairPrice: 13000.00
    }
  ],

  PAL: [

    {
      name: "Progressive Blue Cut",
      pairPrice: 16000.00
    },
    {
      name: "Progressive Blue Cut Photochromic",
      pairPrice: 19000.00
    },


    {
      name: "Progressive UnCoated (Plano to +3.00) Add 3.00",
      pairPrice: 9000.00
    },
    {
      name: "Progressive HMC (Plano to +3.00) Add 3.00",
      pairPrice: 9000.00
    },
    {
      name: "Progressive HMC Photo Grey (Plano to +3.00) Add 3.00",
      pairPrice: 17500.00
    },
    {
      name: "Progressive Bluecut (Plano to +3.00) Add 3.00",
      pairPrice: 18000.00
    },
    {
      name: "Progressive Bluecut Photo Grey (Plano to +3.00) Add 3.00",
      pairPrice: 22000.00
    },
    {
      name: "Progressive UnCoated (-0.25 to -3.00) Add 3.00",
      pairPrice: 9000.00
    },
    {
      name: "Progressive HMC (-0.25 to -3.00) Add 3.00",
      pairPrice: 10000.00
    },
    {
      name: "Progressive HMC Photo Grey (-0.25 to -3.00) Add 3.00",
      pairPrice: 17500.00
    },
    {
      name: "Progressive Bluecut (-0.25 to -3.00) Add 3.00",
      pairPrice: 10000.00
    },
    {
      name: "Progressive Bluecut Photo Grey (-0.25 to -3.00) Add 3.00",
      pairPrice: 25000.00
    }
  ]
},


ESSILOR: {

  SV: [

    {
      name: "Crizal Easy Pro Single Vision Stock 1.56",
      pairPrice: 10500
    },

    {
      name: "Crizal Prevencia Single Vision Stock 1.56",
      pairPrice: 15000
    },

    {
      name: "Elements Single Vision Blue Block stock 1.56",
      pairPrice: 7600
    },

    {
      name: "Single Vision 1.5 Rx Uncoated",
      pairPrice: 3000
    },

    {
      name: "Single Vision 1.5 Rx Titus",
      pairPrice: 3600
    },

    {
      name: "Single Vision 1.5 Rx e-HMC",
      pairPrice: 9500
    },

    {
      name: "Single Vision 1.5 Rx Crizal Easy Pro",
      pairPrice: 12000
    },

    {
      name: "Single Vision 1.5 Rx Prevencia",
      pairPrice: 16700
    },

    {
      name: "Single Vision - High Index Airwear (Polycarbonate) 1.59 Rx Crizal Easy Pro",
      pairPrice: 33700
    },

    {
      name: "Single Vision - High Index Airwear (Polycarbonate) 1.59 Rx Prevencia",
      pairPrice: 39500
    },

    {
      name: "Single Vision - High Index 1.6 Rx Titus",
      pairPrice: 14200
    },

    {
      name: "Single Vision - High Index 1.6 Rx e-HMC",
      pairPrice: 20200
    },

    {
      name: "Single Vision - High Index 1.6 Rx Crizal Easy Pro",
      pairPrice: 22600
    },

    {
      name: "Single Vision - High Index 1.6 Rx Prevencia",
      pairPrice: 28200
    },

    {
      name: "Single Vision - High Index 1.67 Rx Titus",
      pairPrice: 21600
    },

    {
      name: "Single Vision - High Index 1.67 Rx e-HMC",
      pairPrice: 27500
    },

    {
      name: "Single Vision - High Index 1.67 Rx Crizal Easy Pro",
      pairPrice: 29900
    },

    {
      name: "Single Vision - High Index 1.67 Rx Prevencia",
      pairPrice: 35700
    },

    {
      name: "Single Vision - High Index 1.74 Rx Titus",
      pairPrice: 42000
    },

    {
      name: "Single Vision - High Index 1.74 Rx e-HMC",
      pairPrice: 47900
    },

    {
      name: "Single Vision - High Index 1.74 Rx Crizal Easy Pro",
      pairPrice: 50400
    },

    {
      name: "Single Vision - High Index 1.74 Rx Prevencia",
      pairPrice: 55900
    },

    {
      name: "Single Vision - Lenticular 1.5 Rx Titus",
      pairPrice: 11800
    },

    {
      name: "Single Vision - Lenticular 1.5 Rx e-HMC",
      pairPrice: 17500
    },

    {
      name: "Single Vision - Lenticular 1.5 Rx Crizal Easy Pro",
      pairPrice: 20200
    },

    {
      name: "Single Vision - Lenticular 1.5 Rx Prevencia",
      pairPrice: 24900
    },

    {
      name: "Single Vision - Photochromic 1.5 Rx Titus",
      pairPrice: 14500
    },

    {
      name: "Single Vision - Photochromic 1.5 Rx e-HMC",
      pairPrice: 20300
    },

    {
      name: "Single Vision - Photochromic 1.5 Rx Crizal Easy Pro",
      pairPrice: 22800
    },

    {
      name: "Single Vision - Photochromic 1.5 Rx Prevencia",
      pairPrice: 27800
    },

    {
      name: "Single Vision - Eyezen Boost Crizal Prevencia 1.5 Rx",
      pairPrice: 24200
    },

    {
      name: "Single Vision - Eyezen Boost Crizal Prevencia 1.59 Rx",
      pairPrice: 29200
    },

    {
      name: "Single Vision - Eyezen Boost Crizal Prevencia 1.67 Rx",
      pairPrice: 52900
    },

    {
      name: "Single Vision - Eyezen Boost Transitions Classic Crizal Prevencia 1.59 Rx",
      pairPrice: 75700
    },

    {
      name: "Single Vision - Eyezen Boost Transitions Classic Crizal Prevencia 1.67 Rx",
      pairPrice: 99800
    }

  ],

  BF: [

    {
      name: "Round Segment 1.5 Rx Uncoated",
      pairPrice: 1350
    },

    {
      name: "Round Segment 1.5 Rx Titus",
      pairPrice: 5600
    },

    {
      name: "Round Segment 1.5 Rx e-HMC",
      pairPrice: 9400
    },

    {
      name: "Round Segment 1.5 Rx Crizal Uv",
      pairPrice: 11300
    },

    {
      name: "Flat Top 1.5 Rx Uncoated",
      pairPrice: 1650
    },

    {
      name: "Flat Top 1.5 Rx Titus",
      pairPrice: 5600
    },

    {
      name: "Flat Top 1.5 Rx e-HMC",
      pairPrice: 9400
    },

    {
      name: "Flat Top 1.5 Rx Crizal Uv",
      pairPrice: 11300
    },

    {
      name: "Round segment Photochromic 1.5 Rx Titus",
      pairPrice: 12900
    },

    {
      name: "Round segment Photochromic 1.5 Rx e-HMC",
      pairPrice: 16800
    },

    {
      name: "Round segment Photochromic 1.5 Rx Crizal Uv",
      pairPrice: 23000
    },

    {
      name: "Flat top - Acclimates 1.5 Rx Titus",
      pairPrice: 39800
    },

    {
      name: "Flat top - Acclimates 1.5 Rx Crizal Uv",
      pairPrice: 47900
    },

    {
      name: "Round Segment - Lenticular 1.5 Rx Uncoated",
      pairPrice: 5800
    },

    {
      name: "Round Segment - Lenticular 1.5 Rx Titus",
      pairPrice: 15700
    },

    {
      name: "Round Segment - Lenticular 1.5 Rx e-HMC",
      pairPrice: 19500
    },

    {
      name: "Round Segment - Lenticular 1.5 Rx Crizal Uv",
      pairPrice: 26400
    }

  ],

  PAL: [

    {
      name: "SPEX Progressive 1.5 Titus",
      pairPrice: 9200
    },

    {
      name: "SPEX Progressive 1.5 e-HMC",
      pairPrice: 13800
    },

    {
      name: "SPEX Progressive 1.5 Crizal Easy Pro",
      pairPrice: 18400
    },

    {
      name: "Essentials Everyday 1.5 Titus",
      pairPrice: 17250
    },

    {
      name: "Essentials Everyday 1.5 e-HMC",
      pairPrice: 18500
    },

    {
      name: "Essentials Everyday 1.5 Crizal Easy Pro",
      pairPrice: 23000
    },

    {
      name: "Essentials Everyday 1.6 Titus",
      pairPrice: 28700
    },

    {
      name: "Essentials Everyday 1.6 Crizal Easy Pro",
      pairPrice: 39700
    },

    {
      name: "Essentials Everyday 1.67 Titus",
      pairPrice: 43700
    },

    {
      name: "Essentials Everyday 1.67 Crizal Easy Pro",
      pairPrice: 55500
    },

    {
      name: "Essentials Active 1.5 Titus",
      pairPrice: 21400
    },

    {
      name: "Essentials Active 1.5 e-HMC",
      pairPrice: 22200
    },

    {
      name: "Essentials Active 1.5 Crizal Easy Pro",
      pairPrice: 31800
    },

    {
      name: "Essentials Active 1.59 Titus",
      pairPrice: 35500
    },

    {
      name: "Essentials Active 1.59 Crizal Easy Pro",
      pairPrice: 42200
    },

    {
      name: "Varilux Liberty 3.0 Digital 1.5 Crizal Easy",
      pairPrice: 39000
    },

    {
      name: "Varilux Liberty 3.0 Digital 1.5 Crizal Prevencia",
      pairPrice: 44600
    },

    {
      name: "Varilux Ultra Digital 1.5 Crizal Easy",
      pairPrice: 44600
    },

    {
      name: "Varilux Ultra Digital 1.5 Crizal Prevencia",
      pairPrice: 50300
    },

    {
      name: "Varilux Comfort Max Digital 1.5 Crizal Easy",
      pairPrice: 56700
    },

    {
      name: "Varilux Comfort Max Digital 1.5 Crizal Prevencia",
      pairPrice: 62400
    },

    {
      name: "Varilux E Series - Clear 1.5 Crizal Easy",
      pairPrice: 70800
    },

    {
      name: "Varilux E Series - Clear 1.5 Crizal Prevencia",
      pairPrice: 76400
    },

    {
      name: "Varilux S Series 1.5 Crizal Easy",
      pairPrice: 102500
    },

    {
      name: "Varilux S Series 1.5 Crizal Prevencia",
      pairPrice: 117800
    },

    {
      name: "Varilux S 4D 1.5 Crizal Easy",
      pairPrice: 155800
    },

    {
      name: "Varilux S 4D 1.5 Crizal Prevencia",
      pairPrice: 175900
    }

  ]

},






NEOFORM: {
  SV: [
    { name: "Endless Single Vision Duramax 1.5", pairPrice: 17700 },
    { name: "Endless Single Vision DuraBlue 1.5", pairPrice: 22500 },
    { name: "Endless Single Vision DuraUV 1.5", pairPrice: 27600 },
    { name: "Endless Single Vision DuraRelax 1.5", pairPrice: 28500 },
    { name: "Endless Single Vision DuraGuard 1.5", pairPrice: 38700 },
    { name: "Endless Single Vision DuraGold 1.5", pairPrice: 40200 },
    { name: "Endless Single Vision DuraUV 1.6", pairPrice: 49200 },
    { name: "Endless Single Vision DuraRelax 1.6", pairPrice: 50400 },
    { name: "Endless Single Vision DuraUV 1.67", pairPrice: 75000 },
    { name: "Endless Single Vision DuraRelax 1.67", pairPrice: 76200 },
    { name: "Endless Single Vision DuraUV 1.74", pairPrice: 165000 },
    { name: "Endless Single Vision DuraRelax 1.74", pairPrice: 166800 },

    { name: "Endless Single Vision Durachrome 1.5", pairPrice: 37500 },
    { name: "Endless Single Vision DurachromeUV 1.5", pairPrice: 41700 },
    { name: "Endless Single Vision DurachromeRelax 1.5", pairPrice: 43200 },
    { name: "Endless Single Vision DurachromeGuard 1.5", pairPrice: 45000 },
    { name: "Endless Single Vision DurachromeGold 1.5", pairPrice: 46200 },

    { name: "Endless Single Vision Single Side HMC 1.5", pairPrice: 19200 },
    { name: "Endless Single Vision Single Side BlueCut HMC 1.5", pairPrice: 23400 },
    { name: "Endless Single Vision Single Side Photogray 1.5", pairPrice: 24000 },
    { name: "Endless Single Vision Single Side BlueCut Photogray 1.5", pairPrice: 31500 },

    { name: "Endless Boost Single Vision Duramax 1.5", pairPrice: 19500 },
    { name: "Endless Boost Single Vision DuraBlue 1.5", pairPrice: 25500 },
    { name: "Endless Boost Single Vision DuraUV 1.5", pairPrice: 28800 },
    { name: "Endless Boost Single Vision DuraRelax 1.5", pairPrice: 29700 },
    { name: "Endless Boost Single Vision DuraGuard 1.5", pairPrice: 40200 },
    { name: "Endless Boost Single Vision DuraGold 1.5", pairPrice: 41700 },
    { name: "Endless Boost Single Vision DuraUV 1.6", pairPrice: 54000 },
    { name: "Endless Boost Single Vision DuraRelax 1.6", pairPrice: 55200 },
    { name: "Endless Boost Single Vision DuraUV 1.67", pairPrice: 78000 },
    { name: "Endless Boost Single Vision DuraRelax 1.67", pairPrice: 80400 },
    { name: "Endless Boost Single Vision DuraUV 1.74", pairPrice: 168000 },
    { name: "Endless Boost Single Vision DuraRelax 1.74", pairPrice: 170400 },

    { name: "Duramax Single Vision Duramax 1.5", pairPrice: 7950 },
    { name: "Duramax Single Vision DuraBlue 1.5", pairPrice: 9450 },
    { name: "Duramax Single Vision DuraUV 1.5", pairPrice: 12150 },
    { name: "Duramax Single Vision DuraRelax 1.5", pairPrice: 18600 },
    { name: "Duramax Single Vision DuraGuard 1.5", pairPrice: 23100 },
    { name: "Duramax Single Vision DuraGold 1.5", pairPrice: 23880 },

    { name: "POLYCARBONATE Digital Single Vision Endless SV Duramax", pairPrice: 33000 },
    { name: "POLYCARBONATE Digital Single Vision Endless SV DuraUV", pairPrice: 36000 },
    { name: "POLYCARBONATE Digital Single Vision Endless SV DuraRelax", pairPrice: 38400 },

    { name: "TRILOGY TRIVEX Digital Single Vision Endless SV Duramax", pairPrice: 48600 },
    { name: "TRILOGY TRIVEX Digital Single Vision Endless SV DuraUV", pairPrice: 51000 },
    { name: "TRILOGY TRIVEX Digital Single Vision Endless SV DuraRelax", pairPrice: 53400 },

    { name: "NEOCHROMES Digital Single Vision Endless SV Duramax 1.5", pairPrice: 81600 },
    { name: "NEOCHROMES Digital Single Vision Endless SV DuraUV 1.5", pairPrice: 84000 },
    { name: "NEOCHROMES Digital Single Vision Endless Boost Duramax 1.5", pairPrice: 84600 },
    { name: "NEOCHROMES Digital Single Vision Endless Boost DuraUV 1.5", pairPrice: 87000 },

    { name: "TRANSITION GEN 08 Style Colors Digital Single Endless SV Duramax", pairPrice: 52500 },
    { name: "TRANSITION GEN 08 Style Colors Digital Single Endless SV DuraUV", pairPrice: 59700 },
    { name: "TRANSITION GEN 08 Style Colors Digital Single Endless Boost Duramax", pairPrice: 56700 },
    { name: "TRANSITION GEN 08 Style Colors Digital Single Endless Boost DuraUV", pairPrice: 62700 },

    { name: "TRANSITION GEN S Style Colors Digital Single Endless SV Duramax", pairPrice: 73950 },
    { name: "TRANSITION GEN S Style Colors Digital Single Endless SV DuraUV", pairPrice: 80070 },
    { name: "TRANSITION GEN S Style Colors Digital Single Endless Boost Duramax", pairPrice: 76950 },
    { name: "TRANSITION GEN S Style Colors Digital Single Endless Boost DuraUV", pairPrice: 83100 },

    { name: "TRANSITION Xtractive Digital Single Endless SV Duramax", pairPrice: 156600 },
    { name: "TRANSITION Xtractive Digital Single Endless SV DuraUV", pairPrice: 159000 },
    { name: "TRANSITION Xtractive Digital Single Endless SV DuraRelax", pairPrice: 161400 },

    { name: "NUPOLAR Single Vision Endless SV Duramax", pairPrice: 50700 },
    { name: "NUPOLAR Single Vision Endless SV DuraUV", pairPrice: 53700 },
    { name: "NUPOLAR Single Vision Endless SV DuraRelax", pairPrice: 56100 }
  ],

  BF: [],

  PAL: [
    { name: "Camber Steady Plus Progressive DuraUV 1.5", pairPrice: 114000 },
    { name: "Camber Steady Plus Progressive DuraRelax 1.5", pairPrice: 120000 },
    { name: "Camber Steady Plus Progressive DuraUV Trivex", pairPrice: 141000 },
    { name: "Camber Steady Plus Progressive DuraRelax Trivex", pairPrice: 147000 },

    { name: "Endless Steady Progressive Duramax 1.5", pairPrice: 41700 },
    { name: "Endless Steady Progressive DuraBlue 1.5", pairPrice: 47700 },
    { name: "Endless Steady Progressive DuraUV 1.5", pairPrice: 53700 },
    { name: "Endless Steady Progressive DuraRelax 1.5", pairPrice: 59700 },

    { name: "Essential Steady Progressive Duramax 1.5", pairPrice: 25200 },
    { name: "Essential Steady Progressive DuraBlue 1.5", pairPrice: 29700 },
    { name: "Essential Steady Progressive DuraUV 1.5", pairPrice: 32700 },
    { name: "Essential Steady Progressive DuraRelax 1.5", pairPrice: 35700 },

    { name: "Easyfit Digital Progressive Duramax 1.5", pairPrice: 17100 },
    { name: "Easyfit Digital Progressive DuraBlue 1.5", pairPrice: 26700 },
    { name: "Easyfit Digital Progressive DuraUV 1.5", pairPrice: 23400 },
    { name: "Easyfit Digital Progressive DuraRelax 1.5", pairPrice: 29400 },

    { name: "Crossbow Digital Progressive UnCoated 1.5", pairPrice: 8700 },
    { name: "Crossbow Digital Progressive Duramax 1.5", pairPrice: 11700 },
    { name: "Crossbow Digital Progressive DuraBlue 1.5", pairPrice: 20700 },
    { name: "Crossbow Digital Progressive DuraUV 1.5", pairPrice: 29700 },

    { name: "NUPOLAR Digital Progressive EasyFit Duramax", pairPrice: 50700 },
    { name: "NUPOLAR Digital Progressive EasyFit DuraUV", pairPrice: 53700 },
    { name: "NUPOLAR Digital Progressive EasyFit DuraRelax", pairPrice: 56100 }
  ],

  OTHER: [
    { name: "Mirror Coating (Limited Colors)", pairPrice: 12000 },
    { name: "Shaded Poloroid (Limited Colors)", pairPrice: 20000 }
  ]
},





HOYA: {
  SV: [
    { name: "STELLIFY FVS Index 1.50 HVA", pairPrice: 11000 },
    { name: "STELLIFY FVS Index 1.55 HVP", pairPrice: 14750 },
    { name: "STELLIFY FVS Index 1.55 HVP BlueControl", pairPrice: 19875 },
    { name: "STELLIFY FVS Index 1.60 HVP", pairPrice: 19875 },
    { name: "STELLIFY FVS Index 1.60 HVP BlueControl", pairPrice: 19875 }
  ],

  BF: [],

  PAL: [
    { name: "STELLIFY MINI Index 1.56 HMC", pairPrice: 17250 },
    { name: "STELLIFY MINI Index 1.56 HMC Blue Ray", pairPrice: 19750 },
    { name: "STELLIFY MINI PHOTO Index 1.56 HMC", pairPrice: 22250 },
    { name: "STELLIFY MINI PHOTO Index 1.56 HMC Blue Ray", pairPrice: 24750 },

    { name: "STELLIFY DGT Index 1.50 HC", pairPrice: 25425 },
    { name: "STELLIFY DGT Index 1.50 HVP", pairPrice: 37250 },
    { name: "STELLIFY DGT Index 1.50 HVP BlueControl", pairPrice: 42250 },

    { name: "STELLIFY DGT Index 1.55 HC", pairPrice: 34600 },
    { name: "STELLIFY DGT Index 1.55 HVP", pairPrice: 46275 },
    { name: "STELLIFY DGT Index 1.55 HVP BlueControl", pairPrice: 49600 },

    { name: "STELLIFY COMFY Index 1.50 HC", pairPrice: 32525 },
    { name: "STELLIFY COMFY Index 1.50 HVP", pairPrice: 44175 },
    { name: "STELLIFY COMFY Index 1.50 HVP BlueControl", pairPrice: 47525 },

    { name: "STELLIFY COMFY Index 1.55 HC", pairPrice: 40850 },
    { name: "STELLIFY COMFY Index 1.55 HVP", pairPrice: 52525 },
    { name: "STELLIFY COMFY Index 1.55 HVP BlueControl", pairPrice: 55850 },

    { name: "STELLIFY COMFY Index 1.60 HC", pairPrice: 62250 },
    { name: "STELLIFY COMFY Index 1.60 HVP", pairPrice: 67250 },
    { name: "STELLIFY COMFY Index 1.60 HVP BlueControl", pairPrice: 72250 },

    { name: "STELLIFY COMFY SOLIO Index 1.55 HC", pairPrice: 59200 },
    { name: "STELLIFY COMFY SOLIO Index 1.55 HVP", pairPrice: 70850 },
    { name: "STELLIFY COMFY SOLIO Index 1.55 HVP BlueControl", pairPrice: 74200 }
  ]
},





NOVAR: {

  SV: [
    {
      name: "Single Vision Eyelux HD BlueCut",
      pairPrice: 32000
    },
    {
      name: "Single Vision Eyelux HD BlueCut Photochromic",
      pairPrice: 32000
    },



  ],

  BF: [

  ],

  PAL: [

    {
      name: "Progressive Precisa Eyelux HD BlueCut",
      pairPrice: 33000
    },
        {
      name: "Progressive Precisa Eyelux HD BlueCut Photochromic",
      pairPrice: 33000
    },
    {
      name: "Progressive Evolution Eyelux HD BlueCut",
      pairPrice: 49000
    },

    {
      name: "Progressive Evolution Eyelux HD BlueCut Photochromic",
      pairPrice: 49000
    },
    {
      name: "Progressive E Life Eyelux HD BlueCut",
      pairPrice: 69000
    },

            {
      name: "Progressive E Life Eyelux HD BlueCut Photochromic",
      pairPrice: 69000
    },


    // ECOLITE
    {
      name: "ECOLITE UnCoated 1.49",
      pairPrice: 12000
    },
    {
      name: "ECOLITE HMC 1.56",
      pairPrice: 16000
    },
    {
      name: "ECOLITE BLUECUT 1.56",
      pairPrice: 18000
    },
    {
      name: "ECOLITE HMC Photo Grey 1.56",
      pairPrice: 22000
    },
    {
      name: "ECOLITE Bluecut Photo Grey 1.56",
      pairPrice: 26000
    },
    {
      name: "ECOLITE HMC 1.61",
      pairPrice: 22000
    },
    {
      name: "ECOLITE BLUECUT 1.61",
      pairPrice: 26000
    },
    {
      name: "ECOLITE HMC Photo Grey 1.61",
      pairPrice: 32000
    },
    {
      name: "ECOLITE Bluecut Photo Grey 1.61",
      pairPrice: 37000
    },
    {
      name: "ECOLITE HMC 1.67",
      pairPrice: 32000
    },
    {
      name: "ECOLITE BLUECUT 1.67",
      pairPrice: 36000
    },
    {
      name: "ECOLITE HMC Photo Grey 1.67",
      pairPrice: 53000
    },
    {
      name: "ECOLITE Bluecut Photo Grey 1.67",
      pairPrice: 57000
    },
    {
      name: "ECOLITE HMC 1.74",
      pairPrice: 60000
    },
    {
      name: "ECOLITE BLUECUT 1.74",
      pairPrice: 64000
    },
    {
      name: "Polarized 1.49 Grey, Green, Brown",
      pairPrice: 26000
    },

    // PRIZMA
    {
      name: "PRIZMA UnCoated 1.49",
      pairPrice: 18000
    },
    {
      name: "PRIZMA HMC 1.56",
      pairPrice: 20000
    },
    {
      name: "PRIZMA BLUECUT 1.56",
      pairPrice: 22000
    },
    {
      name: "PRIZMA HMC Photo Grey 1.56",
      pairPrice: 30000
    },
    {
      name: "PRIZMA Bluecut Photo Grey 1.56",
      pairPrice: 35000
    },
    {
      name: "PRIZMA HMC 1.61",
      pairPrice: 30000
    },
    {
      name: "PRIZMA BLUECUT 1.61",
      pairPrice: 32000
    },
    {
      name: "PRIZMA HMC Photo Grey 1.61",
      pairPrice: 38000
    },
    {
      name: "PRIZMA Bluecut Photo Grey 1.61",
      pairPrice: 45000
    },
    {
      name: "PRIZMA HMC 1.67",
      pairPrice: 40000
    },
    {
      name: "PRIZMA BLUECUT 1.67",
      pairPrice: 42000
    },
    {
      name: "PRIZMA HMC Photo Grey 1.67",
      pairPrice: 55000
    },
    {
      name: "PRIZMA Bluecut Photo Grey 1.67",
      pairPrice: 59000
    },
    {
      name: "PRIZMA HMC 1.74",
      pairPrice: 62000
    },
    {
      name: "PRIZMA BLUECUT 1.74",
      pairPrice: 66000
    },
    {
      name: "Polarized 1.49 Grey, Green, Brown",
      pairPrice: 28000
    },

    // REVOLUTIONS PLUS
    {
      name: "REVOLUTIONS PLUS UnCoated 1.49",
      pairPrice: 23500
    },
    {
      name: "REVOLUTIONS PLUS HMC 1.56",
      pairPrice: 27500
    },
    {
      name: "REVOLUTIONS PLUS BLUECUT 1.56",
      pairPrice: 32000
    },
    {
      name: "REVOLUTIONS PLUS HMC Photo Grey 1.56",
      pairPrice: 33500
    },
    {
      name: "REVOLUTIONS PLUS Bluecut Photo Grey 1.56",
      pairPrice: 43200
    },
    {
      name: "REVOLUTIONS PLUS HMC 1.61",
      pairPrice: 36000
    },
    {
      name: "REVOLUTIONS PLUS BLUECUT 1.61",
      pairPrice: 38000
    },
    {
      name: "REVOLUTIONS PLUS HMC Photo Grey 1.61",
      pairPrice: 43500
    },
    {
      name: "REVOLUTIONS PLUS Bluecut Photo Grey 1.61",
      pairPrice: 52000
    },
    {
      name: "REVOLUTIONS PLUS HMC 1.67",
      pairPrice: 48000
    },
    {
      name: "REVOLUTIONS PLUS BLUECUT 1.67",
      pairPrice: 50000
    },
    {
      name: "REVOLUTIONS PLUS HMC Photo Grey 1.67",
      pairPrice: 60000
    },
    {
      name: "REVOLUTIONS PLUS Bluecut Photo Grey 1.67",
      pairPrice: 62000
    },
    {
      name: "REVOLUTIONS PLUS HMC 1.74",
      pairPrice: 64000
    },
    {
      name: "REVOLUTIONS PLUS BLUECUT 1.74",
      pairPrice: 68000
    },
    {
      name: "Polarized 1.49 Grey, Green, Brown",
      pairPrice: 30000
    },

    // MAX VIEW
    {
      name: "MAX VIEW UnCoated 1.49",
      pairPrice: 28000
    },
    {
      name: "MAX VIEW HMC 1.56",
      pairPrice: 38000
    },
    {
      name: "MAX VIEW BLUECUT 1.56",
      pairPrice: 43600
    },
    {
      name: "MAX VIEW HMC Photo Grey 1.56",
      pairPrice: 45400
    },
    {
      name: "MAX VIEW Bluecut Photo Grey 1.56",
      pairPrice: 51000
    },
    {
      name: "MAX VIEW HMC 1.61",
      pairPrice: 48000
    },
    {
      name: "MAX VIEW BLUECUT 1.61",
      pairPrice: 53000
    },
    {
      name: "MAX VIEW HMC Photo Grey 1.61",
      pairPrice: 55000
    },
    {
      name: "MAX VIEW Bluecut Photo Grey 1.61",
      pairPrice: 64000
    },
    {
      name: "MAX VIEW HMC 1.67",
      pairPrice: 55000
    },
    {
      name: "MAX VIEW BLUECUT 1.67",
      pairPrice: 65000
    },
    {
      name: "MAX VIEW HMC Photo Grey 1.67",
      pairPrice: 70000
    },
    {
      name: "MAX VIEW Bluecut Photo Grey 1.67",
      pairPrice: 74000
    },
    {
      name: "MAX VIEW HMC 1.74",
      pairPrice: 67000
    },
    {
      name: "MAX VIEW BLUECUT 1.74",
      pairPrice: 72000
    },
    {
      name: "Polarized 1.49 Grey, Green, Brown",
      pairPrice: 33000
    }

  ]

},



  GENERIC: {
    SV: [],
    BF: [],
    PAL: []
  },


};


const [leftLensBrand, setLeftLensBrand] =
  useState("");

const [leftLensType, setLeftLensType] =
  useState("");

const [leftLens, setLeftLens] =
  useState(null);

const [rightLensBrand, setRightLensBrand] =
  useState("");

const [rightLensType, setRightLensType] =
  useState("");

const [rightLens, setRightLens] =
  useState(null);

  











  useEffect(() => {

  let total = 0;

  if (leftLens) {
    total += leftLens.pairPrice / 2;
  }

  if (rightLens) {
    total += rightLens.pairPrice / 2;
  }

  setFormData(prev => ({
    ...prev,
    lensPrice: total.toFixed(2)
  }));

}, [leftLens, rightLens]);


















///////////////////////////////////////////// Add Item ////////////////////////////////////////////

// Add Items states
const [itemName, setItemName] = useState("");
const [itemPrice, setItemPrice] = useState("");


// Add Items handler
const handleAddItemforconsultation = async () => {
  // Validation
  if (!itemName.trim()) return alert("Item Name is required");
  if (!itemPrice) return alert("Price is required");
  if (parseFloat(itemPrice) <= 0) return alert("Price must be greater than 0");

  try {
    await addDoc(collection(db, "items"), {
      name: itemName.trim(),
      price: parseFloat(itemPrice),
      createdAt: serverTimestamp()
    });

    alert("Item added successfully!");
    handleClearItems();
  } catch (err) {
    console.error(err);
    alert("Failed to add item.");
  }
};

// Clear Items form
const handleClearItems = () => {
  setItemName("");
  setItemPrice("");
};










const handleLogout = () => {
  // Remove login token / session
  localStorage.removeItem("adminToken");

  // Redirect to login page
  window.location.href = "/";
};









/////////////////////////////////////////////////////// view supplier ////////////////////////////////////////////////////////////


  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [sortType, setSortType] = useState("newest");
  const [currentPage, setCurrentPage] = useState(1);
  const [editData, setEditData] = useState(null);

  const itemsPerPage = 5;

  // FETCH DATA
  const fetchSuppliers = async () => {
    try {
      const q = query(collection(db, "suppliers"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSuppliers(list);
      setFiltered(list);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  // SEARCH
  useEffect(() => {
    let data = [...suppliers];

    if (search) {
      data = data.filter((s) =>
        s.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    // SORT
    if (sortType === "az") {
      data.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortType === "newest") {
      data.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
    }

    setFiltered(data);
    setCurrentPage(1);
  }, [search, sortType, suppliers]);

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this supplier?")) return;
    await deleteDoc(doc(db, "suppliers", id));
    fetchSuppliers();
  };

  // UPDATE
  const handleUpdate = async () => {
    try {
      const ref = doc(db, "suppliers", editData.id);
      await updateDoc(ref, {
        name: editData.name,
        email: editData.email,
        phone: editData.phone,
        company: editData.company,
        address: editData.address,
      });
      setEditData(null);
      fetchSuppliers();
    } catch (err) {
      console.error(err);
    }
  };

  // PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);


 
  

//////////////////////////////////////////////////// purchasing order //////////////////////////////////////////////////////////////////////

// Fetch suppliers from Firestore
useEffect(() => {
  const fetchSuppliers = async () => {
    const snapshot = await getDocs(collection(db, "suppliers"));
    const supplierData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setSuppliers(supplierData);
  };

  fetchSuppliers();
}, []);

// Generate next PO number
useEffect(() => {
  const fetchLastPO = async () => {
    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc"),
      limit(1)
    );

    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const lastPO = snapshot.docs[0].data().purchaseOrderNo;
      const lastNum = parseInt(lastPO.split("-").pop());
      const newNum = String(lastNum + 1).padStart(3, "0");
      setPurchaseOrderNo(`PO-${newNum}`);
    } else {
      setPurchaseOrderNo("PO-001");
    }
  };

  fetchLastPO();
}, [lensList, frameList]);

// Create PO
const handleCreatePurchaseOrder = async () => {
  if (!supplierName) return alert("Select a supplier");

  try {
    await addDoc(collection(db, "purchasing_order"), {
      purchaseOrderNo,
      supplierName,
      lensList,
      frameList,
      createdAt: serverTimestamp(),
    });

    alert("Purchase Order Created Successfully!");

    // Reset fields
    setLensList([]);
    setFrameList([]);
    setSupplierName("");

    // Update PO no
    const lastNum = parseInt(purchaseOrderNo.split("-").pop());
    const nextNum = String(lastNum + 1).padStart(3, "0");
    setPurchaseOrderNo(`PO-${nextNum}`);

  } catch (error) {
    console.error("Error creating PO:", error);
    alert("Failed to create purchase order. Check console for details.");
  }
};






/////////////////////////////////////////// Add Stock //////////////////////////////////////////////

const [selectedCategory, setSelectedCategory] = useState(""); // "lens" or "frame"

useEffect(() => {
  const fetchPurchaseOrders = async () => {
    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc")
    );
    const snapshot = await getDocs(q);
    const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPurchaseOrders(list);
  };

  fetchPurchaseOrders();
}, []);








const handleAddItems = async () => {
  if (!selectedCategory) return alert("Select Lens or Frame");

  try {
    await addDoc(collection(db, "stock"), {
      purchaseOrderNo,
      supplierName,
      category: selectedCategory,
      purchaseDate,
      items,
      createdAt: serverTimestamp()
    });

    alert("Stock added successfully!");
    handleClear();
  } catch (err) {
    console.error(err);
    alert("Failed to add stock.");
  }
};




  // Clears the form fields
const handleClear = () => {
  setPurchaseOrderNo("");
  setSupplierName("");
  setPurchaseDate("");
  setSelectedCategory("");
  setItems([]);
};




const handleLoad = () => {
  if (!selectedCategory) return alert("Select Lens or Frame first");

  const selectedOrder = purchaseOrders.find(po => po.purchaseOrderNo === purchaseOrderNo);
  if (!selectedOrder) return;

  setSupplierName(selectedOrder.supplierName || "");
  setPurchaseDate(selectedOrder.createdAt
    ? selectedOrder.createdAt.toDate().toISOString().split("T")[0]
    : ""
  );

  // Load only lens or frame items
  const dataToLoad = selectedCategory === "lens" ? selectedOrder.lensList || [] : selectedOrder.frameList || [];

  const formattedItems = dataToLoad.map(item => ({ ...item, supplyQty: item.supplyQty || 0 }));
  setItems(formattedItems);
};






// Example: Update quantity of an item
const handleSupplyQtyChange = (index, value) => {
  const updatedItems = [...items];
  updatedItems[index].supplyQty = value;
  setItems(updatedItems);
};






 
  
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  const [lensForm, setLensForm] = useState({
  
    sph: "",
    add: "",
    cyl: "",
    axis: "",
    model: "CR39",
    progressive: false,
    qty: ""
  });

  const [frameForm, setFrameForm] = useState({
  
    modelNo: "",
    brand: "",
    colour: "",
    sex: "",
    qty: ""
  });

  const handleLensAdd = () => {
    setLensList([...lensList, lensForm]);
    setLensForm({
      sph: "",
      add: "",
      cyl: "",
      axis: "",
      model: "CR39",
      progressive: false,
      qty: ""
    });
  };

  const handleFrameAdd = () => {
    setFrameList([...frameList, frameForm]);
    setFrameForm({
      modelNo: "",
      brand: "",
      colour: "",
      sex: "",
      qty: ""
    });
  };




////////////////////////////////////////////////////// Quick Stock add/////////////////////////////////////////////////////////

// State
const [lensFormquickAdd, setLensFormquickAdd] = useState({
  sph: 0,
  cyl: 0,
  add: 0,
  model: "",
  buyingPrice: "",
  sellingPrice: "",
  qty: "",
});

// Handle Input Change
const handleChange = (e) => {
  setLensFormquickAdd({
    ...lensFormquickAdd,
    [e.target.name]: e.target.value,
  });
};

// Add Lens to List
const handleAdd = () => {
  if (
    lensFormquickAdd.buyingPrice === "" ||
    lensFormquickAdd.sellingPrice === "" ||
    lensFormquickAdd.qty === ""
  ) {
    alert("Please fill all fields!");
    return;
  }

  setLensList([...lensList, lensFormquickAdd]);

  // Reset fields
  setLensFormquickAdd({
    sph: 0,
    cyl: 0,
    add: 0,
    model: "",
    buyingPrice: "",
    sellingPrice: "",
    qty: "",
  });
};

// Clear Entire List
const clearList = () => {
  setLensList([]);
};


/////////////////////////////////////////////////////////////////////// Add Suppliers//////////////////////////////////////////////

// Add Supplier states
const [supplierEmail, setSupplierEmail] = useState("");
const [supplierPhone, setSupplierPhone] = useState("");
const [supplierCompany, setSupplierCompany] = useState("");
const [supplierAddress, setSupplierAddress] = useState("");
const [addingSupplier, setAddingSupplier] = useState(false);


// Add Supplier handler
const handleAddSupplier = async () => {
  // Validation
  if (!supplierName.trim()) {
    return alert("Supplier Name is required");
  }

  setAddingSupplier(true);

  try {
    await addDoc(collection(db, "suppliers"), {
      name: supplierName.trim(),
      email: supplierEmail.trim() || null,
      phone: supplierPhone.trim(),
      company: supplierCompany.trim(),
      address: supplierAddress.trim(),
      createdAt: serverTimestamp()
    });

    alert("Supplier added successfully!");
    handleClearSupplier();

  } catch (err) {
    console.error(err);
    alert("Failed to add supplier.");
  } finally {
    setAddingSupplier(false);
  }
};

// Clear Supplier form
const handleClearSupplier = () => {
  setSupplierName("");
  setSupplierEmail("");
  setSupplierPhone("");
  setSupplierCompany("");
  setSupplierAddress("");
};



  


////////////////////////////////////////////////////////////////////// stock report Hisotry report - stock history/////////////////////////////////////////////////////////


  // ============================================
// STATE DECLARATIONS
// ============================================

const [searchText, setSearchText] = useState("");
const [frameTypeFilter, setFrameTypeFilter] = useState("all");
const [uniqueFrameTypes, setUniqueFrameTypes] = useState([]);

// Stock History States
const [lensStockHistory, setLensStockHistory] = useState([]);
const [frameStockHistory, setFrameStockHistory] = useState([]);
const [sunglassStockHistory, setSunglassStockHistory] = useState([]);
const [otherStockHistory, setOtherStockHistory] = useState([]);

const [filteredLensHistory, setFilteredLensHistory] = useState([]);
const [filteredFrameHistory, setFilteredFrameHistory] = useState([]);
const [filteredSunglassHistory, setFilteredSunglassHistory] = useState([]);
const [filteredOtherHistory, setFilteredOtherHistory] = useState([]);

const [historyCategory, setHistoryCategory] = useState("lens");
const [loading, setLoading] = useState(false);
const [filterType, setFilterType] = useState("all");
const [filterValue, setFilterValue] = useState("");

const [lensTotalQty, setLensTotalQty] = useState(0);
const [frameTotalQty, setFrameTotalQty] = useState(0);
const [sunglassTotalQty, setSunglassTotalQty] = useState(0);
const [otherTotalQty, setOtherTotalQty] = useState(0);

// Edit Modal States
const [editingStock, setEditingStock] = useState(null);
const [editingItem, setEditingItem] = useState(null);
const [editFormData, setEditFormData] = useState({});
const [showEditModal, setShowEditModal] = useState(false);

// ============================================
// FILTER FUNCTION
// ============================================

const filterByDate = (data, type, value) => {
  if (type === "all" || !value) return data;
  
  return data.filter(item => {
    let itemDate = null;
    
    if (item.createdAt?.toDate) {
      itemDate = item.createdAt.toDate();
    } else if (item.createdAt) {
      itemDate = new Date(item.createdAt);
    }
    
    if (!itemDate || isNaN(itemDate.getTime())) return false;
    
    switch(type) {
      case "day":
        const selectedDate = new Date(value);
        return itemDate.toDateString() === selectedDate.toDateString();
      
      case "month":
        const selectedMonth = parseInt(value.split("-")[1]);
        const selectedYear = parseInt(value.split("-")[0]);
        return itemDate.getMonth() + 1 === selectedMonth && 
               itemDate.getFullYear() === selectedYear;
      
      case "year":
        const selectedYearOnly = parseInt(value);
        return itemDate.getFullYear() === selectedYearOnly;
      
      default:
        return true;
    }
  });
};

// ============================================
// FILTER EFFECT
// ============================================

useEffect(() => {
  const lens = filterByDate(lensStockHistory, filterType, filterValue)
    .filter(stock =>
      stock.items?.some(item =>
        `${item.model || ""} ${item.sph || ""} ${item.cyl || ""}`
          .toLowerCase()
          .includes(searchText.toLowerCase())
      )
    );

  const frame = filterByDate(frameStockHistory, filterType, filterValue)
    .filter(stock => {
      const matchesSearch = stock.items?.some(item =>
        `${item.brand || ""} ${item.modelNo || ""} ${item.colour || ""}`
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
      
      if (frameTypeFilter !== "all" && matchesSearch) {
        return stock.items?.some(item => 
          item.ftype?.toLowerCase() === frameTypeFilter.toLowerCase()
        );
      }
      
      return matchesSearch;
    });

  const sunglass = filterByDate(sunglassStockHistory, filterType, filterValue)
    .filter(stock =>
      stock.items?.some(item =>
        `${item.brand || ""} ${item.modelNo || ""} ${item.colour || ""}`
          .toLowerCase()
          .includes(searchText.toLowerCase())
      )
    );

  const other = filterByDate(otherStockHistory, filterType, filterValue)
    .filter(stock =>
      stock.items?.some(item =>
        `${item.brand || ""} ${item.modelNo || ""} ${item.colour || ""}`
          .toLowerCase()
          .includes(searchText.toLowerCase())
      )
    );

  setFilteredLensHistory(lens);
  setFilteredFrameHistory(frame);
  setFilteredSunglassHistory(sunglass);
  setFilteredOtherHistory(other);

  const frameTypes = new Set();
  frameStockHistory.forEach(stock => {
    stock.items?.forEach(item => {
      if (item.ftype) {
        frameTypes.add(item.ftype);
      }
    });
  });
  setUniqueFrameTypes(Array.from(frameTypes));

  const calculateTotals = (data) => {
    let total = 0;
    data.forEach(stock => {
      if (stock.items && Array.isArray(stock.items)) {
        stock.items.forEach(item => {
          total += Number(item.qty) || 0;
        });
      }
    });
    return total;
  };

  setLensTotalQty(calculateTotals(lens));
  setFrameTotalQty(calculateTotals(frame));
  setSunglassTotalQty(calculateTotals(sunglass));
  setOtherTotalQty(calculateTotals(other));

}, [
  lensStockHistory,
  frameStockHistory,
  sunglassStockHistory,
  otherStockHistory,
  filterType,
  filterValue,
  searchText,
  frameTypeFilter
]);

// ============================================
// RESET FILTERS
// ============================================

const resetStockHistoryFilters = () => {
  setFilterType("all");
  setFilterValue("");
  setFrameTypeFilter("all");
};

// ============================================
// DELETE STOCK
// ============================================

// const handleDeleteStock = async (stockId) => {
//   if (!window.confirm("Are you sure you want to delete this stock record?")) {
//     return;
//   }

//   try {
//     await deleteDoc(doc(db, "stock", stockId));
    
//     setLensStockHistory(prev => prev.filter(s => s.id !== stockId));
//     setFrameStockHistory(prev => prev.filter(s => s.id !== stockId));
//     setSunglassStockHistory(prev => prev.filter(s => s.id !== stockId));
//     setOtherStockHistory(prev => prev.filter(s => s.id !== stockId));
    
//     alert("Stock record deleted successfully!");
//   } catch (error) {
//     console.error("Error deleting stock:", error);
//     alert("Failed to delete stock: " + error.message);
//   }
// };


// ============================================
// DELETE STOCK WITH PASSWORD PROTECTION
// ============================================

const handleDeleteStock = async (stockId) => {
  // First, ask for password
  const password = prompt("Enter authorization password to delete this stock record:");
  
  // Check if user cancelled the prompt
  if (password === null) {
    return;
  }
  
  // Validate password
  if (password !== "Hov@355") {
    alert("Incorrect password! Access denied.");
    return;
  }
  
  // Confirm deletion after password is correct
  if (!window.confirm("Are you sure you want to delete this stock record?")) {
    return;
  }

  try {
    await deleteDoc(doc(db, "stock", stockId));
    
    setLensStockHistory(prev => prev.filter(s => s.id !== stockId));
    setFrameStockHistory(prev => prev.filter(s => s.id !== stockId));
    setSunglassStockHistory(prev => prev.filter(s => s.id !== stockId));
    setOtherStockHistory(prev => prev.filter(s => s.id !== stockId));
    
    alert("Stock record deleted successfully!");
  } catch (error) {
    console.error("Error deleting stock:", error);
    alert("Failed to delete stock: " + error.message);
  }
};


// ============================================
// EDIT STOCK
// ============================================

// const handleEditStock = (stock, item, itemIndex) => {
//   setEditingStock(stock);
//   setEditingItem({ ...item, itemIndex });
  
//   const formData = {};
//   Object.keys(item).forEach(key => {
//     if (key !== 'id' && key !== 'itemIndex') {
//       formData[key] = item[key] || '';
//     }
//   });
  
//   setEditFormData(formData);
//   setShowEditModal(true);
// };



const handleEditStock = (stock, item, itemIndex) => {
  // First, ask for password
  const password = prompt("🔒 Enter authorization password to edit this stock record:");
  
  // Check if user cancelled the prompt
  if (password === null) {
    return;
  }
  
  // Validate password
  if (password !== "Hov@355") {
    alert("❌ Incorrect password! Access denied.");
    return;
  }
  
  // If password is correct, proceed with editing
  setEditingStock(stock);
  setEditingItem({ ...item, itemIndex });
  
  const formData = {};
  Object.keys(item).forEach(key => {
    if (key !== 'id' && key !== 'itemIndex') {
      formData[key] = item[key] || '';
    }
  });
  
  setEditFormData(formData);
  setShowEditModal(true);
};







const handleEditInputChange = (e) => {
  const { name, value } = e.target;
  setEditFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleSaveEdit = async () => {
  try {
    if (!editingStock || !editingItem) return;

    const stockRef = doc(db, "stock", editingStock.id);
    const stockDoc = await getDoc(stockRef);
    
    if (!stockDoc.exists()) {
      alert("Stock record not found!");
      return;
    }

    const stockData = stockDoc.data();
    const updatedItems = [...(stockData.items || [])];
    
    const updatedItem = {};
    Object.keys(editFormData).forEach(key => {
      if (['qty', 'supplyQty', 'sellingPrice', 'purchasePrice', 'size', 'dm', 'bc'].includes(key)) {
        updatedItem[key] = Number(editFormData[key]) || 0;
      } else {
        updatedItem[key] = editFormData[key];
      }
    });
    
    updatedItems[editingItem.itemIndex] = updatedItem;

    await updateDoc(stockRef, {
      items: updatedItems
    });

    const updateLocalState = (setter, history) => {
      const updated = history.map(s => 
        s.id === editingStock.id ? { ...s, items: updatedItems } : s
      );
      setter(updated);
    };

    if (editingStock.category === 'lens') {
      updateLocalState(setLensStockHistory, lensStockHistory);
    } else if (editingStock.category === 'frame') {
      updateLocalState(setFrameStockHistory, frameStockHistory);
    } else if (editingStock.category === 'sunglass') {
      updateLocalState(setSunglassStockHistory, sunglassStockHistory);
    } else if (editingStock.category === 'other') {
      updateLocalState(setOtherStockHistory, otherStockHistory);
    }

    alert("Stock updated successfully!");
    setShowEditModal(false);
    setEditingStock(null);
    setEditingItem(null);
    
  } catch (error) {
    console.error("Error updating stock:", error);
    alert("Failed to update stock: " + error.message);
  }
};

const handleCancelEdit = () => {
  setShowEditModal(false);
  setEditingStock(null);
  setEditingItem(null);
};

// ============================================
// EXPORT TO EXCEL
// ============================================

const exportToExcel = () => {
  try {
    let exportData = [];
    let sheetName = "";
    
    if (historyCategory === "lens") {
      sheetName = "Lens_Stock_History";
      filteredLensHistory.forEach(stock => {
        if (stock.items && Array.isArray(stock.items)) {
          stock.items.forEach(item => {
            exportData.push({
              "Purchase Order No": stock.purchaseOrderNo || "",
              "Supplier Name": stock.supplierName || "",
              "Purchase Date": stock.purchaseDate || "",
              "SPH": item.sph || "",
              "Add": item.add || "",
              "CYL": item.cyl || "",
              "Axis": item.axis || "",
              "Model": item.model || "",
              "Is Progressive": item.progressive ? "Yes" : "No",
              "Available Qty": item.qty || "",
              "Supply Qty": item.supplyQty || 0,
              "Selling Price": item.sellingPrice || "",
              "Status": item.supplyQty >= item.qty ? "Complete" : "Pending",
              "Stock Added Date": stock.createdAt ? new Date(stock.createdAt).toLocaleDateString() : "",
              "Filter Applied": filterType === "all" ? "All Data" : 
                filterType === "day" ? `Date: ${filterValue}` :
                filterType === "month" ? `Month: ${filterValue}` :
                `Year: ${filterValue}`
            });
          });
        }
      });
    } else if (historyCategory === "frame") {
      sheetName = "Frame_Stock_History";
      filteredFrameHistory.forEach(stock => {
        if (stock.items && Array.isArray(stock.items)) {
          stock.items.forEach(item => {
            if (frameTypeFilter !== "all" && 
                item.ftype?.toLowerCase() !== frameTypeFilter.toLowerCase()) {
              return;
            }
            exportData.push({
              "Purchase Order No": stock.purchaseOrderNo || "",
              "Supplier Name": stock.supplierName || "",
              "Purchase Date": stock.purchaseDate || "",
              "Model No": item.modelNo || "",
              "Brand": item.brand || "",
              "Frame Type": item.ftype || "",
              "Colour": item.colour || "",
              "Size": item.size || "",
              "Sex": item.sex || "",
              "Available Qty": item.qty || "",
              "Supply Qty": item.supplyQty || 0,
              "Selling Price": item.sellingPrice || "",
              "Status": item.supplyQty >= item.qty ? "Complete" : "Pending",
              "Stock Added Date": stock.createdAt ? new Date(stock.createdAt).toLocaleDateString() : "",
              "Filter Applied": filterType === "all" ? "All Data" : 
                filterType === "day" ? `Date: ${filterValue}` :
                filterType === "month" ? `Month: ${filterValue}` :
                `Year: ${filterValue}`,
              "Frame Type Filter": frameTypeFilter !== "all" ? `Frame Type: ${frameTypeFilter}` : "All Frame Types"
            });
          });
        }
      });
    } else if (historyCategory === "sunglass") {
      sheetName = "Sunglass_Stock_History";
      filteredSunglassHistory.forEach(stock => {
        stock.items?.forEach(item => {
          exportData.push({
            "Purchase Order No": stock.purchaseOrderNo || "",
            "Supplier Name": stock.supplierName || "",
            "Purchase Date": stock.purchaseDate || "",
            "Model No": item.modelNo || "",
            "Brand": item.brand || "",
            "Colour": item.colour || "",
            "Size": item.size || "",
            "Sex": item.sex || "",
            "Available Qty": item.qty || "",
            "Supply Qty": item.supplyQty || 0,
            "Selling Price": item.sellingPrice || "",
            "Stock Added Date": stock.createdAt ? new Date(stock.createdAt).toLocaleDateString() : "",
          });
        });
      });
    } else if (historyCategory === "other") {
      sheetName = "Other_Stock_History";
      filteredOtherHistory.forEach(stock => {
        stock.items?.forEach(item => {
          exportData.push({
            "Purchase Order No": stock.purchaseOrderNo || "",
            "Supplier Name": stock.supplierName || "",
            "Purchase Date": stock.purchaseDate || "",
            "Model No": item.modelNo || "",
            "Brand": item.brand || "",
            "DM": item.dm || "",
            "BC": item.bc || "",
            "Sex": item.sex || "",
            "Available Qty": item.qty || "",
            "Supply Qty": item.supplyQty || 0,
            "Selling Price": item.sellingPrice || "",
            "Stock Added Date": stock.createdAt ? new Date(stock.createdAt).toLocaleDateString() : "",
          });
        });
      });
    }

    if (exportData.length === 0) {
      alert("No data to export!");
      return;
    }
    
    const ws = XLSX.utils.json_to_sheet(exportData);
    const colWidths = [];
    Object.keys(exportData[0]).forEach(key => {
      const maxLength = Math.max(
        key.length,
        ...exportData.map(row => String(row[key] || "").length)
      );
      colWidths.push({ wch: Math.min(maxLength + 2, 50) });
    });
    ws['!cols'] = colWidths;
    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    
    const date = new Date();
    const dateStr = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    let filterStr = "";
    if (filterType !== "all") {
      filterStr = `_${filterType}_${filterValue.replace(/[^a-zA-Z0-9]/g, '-')}`;
    }
    const fileName = `${sheetName}${filterStr}_${dateStr}.xlsx`;
    
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
    
    alert(`Successfully exported ${exportData.length} records to Excel!`);
  } catch (error) {
    console.error("Export error:", error);
    alert("Error exporting to Excel: " + error.message);
  }
};

// ============================================
// EXPORT TO PDF (AVAILABLE STOCK ONLY)
// ============================================

const exportStockToPDF = (category, data) => {
  // Filter out items with qty = 0 - Only show available stock
  const filteredData = data
    .map(stock => ({
      ...stock,
      items: stock.items?.filter(item => item.qty > 0) || []
    }))
    .filter(stock => stock.items.length > 0);

  if (filteredData.length === 0) {
    alert(`No available stock (qty > 0) found for ${category} to export.`);
    return;
  }

  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 15;
  let yPos = 32;

  // ===== LETTERHEAD WITH DARK HEADER =====
  const darkHeader = [15, 23, 42];
  
  // Dark blue header background
  doc.setFillColor(...darkHeader);
  doc.rect(0, 0, pageWidth, 32, "F");

  // Add Logo (if available)
  try {
    doc.addImage("/house-of-vision-logo.png", "PNG", 10, 4, 60, 17);
  } catch (err) {
    console.log("Logo not found");
  }

  // Company Name (White)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(255, 255, 255);
  doc.text("HOUSE OF VISION", 75, 12);

  // Address and Contact (White)
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("No. 355, Maharagama Road, Boralesgamuwa", 75, 18);
  doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150 | Web: www.houseofvision.lk", 75, 24);

  // Reset text color for rest of document
  doc.setTextColor(0, 0, 0);
  yPos = 40;

  // ===== TITLE =====
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(15, 23, 42);
  doc.text(`${category} Stock Report (Available Only)`, pageWidth / 2, yPos, { align: "center" });
  yPos += 8;

  // ===== GENERATED DATE =====
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  const generatedDate = new Date().toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  doc.text(`Generated: ${generatedDate}`, margin, yPos);
  yPos += 8;

  // ===== FILTER INFO =====
  let filterInfo = "All Records";
  if (filterType === "day" && filterValue) {
    filterInfo = `Date: ${new Date(filterValue).toLocaleDateString()}`;
  } else if (filterType === "month" && filterValue) {
    const [year, month] = filterValue.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1);
    filterInfo = `Month: ${date.toLocaleString('default', { month: 'long', year: 'numeric' })}`;
  } else if (filterType === "year" && filterValue) {
    filterInfo = `Year: ${filterValue}`;
  }
  doc.setFontSize(9);
  doc.text(`Filter: ${filterInfo}`, margin, yPos);
  yPos += 6;

  // ===== TABLE HEADERS =====
  let headers = [];
  let columns = [];

  if (category === "Lens") {
    headers = ['Supplier', 'Date', 'Sph', 'Add', 'Cyl', 'Axis', 'Model', 'Prog.', 'Qty'];
    columns = [
      { key: 'supplierName', width: 40 },
      { key: 'purchaseDate', width: 22 },
      { key: 'sph', width: 18 },
      { key: 'add', width: 18 },
      { key: 'cyl', width: 18 },
      { key: 'axis', width: 18 },
      { key: 'model', width: 28 },
      { key: 'progressive', width: 18 },
      { key: 'qty', width: 15 }
    ];
  } else if (category === "Frame") {
    headers = ['Supplier', 'Date', 'Model No', 'Brand', 'Frame Type', 'Colour', 'Qty'];
    columns = [
        { key: 'supplierName', width:28 },
        { key: 'purchaseDate', width: 22 },
        { key: 'modelNo', width: 20 },
        { key: 'brand', width: 25 },
        { key: 'ftype', width: 22 },
        { key: 'colour', width: 30 },
        { key: 'qty', width: 15 }
    ];
  } else if (category === "Sunglass") {
    headers = ['Supplier', 'Date', 'Model No', 'Brand', 'Colour', 'Qty'];
    columns = [
      { key: 'supplierName', width: 40 },
      { key: 'purchaseDate', width: 25 },
      { key: 'modelNo', width: 30 },
      { key: 'brand', width: 30 },
      { key: 'colour', width: 25 },
      { key: 'qty', width: 18 }
    ];
  } else {
    headers = ['Supplier', 'Date', 'Model No', 'Brand', 'DM', 'BC', 'Qty'];
    columns = [
      { key: 'supplierName', width: 28 },
      { key: 'purchaseDate', width: 22 },
      { key: 'modelNo', width: 25 },
      { key: 'brand', width: 25 },
      { key: 'dm', width: 18 },
      { key: 'bc', width: 18 },
      { key: 'qty', width: 15 }
    ];
  }

  // Calculate column widths
  const totalWidth = pageWidth - (margin * 2);
  const colWidths = columns.map(col => (col.width / headers.reduce((sum, _, i) => sum + columns[i].width, 0)) * totalWidth);

  // ===== DRAW TABLE =====
  const drawTableHeader = () => {
    // Header background
    doc.setFillColor(15, 23, 42);
    doc.rect(margin, yPos, totalWidth, 10, 'F');
    
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    
    let xPos = margin;
    headers.forEach((header, i) => {
      doc.text(header, xPos + 2, yPos + 7);
      xPos += colWidths[i];
    });
    
    yPos += 10;
    doc.setTextColor(0, 0, 0);
  };

  drawTableHeader();

  // ===== TABLE ROWS =====
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);

  let rowCount = 0;
  let totalQty = 0;

  filteredData.forEach((stock) => {
    stock.items.forEach((item) => {
      // Check if we need a new page
      if (yPos > pageHeight - 20) {
        doc.addPage();
        yPos = 20;
        // Redraw header on new page
        doc.setFillColor(...darkHeader);
        doc.rect(0, 0, pageWidth, 40, "F");
        try {
          doc.addImage("/house-of-vision-logo.png", "PNG", 10, 4, 22, 22);
        } catch (err) {
          console.log("Logo not found");
        }
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.setTextColor(255, 255, 255);
        doc.text("HOUSE OF VISION", 40, 12);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text("No. 355, Maharagama Road, Boralesgamuwa", 40, 18);
        doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150 | Web: www.houseofvision.lk", 40, 24);
        doc.setTextColor(0, 0, 0);
        yPos = 40;
        drawTableHeader();
      }

      // Row background (alternating)
      if (rowCount % 2 === 0) {
        doc.setFillColor(248, 250, 252);
        doc.rect(margin, yPos, totalWidth, 8, 'F');
      }

      let xPos = margin;
      columns.forEach((col, i) => {
        let value = '';
        
        // Get the value based on the column key
        if (col.key === 'progressive') {
          value = item.progressive ? 'Yes' : 'No';
        } else if (col.key === 'purchaseDate') {
          if (stock.purchaseDate) {
            if (typeof stock.purchaseDate === 'string') {
              const dateParts = stock.purchaseDate.split('-');
              if (dateParts.length === 3) {
                value = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
              } else {
                value = stock.purchaseDate;
              }
            } else if (stock.purchaseDate instanceof Date) {
              value = stock.purchaseDate.toLocaleDateString('en-GB');
            } else if (stock.purchaseDate.toDate) {
              value = stock.purchaseDate.toDate().toLocaleDateString('en-GB');
            } else {
              value = String(stock.purchaseDate);
            }
          } else {
            value = '-';
          }
        } else if (col.key === 'supplierName') {
          value = stock.supplierName || '-';
        } else if (col.key === 'purchaseOrderNo') {
          value = stock.purchaseOrderNo || '-';
        } else {
          value = item[col.key] || '';
        }
        
        // Truncate long text
        if (value.length > 15) {
          value = value.substring(0, 13) + '..';
        }
        
        doc.text(String(value), xPos + 2, yPos + 6);
        xPos += colWidths[i];
      });

      yPos += 8;
      rowCount++;
      totalQty += (item.qty || 0);
    });
  });

  // ===== SUMMARY FOOTER =====
  if (yPos > pageHeight - 25) {
    doc.addPage();
    yPos = 20;
  }

  yPos += 5;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setDrawColor(0, 0, 0);
  doc.line(margin, yPos - 3, pageWidth - margin, yPos - 3);
  
  doc.text(`Total Records: ${rowCount}`, margin, yPos + 6);
  doc.text(`Total Available Quantity: ${totalQty}`, pageWidth / 2 - 10, yPos + 6);

  // ===== SAVE PDF =====
  const fileName = `${category}_Available_Stock_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(fileName);
};

// ============================================
// FETCH STOCK HISTORY
// ============================================

useEffect(() => {
  const fetchStockHistory = async () => {
    setLoading(true);
    try {
      const q = query(
        collection(db, "stock"),
        orderBy("createdAt", "desc")
      );
      const snapshot = await getDocs(q);
      
      const lensStocks = [];
      const frameStocks = [];
      const sunglassStocks = [];
      const otherStocks = [];
      
      snapshot.docs.forEach(doc => {
        const stockData = { id: doc.id, ...doc.data() };
        if (stockData.category === "lens") {
          lensStocks.push(stockData);
        } else if (stockData.category === "frame") {
          frameStocks.push(stockData);
        } else if (stockData.category === "sunglass") {
          sunglassStocks.push(stockData);
        } else if (stockData.category === "other") {
          otherStocks.push(stockData);
        }
      });
      
      setLensStockHistory(lensStocks);
      setFrameStockHistory(frameStocks);
      setSunglassStockHistory(sunglassStocks);
      setOtherStockHistory(otherStocks);
    } catch (err) {
      console.error("Error fetching stock history:", err);
      alert("Failed to load stock history");
    } finally {
      setLoading(false);
    }
  };
  
  if (selectedOption === "StockHistory") {
    fetchStockHistory();
  }
}, [selectedOption]);













////////////////////////////////////////////////// Quick Add Stock /////////////////////////////////////////////////

const [isAddingStock, setIsAddingStock] = useState(false);

// Quick Add Stock states
const [quickSelectedCategory, setQuickSelectedCategory] = useState("");
const [quickSupplierName, setQuickSupplierName] = useState("");
const [quickPurchaseDate, setQuickPurchaseDate] = useState("");
const [quickItems, setQuickItems] = useState([]);
const [suppliersList, setSuppliersList] = useState([]);

// Fetch suppliers for quick add
useEffect(() => {
  const fetchSuppliers = async () => {
    try {
      const q = query(collection(db, "suppliers"), orderBy("name"));
      const snapshot = await getDocs(q);
      const suppliers = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSuppliersList(suppliers);
    } catch (err) {
      console.error("Error fetching suppliers:", err);
    }
  };
  
  if (selectedOption === "quickAdd") {
    fetchSuppliers();
  }
}, [selectedOption]);



// Quick Add Stock handlers
const handleAddQuickItemRow = () => {
  if (!quickSelectedCategory) {
    alert("Please select a category first");
    return;
  }
  
  // Each item added will become its own stock record
  if (quickSelectedCategory === "lens") {
    setQuickItems([
      ...quickItems,
      {
        sph: "",
        add: "",
        cyl: "",
        axis: "",
        model: "",
        progressive: false,
        buyingPrice: "",
        sellingPrice: "",
        qty: "",
        supplyQty: "",
      }
    ]);
  } else if (quickSelectedCategory === "frame") {
    setQuickItems([
      ...quickItems,
      {
        brand: "",
        modelNo: "",
        ftype: "",
        colour: "",
        size: "",
        sex: "",
        qty: "",
        buyingPrice: "",
        sellingPrice: "",
        supplyQty: "",
      }
    ]);
  } else if (quickSelectedCategory === "sunglass") {
    setQuickItems([
      ...quickItems,
      {
        brand: "",
        modelNo: "",
        colour: "",
        size: "",
        sex: "",
        qty: "",
        buyingPrice: "",
        sellingPrice: "",
        supplyQty: "",
      }
    ]);
  } else if (quickSelectedCategory === "other") {
    setQuickItems([
      ...quickItems,
      {
        brand: "",
        modelNo: "",
        colour: "",
        dm: "",
        bc: "",
        sex: "",
        qty: "",
        buyingPrice: "",
        sellingPrice: "",
        supplyQty: "",
      }
    ]);
  }
};








const handleQuickItemChange = (index, field, value) => {
  const updatedItems = [...quickItems];
  updatedItems[index][field] = value;
  setQuickItems(updatedItems);
};

const handleRemoveQuickItem = (index) => {
  const updatedItems = quickItems.filter((_, i) => i !== index);
  setQuickItems(updatedItems);
};









const handleQuickAddStock = async () => {
  if (isAddingStock) return;
  setIsAddingStock(true);

  try {
    // Validation
    if (!quickSelectedCategory) {
      alert("Please select a category");
      setIsAddingStock(false);
      return;
    }

    if (!quickSupplierName) {
      alert("Please select a supplier");
      setIsAddingStock(false);
      return;
    }

    if (!quickPurchaseDate) {
      alert("Please select purchase date");
      setIsAddingStock(false);
      return;
    }

    if (quickItems.length === 0) {
      alert("Please add at least one item");
      setIsAddingStock(false);
      return;
    }

    // Validate each item based on category - ONLY compulsory fields
    for (let i = 0; i < quickItems.length; i++) {
      const item = quickItems[i];

      // if (quickSelectedCategory === "lens") {
      //   if (!item.model || item.qty <= 0 || item.supplyQty <= 0 || !item.sellingPrice) {
      //     alert(`Lens Item ${i + 1}: Please fill all required fields (Model, Qty, Supply Qty, Selling Price)`);
      //     setIsAddingStock(false);
      //     return;
      //   }
      // } else 
        
        if (quickSelectedCategory === "frame") {
        if (!item.brand || !item.modelNo || item.qty <= 0 || item.supplyQty <= 0 || !item.sellingPrice) {
          alert(`Frame Item ${i + 1}: Please fill all required fields (Brand, Model No, Qty, Supply Qty, Selling Price)`);
          setIsAddingStock(false);
          return;
        }
      } else if (quickSelectedCategory === "sunglass") {
        if (!item.brand || !item.modelNo || item.qty <= 0 || item.supplyQty <= 0 || !item.sellingPrice) {
          alert(`Sunglass Item ${i + 1}: Please fill all required fields (Brand, Model No, Qty, Supply Qty, Selling Price)`);
          setIsAddingStock(false);
          return;
        }
      } else if (quickSelectedCategory === "other") {
        if (!item.brand || !item.modelNo || item.qty <= 0 || item.supplyQty <= 0 ) {
          // || !item.sellingPrice
          alert(`Other Item ${i + 1}: Please fill all required fields (Brand, Model No, Qty, Supply Qty, Selling Price)`);
          setIsAddingStock(false);
          return;
        }
      }
    }

    const quickPONo = `QUICK-${Date.now()}`;

    // 🔥 NEW: Save each item as an INDIVIDUAL stock record
    for (let i = 0; i < quickItems.length; i++) {
      const item = quickItems[i];
      
      // Prepare item data for Firestore
      const stockData = {
        purchaseOrderNo: quickPONo,
        supplierName: quickSupplierName,
        category: quickSelectedCategory,
        purchaseDate: quickPurchaseDate,
        status: "In Stock",
        isQuickAdd: true,
  createdAt: new Date(),    // ✅ Store as Date object (Firestore converts to Timestamp)
  updatedAt: new Date()     // ✅ Store as Date object (Firestore converts to Timestamp)
      };

      // Add category-specific fields
      if (quickSelectedCategory === "lens") {
        stockData.items = [{
          sph: item.sph || "",
          add: item.add || "",
          cyl: item.cyl || "",
          axis: item.axis || "",
          model: item.model || "",
          progressive: item.progressive || false,
          buyingPrice: parseFloat(item.buyingPrice) || 0,
          sellingPrice: parseFloat(item.sellingPrice) || 0,
          qty: parseInt(item.qty) || 0,
          supplyQty: parseInt(item.supplyQty) || 0
        }];
      } else if (quickSelectedCategory === "frame") {
        stockData.items = [{
          brand: item.brand || "",
          modelNo: item.modelNo || "",
          ftype: item.ftype || "",
          colour: item.colour || "",
          size: item.size || "",
          sex: item.sex || "",
          buyingPrice: parseFloat(item.buyingPrice) || 0,
          sellingPrice: parseFloat(item.sellingPrice) || 0,
          qty: parseInt(item.qty) || 0,
          supplyQty: parseInt(item.supplyQty) || 0
        }];
      } else if (quickSelectedCategory === "sunglass") {
        stockData.items = [{
          brand: item.brand || "",
          modelNo: item.modelNo || "",
          colour: item.colour || "",
          size: item.size || "",
          sex: item.sex || "",
          buyingPrice: parseFloat(item.buyingPrice) || 0,
          sellingPrice: parseFloat(item.sellingPrice) || 0,
          qty: parseInt(item.qty) || 0,
          supplyQty: parseInt(item.supplyQty) || 0
        }];
      } else if (quickSelectedCategory === "other") {
        stockData.items = [{
          brand: item.brand || "",
          modelNo: item.modelNo || "",
          colour: item.colour || "",
          dm: item.dm || "",
          bc: item.bc || "",
          sex: item.sex || "",
          buyingPrice: parseFloat(item.buyingPrice) || 0,
          sellingPrice: parseFloat(item.sellingPrice) || 0,
          qty: parseInt(item.qty) || 0,
          supplyQty: parseInt(item.supplyQty) || 0
        }];
      }

      // Save individual record
      await addDoc(collection(db, "stock"), stockData);
    }

    alert(`${quickItems.length} item(s) added successfully!`);
    handleClearQuickForm();

  } catch (err) {
    console.error("Error adding stock:", err);
    alert("Failed to add stock. Please try again.");
  } finally {
    setIsAddingStock(false);
  }
};



const handleClearQuickForm = () => {
  setQuickSelectedCategory("");
  setQuickSupplierName("");
  setQuickPurchaseDate("");
  setQuickItems([]);
};


////////////////////////////// high index lens //////////////////////////////////////////////////////////

const [isHighIndexLens, setIsHighIndexLens] = useState(false);

const [highIndexLeftBrand, setHighIndexLeftBrand] = useState("");
const [highIndexLeftType, setHighIndexLeftType] = useState("");
const [highIndexLeftName, setHighIndexLeftName] = useState("");
const [highIndexLeftPrice, setHighIndexLeftPrice] = useState();

const [highIndexRightBrand, setHighIndexRightBrand] = useState("");
const [highIndexRightType, setHighIndexRightType] = useState("");
const [highIndexRightName, setHighIndexRightName] = useState("");
const [highIndexRightPrice, setHighIndexRightPrice] = useState();






///////////////////////////////////////// create invoice /////////////////////////////////////////////////////
const [bluecut, setBluecut] = useState("No");
const [photochromic, setPhotochromic] = useState("No");

const [selectedFramePrice, setSelectedFramePrice] = useState(0);

const TINT_CHARGE = 1000;

// Add this with your other state declarations
const [eyeCamps, setEyeCamps] = useState([]);
const [selectedEyeCamp, setSelectedEyeCamp] = useState('all');

// Add this with your other state declarations
const [applyVAT, setApplyVAT] = useState(false);
const [applyTint, setApplyTint] = useState(false);


  // State for invoice number management
  const [currentInvoiceNumber, setCurrentInvoiceNumber] = useState('');
  
  // State declarations
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [frameSearchTerm, setFrameSearchTerm] = useState('');
  const [frameSuggestions, setFrameSuggestions] = useState([]);
  const [showFrameSuggestions, setShowFrameSuggestions] = useState(false);
  const [availableFrames, setAvailableFrames] = useState([]);
  const [lensOptions, setLensOptions] = useState([]);

  // Form data state
  const [formData, setFormData] = useState({
    // Customer Information
    salePerson: '',
    title: '',
    firstName: '',
    lastName: '',
    address: '',
    tpNo: '',
    email: '',
    age: '',
    
    // Prescription
    prescriptionDate: '',
    referredBy: '-',
    pd: '',
    lpd: '',
    sh: '',
    lsh: '',
    
    // Right Eye
    rightVisualAcuity: '',
    rightSph: '',
    rightCyl: '',
    rightAxis: '',
    rightAdd: '',
    rightNearVA: '',
    
    // Left Eye
    leftVisualAcuity: '',
    leftSph: '',
    leftCyl: '',
    leftAxis: '',
    leftAdd: '',
    leftNearVA: '',


    // HB Rx Fields - SAVED SEPARATELY
  hbRxRightVisualAcuity: '',
  hbRxRightSph: '',
  hbRxRightCyl: '',
  hbRxRightAxis: '',
  hbRxRightAdd: '',
  hbRxRightNearVA: '',
  
  hbRxLeftVisualAcuity: '',
  hbRxLeftSph: '',
  hbRxLeftCyl: '',
  hbRxLeftAxis: '',
  hbRxLeftAdd: '',
  hbRxLeftNearVA: '',


    
    // Lens & Frame
    leftLensModel: '',
    rightLensModel: '',

    lensModel: '',
    lensPrice: '',

    bluecut,
    photochromic,


    frameModel: '',
    ftype: "",
    framePrice: '',
    brand: '',
    colour: '',
    size: '',
    selectedFrameId: '',
    selectedLensId: '',
    ewCategory:'',
    note: '',
    
    // Pricing & Delivery
    deliveryDate: '',
      discount: 0,
      discountType: 'amount',
    advancePayment: '',
    billDescription: '',
    paymentMethod: 'Cash'
  });






const [isOwnFrame, setIsOwnFrame] = useState(false);

// Handle own frame toggle
const handleOwnFrameToggle = (e) => {
  const checked = e.target.checked;
  setIsOwnFrame(checked);
  
  if (checked) {
    // Set frame model to "Own Frame"
    handleInputChange({
      target: {
        name: 'frameModel',
        value: 'Own Frame'
      }
    });
    // Clear any frame search term
    setFrameSearchTerm('Own Frame');
    // Clear frame suggestions
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);
  } else {
    // Clear frame model when unchecked
    handleInputChange({
      target: {
        name: 'frameModel',
        value: ''
      }
    });
    setFrameSearchTerm('');
  }
};










// STATES
const [selectedSalesPerson, setSelectedSalesPerson] = useState('');
const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
const [enteredPassword, setEnteredPassword] = useState('');
const [passwordError, setPasswordError] = useState('');
const [verifiedSalesPerson, setVerifiedSalesPerson] = useState(null);
const [modalPerson, setModalPerson] = useState('');


// PASSWORD LIST
const salesPersonCodes = {
  'Team A': '8765',
  'Team B': '4432',
  'Team C': '3298',
  'Team D': '4567',

  'Team E': '9089',
  'Team F': '8079',
  'Team G': '7069',
  'Team H': '6059',

  'Team I': '5049',
  'Team J': '4039',
  'Team K': '3029',
  'Team L': '2019',

  'Team M': '1009',
  'Team N': '0910'
};


// SELECT SALES PERSON
const handleSalesPersonSelect = (e) => {

  const value = e.target.value;

  if (value !== '') {

    // Already verified
    if (verifiedSalesPerson === value) {
      setSelectedSalesPerson(value);
      return;
    }

    setSelectedSalesPerson(value);
    setModalPerson(value);
    setIsPasswordModalOpen(true);
    setEnteredPassword('');
    setPasswordError('');

  } else {

    setSelectedSalesPerson('');
    setModalPerson('');

  }
};


// VERIFY PASSWORD
const handlePasswordSubmit = () => {

  const expectedPassword = salesPersonCodes[modalPerson];

  if (enteredPassword === expectedPassword) {

    // Mark verified
    setVerifiedSalesPerson(modalPerson);

    // KEEP SELECTED SALES PERSON
    setSelectedSalesPerson(modalPerson);

    setIsPasswordModalOpen(false);
    setEnteredPassword('');
    setPasswordError('');
    setModalPerson('');

    alert(`✅ Access granted for ${modalPerson}`);

  } else {

    setPasswordError('❌ Incorrect password. Please try again.');

  }

};


// CLOSE MODAL
const handleModalClose = () => {

  setIsPasswordModalOpen(false);
  setSelectedSalesPerson('');
  setModalPerson('');
  setEnteredPassword('');
  setPasswordError('');

};




















// Errors state
  const [errors, setErrors] = useState({});

  // Calculate total amount
  // const totalAmount = (parseFloat(formData.lensPrice) || 0) + (parseFloat(formData.framePrice) || 0) - (parseFloat(formData.discount) || 0);
// Calculate total amount with VAT

// Calculate discount amount based on type
const calculateDiscountAmount = () => {
  const discountValue = parseFloat(formData.discount) || 0;
const subtotal =
  (parseFloat(formData.lensPrice) || 0) +
  (parseFloat(formData.framePrice) || 0) +
  (applyTint ? TINT_CHARGE : 0);
  
  if (formData.discountType === 'percentage') {
    // If percentage, calculate the actual amount
    return (discountValue / 100) * subtotal;
  } else {
    // If amount, use as is
    return discountValue;
  }
};

// // Calculate total amount with VAT
// const calculateTotalWithVAT = () => {
//   const subtotal = (parseFloat(formData.lensPrice) || 0) + (parseFloat(formData.framePrice) || 0);
//   const discountAmount = calculateDiscountAmount();
//   const subtotalAfterDiscount = subtotal - discountAmount;
  
//   if (applyVAT) {
//     const vatAmount = subtotalAfterDiscount * 0.18;
//     return subtotalAfterDiscount + vatAmount;
//   }
//   return subtotalAfterDiscount;
// };

// const totalAmount = calculateTotalWithVAT();
// const discountAmount = calculateDiscountAmount();
// const subtotalBeforeVAT = (parseFloat(formData.lensPrice) || 0) + (parseFloat(formData.framePrice) || 0) - discountAmount;
// const vatAmount = applyVAT ? subtotalBeforeVAT * 0.18 : 0;

const calculateTotalWithVAT = () => {
  const subtotal =
    (parseFloat(formData.lensPrice) || 0) +
    (parseFloat(formData.framePrice) || 0) +
    (applyTint ? TINT_CHARGE : 0);

  const discountAmount = calculateDiscountAmount();
  const subtotalAfterDiscount = subtotal - discountAmount;

  if (applyVAT) {
    const vatAmount = subtotalAfterDiscount * 0.18;
    return subtotalAfterDiscount + vatAmount;
  }

  return subtotalAfterDiscount;
};


const totalAmount = calculateTotalWithVAT();
const discountAmount = calculateDiscountAmount();
const subtotalBeforeVAT = (parseFloat(formData.lensPrice) || 0) + (parseFloat(formData.framePrice) || 0) - discountAmount;
const vatAmount = applyVAT ? subtotalBeforeVAT * 0.18 : 0;






  // Validate form
  const validateForm = () => {
      const newErrors = {};
    if (!selectedSalesPerson || selectedSalesPerson.trim() === '') {
  newErrors.salePerson = 'Sales Person is required';
}
    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
    // if (!formData.address.trim()) newErrors.address = 'Address is required';
    if (!formData.tpNo.trim()) newErrors.tpNo = 'Phone number is required';
    // if (!formData.age) newErrors.age = 'Date of Birth is required';
    // if (formData.age && (formData.age < 0 || formData.age > 120)) newErrors.age = 'Valid age is required (1-120)';
  
    
    return newErrors;
  };






// Function to generate next invoice number
const generateNextInvoiceNumber = async () => {
  try {
    const invoicesRef = collection(db, "invoices");
    const q = query(
      invoicesRef,
      orderBy("invoiceNumber", "desc"),
      limit(1)
    );

    const querySnapshot = await getDocs(q);

    // First invoice will be INV-15000
    let lastNumber = 7569;

    if (!querySnapshot.empty) {
      const lastInvoice = querySnapshot.docs[0].data();
      const lastInvoiceNum = lastInvoice.invoiceNumber || "";

      const match = lastInvoiceNum.match(/INV-(\d+)/);

      if (match) {
        lastNumber = parseInt(match[1], 10);
      }
    }

    const nextNumber = lastNumber + 1;
    const formattedNumber = `INV-${nextNumber}`;

    setCurrentInvoiceNumber(formattedNumber);
    return formattedNumber;

  } catch (error) {
    console.error("Error generating invoice number:", error);

    // Fallback
    const fallbackNumber = "INV-7570";
    setCurrentInvoiceNumber(fallbackNumber);
    return fallbackNumber;
  }
};











  // Function to refresh/snapshot the invoice number
  const refreshInvoiceNumber = async () => {
    const newNumber = await generateNextInvoiceNumber();
    return newNumber;
  };
























  // Reset form
  const handleResetForm = () => {
    setFormData({
      salePerson: '',
      title: '',
      firstName: '',
      lastName: '',
      address: '',
      tpNo: '',
      email: '',
      age: '',
      prescriptionDate: '',
      referredBy: '-',
      pd: '',
      lpd: '',
      sh: '',
      lsh: '',

      bluecut: '',
      photochromic: '',

      rightVisualAcuity: '',
      rightSph: '',
      rightCyl: '',
      rightAxis: '',
      rightAdd: '',
      rightNearVA: '',
      leftVisualAcuity: '',
      leftSph: '',
      leftCyl: '',
      leftAxis: '',
      leftAdd: '',
      leftNearVA: '',

 // ✅ HB Rx Reset
    hbRxRightVisualAcuity: '',
    hbRxRightSph: '',
    hbRxRightCyl: '',
    hbRxRightAxis: '',
    hbRxRightAdd: '',
    hbRxRightNearVA: '',
    hbRxLeftVisualAcuity: '',
    hbRxLeftSph: '',
    hbRxLeftCyl: '',
    hbRxLeftAxis: '',
    hbRxLeftAdd: '',
    hbRxLeftNearVA: '',



  highIndexLeftBrand: '',
  highIndexLeftType: '',
  highIndexLeftName: '',
  highIndexLeftPrice: '',

  highIndexRightBrand: '',
  highIndexRightType: '',
  highIndexRightName: '',
  highIndexRightPrice: '',



      lensModel: '',
      lensPrice: '',
      frameModel: '',
      framePrice: '',
      ftype: '',
      brand: '',
      colour: '',
      size: '',
      selectedFrameId: '',
      selectedLensId: '',
       ewCategory:'',
       note: '',
      deliveryDate: '',
      discount: '',
      advancePayment: '',
      billDescription: 'Frame and Lenses',
      paymentMethod: 'Cash'
    });
    setFrameSearchTerm('');
    setErrors({});
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);
  };























  const generateCustomerPrescriptionPDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  let y = 15;

  // Helper function to format date safely
  const formatDateSafe = (dateValue) => {
    if (!dateValue) return "-";
    try {
      if (dateValue.toDate) {
        return dateValue.toDate().toLocaleDateString();
      } else if (dateValue.seconds) {
        return new Date(dateValue.seconds * 1000).toLocaleDateString();
      } else if (typeof dateValue === 'string') {
        return new Date(dateValue).toLocaleDateString();
      } else if (dateValue instanceof Date) {
        return dateValue.toLocaleDateString();
      }
      return "Invalid Date";
    } catch (e) {
      return "Invalid Date";
    }
  };

  // ------------------------------
  // HEADER WITH LOGO
  // ------------------------------
  // try {
  //   doc.addImage("/house-of-vision-logo.png", "PNG", 10, y, 60, 17);
  // } catch (logoError) {
  //   console.error("Logo not found, continuing without it");
  // }

  // doc.setFont("Times New Roman", "bold");
  // doc.setFontSize(12);
  // doc.text("HOUSE OF VISION", pageWidth - 10, 20, { align: "right" });

  // doc.setFont("Times New Roman", "normal");
  // doc.setFontSize(8);
  // doc.text("No. 355, Maharagama Road, Boralesgamuwa", pageWidth - 10, 27, { align: "right" });
  // doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", pageWidth - 10, 33, { align: "right" });
  // doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", pageWidth - 10, 39, { align: "right" });
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.text(`Date: ${formatDateSafe(invoiceData.prescription?.date)}`, pageWidth - 10, 45, { align: "right" });

  y = 48;

  // ------------------------------
  // DIVIDER LINE
  // ------------------------------
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;



  // ------------------------------
  // TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("PRESCRIPTION", pageWidth / 2, y, { align: "center" });
  y += 6;



  // ------------------------------
  // WATERMARK (CENTERED)
  // ------------------------------

  
  // try {
  //   const imgProps = doc.getImageProperties("/watermark.png");
  //   const watermarkWidth = 120;
  //   const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  //   const centerX = pageWidth / 2 - watermarkWidth / 2;
  //   doc.setGState(new doc.GState({ opacity: 0.10 }));
  //   doc.addImage("/watermark.png", "PNG", centerX, 90, watermarkWidth, watermarkHeight);
  //   doc.setGState(new doc.GState({ opacity: 1 }));
  // } catch (watermarkError) {
  //   console.error("Watermark not found");
  // }



  // ------------------------------
  // PATIENT DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Patient Details", 10, y);
  y += 6;




  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);

  doc.text(`Invoice: ${invoiceData.invoiceNumber}`, 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(10);
  
//In generatePrescriptionPDF function

const calculateAge = (dob) => {
  if (!dob || dob === '-') return '-';
  
  try {
    let birthDate;
    
    // Handle different date formats
    if (dob.includes('-')) {
      const parts = dob.split('-');
      if (parts.length === 3) {
        // Format: YYYY-MM-DD
        if (parts[0].length === 4) {
          birthDate = new Date(parts[0], parts[1] - 1, parts[2]);
        } 
        // Format: DD-MM-YYYY
        else if (parts[2].length === 4) {
          birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
        }
      }
    } else if (dob.includes('.')) {
      const parts = dob.split('.');
      if (parts.length === 3) {
        // Format: DD.MM.YYYY
        if (parts[2].length === 4) {
          birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
        }
      }
    } else {
      // Try direct date parsing
      birthDate = new Date(dob);
    }
    
    if (!birthDate || isNaN(birthDate.getTime())) {
      return dob; // Return original if parsing fails
    }
    
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age; // Return just the number
  } catch (error) {
    return dob; // Return original if error
  }
};

// Use age calculation
const dobValue = invoiceData.customer?.age || invoiceData.customer?.dob || '-';
const ageDisplay = calculateAge(dobValue);

doc.text(`Name: ${invoiceData.customer.fullName}`, 10, y);
doc.text(`Age: ${ageDisplay}`, 105, y);
  y += 4;
  // doc.text(`Address: ${invoiceData.customer.address || "-"}`, 10, y);
  // doc.text(`Tel: ${invoiceData.customer.tpNo}`, 105, y);


  // y += 6;

  /////////////////////////////////////////////////////////////////////////////



    // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

 
 doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text("Lens Details", 10, y);
  y += 6;



// Helper function to get lens data from invoice
const getLensData = (invoiceData) => {
  if (!invoiceData?.products) {
    return {
      leftLens: {},
      rightLens: {}
    };
  }

  const { products } = invoiceData;

  // --------------------------------------------------
  // CASE 1: High Index Lenses
  // --------------------------------------------------
  if (products.highIndexLens === true) {
    return {
      leftLens: products.highIndexLeft || {},
      rightLens: products.highIndexRight || {}
    };
  }

  // --------------------------------------------------
  // CASE 2: Regular Left / Right Lens Objects
  // --------------------------------------------------
  if (products.leftLens || products.rightLens) {
    return {
      leftLens: products.leftLens || {},
      rightLens: products.rightLens || {}
    };
  }

  // --------------------------------------------------
  // CASE 3: lensModel string
  // Example:
  // LEFT: Single Vision Eyelux HD BlueCut Photochromic
  // RIGHT: Single Vision Eyelux HD BlueCut Photochromic
  // --------------------------------------------------
  if (products.lensModel) {
    const lensModel = products.lensModel;

    let leftName = "";
    let rightName = "";

    // Extract LEFT:
    const leftMatch = lensModel.match(
      /LEFT:\s*(.*?)(?=\s+RIGHT:|$)/i
    );

    // Extract RIGHT:
    const rightMatch = lensModel.match(
      /RIGHT:\s*(.*)$/i
    );

    if (leftMatch) {
      leftName = leftMatch[1].trim();
    }

    if (rightMatch) {
      rightName = rightMatch[1].trim();
    }

    // If LEFT / RIGHT format was not found,
    // treat the whole value as a single lens name.
    if (!leftName && !rightName) {
      leftName = lensModel.trim();
    }

    return {
      leftLens: {
        brand: "-",
        type: "-",
        name: leftName || "-"
      },

      rightLens: {
        brand: "-",
        type: "-",
        name: rightName || "-"
      }
    };
  }

  // --------------------------------------------------
  // CASE 4: Products Array
  // --------------------------------------------------
  if (Array.isArray(invoiceData.productsArray)) {
    const lensItems = invoiceData.productsArray.filter(item =>
      ["lens", "lenses"].includes(
        (item.category || "").toLowerCase()
      )
    );

    if (lensItems.length > 0) {
      const lensName = lensItems
        .map(item =>
          `${item.brand || ""} ${item.modelNo || ""}`.trim()
        )
        .filter(name => name)
        .join(" / ");

      return {
        leftLens: {
          brand: "-",
          type: "-",
          name: lensName || "-"
        },
        rightLens: {
          brand: "-",
          type: "-",
          name: "-"
        }
      };
    }
  }

  // --------------------------------------------------
  // DEFAULT
  // --------------------------------------------------
  return {
    leftLens: {},
    rightLens: {}
  };
};


// Get lens data
const { leftLens, rightLens } = getLensData(invoiceData);


// LEFT LENS - Same print structure
const leftText = `Left Lens : ${leftLens.brand || "-"}, ${leftLens.type || "-"}, ${leftLens.name || "-"}`;
doc.text(leftText, 10, y);
y += 4;


// RIGHT LENS - Same print structure
const rightText = `Right Lens : ${rightLens.brand || "-"}, ${rightLens.type || "-"}, ${rightLens.name || "-"}`;
doc.text(rightText, 10, y);

y += 6;





if (invoiceData.products.bluecut === "Yes") {
  doc.text("Blue Cut: Yes", 10, y);
}

if (invoiceData.products.photochromic === "Yes") {
  doc.text("Photochromic: Yes", 70, y);
}


y += 6;
  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // ------------------------------
  // PRESCRIPTION SECTION WITH NAVY BLUE BAR
  // ------------------------------
  doc.setFillColor(0, 0, 128);
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Prescription (Rx)", 12, y);


y += 8;


// ------------------------------
// PRESCRIPTION TABLE - A5 OPTIMIZED
// ------------------------------

const p = invoiceData.prescription || {};

// Table dimensions
const tableWidth = 120;
const tableStartX = (pageWidth - tableWidth) / 2;
const rowHeight = 8;
const fontSize = 10;

// Column widths - adjusted for 8 columns (removed SH, kept Near VA)
const colWidths = {
    eye: 30,    // "Right Eye"/"Left Eye"
    sph: 17,
    cyl: 17,
    axis: 16,
    add: 14,
    va: 14,
    nearVA: 14,  // Near VA column
    pd: 14
};

// Calculate total: 30 + 17*3 + 14*4 = 30 + 51 + 56 = 137
// Adjust to fit tableWidth: scale proportionally
const totalCols = 8;
const remainingWidth = tableWidth - (colWidths.eye + colWidths.sph + colWidths.cyl + colWidths.axis + colWidths.add + colWidths.va + colWidths.nearVA + colWidths.pd);
// Distribute remaining width equally
const extraWidth = remainingWidth / totalCols;

// Final column positions
let colPos = {
    eye: tableStartX,
    sph: tableStartX + colWidths.eye + extraWidth,
    cyl: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth,
    axis: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth + colWidths.cyl + extraWidth,
    add: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth + colWidths.cyl + extraWidth + colWidths.axis + extraWidth,
    va: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth + colWidths.cyl + extraWidth + colWidths.axis + extraWidth + colWidths.add + extraWidth,
    nearVA: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth + colWidths.cyl + extraWidth + colWidths.axis + extraWidth + colWidths.add + extraWidth + colWidths.va + extraWidth,
    pd: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth + colWidths.cyl + extraWidth + colWidths.axis + extraWidth + colWidths.add + extraWidth + colWidths.va + extraWidth + colWidths.nearVA + extraWidth
};

// Header
doc.setLineWidth(0.2);
doc.setFont("Times New Roman", "bold");
doc.setFontSize(fontSize);
doc.setFillColor(0, 0, 128); // Navy blue
doc.rect(tableStartX, y, tableWidth, rowHeight, "F");
doc.setTextColor(255, 255, 255);

// Header text - centered in columns (updated labels)
const headerLabels = ["Eye", "SPH", "CYL", "AXIS", "ADD", "D VA", "N VA", "PD"];
const colKeys = ["eye", "sph", "cyl", "axis", "add", "va", "nearVA", "pd"];

headerLabels.forEach((label, i) => {
    const key = colKeys[i];
    const x = colPos[key] + (colWidths[key] + extraWidth) / 2;
    doc.text(label, x, y + 5.5, { align: "center" });
});

// Vertical lines in header
doc.setDrawColor(255, 255, 255);
colKeys.forEach(key => {
    doc.line(colPos[key], y, colPos[key], y + rowHeight);
});
doc.line(tableStartX + tableWidth, y, tableStartX + tableWidth, y + rowHeight);

y += rowHeight;
doc.setTextColor(0, 0, 0);
doc.setDrawColor(0, 0, 0);
doc.setFont("Times New Roman", "bold");

// Right Eye Row
doc.setFillColor(248, 250, 252);
doc.rect(tableStartX, y, tableWidth, rowHeight, "F");
doc.rect(tableStartX, y, tableWidth, rowHeight);

// Data arrays for rows (removed sh and lsh, added nearVA)
const rightEyeData = [
    "Right Eye",
    p.rightEye?.sph || "-",
    p.rightEye?.cyl || "-",
    p.rightEye?.axis != null && p.rightEye?.axis !== ""
    ? `${p.rightEye.axis}°`
    : "-",
    p.rightEye?.add || "-",
    p.rightEye?.visualAcuity || "-",
    p.rightEye?.nearVA || "-",  // Near VA
    p.pd || "-"
];

const leftEyeData = [
    "Left Eye",
    p.leftEye?.sph || "-",
    p.leftEye?.cyl || "-",
    p.leftEye?.axis != null && p.leftEye?.axis !== ""
    ? `${p.leftEye.axis}°`
    : "-",
    p.leftEye?.add || "-",
    p.leftEye?.visualAcuity || "-",
    p.leftEye?.nearVA || "-",  // Near VA
    p.lpd || "-"
];

// Function to draw a row
function drawRow(data, yPos) {
    data.forEach((value, i) => {
        const key = colKeys[i];
        const x = colPos[key] + (colWidths[key] + extraWidth) / 2;
        doc.text(String(value), x, yPos + 5.5, { align: "center" });
    });
    
    // Vertical lines
    colKeys.forEach(key => {
        doc.line(colPos[key], yPos, colPos[key], yPos + rowHeight);
    });
    doc.line(tableStartX + tableWidth, yPos, tableStartX + tableWidth, yPos + rowHeight);
}

// Draw right eye row
drawRow(rightEyeData, y);
y += rowHeight;

// Left Eye Row
doc.rect(tableStartX, y, tableWidth, rowHeight);
drawRow(leftEyeData, y);
y += rowHeight + 4; // Spacing after table

// ------------------------------
// DIVIDER
// ------------------------------
doc.line(10, y, pageWidth - 10, y);
y += 2;





// ------------------------------
// HB Rx SECTION - ONLY PRINT IF DATA EXISTS
// ------------------------------
// ------------------------------
// HB Rx SECTION - ONLY PRINT IF DATA EXISTS
// ------------------------------

// Check if HB Rx has any data
const hasHbRx = invoiceData.hbRx && (
  (invoiceData.hbRx.rightEye?.sph && invoiceData.hbRx.rightEye?.sph !== '') ||
  (invoiceData.hbRx.rightEye?.cyl && invoiceData.hbRx.rightEye?.cyl !== '') ||
  (invoiceData.hbRx.leftEye?.sph && invoiceData.hbRx.leftEye?.sph !== '') ||
  (invoiceData.hbRx.leftEye?.cyl && invoiceData.hbRx.leftEye?.cyl !== '')
);

if (hasHbRx) {
  // HB Rx Header
  y += 4;
  doc.setFillColor(0, 100, 0); // Dark green for HB Rx
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("HB Rx", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 8;

  // HB Rx Table Dimensions
  const hbTableWidth = 130; // Increased width to accommodate 7 columns
  const hbTableStartX = (pageWidth - hbTableWidth) / 2;
  const hbRowHeight = 8;
  const hbFontSize = 10;

  // Column widths for HB Rx (7 columns - added VA)
  const hbColWidths = {
    eye: 30,
    sph: 18,
    cyl: 18,
    axis: 16,
    add: 14,
    va: 16,      // Visual Acuity
    nearVA: 16   // Near Visual Acuity
  };

  // Calculate total columns
  const hbTotalCols = 7;
  const hbRemainingWidth = hbTableWidth - (hbColWidths.eye + hbColWidths.sph + hbColWidths.cyl + hbColWidths.axis + hbColWidths.add + hbColWidths.va + hbColWidths.nearVA);
  const hbExtraWidth = hbRemainingWidth / hbTotalCols;

  // HB Rx Column Positions
  let hbColPos = {
    eye: hbTableStartX,
    sph: hbTableStartX + hbColWidths.eye + hbExtraWidth,
    cyl: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth,
    axis: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth + hbColWidths.cyl + hbExtraWidth,
    add: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth + hbColWidths.cyl + hbExtraWidth + hbColWidths.axis + hbExtraWidth,
    va: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth + hbColWidths.cyl + hbExtraWidth + hbColWidths.axis + hbExtraWidth + hbColWidths.add + hbExtraWidth,
    nearVA: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth + hbColWidths.cyl + hbExtraWidth + hbColWidths.axis + hbExtraWidth + hbColWidths.add + hbExtraWidth + hbColWidths.va + hbExtraWidth
  };

  // HB Rx Header
  doc.setLineWidth(0.2);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(hbFontSize);
  doc.setFillColor(0, 100, 0); // Dark green
  doc.rect(hbTableStartX, y, hbTableWidth, hbRowHeight, "F");
  doc.setTextColor(255, 255, 255);

  // Header labels with both VA and N VA
  const hbHeaderLabels = ["Eye", "SPH", "CYL", "AXIS", "ADD", "D VA", "N VA"];
  const hbColKeys = ["eye", "sph", "cyl", "axis", "add", "va", "nearVA"];

  hbHeaderLabels.forEach((label, i) => {
    const key = hbColKeys[i];
    const x = hbColPos[key] + (hbColWidths[key] + hbExtraWidth) / 2;
    doc.text(label, x, y + 5.5, { align: "center" });
  });

  // Vertical lines in HB Rx header
  doc.setDrawColor(255, 255, 255);
  hbColKeys.forEach(key => {
    doc.line(hbColPos[key], y, hbColPos[key], y + hbRowHeight);
  });
  doc.line(hbTableStartX + hbTableWidth, y, hbTableStartX + hbTableWidth, y + hbRowHeight);

  y += hbRowHeight;
  doc.setTextColor(0, 0, 0);
  doc.setDrawColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");

  // HB Rx Data arrays (with both VA and Near VA)
  const hbRightEyeData = [
    "Right Eye",
    invoiceData.hbRx?.rightEye?.sph || "-",
    invoiceData.hbRx?.rightEye?.cyl || "-",
    invoiceData.hbRx?.rightEye?.axis || "-",
    invoiceData.hbRx?.rightEye?.add || "-",
    invoiceData.hbRx?.rightEye?.visualAcuity || "-",  // VA
    invoiceData.hbRx?.rightEye?.nearVA || "-"         // N VA
  ];

  const hbLeftEyeData = [
    "Left Eye",
    invoiceData.hbRx?.leftEye?.sph || "-",
    invoiceData.hbRx?.leftEye?.cyl || "-",
    invoiceData.hbRx?.leftEye?.axis || "-",
    invoiceData.hbRx?.leftEye?.add || "-",
    invoiceData.hbRx?.leftEye?.visualAcuity || "-",   // VA
    invoiceData.hbRx?.leftEye?.nearVA || "-"          // N VA
  ];

  // Function to draw HB Rx row
  function drawHbRow(data, yPos) {
    data.forEach((value, i) => {
      const key = hbColKeys[i];
      const x = hbColPos[key] + (hbColWidths[key] + hbExtraWidth) / 2;
      doc.text(String(value), x, yPos + 5.5, { align: "center" });
    });
    
    // Vertical lines
    hbColKeys.forEach(key => {
      doc.line(hbColPos[key], yPos, hbColPos[key], yPos + hbRowHeight);
    });
    doc.line(hbTableStartX + hbTableWidth, yPos, hbTableStartX + hbTableWidth, yPos + hbRowHeight);
  }

  // Draw HB Rx Right Eye row
  doc.setFillColor(248, 250, 252);
  doc.rect(hbTableStartX, y, hbTableWidth, hbRowHeight, "F");
  doc.rect(hbTableStartX, y, hbTableWidth, hbRowHeight);
  drawHbRow(hbRightEyeData, y);
  y += hbRowHeight;

  // Draw HB Rx Left Eye row
  doc.rect(hbTableStartX, y, hbTableWidth, hbRowHeight);
  drawHbRow(hbLeftEyeData, y);
  y += hbRowHeight + 4;

  // HB Rx Divider
  doc.line(10, y, pageWidth - 10, y);
  y += 8;
}
y += 4;





  doc.setFontSize(9);
  doc.text(`Note: ${invoiceData.note || "-"}`, 10, y);
  y += 4;
  



  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`${invoiceData.invoiceNumber}_PRESCRIPTION.pdf`);
};














  
  
    const generateOrderForm = (invoiceData) => {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: [148 , 105]  // Width: 148mm, Height: 110mm
      });
  
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      let y = 8;
  
      // Helper function to format date safely (from original)
      const formatDateSafe = (dateValue) => {
        if (!dateValue) return "-";
        try {
          if (dateValue.toDate) {
            return dateValue.toDate().toLocaleDateString();
          } else if (dateValue.seconds) {
            return new Date(dateValue.seconds * 1000).toLocaleDateString();
          } else if (typeof dateValue === 'string') {
            return new Date(dateValue).toLocaleDateString();
          } else if (dateValue instanceof Date) {
            return dateValue.toLocaleDateString();
          }
          return "Invalid Date";
        } catch (e) {
          return "Invalid Date";
        }
      };
  
      // Calculate age function (from original)
      const calculateAge = (dob) => {
        if (!dob || dob === '-') return '-';
        
        try {
          let birthDate;
          
          if (dob.includes('-')) {
            const parts = dob.split('-');
            if (parts.length === 3) {
              if (parts[0].length === 4) {
                birthDate = new Date(parts[0], parts[1] - 1, parts[2]);
              } else if (parts[2].length === 4) {
                birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
              }
            }
          } else if (dob.includes('.')) {
            const parts = dob.split('.');
            if (parts.length === 3) {
              if (parts[2].length === 4) {
                birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
              }
            }
          } else {
            birthDate = new Date(dob);
          }
          
          if (!birthDate || isNaN(birthDate.getTime())) {
            return dob;
          }
          
          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          
          return age;
        } catch (error) {
          return dob;
        }
      };
  
      // ============================================================
      // HEADER - HOUSE OF VISION
      // ============================================================
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(12);
      doc.text("HOUSE OF VISION", pageWidth / 2, y, { align: "center" });
      y += 5;
  
      doc.setFont("Times New Roman", "normal");
      doc.setFontSize(7);
      doc.text("No. 355, Maharagama Rd, Boralesgamuwa", pageWidth / 2, y, { align: "center" });
      y += 4;
      doc.text("Tel. 077 2020261 / 077 2020578", pageWidth / 2, y, { align: "center" });
      y += 6;
  
      // Divider
      doc.setLineWidth(0.2);
      doc.line(5, y, pageWidth - 5, y);
      y += 4;
  
      // ============================================================
      // TITLE - ORDER FORM
      // ============================================================
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(10);
      doc.text("ORDER FORM", pageWidth / 2, y, { align: "center" });
      y += 6;
  
      // ============================================================
      // DATE & INVOICE
      // ============================================================
      doc.setFont("Times New Roman", "normal");
      doc.setFontSize(9);
      
      // Use formatDateSafe for date
      const dateDisplay = invoiceData.prescription?.date 
        ? formatDateSafe(invoiceData.prescription.date) 
        : (invoiceData.date || '-');
      
      doc.text(`Date : ${dateDisplay}`, 5, y);
  
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(11);
      doc.text(`Invoice : ${invoiceData.invoiceNumber || '-'}`, pageWidth - 5, y, { align: "right" });
      y += 5;
      doc.setFont("Times New Roman", "normal");
      doc.setFontSize(9);
      // ============================================================
      // NAME & AGE (using calculateAge from original)
      // ============================================================
      const dobValue = invoiceData.customer?.age || invoiceData.customer?.dob || '-';
      const ageDisplay = calculateAge(dobValue);
      
      doc.text(`Name : ${invoiceData.customer?.fullName || '-'}`, 5, y);
      doc.text(`Age : ${ageDisplay}`, pageWidth - 5, y, { align: "right" });
      y += 6;
  
      // Divider
      doc.line(5, y, pageWidth - 5, y);
      y += 5;
  
      // ============================================================
  // PRESCRIPTION TABLE
  // ============================================================
  const tableX = 10;
  const tableWidth = pageWidth - 20;
  const rowHeight = 7;
  
  const headers = ["Eye", "SPH", "CYL", "AXIS", "ADD"];
  const colCount = headers.length;
  const colWidth = tableWidth / colCount;
  
  // Header Background
  doc.setFillColor(0, 0, 128);
  doc.rect(tableX, y, tableWidth, rowHeight, "F");
  
  // Draw Header Cells
  doc.setDrawColor(0);
  for (let i = 0; i < colCount; i++) {
    doc.rect(tableX + i * colWidth, y, colWidth, rowHeight);
  }
  
  doc.setTextColor(255, 255, 255);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  
  headers.forEach((header, i) => {
    doc.text(
      header,
      tableX + i * colWidth + colWidth / 2,
      y + 4.8,
      { align: "center" }
    );
  });
  
  y += rowHeight;
  
  // Prescription Data
  const p = invoiceData.prescription || {};
  
  const rows = [
    [
      "Right",
      p.rightEye?.sph || "-",
      p.rightEye?.cyl || "-",
      p.rightEye?.axis !== "" && p.rightEye?.axis != null ? `${p.rightEye.axis}°` : "-",
      p.rightEye?.add || "-"
    ],
    [
      "Left",
      p.leftEye?.sph || "-",
      p.leftEye?.cyl || "-",
      p.leftEye?.axis !== "" && p.leftEye?.axis != null ? `${p.leftEye.axis}°` : "-",
      p.leftEye?.add || "-"
    ]
  ];
  
  // Data Rows
  doc.setFont("Times New Roman", "bold");
  doc.setTextColor(0, 0, 0);
  
  rows.forEach(row => {
    row.forEach((value, i) => {
      // Cell border
      doc.rect(tableX + i * colWidth, y, colWidth, rowHeight);
  
      // Cell text
      doc.text(
        String(value),
        tableX + i * colWidth + colWidth / 2,
        y + 4.8,
        { align: "center" }
      );
    });
  
    y += rowHeight;
  });
  
  y += 6;
  
  
       doc.setFont("Times New Roman", "normal");
    doc.setFontSize(9);
    y += 6;
  
  
  
  // Helper function to get lens data from invoice
const getLensData = (invoiceData) => {
  if (!invoiceData?.products) {
    return {
      leftLens: {},
      rightLens: {}
    };
  }

  const { products } = invoiceData;

  // --------------------------------------------------
  // CASE 1: High Index Lenses
  // --------------------------------------------------
  if (products.highIndexLens === true) {
    return {
      leftLens: products.highIndexLeft || {},
      rightLens: products.highIndexRight || {}
    };
  }

  // --------------------------------------------------
  // CASE 2: Regular Left / Right Lens Objects
  // --------------------------------------------------
  if (products.leftLens || products.rightLens) {
    return {
      leftLens: products.leftLens || {},
      rightLens: products.rightLens || {}
    };
  }

  // --------------------------------------------------
  // CASE 3: lensModel string
  // Example:
  // LEFT: Single Vision Eyelux HD BlueCut Photochromic
  // RIGHT: Single Vision Eyelux HD BlueCut Photochromic
  // --------------------------------------------------
  if (products.lensModel) {
    const lensModel = products.lensModel;

    let leftName = "";
    let rightName = "";

    // Extract LEFT:
    const leftMatch = lensModel.match(
      /LEFT:\s*(.*?)(?=\s+RIGHT:|$)/i
    );

    // Extract RIGHT:
    const rightMatch = lensModel.match(
      /RIGHT:\s*(.*)$/i
    );

    if (leftMatch) {
      leftName = leftMatch[1].trim();
    }

    if (rightMatch) {
      rightName = rightMatch[1].trim();
    }

    // If LEFT / RIGHT format was not found,
    // treat the whole value as a single lens name.
    if (!leftName && !rightName) {
      leftName = lensModel.trim();
    }

    return {
      leftLens: {
        brand: "-",
        type: "-",
        name: leftName || "-"
      },

      rightLens: {
        brand: "-",
        type: "-",
        name: rightName || "-"
      }
    };
  }

  // --------------------------------------------------
  // CASE 4: Products Array
  // --------------------------------------------------
  if (Array.isArray(invoiceData.productsArray)) {
    const lensItems = invoiceData.productsArray.filter(item =>
      ["lens", "lenses"].includes(
        (item.category || "").toLowerCase()
      )
    );

    if (lensItems.length > 0) {
      const lensName = lensItems
        .map(item =>
          `${item.brand || ""} ${item.modelNo || ""}`.trim()
        )
        .filter(name => name)
        .join(" / ");

      return {
        leftLens: {
          brand: "-",
          type: "-",
          name: lensName || "-"
        },
        rightLens: {
          brand: "-",
          type: "-",
          name: "-"
        }
      };
    }
  }

  // --------------------------------------------------
  // DEFAULT
  // --------------------------------------------------
  return {
    leftLens: {},
    rightLens: {}
  };
};


// Get lens data
const { leftLens, rightLens } = getLensData(invoiceData);


// LEFT LENS - Same print structure
const leftText = `Left Lens : ${leftLens.brand || "-"}, ${leftLens.type || "-"}, ${leftLens.name || "-"}`;
doc.text(leftText, 10, y);
y += 4;


// RIGHT LENS - Same print structure
const rightText = `Right Lens : ${rightLens.brand || "-"}, ${rightLens.type || "-"}, ${rightLens.name || "-"}`;
doc.text(rightText, 10, y);

y += 6;


  
          doc.setFont("Times New Roman", "normal");
      doc.setFontSize(9);
  if (invoiceData.products.bluecut === "Yes") {
    doc.text("Blue Cut: Yes", 10, y);
  }
  
  if (invoiceData.products.photochromic === "Yes") {
    doc.text("Photochromic: Yes", 70, y);
  }
  
  
  
  
  
  
      // ============================================================
      // SAVE PDF
      // ============================================================
      doc.save(`${invoiceData.invoiceNumber || 'ORDER'}_FORM.pdf`);
    };
  














const generateFullInvoicePDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 12; // Start from 8mm from top edge (was 15)

  // Safe date formatting function
  const formatDateSafe = (dateValue) => {
    if (!dateValue) return "Not set";
    try {
      if (dateValue && typeof dateValue.toDate === 'function') {
        return dateValue.toDate().toLocaleDateString();
      }
      if (dateValue && dateValue.seconds) {
        return new Date(dateValue.seconds * 1000).toLocaleDateString();
      }
      if (dateValue instanceof Date) {
        return dateValue.toLocaleDateString();
      }
      if (typeof dateValue === 'string') {
        const parsedDate = new Date(dateValue);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toLocaleDateString();
        }
      }
      return "Invalid date";
    } catch (error) {
      console.error('Date formatting error:', error);
      return "Invalid date";
    }
  };

  // ------------------------------
  // HEADER WITH LOGO (MOVED UP)
  // ------------------------------
  // try {
  //   doc.addImage("/house-of-vision-logo.png", "PNG", 10, y, 60, 17); // Reduced from 35 to 30
  // } catch (logoError) {
  //   console.error("Logo not found, continuing without it");
  // }

  // doc.setFont("Times New Roman", "bold");
  // doc.setFontSize(14); // Reduced from 12
  // doc.text("HOUSE OF VISION", pageWidth - 10, y + 8, { align: "right" });

  // doc.setFont("Times New Roman", "normal");
  // doc.setFontSize(9); // Reduced from 8
  // doc.text("No. 355, Maharagama Road, Boralesgamuwa", pageWidth - 10, y + 14, { align: "right" });
  // doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", pageWidth - 10, y + 19, { align: "right" });
  // doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", pageWidth - 10, y + 24, { align: "right" });
    doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  // doc.text(`Date: ${formatDateSafe(invoiceData.prescription?.date)}`, pageWidth - 10, y + 29, { align: "right" });



  y = 43; // Adjusted new position after header (was 54)

  // ------------------------------
  // DIVIDER LINE
  // ------------------------------
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 4;

  // ------------------------------
  // TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(12); // Reduced from 11
  doc.text("INVOICE", pageWidth / 2, y, { align: "center" });
  y += 5;

  // ------------------------------
  // WATERMARK (CENTERED)
  // ------------------------------
  // try {
  //   const imgProps = doc.getImageProperties("/watermark.png");
  //   const watermarkWidth = 100; // Reduced from 120
  //   const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  //   const centerX = pageWidth / 2 - watermarkWidth / 2;
  //   doc.setGState(new doc.GState({ opacity: 0.10 }));
  //   doc.addImage("/watermark.png", "PNG", centerX, 70, watermarkWidth, watermarkHeight);
  //   doc.setGState(new doc.GState({ opacity: 1 }));
  // } catch (watermarkError) {
  //   console.error("Watermark not found");
  // }

  // ------------------------------
  // PATIENT DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10); // Reduced from 10
  doc.text("Patient Details", 10, y);
  y += 5;

// Invoice Row
doc.setFont("Times New Roman", "normal");
doc.setFontSize(10);
doc.text(`Date: ${formatDateSafe(invoiceData.prescription?.date)}`, 10, y);
doc.setFont("Times New Roman", "bold");
doc.text(`Invoice: ${invoiceData.invoiceNumber}`, 110, y);
y += 6;
doc.setFont("Times New Roman", "normal");
doc.setFontSize(10);
doc.text(`Name: ${invoiceData.customer.fullName}`, 10, y);
doc.text(`Tel: ${invoiceData.customer.tpNo}`, 90, y);

y += 8;



  // ------------------------------
  // PRODUCT DETAILS SECTION WITH NAVY BLUE BAR
  // ------------------------------
//  doc.setFillColor(200, 200, 200);
  doc.setFillColor(0, 0, 128);
  doc.rect(10, y - 3, pageWidth - 20, 5, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Product Details", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 6;


  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9); // Reduced from 9




  
// --------------------------------------------------
// GET LENS DATA
// --------------------------------------------------
const getLensData = (invoiceData) => {
  if (!invoiceData?.products) {
    return {
      leftLens: {},
      rightLens: {}
    };
  }

  const { products } = invoiceData;

  // CASE 1: High Index Lenses
  if (products.highIndexLens === true) {
    return {
      leftLens: products.highIndexLeft || {},
      rightLens: products.highIndexRight || {}
    };
  }

  // CASE 2: Regular Left / Right Lens Objects
  if (products.leftLens || products.rightLens) {
    return {
      leftLens: products.leftLens || {},
      rightLens: products.rightLens || {}
    };
  }

  // CASE 3: lensModel only
  if (products.lensModel) {
    const lensModel = products.lensModel;

    let leftName = "";
    let rightName = "";

    const leftMatch = lensModel.match(
      /LEFT:\s*(.*?)(?=\s+RIGHT:|$)/i
    );

    const rightMatch = lensModel.match(
      /RIGHT:\s*(.*)$/i
    );

    if (leftMatch) {
      leftName = leftMatch[1].trim();
    }

    if (rightMatch) {
      rightName = rightMatch[1].trim();
    }

    // If LEFT / RIGHT is not available
    if (!leftName && !rightName) {
      leftName = lensModel.trim();
    }

    // Lens price is the total lens price,
    // so split it equally between both eyes.
    const totalLensPrice = Number(products.lensPrice || 0);
    const eachLensPrice = totalLensPrice / 2;

    return {
      leftLens: {
        brand: "-",
        type: "-",
        name: leftName || "-",
        calculatedPrice: eachLensPrice
      },

      rightLens: {
        brand: "-",
        type: "-",
        name: rightName || "-",
        calculatedPrice: eachLensPrice
      }
    };
  }

  return {
    leftLens: {},
    rightLens: {}
  };
};


// --------------------------------------------------
// GET LEFT / RIGHT LENS
// --------------------------------------------------
const { leftLens, rightLens } = getLensData(invoiceData);


// --------------------------------------------------
// LEFT LENS PRICE
// --------------------------------------------------
let leftLensPrice = 0;

if (invoiceData.products?.highIndexLens) {

  leftLensPrice = Number(leftLens.price || 0);

} else if (leftLens.calculatedPrice !== undefined) {

  leftLensPrice = Number(leftLens.calculatedPrice || 0);

} else {

  leftLensPrice = Number(leftLens.pairPrice || 0) / 2;

}


// --------------------------------------------------
// PRINT LEFT LENS
// --------------------------------------------------
doc.setFontSize(7);

const leftText = `Left Lens : ${leftLens.brand || "-"}, ${leftLens.type || "-"}, ${leftLens.name || "-"}`;

doc.text(leftText, 10, y);

doc.setFontSize(9);

doc.text(
  `Rs. ${leftLensPrice.toFixed(2)}`,
  pageWidth - 10,
  y,
  { align: "right" }
);

y += 4;


// --------------------------------------------------
// RIGHT LENS PRICE
// --------------------------------------------------
let rightLensPrice = 0;

if (invoiceData.products?.highIndexLens) {

  rightLensPrice = Number(rightLens.price || 0);

} else if (rightLens.calculatedPrice !== undefined) {

  rightLensPrice = Number(rightLens.calculatedPrice || 0);

} else {

  rightLensPrice = Number(rightLens.pairPrice || 0) / 2;

}


// --------------------------------------------------
// PRINT RIGHT LENS
// --------------------------------------------------
doc.setFontSize(7);

const rightText = `Right Lens : ${rightLens.brand || "-"}, ${rightLens.type || "-"}, ${rightLens.name || "-"}`;

doc.text(rightText, 10, y);

doc.setFontSize(9);

doc.text(
  `Rs. ${rightLensPrice.toFixed(2)}`,
  pageWidth - 10,
  y,
  { align: "right" }
);

y += 4;







  // FRAME
doc.text(
  `Frame: ${invoiceData.products?.frameModel || "-"} | ${invoiceData.products?.brand || "-"}`,
  10,
  y
);
  doc.text(`Rs. ${(invoiceData.products.framePrice || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

if (invoiceData.products.bluecut === "Yes") {
  doc.text("Blue Cut: Yes", 10, y);
}

if (invoiceData.products.photochromic === "Yes") {
  doc.text("Photochromic: Yes", 70, y);
}

 y += 6;
  // ------------------------------
  // PAYMENT DETAILS SECTION WITH NAVY BLUE BAR
  // ------------------------------
//  doc.setFillColor(200, 200, 200);
  doc.setFillColor(0, 0, 128);
  doc.rect(10, y - 3, pageWidth - 20, 5, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Payment Details", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(10);

  // Calculate values properly
  const subtotal = invoiceData.financial.subtotal || 0;
  const discount = invoiceData.financial.discount || 0;
  const subtotalAfterDiscount = subtotal - discount;
  const vatEnabled = invoiceData.financial.vatEnabled || false;
  const vatAmount = invoiceData.financial.vatAmount || 0;
  const totalAmount = invoiceData.financial.totalAmount || subtotalAfterDiscount + (vatEnabled ? vatAmount : 0);
  const advancePayment = invoiceData.financial.advancePayment || 0;
  const balanceDue = totalAmount - advancePayment;


//  doc.setFillColor(200, 200, 200);
  doc.setFillColor(200, 200, 200);
  doc.rect(10, y - 3, pageWidth - 20, 5, "F");
    doc.setTextColor(0, 0, 0);
   doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  // Subtotal
  doc.text("Subtotal", 10, y);
  doc.text(`Rs. ${subtotal.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 8;


  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(10);


// Discount (if any)
if (discount > 0) {
  // Get the discount type and value from your invoice data
  const discountType = invoiceData.financial.discountType || 'amount';
  const discountValue = invoiceData.financial.discountValue || 0;
  
  // Format the discount display based on type
  let discountLabel = "Discount";
  let discountDisplay = `Rs. ${discount.toFixed(2)}`;
  
  if (discountType === 'percentage') {
    discountLabel = `Discount (${discountValue}%)`;
    discountDisplay = `Rs. ${discount.toFixed(2)}`;
  }
  
  doc.text(discountLabel, 10, y);
  doc.text(discountDisplay, pageWidth - 10, y, { align: "right" });
  y += 6;
  
  doc.text("Subtotal (After Discount)", 10, y);
  doc.text(`Rs. ${subtotalAfterDiscount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;
}



// Additional Charges
const tintCharge = invoiceData.financial.tintCharge || 0;

if (tintCharge > 0) {
  doc.setFont("Times New Roman", "bold");
  doc.text("Additional Charges", 10, y);
  y += 4;

  doc.setFont("Times New Roman", "normal");
  doc.text("Tint Charge", 14, y);
  doc.text(`Rs. ${tintCharge.toFixed(2)}`, pageWidth - 10, y, {
    align: "right",
  });
  y += 4;
}






  // VAT Section - Show if VAT is enabled
  if (vatEnabled) {
    doc.setFont("Times New Roman", "bold");
    doc.text(`VAT (${invoiceData.financial.vatRate || 18}%)`, 10, y);
    doc.text(`Rs. ${vatAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 4;
    doc.setFont("Times New Roman", "normal");
  }

 






// PAYMENT DISPLAY LOGIC
const isFullyPaid = balanceDue <= 0;
const hasAdvancePayment = advancePayment > 0;

if (isFullyPaid) {
  // ===========================
  // FULLY PAID
  // ===========================
  doc.setFont("Times New Roman", "bold");
  doc.setTextColor(0, 0, 0);

  doc.text("Payment Status", 10, y);
  doc.text("Fully Paid", pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.text("Total Paid", 10, y);
  doc.text(`Rs. ${totalAmount.toFixed(2)}`, pageWidth - 10, y, {
    align: "right",
  });
  y += 6;

  doc.text("Payment Method", 10, y);
  doc.text(
    invoiceData.financial?.paymentMethod || "Cash",
    pageWidth - 10,
    y,
    { align: "right" }
  );
  y += 6;

  if (invoiceData.paymentDate) {
    doc.text("Payment Date", 10, y);
    doc.text(
      new Date(invoiceData.paymentDate).toLocaleDateString(),
      pageWidth - 10,
      y,
      { align: "right" }
    );
    y += 6;
  }

} else if (hasAdvancePayment) {
  // ===========================
  // PARTIALLY PAID
  // ===========================
  doc.setFont("Times New Roman", "bold");

  doc.text("Payment Status", 10, y);
  doc.text("Partially Paid", pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.setFont("Times New Roman", "normal");

  doc.text("Advance Payment", 10, y);
  doc.text(`Rs. ${advancePayment.toFixed(2)}`, pageWidth - 10, y, {
    align: "right",
  });
  y += 6;

  doc.setFont("Times New Roman", "bold");

  doc.text("Balance Due", 10, y);
  doc.text(`Rs. ${balanceDue.toFixed(2)}`, pageWidth - 10, y, {
    align: "right",
  });
  y += 6;

  doc.setFont("Times New Roman", "normal");

  doc.text("Payment Method", 10, y);
  doc.text(
    invoiceData.financial?.paymentMethod || "Cash",
    pageWidth - 10,
    y,
    { align: "right" }
  );
  y += 6;

  if (invoiceData.paymentDate) {
    doc.text("Payment Date", 10, y);
    doc.text(
      new Date(invoiceData.paymentDate).toLocaleDateString(),
      pageWidth - 10,
      y,
      { align: "right" }
    );
    y += 6;
  }

}  else {
  // ===========================
  // NO ADVANCE PAYMENT
  // ===========================
  doc.setFont("Times New Roman", "normal");

  // Show Advance Payment as 0.00
  doc.text("Advance Payment", 10, y);
  doc.text(`Rs. ${advancePayment.toFixed(2)}`, pageWidth - 10, y, {
    align: "right",
  });
  y += 6;

  // Show Balance Due
  doc.setFont("Times New Roman", "bold");
  doc.text("Balance Due", 10, y);
  doc.text(`Rs. ${balanceDue.toFixed(2)}`, pageWidth - 10, y, {
    align: "right",
  });
  y += 6;

  // Show payment method only if some payment has been made
if (advancePayment > 0) {
  doc.setFont("Times New Roman", "normal");
  doc.text("Payment Method", 10, y);
  doc.text(
    invoiceData.financial?.paymentMethod || "-",
    pageWidth - 10,
    y,
    { align: "right" }
  );
  y += 6;
}
  
}


// Reset text color
doc.setTextColor(0, 0, 0);
doc.setFont("Times New Roman", "normal");
y += 3;






  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 4;



  // doc.setFontSize(9);
  // doc.text(`Note: ${invoiceData.note || "-"}`, 10, y);
  // y += 4;

  // Served By & Delivery Date
  doc.setFontSize(7);
  doc.text(`Served By: ${invoiceData.salePerson || "-"}`, 10, y);
  y += 6;
  // doc.text(`Reffered By: ${invoiceData.prescription?.referredBy || "-"}`, 10, y);
  // y += 6;

  // ------------------------------
  // TERMS & CONDITIONS
  // ------------------------------
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(8);
  doc.text("Terms & Conditions", 10, y);
  y += 4;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);

  const terms = [
    "* Collect your order within 90 days; otherwise, it will be canceled.",
    "* Bring your order form for proper after-service assistance.",
    "* Any frame repairs or adjustments are at customer's risk and Physical damage is excluded from warranty coverage.",
    "* No cancellations once the order is confirmed.",
    "* Warranty coverage depends on the brand and service and All sales are final, No refunds after purchase",
  ];

 y += 3;

  terms.forEach(term => {
    const lines = doc.splitTextToSize(term, pageWidth - 20);
    lines.forEach(line => {
      doc.text(line, 12, y);
      y += 3.5;
    });
  });

  y += 11;


   // ------------------------------
// SIGNATURES
// ------------------------------
doc.setDrawColor(0);
doc.setLineWidth(0.2);

// Left Signature Line
doc.line(15, y, 65, y);

// Right Signature Line
doc.line(90, y, 140, y);

y += 4;

doc.setFont("Times New Roman", "bold");
doc.setFontSize(8);

// Signature Labels
doc.text("Customer Signature", 22, y);
doc.text("Authorized Signature", 96, y);


  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`${invoiceData.invoiceNumber}_FULL_INVOICE.pdf`);
};





  const generateBothPDFs = async (invoiceData) => {
    await generateCustomerPrescriptionPDF(invoiceData);
    // await generateOrderForm(invoiceData);
    await generateFullInvoicePDF(invoiceData);
  };
























  

  // Fetch frames data
  const fetchFramesData = async () => {
    try {
      const q = query(
        collection(db, "stock"),
        where("category", "==", "frame")
      );

      const querySnapshot = await getDocs(q);
      const framesList = [];

      querySnapshot.forEach(docSnap => {
        const data = docSnap.data();

        if (Array.isArray(data.items)) {
          data.items.forEach(item => {
            framesList.push({
              id: docSnap.id,
              ...item
            });
          });
        } else {
          framesList.push({
            id: docSnap.id,
            modelNo: data.modelNo,
            brand: data.brand,
            ftype: data.ftype,
            colour: data.colour,
            size: data.size,
            sellingPrice: data.sellingPrice,
            qty: data.quantity
          });
        }
      });

      setAvailableFrames(framesList);
    } catch (err) {
      console.log("Error loading frames:", err);
    }
  };

  // Fetch stock items (lenses)
  const fetchStockItems = async () => {
    try {
      const lensesQuery = query(collection(db, 'stock'), where('type', '==', 'lens'));
      const lensesSnapshot = await getDocs(lensesQuery);
      const lensesList = lensesSnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data(),
        availableQty: doc.data().quantity || 0
      }));
      setLensOptions(lensesList);
    } catch (error) {
      console.error('Error fetching lenses:', error);
    }
  };






  // Select frame
const selectFrame = (frame) => {
  if (frame.qty <= 0) {
    alert(`Frame "${frame.modelNo}" is out of stock!`);
    return;
  }

  setSelectedFramePrice(Number(frame.sellingPrice)); // <-- ADD THIS

  setFrameSearchTerm(frame.modelNo);
  setShowFrameSuggestions(false);
  setFrameSuggestions([]);

    // Auto-fill formData
    setFormData(prev => ({
      ...prev,
      frameModel: frame.modelNo,
      brand: frame.brand || "",
      ftype: frame.ftype || "",
      colour: frame.colour || "",
      size: frame.size || "",
      framePrice: frame.sellingPrice || 0,
      selectedFrameId: frame.id || "",
      frameQty: frame.qty || 0
    }));
  };



   // Handle frame search
const handleFrameSearch = (text) => {
  console.log("Searching for:", text);

  setFrameSearchTerm(text);

  if (text.length < 2) {
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);
    return;
  }

  const searchText = text.toLowerCase();

  const filtered = availableFrames.filter((frame) => {

    const modelMatch =
      frame.modelNo &&
      frame.modelNo.toLowerCase().includes(searchText);

    const brandMatch =
      frame.brand &&
      frame.brand.toLowerCase().includes(searchText);

    const colorMatch =
      frame.colour &&
      frame.colour.toLowerCase().includes(searchText);

      // const sizeMatch =
      // frame.size &&
      // frame.size.toLowerCase().includes(searchText);

      const ftypeMatch =
      frame.ftype &&
      frame.ftype.toLowerCase().includes(searchText);

    const hasStock = Number(frame.qty) > 0;

    return (modelMatch || brandMatch || colorMatch || ftypeMatch) && hasStock;
  });

  console.log("Filtered suggestions:", filtered);

  setFrameSuggestions(filtered);
  setShowFrameSuggestions(true);
};


  // Save order with specific invoice number
//   const handleSaveOrderWithNumber = async (invoiceNumber) => {



//  // =============================================
//   // 2. DEDUCT STOCK FOR DIRECT SALE ITEMS (BOX ITEMS)
//   // =============================================
//   if (directSaleItems.length > 0) {
//     try {
//       // Use the same functions from direct sales
//       await reduceDirectSaleStock();
//       await createStockOutForDirectSale(invoiceNumber);
//       console.log("Direct sale stock reduced successfully");
//     } catch (error) {
//       console.error("Error processing direct sale stock:", error);
//       alert(`Stock error: ${error.message}`);
//       setIsLoading(false);
//       return;
//     }
//   }


//   const lensSelectValue = document.querySelector('select[name="lensModel"]')?.value || formData.lensModel;


//     let frameStockDoc = null;
//     let frameItemIndex = -1;
//     let currentQty = 0;
    
//     // Handle frame stock deduction
//     if (formData.selectedFrameId) {
//       const frameRef = doc(db, 'stock', formData.selectedFrameId);
//       const frameDoc = await getDoc(frameRef);
      
//       if (frameDoc.exists()) {
//         const frameData = frameDoc.data();
        
//         if (frameData.items && Array.isArray(frameData.items)) {
//           const itemIndex = frameData.items.findIndex(item => item.modelNo === formData.frameModel);
          
//           if (itemIndex !== -1) {
//             currentQty = frameData.items[itemIndex].qty || 0;
            
//             if (currentQty <= 0) {
//               alert(`Frame "${formData.frameModel}" is out of stock!`);
//               setIsLoading(false);
//               return;
//             }
            
//             const updatedItems = [...frameData.items];
//             updatedItems[itemIndex] = {
//               ...updatedItems[itemIndex],
//               qty: currentQty - 1
//             };
            
//             await updateDoc(frameRef, { items: updatedItems });
//             frameStockDoc = frameData;
//             frameItemIndex = itemIndex;
//           } else {
//             alert('Frame item not found in stock!');
//             setIsLoading(false);
//             return;
//           }
//         } else if (frameData.quantity !== undefined) {
//           currentQty = frameData.quantity;
          
//           if (currentQty <= 0) {
//             alert(`Frame "${formData.frameModel}" is out of stock!`);
//             setIsLoading(false);
//             return;
//           }
          
//           await updateDoc(frameRef, { quantity: currentQty - 1 });
//           frameStockDoc = frameData;
//         }
//       } else {
//         alert('Frame document not found!');
//         setIsLoading(false);
//         return;
//       }
//     }
    










//     // Handle lens stock deduction
//     let lensStockDoc = null;
//     if (formData.selectedLensId) {
//       const lensRef = doc(db, 'stock', formData.selectedLensId);
//       const lensDoc = await getDoc(lensRef);
      
//       if (lensDoc.exists()) {
//         const lensData = lensDoc.data();
//         currentQty = lensData.quantity || 0;
        
//         if (currentQty <= 0) {
//           alert(`Lens "${formData.lensModel}" is out of stock!`);
//           setIsLoading(false);
//           return;
//         }
        
//         await updateDoc(lensRef, { quantity: currentQty - 1 });
//         lensStockDoc = lensData;
//       } else {
//         alert('Lens document not found!');
//         setIsLoading(false);
//         return;
//       }
//     }
    
//     // Create invoice data with the permanent invoice number
// // Create invoice data with the permanent invoice number
//     // Create invoice data with the permanent invoice number
// // Create invoice data with the permanent invoice number



// const tintCharge = applyTint ? TINT_CHARGE : 0;

// // Base subtotal
// const subtotal =
//   (parseFloat(formData.lensPrice) || 0) +
//   (parseFloat(formData.framePrice) || 0);

// // Add tint BEFORE discount
// const subtotalWithTint = subtotal + tintCharge;

// // Discount
// let discountAmount = 0;
// const discountValue = parseFloat(formData.discount) || 0;
// const discountType = formData.discountType || 'amount';

// if (discountType === 'percentage') {
//   discountAmount = (discountValue / 100) * subtotalWithTint;
// } else {
//   discountAmount = discountValue;
// }

// // Don't allow discount to exceed subtotal with tint
// discountAmount = Math.min(discountAmount, subtotalWithTint);

// // Total after discount
// const subtotalAfterDiscount = subtotalWithTint - discountAmount;

// // VAT
// const vatAmountCalculated = applyVAT ? subtotalAfterDiscount * 0.18 : 0;

// // Final Total
// const totalWithVAT = subtotalAfterDiscount + vatAmountCalculated;





// const invoiceData = {
//   type: "main-invoice",
//   customer: {
//     title: formData.title,
//     firstName: formData.firstName,
//     lastName: formData.lastName,
//     fullName: `${formData.title || ''} ${formData.firstName} ${formData.lastName}`.trim(),
//     address: formData.address,
//     tpNo: formData.tpNo,
//     email: formData.email,
//     age: formData.age,
    
    
//   },
//   prescription: {
//     date: formData.prescriptionDate || new Date().toISOString().split('T')[0],
//     referredBy: formData.referredBy,
//     pd: formData.pd || '',
//     lpd: formData.lpd || '',
//     sh: formData.sh || '',
//     lsh: formData.lsh || '',
//     rightEye: {
//       visualAcuity: formData.rightVisualAcuity,
//       sph: formData.rightSph,
//       cyl: formData.rightCyl,
//       axis: formData.rightAxis,
//       add: formData.rightAdd,
//       nearVA: formData.rightNearVA
//     },
//     leftEye: {
//       visualAcuity: formData.leftVisualAcuity,
//       sph: formData.leftSph,
//       cyl: formData.leftCyl,
//       axis: formData.leftAxis,
//       add: formData.leftAdd,
//       nearVA: formData.leftNearVA
//     }
//   },
  


//   // ✅ HB Rx DATA - SAVED SEPARATELY
//   hbRx: {
//     rightEye: {
//       visualAcuity: formData.hbRxRightVisualAcuity || '',
//       sph: formData.hbRxRightSph || '',
//       cyl: formData.hbRxRightCyl || '',
//       axis: formData.hbRxRightAxis || '',
//       add: formData.hbRxRightAdd || '',
//       nearVA: formData.hbRxRightNearVA || ''
//     },
//     leftEye: {
//       visualAcuity: formData.hbRxLeftVisualAcuity || '',
//       sph: formData.hbRxLeftSph || '',
//       cyl: formData.hbRxLeftCyl || '',
//       axis: formData.hbRxLeftAxis || '',
//       add: formData.hbRxLeftAdd || '',
//       nearVA: formData.hbRxLeftNearVA || ''
//     }
//   },





//   products: {

//     bluecut:bluecut,
//    photochromic:photochromic,

//    leftLens: leftLens ? {
//     brand: leftLensBrand,
//     type: leftLensType,
//     name: leftLens.name,
//     pairPrice: leftLens.pairPrice,
//     singlePrice: leftLens.pairPrice / 2
//   } : null,

//   rightLens: rightLens ? {
//     brand: rightLensBrand,
//     type: rightLensType,
//     name: rightLens.name,
//     pairPrice: rightLens.pairPrice,
//     singlePrice: rightLens.pairPrice / 2
//   } : null,

//   // HIGH INDEX DATA
//   highIndexLens: isHighIndexLens,

//   highIndexLeft: isHighIndexLens
//     ? {
//         brand: highIndexLeftBrand,
//         type: highIndexLeftType,
//         name: highIndexLeftName,
//         price: Number(highIndexLeftPrice || 0)
//       }
//     : null,

//   highIndexRight: isHighIndexLens
//     ? {
//         brand: highIndexRightBrand,
//         type: highIndexRightType,
//         name: highIndexRightName,
//         price: Number(highIndexRightPrice || 0)
//       }
//     : null,

//   lensModel: formData.lensModel,
//   lensPrice: parseFloat(formData.lensPrice) || 0,
//   frameModel: formData.frameModel,
//   framePrice: parseFloat(formData.framePrice) || 0,
//   brand: formData.brand,
//   colour: formData.colour,
//   ftype: formData.ftype,

// },

//   financial: {
//     subtotal: subtotal,
//       tintCharge,
//   tintEnabled: applyTint,
//    discount: discountAmount || 0,
//     discountType: discountType || 'amount', // Ensure this always has a value
//     discountValue: discountValue || 0,
//     discountDisplay: discountType === 'percentage' 
//       ? `${discountValue}% (Rs. ${discountAmount.toFixed(2)})` 
//       : `Rs. ${discountAmount.toFixed(2)}`,

//     subtotalAfterDiscount: subtotalAfterDiscount, // Make sure th// Make sure this is saved
//     vatEnabled: applyVAT,
//     vatAmount: vatAmountCalculated,
//     vatRate: 18,
//     totalAmount: totalWithVAT,
//     advancePayment: parseFloat(formData.advancePayment) || 0,
//     balanceDue: totalWithVAT - (parseFloat(formData.advancePayment) || 0),
//     billDescription: formData.billDescription,
//     paymentMethod: formData.paymentMethod
//   },


//   delivery: {
//     date: formData.deliveryDate || ''
//   },
//   createdAt: new Date().toISOString(),
//   invoiceNumber: invoiceNumber,
//   status: 'pending',
//   ewCategory: formData.ewCategory,
//   note: formData.note,
//    salePerson:
//     selectedSalesPerson || "",  // ✅ CORRECT - at root level, NOT inside customer
//   eyeCamp: selectedEyeCamp || null  // Add this line
// };






// // Add this function to fetch eye camps
// const fetchEyeCamps = async () => {
//   try {
//     const snapshot = await getDocs(collection(db, "eye_camps"));
//     const camps = snapshot.docs.map(doc => ({
//       id: doc.id,
//       name: doc.data().name,
//       city: doc.data().city
//     }));
//     setEyeCamps(camps);
//   } catch (error) {
//     console.error("Error fetching eye camps:", error);
//   }
// };





//     // Save to Firestore
//     await addDoc(collection(db, 'invoices'), invoiceData);
    
//     // Create stock_out records
//     const stockOutPromises = [];
    
//     // Record frame stock out
//     if (formData.selectedFrameId && formData.frameModel) {
//       stockOutPromises.push(addDoc(collection(db, 'stock_out'), {
//         productId: formData.selectedFrameId,
//         productType: 'frame',
//         productModel: formData.frameModel,
//         brand: formData.brand,
//         ftype: formData.ftype,
//         colour: formData.colour,
//         size: formData.size,
//         quantity: 1,
//         price: parseFloat(formData.framePrice) || 0,
//         invoiceNumber: invoiceNumber,
//         customerName: `${formData.title} ${formData.firstName} ${formData.lastName}`,
//         date: new Date(),
//         type: 'sale',
//         remainingStock: frameStockDoc ? (frameStockDoc.items ? 
//           (frameStockDoc.items[frameItemIndex]?.qty - 1) : 
//           (frameStockDoc.quantity - 1)) : 0
//       }));
//     }
    
//     // Record lens stock out
//     if (formData.selectedLensId && formData.lensModel) {
//       stockOutPromises.push(addDoc(collection(db, 'stock_out'), {
//         productId: formData.selectedLensId,
//         productType: 'lens',
//         productModel: formData.lensModel,
//         quantity: 1,
//         price: parseFloat(formData.lensPrice) || 0,
//         invoiceNumber: invoiceNumber,
//         customerName: `${formData.firstName} ${formData.lastName}`,
//         date: new Date(),
//         type: 'sale',
//         remainingStock: lensStockDoc ? (lensStockDoc.quantity - 1) : 0
//       }));
//     }
    
//     await Promise.all(stockOutPromises);
    
//     // Generate PDFs
//     try {
//       await generateBothPDFs(invoiceData);
//     } catch (pdfError) {
//       console.error('PDF generation error:', pdfError);
//     }
    
//     setShowSuccess(true);
//     setTimeout(() => setShowSuccess(false), 3000);
//     handleResetForm();
    
//     // Refresh stock data
//     await fetchFramesData();
//     await fetchStockItems();
    
//     // Generate next invoice number for future use
//     await generateNextInvoiceNumber();
    
//     console.log(`Invoice ${invoiceNumber} created successfully and cannot be modified`);
//   };




const handleSaveOrderWithNumber = async (invoiceNumber) => {

  // =============================================
  // 1. PREPARE BOX ITEMS DATA
  // =============================================
  const boxItems = directSaleItems.map(item => ({
    stockDocId: item.stockDocId,
    modelNo: item.modelNo,
    brand: item.brand,
    colour: item.colour,
    category: item.category || "other",
    qty: Number(item.qty) || 1,
    price: Number(item.sellingPrice) || 0,
    total: Number(item.total) || 0
  }));

  console.log('Box items to save in invoice:', boxItems);

  // =============================================
  // 2. DEDUCT STOCK FOR DIRECT SALE ITEMS (BOX ITEMS)
  // =============================================
  if (directSaleItems.length > 0) {
    try {
      await reduceDirectSaleStock();
      await createStockOutForDirectSale(invoiceNumber);
      console.log("Direct sale stock reduced successfully");
    } catch (error) {
      console.error("Error processing direct sale stock:", error);
      alert(`Stock error: ${error.message}`);
      setIsLoading(false);
      return;
    }
  }

  // =============================================
  // 3. CALCULATE TOTALS WITH BOX ITEMS
  // =============================================
  const lensSelectValue = document.querySelector('select[name="lensModel"]')?.value || formData.lensModel;
  const tintCharge = applyTint ? TINT_CHARGE : 0;
  
  // Base subtotal (lens + frame + box items)
  const subtotal = (parseFloat(formData.lensPrice) || 0) + 
                   (parseFloat(formData.framePrice) || 0) +
                   boxItems.reduce((sum, item) => sum + item.total, 0);

  const subtotalWithTint = subtotal + tintCharge;

  // Discount
  let discountAmount = 0;
  const discountValue = parseFloat(formData.discount) || 0;
  const discountType = formData.discountType || 'amount';

  if (discountType === 'percentage') {
    discountAmount = (discountValue / 100) * subtotalWithTint;
  } else {
    discountAmount = discountValue;
  }

  discountAmount = Math.min(discountAmount, subtotalWithTint);
  const subtotalAfterDiscount = subtotalWithTint - discountAmount;
  const vatAmountCalculated = applyVAT ? subtotalAfterDiscount * 0.18 : 0;
  const totalWithVAT = subtotalAfterDiscount + vatAmountCalculated;

  // =============================================
  // 4. HANDLE FRAME STOCK DEDUCTION
  // =============================================
  let frameStockDoc = null;
  let frameItemIndex = -1;
  let currentQty = 0;
  
  if (formData.selectedFrameId) {
    const frameRef = doc(db, 'stock', formData.selectedFrameId);
    const frameDoc = await getDoc(frameRef);
    
    if (frameDoc.exists()) {
      const frameData = frameDoc.data();
      
      if (frameData.items && Array.isArray(frameData.items)) {
        const itemIndex = frameData.items.findIndex(item => item.modelNo === formData.frameModel);
        
        if (itemIndex !== -1) {
          currentQty = frameData.items[itemIndex].qty || 0;
          
          if (currentQty <= 0) {
            alert(`Frame "${formData.frameModel}" is out of stock!`);
            setIsLoading(false);
            return;
          }
          
          const updatedItems = [...frameData.items];
          updatedItems[itemIndex] = {
            ...updatedItems[itemIndex],
            qty: currentQty - 1
          };
          
          await updateDoc(frameRef, { items: updatedItems });
          frameStockDoc = frameData;
          frameItemIndex = itemIndex;
        } else {
          alert('Frame item not found in stock!');
          setIsLoading(false);
          return;
        }
      } else if (frameData.quantity !== undefined) {
        currentQty = frameData.quantity;
        
        if (currentQty <= 0) {
          alert(`Frame "${formData.frameModel}" is out of stock!`);
          setIsLoading(false);
          return;
        }
        
        await updateDoc(frameRef, { quantity: currentQty - 1 });
        frameStockDoc = frameData;
      }
    } else {
      alert('Frame document not found!');
      setIsLoading(false);
      return;
    }
  }

  // =============================================
  // 5. HANDLE LENS STOCK DEDUCTION
  // =============================================
  let lensStockDoc = null;
  if (formData.selectedLensId) {
    const lensRef = doc(db, 'stock', formData.selectedLensId);
    const lensDoc = await getDoc(lensRef);
    
    if (lensDoc.exists()) {
      const lensData = lensDoc.data();
      currentQty = lensData.quantity || 0;
      
      if (currentQty <= 0) {
        alert(`Lens "${formData.lensModel}" is out of stock!`);
        setIsLoading(false);
        return;
      }
      
      await updateDoc(lensRef, { quantity: currentQty - 1 });
      lensStockDoc = lensData;
    } else {
      alert('Lens document not found!');
      setIsLoading(false);
      return;
    }
  }

  // =============================================
  // 6. CREATE INVOICE DATA WITH BOX ITEMS
  // =============================================
  const invoiceData = {
    type: "main-invoice",
    
    // ✅ BOX ITEMS SAVED HERE
    boxItems: boxItems,
    directSaleItems: boxItems, // Also save as directSaleItems for compatibility
    
    customer: {
      title: formData.title,
      firstName: formData.firstName,
      lastName: formData.lastName,
      fullName: `${formData.title || ''} ${formData.firstName} ${formData.lastName}`.trim(),
      address: formData.address,
      tpNo: formData.tpNo,
      email: formData.email,
      age: formData.age,
    },
    
    prescription: {
      date: formData.prescriptionDate || new Date().toISOString().split('T')[0],
      referredBy: formData.referredBy,
      pd: formData.pd || '',
      lpd: formData.lpd || '',
      sh: formData.sh || '',
      lsh: formData.lsh || '',
      rightEye: {
        visualAcuity: formData.rightVisualAcuity,
        sph: formData.rightSph,
        cyl: formData.rightCyl,
        axis: formData.rightAxis,
        add: formData.rightAdd,
        nearVA: formData.rightNearVA
      },
      leftEye: {
        visualAcuity: formData.leftVisualAcuity,
        sph: formData.leftSph,
        cyl: formData.leftCyl,
        axis: formData.leftAxis,
        add: formData.leftAdd,
        nearVA: formData.leftNearVA
      }
    },
    
    hbRx: {
      rightEye: {
        visualAcuity: formData.hbRxRightVisualAcuity || '',
        sph: formData.hbRxRightSph || '',
        cyl: formData.hbRxRightCyl || '',
        axis: formData.hbRxRightAxis || '',
        add: formData.hbRxRightAdd || '',
        nearVA: formData.hbRxRightNearVA || ''
      },
      leftEye: {
        visualAcuity: formData.hbRxLeftVisualAcuity || '',
        sph: formData.hbRxLeftSph || '',
        cyl: formData.hbRxLeftCyl || '',
        axis: formData.hbRxLeftAxis || '',
        add: formData.hbRxLeftAdd || '',
        nearVA: formData.hbRxLeftNearVA || ''
      }
    },
    
    products: {
      bluecut: bluecut,
      photochromic: photochromic,
      lensModel: formData.lensModel,
      lensPrice: parseFloat(formData.lensPrice) || 0,
      frameModel: formData.frameModel,
      framePrice: parseFloat(formData.framePrice) || 0,
      brand: formData.brand,
      colour: formData.colour,
      ftype: formData.ftype,
    },
    
    // ✅ PRODUCTS ARRAY WITH ALL ITEMS (for easier restoration)
    productsArray: [
      // Frame
      ...(formData.selectedFrameId ? [{
        type: 'frame',
        stockDocId: formData.selectedFrameId,
        modelNo: formData.frameModel,
        brand: formData.brand,
        colour: formData.colour,
        price: parseFloat(formData.framePrice) || 0,
        qty: 1,
        total: parseFloat(formData.framePrice) || 0
      }] : []),
      
      // Lens
      ...(formData.selectedLensId ? [{
        type: 'lens',
        stockDocId: formData.selectedLensId,
        modelNo: formData.lensModel,
        price: parseFloat(formData.lensPrice) || 0,
        qty: 1,
        total: parseFloat(formData.lensPrice) || 0
      }] : []),
      
      // ✅ BOX ITEMS
      ...boxItems
    ],
    
    financial: {
      subtotal: subtotal,
      tintCharge: tintCharge,
      tintEnabled: applyTint,
      discount: discountAmount || 0,
      discountType: discountType || 'amount',
      discountValue: discountValue || 0,
      discountDisplay: discountType === 'percentage' 
        ? `${discountValue}% (Rs. ${discountAmount.toFixed(2)})` 
        : `Rs. ${discountAmount.toFixed(2)}`,
      subtotalAfterDiscount: subtotalAfterDiscount,
      vatEnabled: applyVAT,
      vatAmount: vatAmountCalculated,
      vatRate: 18,
      totalAmount: totalWithVAT,
      advancePayment: parseFloat(formData.advancePayment) || 0,
      balanceDue: totalWithVAT - (parseFloat(formData.advancePayment) || 0),
      billDescription: formData.billDescription,
      paymentMethod: formData.paymentMethod
    },
    
    delivery: {
      date: formData.deliveryDate || ''
    },
    
    createdAt: new Date().toISOString(),
    invoiceNumber: invoiceNumber,
    status: 'pending',
    ewCategory: formData.ewCategory,
    note: formData.note,
    salePerson: selectedSalesPerson || "",
    eyeCamp: selectedEyeCamp || null
  };

  console.log('Saving invoice with box items:', invoiceData.boxItems);

  // =============================================
  // 7. SAVE TO FIRESTORE
  // =============================================
  await addDoc(collection(db, 'invoices'), invoiceData);
  
  // =============================================
  // 8. CREATE STOCK_OUT RECORDS
  // =============================================
  const stockOutPromises = [];
  
  // Frame stock out
  if (formData.selectedFrameId && formData.frameModel) {
    stockOutPromises.push(addDoc(collection(db, 'stock_out'), {
      productId: formData.selectedFrameId,
      productType: 'frame',
      productModel: formData.frameModel,
      brand: formData.brand,
      ftype: formData.ftype,
      colour: formData.colour,
      size: formData.size,
      quantity: 1,
      price: parseFloat(formData.framePrice) || 0,
      invoiceNumber: invoiceNumber,
      customerName: `${formData.title} ${formData.firstName} ${formData.lastName}`,
      date: new Date(),
      type: 'sale',
      remainingStock: frameStockDoc ? (frameStockDoc.items ? 
        (frameStockDoc.items[frameItemIndex]?.qty - 1) : 
        (frameStockDoc.quantity - 1)) : 0
    }));
  }
  
  // Lens stock out
  if (formData.selectedLensId && formData.lensModel) {
    stockOutPromises.push(addDoc(collection(db, 'stock_out'), {
      productId: formData.selectedLensId,
      productType: 'lens',
      productModel: formData.lensModel,
      quantity: 1,
      price: parseFloat(formData.lensPrice) || 0,
      invoiceNumber: invoiceNumber,
      customerName: `${formData.firstName} ${formData.lastName}`,
      date: new Date(),
      type: 'sale',
      remainingStock: lensStockDoc ? (lensStockDoc.quantity - 1) : 0
    }));
  }
  
  await Promise.all(stockOutPromises);
  
  // =============================================
  // 9. GENERATE PDFS
  // =============================================
  try {
    await generateBothPDFs(invoiceData);
  } catch (pdfError) {
    console.error('PDF generation error:', pdfError);
  }
  
  setShowSuccess(true);
  setTimeout(() => setShowSuccess(false), 3000);
  handleResetForm();
  
  await fetchFramesData();
  await fetchStockItems();
  await generateNextInvoiceNumber();
  
  console.log(`Invoice ${invoiceNumber} created successfully with ${boxItems.length} box items`);
};









  // Main handleSaveOrder function
  const handleSaveOrder = async () => {
    // Validation
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }






    
    setIsLoading(true);
    
    try {
      // Refresh and get a new invoice number (snapshot)
      const invoiceNumber = await refreshInvoiceNumber();
      
      // Verify invoice number is unique (double-check)
      const invoiceCheckQuery = query(
        collection(db, 'invoices'),
        where('invoiceNumber', '==', invoiceNumber)
      );
      const existingInvoice = await getDocs(invoiceCheckQuery);
      
      if (!existingInvoice.empty) {
        // If somehow duplicate exists, generate another one
        console.warn('Duplicate invoice number detected, regenerating...');
        const newInvoiceNumber = await generateNextInvoiceNumber();
        await handleSaveOrderWithNumber(newInvoiceNumber);
        return;
      }
      
      await handleSaveOrderWithNumber(invoiceNumber);
      


    } catch (error) {
      console.error('Error saving order:', error);
      alert('Error saving order: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Initialize invoice number on component mount
  useEffect(() => {
    const init = async () => {
      await fetchFramesData();
      await fetchStockItems();
      await generateNextInvoiceNumber();
    };
    init();
  }, []);

  // Invoice Number Display Component
  const InvoiceNumberDisplay = () => (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      backgroundColor: '#4CAF50',
      color: 'white',
      padding: '8px 12px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: 'bold',
      zIndex: 1000
    }}>
      Next Invoice: {currentInvoiceNumber}
    </div>
  );






// Update frame stock
const updateFrameStock = async (docId, modelNo, changeQty) => {
  const ref = doc(db, "stock", docId);
  const snap = await getDoc(ref);
  const data = snap.data();

  const updatedItems = data.items.map(item =>
    item.modelNo === modelNo
      ? { ...item, qty: (item.qty || 0) + changeQty }
      : item
  );

  await updateDoc(ref, { items: updatedItems });
};

// Handle lens selection

const handleLensSelect = (e) => {
  setFormData({...formData, lensModel: e.target.value});
};





// Fetch stock on component mount
useEffect(() => {
  fetchStockItems();
}, []);








useEffect(() => {

  const leftPrice = leftLens
    ? leftLens.pairPrice / 2
    : 0;

  const rightPrice = rightLens
    ? rightLens.pairPrice / 2
    : 0;

  const totalLensPrice =
    leftPrice + rightPrice;

  setFormData(prev => ({
    ...prev,

    lensPrice: totalLensPrice.toFixed(2),

    lensModel:
      `${leftLens ? `LEFT: ${leftLens.name}` : ""} ${
        rightLens ? `RIGHT: ${rightLens.name}` : ""
      }`.trim()
  }));

}, [leftLens, rightLens]);




///////////////////////////////////// high index /////////////////////////////
useEffect(() => {

  if (isHighIndexLens) {

    const totalLensPrice =
      Number(highIndexLeftPrice || 0) +
      Number(highIndexRightPrice || 0);

    setFormData(prev => ({
      ...prev,
      lensPrice: totalLensPrice
    }));

  } else {

    const totalLensPrice =
      (leftLens?.pairPrice || 0) / 2 +
      (rightLens?.pairPrice || 0) / 2;

    setFormData(prev => ({
      ...prev,
      lensPrice: totalLensPrice
    }));

  }

}, [
  isHighIndexLens,
  leftLens,
  rightLens,
  highIndexLeftPrice,
  highIndexRightPrice
]);














/////////////////////// same patients details fetch ///////////////////////////

// Add these with your other state declarations
const [customerSearchTerm, setCustomerSearchTerm] = useState('');
const [showCustomerSearch, setShowCustomerSearch] = useState(false);
const [searchResults, setSearchResults] = useState([]);
const [isSearchingCustomer, setIsSearchingCustomer] = useState(false);
const [isEditingCustomer, setIsEditingCustomer] = useState(false);
const [existingCustomerData, setExistingCustomerData] = useState(null);

// Add this function to search for existing customers
// Function to search for existing customers
const searchExistingCustomer = async (searchTerm) => {
  if (!searchTerm || searchTerm.length < 2) {
    setSearchResults([]);
    return;
  }

  setIsSearchingCustomer(true);
  try {
    const results = [];
    const seenCustomers = new Set();
    
    // Convert search term to lowercase for case-insensitive comparison
    const searchLower = searchTerm.toLowerCase();
    
    // Get ALL invoices (or use a larger limit) to search through
    // Note: Firestore doesn't support case-insensitive queries directly
    // So we fetch data and filter client-side
    const invoicesQuery = query(
      collection(db, 'invoices'),
      orderBy('createdAt', 'desc'),
      limit(500) // Adjust based on your data size
    );
    
    const querySnapshot = await getDocs(invoicesQuery);
    
    querySnapshot.forEach(doc => {
      const data = doc.data();
      if (data.customer) {
        const customer = data.customer;
        const tpNo = customer.tpNo || '';
        
        // Check if this customer is already added
        if (seenCustomers.has(tpNo)) return;
        
        // Build searchable fields with proper fallbacks
        const firstName = (customer.firstName || '').toLowerCase();
        const lastName = (customer.lastName || '').toLowerCase();
        const fullName = (customer.fullName || '').toLowerCase();
        const phone = tpNo.toLowerCase();
        const address = (customer.address || '').toLowerCase();
        const email = (customer.email || '').toLowerCase();
        
        // Check if search term matches ANY field
        const isMatch = 
          firstName.includes(searchLower) ||
          lastName.includes(searchLower) ||
          fullName.includes(searchLower) ||
          phone.includes(searchLower) ||
          address.includes(searchLower) ||
          email.includes(searchLower);
        
        if (isMatch) {
          seenCustomers.add(tpNo);
          results.push({
            id: doc.id,
            customer: customer
          });
        }
      }
    });
    
    // Sort results by relevance (exact matches first)
    results.sort((a, b) => {
      const aFull = (a.customer.fullName || '').toLowerCase();
      const bFull = (b.customer.fullName || '').toLowerCase();
      
      // Exact match on full name gets priority
      if (aFull === searchLower && bFull !== searchLower) return -1;
      if (bFull === searchLower && aFull !== searchLower) return 1;
      
      // Starts with search term gets priority
      if (aFull.startsWith(searchLower) && !bFull.startsWith(searchLower)) return -1;
      if (bFull.startsWith(searchLower) && !aFull.startsWith(searchLower)) return 1;
      
      return aFull.localeCompare(bFull);
    });
    
    setSearchResults(results);
  } catch (error) {
    console.error('Error searching customers:', error);
    // If the query fails due to missing index, fallback to simpler search
    try {
      // Fallback: Search using simple queries
      const fallbackResults = await searchCustomersFallback(searchTerm);
      setSearchResults(fallbackResults);
    } catch (fallbackError) {
      console.error('Fallback search also failed:', fallbackError);
      setSearchResults([]);
    }
  }
  setIsSearchingCustomer(false);
};

// Fallback search function if the main query fails
const searchCustomersFallback = async (searchTerm) => {
  const results = [];
  const seenCustomers = new Set();
  const searchLower = searchTerm.toLowerCase();
  
  // Try searching by fullName first
  try {
    const fullNameQuery = query(
      collection(db, 'invoices'),
      where('customer.fullName', '>=', searchTerm),
      where('customer.fullName', '<=', searchTerm + '\uf8ff'),
      limit(100)
    );
    const snapshot = await getDocs(fullNameQuery);
    snapshot.forEach(doc => {
      const data = doc.data();
      if (data.customer && data.customer.tpNo) {
        const key = data.customer.tpNo;
        if (!seenCustomers.has(key)) {
          seenCustomers.add(key);
          results.push({ id: doc.id, customer: data.customer });
        }
      }
    });
  } catch (e) {
    console.log('Full name search failed:', e);
  }
  
  // Try searching by phone
  try {
    const phoneQuery = query(
      collection(db, 'invoices'),
      where('customer.tpNo', '>=', searchTerm),
      where('customer.tpNo', '<=', searchTerm + '\uf8ff'),
      limit(100)
    );
    const snapshot = await getDocs(phoneQuery);
    snapshot.forEach(doc => {
      const data = doc.data();
      if (data.customer && data.customer.tpNo) {
        const key = data.customer.tpNo;
        if (!seenCustomers.has(key)) {
          seenCustomers.add(key);
          results.push({ id: doc.id, customer: data.customer });
        }
      }
    });
  } catch (e) {
    console.log('Phone search failed:', e);
  }
  
  // Try searching by firstName
  try {
    const firstNameQuery = query(
      collection(db, 'invoices'),
      where('customer.firstName', '>=', searchTerm),
      where('customer.firstName', '<=', searchTerm + '\uf8ff'),
      limit(100)
    );
    const snapshot = await getDocs(firstNameQuery);
    snapshot.forEach(doc => {
      const data = doc.data();
      if (data.customer && data.customer.tpNo) {
        const key = data.customer.tpNo;
        if (!seenCustomers.has(key)) {
          seenCustomers.add(key);
          results.push({ id: doc.id, customer: data.customer });
        }
      }
    });
  } catch (e) {
    console.log('First name search failed:', e);
  }
  
  // Try searching by lastName
  try {
    const lastNameQuery = query(
      collection(db, 'invoices'),
      where('customer.lastName', '>=', searchTerm),
      where('customer.lastName', '<=', searchTerm + '\uf8ff'),
      limit(100)
    );
    const snapshot = await getDocs(lastNameQuery);
    snapshot.forEach(doc => {
      const data = doc.data();
      if (data.customer && data.customer.tpNo) {
        const key = data.customer.tpNo;
        if (!seenCustomers.has(key)) {
          seenCustomers.add(key);
          results.push({ id: doc.id, customer: data.customer });
        }
      }
    });
  } catch (e) {
    console.log('Last name search failed:', e);
  }
  
  return results;
};





// Function to select an existing customer
const selectExistingCustomer = (customerData) => {
  setExistingCustomerData(customerData);
  setFormData({
    ...formData,
    title: customerData.customer.title || '',
    firstName: customerData.customer.firstName || '',
    lastName: customerData.customer.lastName || '',
    fullName: customerData.customer.fullName || '',
    address: customerData.customer.address || '',
    tpNo: customerData.customer.tpNo || '',
    email: customerData.customer.email || '',
    age: customerData.customer.age || '',
  });
  setCustomerSearchTerm('');
  setSearchResults([]);
  setShowCustomerSearch(false);
  setIsEditingCustomer(true);
};

// Function to reset customer form for new entry
const resetCustomerForm = () => {
  setExistingCustomerData(null);
  setFormData({
    ...formData,
    title: '',
    firstName: '',
    lastName: '',
    fullName: '',
    address: '',
    tpNo: '',
    email: '',
    age: '',
  });
  setIsEditingCustomer(false);
  setCustomerSearchTerm('');
  setSearchResults([]);
};






// Update handleInputChange to update fullName
// UPDATE THE EXISTING handleInputChange (DON'T ADD A NEW ONE)
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value,
    // Auto-generate fullName when firstName or lastName changes
    fullName: name === 'firstName' || name === 'lastName' 
      ? (name === 'firstName' 
          ? `${value} ${prev.lastName || ''}`.trim()
          : `${prev.firstName || ''} ${value}`.trim())
      : name === 'fullName' ? value : prev.fullName
  }));
};














// Add this CSS for suggestions dropdown (add to your CSS file or styled-components)
const styles = `
  .suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .suggestion-item {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
  }
  
  .suggestion-item:hover {
    background-color: #f5f5f5;
  }
  
  .suggestion-details {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
  }
  
  .stock-badge {
    background: #4CAF50;
    color: white;
    padding: 2px 6px;
    border-radius: 3px;
    margin-left: 8px;
    font-size: 10px;
  }
  
  .readonly-field {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
  
  .toast-notification {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #4CAF50;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 2000;
    animation: slideIn 0.3s ease;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

// Inject styles (add this once in your component or in a CSS file)
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}





























///////////////////////////// direct sale states//////////////////////////////////////////////////////////////////////////

const [directSaleSearch, setDirectSaleSearch] = useState('');
const [directSaleSuggestions, setDirectSaleSuggestions] = useState([]);
const [showDirectSaleSuggestions, setShowDirectSaleSuggestions] = useState(false);

const [availableDirectProducts, setAvailableDirectProducts] = useState([]);
const [directSaleItems, setDirectSaleItems] = useState([]);

const [discountType, setDiscountType] = useState("amount");

const [billingDate, setBillingDate] = useState(
  new Date().toISOString().split("T")[0]
);



const [saleForm, setSaleForm] = useState({salePerson: ""});








//////////////////////////////////////////// view stock - out/////////////////////////////////////////////////////

// Add state for stock-out data
const [stockOutRecords, setStockOutRecords] = useState([]);
const [filteredStockOut, setFilteredStockOut] = useState([]);
const [stockOutSearchTerm, setStockOutSearchTerm] = useState('');
const [stockOutFilterType, setStockOutFilterType] = useState('all');
const [stockOutDateRange, setStockOutDateRange] = useState({
  start: '',
  end: ''
});
const [isLoadingStockOut, setIsLoadingStockOut] = useState(false);

// Helper function to safely format date
const formatDateSafe = (dateValue) => {
  if (!dateValue) return 'Invalid Date';
  
  try {
    // Handle Firestore Timestamp
    if (dateValue?.toDate) {
      const d = dateValue.toDate();
      if (isNaN(d.getTime())) return 'Invalid Date';
      return d.toLocaleDateString('en-GB');
    }
    
    // Handle string or number
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return 'Invalid Date';
    return d.toLocaleDateString('en-GB');
  } catch (error) {
    console.error('Date formatting error:', error);
    return 'Invalid Date';
  }
};

const formatTimeSafe = (dateValue) => {
  if (!dateValue) return 'Invalid Time';
  
  try {
    if (dateValue?.toDate) {
      const d = dateValue.toDate();
      if (isNaN(d.getTime())) return 'Invalid Time';
      return d.toLocaleTimeString('en-GB');
    }
    
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return 'Invalid Time';
    return d.toLocaleTimeString('en-GB');
  } catch (error) {
    console.error('Time formatting error:', error);
    return 'Invalid Time';
  }
};

// Fetch stock-out history
const fetchStockOutHistory = async () => {
  try {
    setIsLoadingStockOut(true);
    const stockOutQuery = query(
      collection(db, 'stock_out'),
      orderBy('date', 'desc')
    );
    const stockOutSnapshot = await getDocs(stockOutQuery);
    const records = stockOutSnapshot.docs.map(doc => {
      const data = doc.data();
      // Parse the date properly
      let dateObj;
      if (data.date?.toDate) {
        dateObj = data.date.toDate();
      } else {
        dateObj = new Date(data.date);
      }
      
      return { 
        id: doc.id, 
        ...data,
        rawDate: dateObj,
        dateFormatted: !isNaN(dateObj.getTime()) ? dateObj.toLocaleDateString('en-GB') : 'Invalid Date',
        timeFormatted: !isNaN(dateObj.getTime()) ? dateObj.toLocaleTimeString('en-GB') : 'Invalid Time'
      };
    });
    
    setStockOutRecords(records);
    setFilteredStockOut(records);
    setIsLoadingStockOut(false);
  } catch (error) {
    console.error('Error fetching stock-out history:', error);
    setIsLoadingStockOut(false);
    alert('Error fetching stock-out history: ' + error.message);
  }
};

// Filter stock-out records
const filterStockOut = () => {
  let filtered = [...stockOutRecords];
  
  // Filter by search term
  if (stockOutSearchTerm) {
    const searchLower = stockOutSearchTerm.toLowerCase();
    filtered = filtered.filter(record => 
      record.productModel?.toLowerCase().includes(searchLower) ||
      record.brand?.toLowerCase().includes(searchLower) ||
      record.customerName?.toLowerCase().includes(searchLower) ||
      record.invoiceNumber?.toLowerCase().includes(searchLower) ||
      record.colour?.toLowerCase().includes(searchLower)
    );
  }
  
  // Filter by product type
  if (stockOutFilterType !== 'all') {
    filtered = filtered.filter(record => record.productType === stockOutFilterType);
  }
  
  // Filter by date range - using rawDate for comparison
  if (stockOutDateRange.start && stockOutDateRange.start !== '') {
    const startDate = new Date(stockOutDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(record => {
      if (!record.rawDate || isNaN(record.rawDate.getTime())) return false;
      return record.rawDate >= startDate;
    });
  }
  
  if (stockOutDateRange.end && stockOutDateRange.end !== '') {
    const endDate = new Date(stockOutDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(record => {
      if (!record.rawDate || isNaN(record.rawDate.getTime())) return false;
      return record.rawDate <= endDate;
    });
  }
  
  setFilteredStockOut(filtered);
};




// Generate PDF Report
const generateStockOutReportPDF = async () => {
  const pdf = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const leftMargin = 12;
  const rightMargin = 12;

  const primaryColor = [41, 128, 185];
  const darkHeader = [15, 23, 42];

  // =========================
  // HEADER
  // =========================
  pdf.setFillColor(...darkHeader);
  pdf.rect(0, 0, pageWidth, 32, "F");

  try {
    pdf.addImage("/house-of-vision-logo.png", "PNG", leftMargin, 4, 60, 17);
  } catch (err) {
    console.log("Logo not found");
  }

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);
  pdf.setTextColor(255, 255, 255);
  pdf.text("HOUSE OF VISION", 85, 12);

  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(9);
  pdf.text("No. 355, Maharagama Road, Boralesgamuwa", 85, 18);
  pdf.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150 | Email: Info@houseofvision.lk", 85, 24);

  pdf.setFontSize(14);
  pdf.setFont("helvetica", "bold");
  pdf.text("STOCK OUT REPORT", pageWidth - rightMargin, 12, { align: "right" });

  pdf.setFontSize(9);
  pdf.setFont("helvetica", "normal");
  pdf.text(
    `Generated: ${new Date().toLocaleString('en-GB')}`,
    pageWidth - rightMargin,
    20,
    { align: "right" }
  );

  // =========================
  // DATE RANGE FILTER INFO
  // =========================
  if (stockOutDateRange.start || stockOutDateRange.end) {
    pdf.setFontSize(8);
    pdf.setTextColor(100, 100, 100);
    let filterText = "Date Filter: ";
    if (stockOutDateRange.start && stockOutDateRange.end) {
      filterText += `${formatDateSafe(stockOutDateRange.start)} to ${formatDateSafe(stockOutDateRange.end)}`;
    } else if (stockOutDateRange.start) {
      filterText += `From ${formatDateSafe(stockOutDateRange.start)}`;
    } else if (stockOutDateRange.end) {
      filterText += `Until ${formatDateSafe(stockOutDateRange.end)}`;
    }
    pdf.text(filterText, leftMargin, 36);
  }


  // =========================
  // TABLE CONFIG - Updated headers order
  // =========================
  const headers = ["Invoice No", "Date", "Type", "Model", "Frame Type", "Customer", "Qty", "Price", "Total"];
  const colWidths = [30, 25, 22, 35, 25, 40, 15, 22, 25];

  const drawTableHeader = (startY) => {
    let x = leftMargin;

    pdf.setFillColor(...primaryColor);
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(8);

    headers.forEach((h, i) => {
      pdf.rect(x, startY, colWidths[i], 8, "F");
      pdf.text(h, x + 2, startY + 5.5);
      x += colWidths[i];
    });

    return startY + 8;
  };

  // =========================
  // START POSITION
  // =========================
  let y = 44;

  // =========================
  // SUMMARY BLOCK
  // =========================
  pdf.setFontSize(11);
  pdf.setTextColor(...primaryColor);
  pdf.setFont("helvetica", "bold");
  pdf.text("SUMMARY", leftMargin, y);

  y += 7;

  pdf.setFontSize(9);
  pdf.setTextColor(0, 0, 0);
  pdf.setFont("helvetica", "normal");

 

  y += 12;

  // =========================
  // TABLE HEADER (FIRST PAGE)
  // =========================
  y = drawTableHeader(y);

  // =========================
  // TABLE ROWS
  // =========================
  pdf.setTextColor(0, 0, 0);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8);

  let rowCount = 0;
  const rowsPerPage = 20;

  for (let record of filteredStockOut) {
    if (rowCount === rowsPerPage) {
      pdf.addPage();
      y = 20;
      y = drawTableHeader(y);
      rowCount = 0;
      pdf.setTextColor(0, 0, 0);
      pdf.setFont("helvetica", "normal");
    }

    let x = leftMargin;
    
    const invoiceNumber = record.invoiceNumber || "-";
    const dateStr = formatDateSafe(record.rawDate || record.date);
   const productType = record.productType || record.category || "-";
    const productModel = (record.productModel || "-").substring(0, 25);
    const frameType = record.ftype || "-";
    const customerName = (record.customerName || "-").substring(0, 20);
    const quantity = record.quantity || 0;
    const price = record.price || 0;
    const total = price * quantity;

    const row = [
      invoiceNumber,
      dateStr,
      productType,
      productModel,
      frameType,
      customerName,
      quantity.toString(),
      `Rs.${price.toFixed(0)}`,
      `Rs.${total.toFixed(0)}`
    ];

    pdf.setDrawColor(200);

    row.forEach((cell, i) => {
      pdf.rect(x, y, colWidths[i], 6);
      pdf.text(String(cell), x + 2, y + 4.5);
      x += colWidths[i];
    });

    y += 6;
    rowCount++;
  }

  // =========================
  // FOOTER
  // =========================
  const pageCount = pdf.internal.getNumberOfPages();

  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    pdf.setTextColor(120);

    pdf.text("Optical Management System", leftMargin, pageHeight - 6);
    pdf.text(`Page ${i} of ${pageCount}`, pageWidth - rightMargin, pageHeight - 6, {
      align: "right",
    });
  }

  pdf.save(`STOCK_OUT_REPORT_${new Date().toISOString().split('T')[0]}.pdf`);
};

// Calculate summary statistics
const getStockOutSummary = () => {
  const totalItems = filteredStockOut.reduce((sum, record) => sum + (record.quantity || 0), 0);
  const totalValue = filteredStockOut.reduce((sum, record) => sum + ((record.price || 0) * (record.quantity || 0)), 0);
  const frameTotal = filteredStockOut.filter(r => r.productType === 'frame').reduce((sum, r) => sum + (r.quantity || 0), 0);
  const lensTotal = filteredStockOut.filter(r => r.productType === 'lens').reduce((sum, r) => sum + (r.quantity || 0), 0);
  
  return { totalItems, totalValue, frameTotal, lensTotal };
};

// Fetch stock-out on component mount
useEffect(() => {
  if (selectedOption === "viewStockOut") {
    fetchStockOutHistory();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  if (stockOutRecords.length > 0) {
    filterStockOut();
  }
}, [stockOutSearchTerm, stockOutFilterType, stockOutDateRange.start, stockOutDateRange.end, stockOutRecords]);

// Reset filters
const resetStockOutFilters = () => {
  setStockOutSearchTerm('');
  setStockOutFilterType('all');
  setStockOutDateRange({ start: '', end: '' });
  setFilteredStockOut(stockOutRecords);
};

// Delete stock-out record (admin only)
const deleteStockOutRecord = async (recordId) => {
  if (window.confirm('Are you sure you want to delete this record?')) {
    try {
      await deleteDoc(doc(db, 'stock_out', recordId));
      await fetchStockOutHistory();
      alert('Record deleted successfully');
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('Error deleting record: ' + error.message);
    }
  }
};




/////////////////////////////////////////////////// create balance invoice /////////////////////////////////////////////////////////////////


// State for balance invoice
const [showBalanceModal, setShowBalanceModal] = useState(false);
const [selectedInvoice, setSelectedInvoice] = useState(null);
const [balanceAmount, setBalanceAmount] = useState(0);
const [balancePaymentMethod, setBalancePaymentMethod] = useState('Cash');
const [balancePaidAmount, setBalancePaidAmount] = useState('');
const [balanceInvoices, setBalanceInvoices] = useState([]);
const [searchInvoiceNo, setSearchInvoiceNo] = useState('');
const [filteredInvoices, setFilteredInvoices] = useState([]);
const [isLoadingInvoices, setIsLoadingInvoices] = useState(false);
const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split('T')[0]);


// Cache for balance invoice numbers
const balanceNumberCache = new Map();

// OPTIMIZED: Fetch pending balance invoices with pagination
const fetchPendingBalanceInvoices = async () => {
  try {
    setIsLoadingInvoices(true);
    
    // Add limit for faster loading
    const invoicesQuery = query(
      collection(db, 'invoices'),
      where('financial.balanceDue', '>', 0), // Only fetch pending invoices
      orderBy('createdAt', 'desc'),
      limit(50) // Limit to last 50 pending invoices
    );
    
    const invoicesSnapshot = await getDocs(invoicesQuery);
    const invoicesList = [];
    
    // Process invoices in parallel
    const batchPromises = invoicesSnapshot.docs.map(async (docSnap) => {
      const invoiceData = { id: docSnap.id, ...docSnap.data() };
      const balanceDue = invoiceData.financial?.balanceDue || 0;
      
      // Only fetch balance records if needed
      let balanceRecords = [];
      if (balanceDue > 0) {
        const balanceInvoiceQuery = query(
          collection(db, 'balance_invoices'),
          where('originalInvoiceId', '==', docSnap.id),
          orderBy('balanceNumber', 'asc'),
          limit(5) // Limit balance records to last 5
        );
        const balanceSnapshot = await getDocs(balanceInvoiceQuery);
        balanceRecords = balanceSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      }
      
      return {
        ...invoiceData,
        docId: docSnap.id,
        balanceDue: balanceDue,
        hasBalanceInvoices: balanceRecords.length > 0,
        balanceRecords: balanceRecords,
        totalPaidBalance: balanceRecords.reduce((sum, record) => sum + (record.paidAmount || 0), 0)
      };
    });
    
    const results = await Promise.all(batchPromises);
    invoicesList.push(...results);
    
    setBalanceInvoices(invoicesList);
    setFilteredInvoices(invoicesList);
    setIsLoadingInvoices(false);
  } catch (error) {
    console.error('Error fetching invoices:', error);
    setIsLoadingInvoices(false);
    alert('Error fetching invoices: ' + error.message);
  }
};

// OPTIMIZED: Generate balance invoice number with caching
const generateBalanceInvoiceNumber = async (originalInvoiceNumber) => {
  // Check cache first
  if (balanceNumberCache.has(originalInvoiceNumber)) {
    const cached = balanceNumberCache.get(originalInvoiceNumber);
    const nextNumber = cached + 1;
    balanceNumberCache.set(originalInvoiceNumber, nextNumber);
    return {
      balanceInvoiceNumber: `${originalInvoiceNumber}-${nextNumber}`,
      balanceNumber: nextNumber
    };
  }

  try {
    const balanceInvoicesQuery = query(
      collection(db, 'balance_invoices'),
      where('originalInvoiceNumber', '==', originalInvoiceNumber)
    );

    const balanceSnapshot = await getDocs(balanceInvoicesQuery);
    let lastBalanceNumber = 0;

    balanceSnapshot.forEach((doc) => {
      const data = doc.data();
      if ((data.balanceNumber || 0) > lastBalanceNumber) {
        lastBalanceNumber = data.balanceNumber || 0;
      }
    });

    const nextBalanceNumber = lastBalanceNumber + 1;
    
    // Cache the result
    balanceNumberCache.set(originalInvoiceNumber, nextBalanceNumber);

    return {
      balanceInvoiceNumber: `${originalInvoiceNumber}-${nextBalanceNumber}`,
      balanceNumber: nextBalanceNumber
    };
  } catch (error) {
    console.error('Error generating balance invoice number:', error);
    return {
      balanceInvoiceNumber: `${originalInvoiceNumber}-1`,
      balanceNumber: 1
    };
  }
};

// OPTIMIZED: Search with debounce
useEffect(() => {
  const timeoutId = setTimeout(() => {
    if (searchInvoiceNo) {
      const filtered = balanceInvoices.filter(invoice => 
        invoice.invoiceNumber?.toLowerCase().includes(searchInvoiceNo.toLowerCase())
      );
      setFilteredInvoices(filtered);
    } else {
      setFilteredInvoices(balanceInvoices);
    }
  }, 300);
  
  return () => clearTimeout(timeoutId);
}, [searchInvoiceNo, balanceInvoices]);

// Optimized search handler
const handleInvoiceSearch = () => {
  if (!searchInvoiceNo.trim()) {
    setFilteredInvoices(balanceInvoices);
  } else {
    const filtered = balanceInvoices.filter(invoice => 
      invoice.invoiceNumber?.toLowerCase().includes(searchInvoiceNo.toLowerCase())
    );
    setFilteredInvoices(filtered);
  }
};

// Optimized open balance modal
const openBalanceModal = async (invoice) => {
  try {
    setIsLoading(true); // Show loading state
    const { balanceInvoiceNumber } = await generateBalanceInvoiceNumber(invoice.invoiceNumber);
    setNextBalanceInvoiceNo(balanceInvoiceNumber);
    setSelectedInvoice(invoice);
    setBalanceAmount(invoice.balanceDue);
    setBalancePaidAmount(invoice.balanceDue.toString());
    setBalancePaymentMethod('Cash');
    setPaymentDate(new Date().toISOString().split('T')[0]);
    setShowBalanceModal(true);
    setIsLoading(false);
  } catch (error) {
    console.error("Error opening modal:", error);
    setIsLoading(false);
    alert('Error opening modal: ' + error.message);
  }
};

// Fetch on component mount only once
useEffect(() => {
  if (selectedOption === "createBalanceInvoice") {
    fetchPendingBalanceInvoices();
  }
}, [selectedOption]);









// Create balance invoice
const handleCreateBalanceInvoice = async () => {
  if (!selectedInvoice) return;
  
  const paidAmount = parseFloat(balancePaidAmount);
  
  if (isNaN(paidAmount) || paidAmount <= 0) {
    alert('Please enter a valid amount');
    return;
  }
  
  if (paidAmount > selectedInvoice.balanceDue) {
    alert(`Amount cannot exceed balance due of Rs. ${selectedInvoice.balanceDue.toFixed(2)}`);
    return;
  }
  
  setIsLoading(true);
  
  try {
    // Generate balance invoice number
    const { balanceInvoiceNumber, balanceNumber } = await generateBalanceInvoiceNumber(selectedInvoice.invoiceNumber);
    
    const newBalanceDue = selectedInvoice.balanceDue - paidAmount;
    const paymentDateTime = new Date(paymentDate).toISOString();
    
    // Create balance invoice record
    const balanceInvoiceData = {
      originalInvoiceId: selectedInvoice.docId,
      originalInvoiceNumber: selectedInvoice.invoiceNumber,
      balanceNumber: balanceNumber,
      balanceInvoiceNumber: balanceInvoiceNumber,
      customerName: selectedInvoice.customer?.fullName,
      customerPhone: selectedInvoice.customer?.tpNo,
      customerAddress: selectedInvoice.customer?.address,
      originalAmount: selectedInvoice.financial?.totalAmount || 0,
      originalAdvance: selectedInvoice.financial?.advancePayment || 0,
      previousBalance: selectedInvoice.balanceDue,
      paidAmount: paidAmount,
      remainingBalance: newBalanceDue,
      paymentMethod: balancePaymentMethod,
      paymentDate: paymentDateTime,
      paymentDateOnly: paymentDate,
      status: newBalanceDue <= 0 ? 'settled' : 'partial',
      createdAt: new Date().toISOString()
    };
    
    // Save balance invoice to Firestore
    await addDoc(collection(db, 'balance_invoices'), balanceInvoiceData);
    
    // Update original invoice
    const invoiceRef = doc(db, 'invoices', selectedInvoice.docId);
    const updatedAdvancePayment = (selectedInvoice.financial?.advancePayment || 0) + paidAmount;
    const updatedBalanceDue = selectedInvoice.financial?.totalAmount - updatedAdvancePayment;
    
    await updateDoc(invoiceRef, {
      'financial.advancePayment': updatedAdvancePayment,
      'financial.balanceDue': updatedBalanceDue,
      status: updatedBalanceDue <= 0 ? 'paid' : 'pending'
    });
    
    // Generate balance invoice PDF (optional - remove if you don't have this function)
    if (typeof generateBalanceInvoicePDF === 'function') {
      await generateBalanceInvoicePDF(balanceInvoiceData, selectedInvoice);
    }
    
    alert(`Balance invoice created successfully!\nInvoice: ${balanceInvoiceNumber}\nDate: ${paymentDate}\nPaid: Rs. ${paidAmount.toFixed(2)}\nRemaining: Rs. ${newBalanceDue.toFixed(2)}`);
    
    setShowBalanceModal(false);
    setSelectedInvoice(null);
    setBalancePaidAmount('');
    setPaymentDate(new Date().toISOString().split('T')[0]);
    
    // Refresh the list
    await fetchPendingBalanceInvoices();
    
  } catch (error) {
    console.error('Error creating balance invoice:', error);
    alert('Error creating balance invoice: ' + error.message);
  } finally {
    setIsLoading(false);
  }
};



















const generateBalanceInvoicePDF = async (balanceData, originalInvoice) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a5'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  let y = 15;

  // ------------------------------
  // HEADER WITH LOGO
  // ------------------------------
  // try {
  //   doc.addImage("/house-of-vision-logo.png", "PNG", 10, y, 60, 17);
  // } catch (logoError) {
  //   console.error("Logo not found, continuing without it");
  // }

  // doc.setFont("Times New Roman", "bold");
  // doc.setFontSize(12);
  // doc.text("HOUSE OF VISION", pageWidth - 10, 20, { align: "right" });

  // doc.setFont("Times New Roman", "normal");
  // doc.setFontSize(8);
  // doc.text("No. 355, Maharagama Road, Boralesgamuwa", pageWidth - 10, 27, { align: "right" });
  // doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", pageWidth - 10, 33, { align: "right" });
  // doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", pageWidth - 10, 39, { align: "right" });
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.text(`Date: ${new Date(balanceData.paymentDate).toLocaleDateString()}`, pageWidth - 10, 45, { align: "right" });

  y = 48;

  // ------------------------------
  // DIVIDER LINE
  // ------------------------------
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // ------------------------------
  // INVOICE TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("RECEIPT", pageWidth / 2, y, { align: "center" });
  y += 6;

  // ------------------------------
  // CUSTOMER DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Customer Details", 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text(`Name: ${balanceData.customerName || '-'}`, 10, y);
  y += 6;
  doc.text(`Phone: ${balanceData.customerPhone || '-'}`, 10, y);
  y += 6;
  doc.text(`Invoice: ${balanceData.originalInvoiceNumber}`, 10, y);
  y += 6;
  doc.setFontSize(9);
  doc.text(`Receipt No: ${balanceData.balanceInvoiceNumber}`, 10, y);
  y += 6;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;



  // ------------------------------
  // PAYMENT DETAILS SECTION WITH NAVY BLUE BAR
  // ------------------------------
  doc.setFillColor(0, 0, 128);
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Payment Details", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 7;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  
  doc.text("Original Amount", 10, y);
  doc.text(`Rs. ${(balanceData.originalAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.text("Previous Advance", 10, y);
  doc.text(`Rs. ${(balanceData.originalAdvance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.text("Previous Balance", 10, y);
  doc.text(`Rs. ${(balanceData.previousBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 8;

  doc.setFont("Times New Roman", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Amount Paid", 10, y);
  doc.text(`Rs. ${(balanceData.paidAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setTextColor(0, 0, 0);
  doc.text("Payment Method", 10, y);
  doc.text(balanceData.paymentMethod || "-", pageWidth - 10, y, { align: "right" });
  y += 8;

  if ((balanceData.remainingBalance || 0) > 0) {
    doc.setFont("Times New Roman", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("Remaining Balance", 10, y);
    doc.text(`Rs. ${(balanceData.remainingBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  } else {
    doc.setFont("Times New Roman", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("Status:", 10, y);
    doc.text("Fully Paid - Thank You!", pageWidth - 10, y, { align: "right" });
  }
  y += 10;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;


   // ------------------------------
  // TERMS & CONDITIONS
  // ------------------------------
  // doc.setTextColor(0, 0, 0);
  // doc.setFont("Times New Roman", "bold");
  // doc.setFontSize(8);
  // doc.text("Terms & Conditions", 10, y);
  // y += 6;

  // doc.setFont("Times New Roman", "normal");
  // doc.setFontSize(8);
  // doc.setTextColor(0, 0, 0);

  // const terms = [
  //   "* Collect your order within 90 days; otherwise, it will be canceled.",
  //   "* Bring your order form for proper after-service assistance.",
  //   "* Any frame repairs or adjustments are at customer's risk and Physical damage is excluded from warranty coverage.",
  //   "* No cancellations once the order is confirmed.",
  //   "* Warranty coverage depends on the brand and service and All sales are final, No refunds after purchase",
  // ];



  // terms.forEach(term => {
  //   const lines = doc.splitTextToSize(term, pageWidth - 20);
  //   lines.forEach(line => {
  //     doc.text(line, 12, y);
  //     y += 4;
  //   });
  // });

  y += 15;

  // ------------------------------
  // FOOTER THANK YOU
  // ------------------------------

// doc.setFontSize(8);
// doc.setTextColor(0, 0, 0);  // RED
// doc.setFont("Times New Roman", "bolditalic");
// doc.text("Member of Mount Apollo Hospitals", pageWidth / 2, y + 5, { align: "center" });


   // ------------------------------
// SIGNATURES
// ------------------------------
doc.setDrawColor(0);
doc.setLineWidth(0.2);

// Left Signature Line
doc.line(15, y, 65, y);

// Right Signature Line
// doc.line(90, y, 140, y);

y += 4;

doc.setFont("Times New Roman", "bold");
doc.setFontSize(8);

// Signature Labels
doc.text("Authorized Signature", 22, y);
// doc.text("Customer Signature", 96, y);



  // ------------------------------
  // SAVE PDF
  // ------------------------------
  const fileName = `${balanceData.balanceInvoiceNumber}_BALANCE_INVOICE.pdf`;
  doc.save(fileName);
};


  // Fetch invoices when component mounts or when selectedOption changes
  useEffect(() => {
    if (selectedOption === "createBalanceInvoice") {
      fetchPendingBalanceInvoices();
    }
  }, [selectedOption]);











/////////////////////////////////////////////////////// view all balance invoices ////////////////////////////////////////////////////////////
// Add state for balance invoices list
const [allBalanceInvoices, setAllBalanceInvoices] = useState([]);
const [filteredBalanceInvoices, setFilteredBalanceInvoices] = useState([]);
const [balanceInvoiceSearchTerm, setBalanceInvoiceSearchTerm] = useState('');
const [balanceInvoiceFilterStatus, setBalanceInvoiceFilterStatus] = useState('all');
const [isLoadingBalanceInvoices, setIsLoadingBalanceInvoices] = useState(false);
const [selectedBalanceInvoice, setSelectedBalanceInvoice] = useState(null);
const [showBalanceInvoiceDetails, setShowBalanceInvoiceDetails] = useState(false);



// Update your fetchAllBalanceInvoices function to include upinNo and receiptNo
const fetchAllBalanceInvoices = async () => {
  try {
    setIsLoadingBalanceInvoices(true);
    const balanceInvoicesQuery = query(
      collection(db, 'balance_invoices'),
      orderBy('createdAt', 'desc')
    );
    const balanceSnapshot = await getDocs(balanceInvoicesQuery);
    const balanceList = [];
    
    for (const doc of balanceSnapshot.docs) {
      const data = doc.data();
      balanceList.push({
        id: doc.id,
        ...data,
        formattedDate: data.createdAt ? new Date(data.createdAt).toLocaleDateString() : '-',
        formattedTime: data.createdAt ? new Date(data.createdAt).toLocaleTimeString() : '-',
        statusText: data.remainingBalance <= 0 ? 'Settled' : 'Partial',
        statusColor: data.remainingBalance <= 0 ? '#4CAF50' : '#ff9800',

      });
    }
    
    setAllBalanceInvoices(balanceList);
    setFilteredBalanceInvoices(balanceList);
    setIsLoadingBalanceInvoices(false);
  } catch (error) {
    console.error('Error fetching balance invoices:', error);
    setIsLoadingBalanceInvoices(false);
    alert('Error fetching balance invoices: ' + error.message);
  }
};





// Filter balance invoices
const filterBalanceInvoices = () => {
  let filtered = [...allBalanceInvoices];
  
  // Search filter
  if (balanceInvoiceSearchTerm) {
    const searchLower = balanceInvoiceSearchTerm.toLowerCase();
    filtered = filtered.filter(invoice => 
      invoice.balanceInvoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.originalInvoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.customerName?.toLowerCase().includes(searchLower) ||
      invoice.customerPhone?.toLowerCase().includes(searchLower)
    );
  }
  
  // Status filter
  if (balanceInvoiceFilterStatus !== 'all') {
    filtered = filtered.filter(invoice => 
      balanceInvoiceFilterStatus === 'settled' ? invoice.remainingBalance <= 0 : invoice.remainingBalance > 0
    );
  }
  
  setFilteredBalanceInvoices(filtered);
};





// Download balance invoice PDF
// Replace your existing downloadBalanceInvoicePDF function with this improved version

// REPLACE your existing downloadBalanceInvoicePDF with this

const downloadBalanceInvoicePDF = async (balanceInvoice) => {
  try {
    // Fetch ALL balance invoices (payment records) for this original invoice
    const allPaymentsQuery = query(
      collection(db, 'balance_invoices'),
      where('originalInvoiceNumber', '==', balanceInvoice.originalInvoiceNumber),
      orderBy('createdAt', 'asc')
    );
    
    const allPaymentsSnapshot = await getDocs(allPaymentsQuery);
    const allPayments = [];
    
    allPaymentsSnapshot.forEach(doc => {
      const data = doc.data();
      allPayments.push({
        id: doc.id,
        date: data.createdAt,
        paidAmount: data.paidAmount || 0,
        newBalance: data.remainingBalance || 0,
        paymentMethod: data.paymentMethod,
        balanceInvoiceNumber: data.balanceInvoiceNumber
      });
    });
    
    // Fetch original invoice details
    let originalInvoiceData = null;
    const originalInvoiceQuery = query(
      collection(db, 'invoices'),
      where('invoiceNumber', '==', balanceInvoice.originalInvoiceNumber)
    );
    const originalSnapshot = await getDocs(originalInvoiceQuery);
    
    if (!originalSnapshot.empty) {
      originalInvoiceData = originalSnapshot.docs[0].data();
    }
    
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5"
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    let y = 13; // Slightly increased

    // ------------------------------
    // HEADER WITH LOGO
    // ------------------------------
    // try {
    //   doc.addImage("/house-of-vision-logo.png", "PNG", 10, y, 60, 17); // Slightly larger logo
    // } catch (logoError) {
    //   console.error("Logo not found");
    // }

    // doc.setFont("Times New Roman", "bold");
    // doc.setFontSize(12); // Increased
    // doc.text("HOUSE OF VISION", pageWidth - 10, 19, { align: "right" });

    // doc.setFont("Times New Roman", "normal");
    // doc.setFontSize(8); // Increased
    // doc.text("No. 355, Maharagama Road, Boralesgamuwa", pageWidth - 10, 25, { align: "right" });
    // doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", pageWidth - 10, 30, { align: "right" });
    // doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", pageWidth - 10, 35, { align: "right" });
      doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
    doc.text(`Date: ${balanceInvoice.formattedDate || new Date().toLocaleDateString()}`, pageWidth - 10, 40, { align: "right" });

    y = 42; // Adjusted Y position after header

    // ------------------------------
    // WATERMARK
    // ------------------------------
    // try {
    //   const imgProps = doc.getImageProperties("/watermark.png");
    //   const watermarkWidth = 110; // Slightly larger
    //   const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
    //   const centerX = pageWidth / 2 - watermarkWidth / 2;

    //   doc.setGState(new doc.GState({ opacity: 0.10 }));
    //   doc.addImage("/watermark.png", "PNG", centerX, 75, watermarkWidth, watermarkHeight);
    //   doc.setGState(new doc.GState({ opacity: 1 }));
    // } catch (watermarkError) {
    //   console.error("Watermark not found");
    // }

    // Divider
    doc.setLineWidth(0.3);
    doc.line(10, y, pageWidth - 10, y);
    y += 6;

    // ------------------------------
    // INVOICE TITLE
    // ------------------------------
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(12); // Increased
    doc.text("RECEIPT", pageWidth / 2, y, { align: "center" });
    y += 7;

    // ------------------------------
    // INVOICE DETAILS
    // ------------------------------
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(9); // Increased
    doc.text(`Original Invoice: ${balanceInvoice.originalInvoiceNumber}`, 10, y);
    y += 6;
    
    // ------------------------------
    // CUSTOMER DETAILS
    // ------------------------------
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(10); // Increased
    
    const patientLines = doc.splitTextToSize(`Customer: ${balanceInvoice.customerName || '-'}`, 70);
    doc.text(patientLines, 10, y);
    y += patientLines.length * 5 + 2;

    doc.setFontSize(9); // Increased
    doc.text(`Phone: ${balanceInvoice.customerPhone || '-'}`, 10, y);
    y += 6;

    // ------------------------------
    // TABLE HEADER (BLUE)
    // ------------------------------
    doc.setFillColor(32, 30, 244);
    doc.setTextColor(255, 255, 255);
    doc.rect(10, y, pageWidth - 20, 7, "F"); // Slightly taller

    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(9); // Increased
    doc.text("Payment Details", 12, y + 5);
    y += 11;
    doc.setTextColor(0, 0, 0);

    // ------------------------------
    // FINANCIAL SUMMARY
    // ------------------------------
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(9); // Increased
    
    doc.text("Original Amount:", 12, y);
    doc.text(`Rs ${(balanceInvoice.originalAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 5;

    doc.text("Previous Advance:", 12, y);
    doc.text(`Rs ${(balanceInvoice.originalAdvance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 5;

    doc.text("Previous Balance:", 12, y);
    doc.text(`Rs ${(balanceInvoice.originalBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 5;

    doc.line(10, y, pageWidth - 10, y);
    y += 5;

    doc.setFont("Times New Roman", "bold");
    doc.text("Amount Paid:", 12, y);
    doc.text(`Rs ${(balanceInvoice.paidAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 5;

    doc.setFont("Times New Roman", "normal");
    doc.text("Payment Method:", 12, y);
    doc.text(balanceInvoice.paymentMethod || "-", pageWidth - 10, y, { align: "right" });
    y += 5;

    if ((balanceInvoice.remainingBalance || 0) > 0) {
      doc.setFont("Times New Roman", "bold");
      doc.text("Remaining Balance:", 12, y);
      doc.text(`Rs ${(balanceInvoice.remainingBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    } else {
      doc.setFont("Times New Roman", "normal");
      doc.text("Status:", 12, y);
      doc.text("Fully Paid", pageWidth - 10, y, { align: "right" });
    }
    y += 7;
    doc.setTextColor(0, 0, 0);

    // ------------------------------
    // PAYMENT HISTORY SECTION
    // ------------------------------
    if (allPayments.length > 0) {
      doc.setFillColor(32, 30, 244);
      doc.setTextColor(255, 255, 255);
      doc.rect(10, y, pageWidth - 20, 7, "F");
      
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(9);
      doc.text("All Balance Payments", 12, y + 5);
      y += 10;
      doc.setTextColor(0, 0, 0);

      // Table headers for payment history
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(8);
      doc.text("No.", 10, y);
      doc.text("Date", 25, y);
      doc.text("Receipt No", 52, y);
      doc.text("Paid (Rs)", pageWidth - 58, y, { align: "center" });
      doc.text("Balance (Rs)", pageWidth - 20, y, { align: "right" });
      y += 5;
      
      doc.setLineWidth(0.2);
      doc.line(10, y, pageWidth - 10, y);
      y += 4;
      
      doc.setFont("Times New Roman", "normal");
      doc.setFontSize(8);
      
      // Display payments with adjusted spacing
      const displayPayments = allPayments.slice(0, 6); // Max 6 payments on one page
      
      displayPayments.forEach((payment, idx) => {
        const paymentDate = payment.date ? new Date(payment.date).toLocaleDateString() : "-";
        
        doc.text(`${idx + 1}`, 10, y);
        doc.text(paymentDate, 25, y);
        doc.text(payment.balanceInvoiceNumber || "-", 52, y);
        doc.text(`Rs ${payment.paidAmount.toFixed(2)}`, pageWidth - 58, y, { align: "center" });
        doc.text(`Rs ${payment.newBalance.toFixed(2)}`, pageWidth - 20, y, { align: "right" });
        y += 4.5;
        
        if (idx === 5 && allPayments.length > 6) {
          doc.setFont("Times New Roman", "italic");
          doc.setFontSize(7);
          doc.text(`+ ${allPayments.length - 6} more payments`, 10, y);
          doc.setFont("Times New Roman", "normal");
        }
      });
    }


y += 20;

   // ------------------------------
// SIGNATURES
// ------------------------------
doc.setDrawColor(0);
doc.setLineWidth(0.2);

// Left Signature Line
doc.line(15, y, 65, y);

// Right Signature Line
// doc.line(90, y, 140, y);

y += 4;

doc.setFont("Times New Roman", "bold");
doc.setFontSize(8);

// Signature Labels
doc.text("Authorized Signature", 22, y);
// doc.text("Customer Signature", 96, y);





    // ------------------------------
    // SAVE PDF
    // ------------------------------
    const fileName = `${balanceInvoice.balanceInvoiceNumber}_BALANCE_INVOICE.pdf`;
    doc.save(fileName);
    alert('PDF downloaded successfully!');
    
  } catch (error) {
    console.error('Error downloading PDF:', error);
    alert('Error downloading PDF: ' + error.message);
  }
};







// Delete balance invoice
const deleteBalanceInvoice = async (
  balanceInvoiceId,
  balanceInvoiceNumber
) => {

  // PASSWORD CHECK
  const password = prompt(
    `Enter authorized password to delete balance invoice ${balanceInvoiceNumber}`
  );

  // AUTH PASSWORD
  if (password !== "Hov@355") {
    alert("Unauthorized Password!");
    return;
  }

  // CONFIRM DELETE
  if (
    window.confirm(
      `Are you sure you want to delete balance invoice ${balanceInvoiceNumber}?\n\nThis action cannot be undone!`
    )
  ) {

    try {

      // Get balance invoice data
      const balanceInvoiceRef = doc(
        db,
        'balance_invoices',
        balanceInvoiceId
      );

      const balanceDoc = await getDoc(balanceInvoiceRef);

      const balanceData = balanceDoc.data();

      // Update original invoice
      if (balanceData && balanceData.originalInvoiceId) {

        const originalInvoiceRef = doc(
          db,
          'invoices',
          balanceData.originalInvoiceId
        );

        const originalDoc = await getDoc(originalInvoiceRef);

        if (originalDoc.exists()) {

          const originalData = originalDoc.data();

          const currentAdvance =
            originalData.financial?.advancePayment || 0;

          const updatedAdvance =
            currentAdvance - balanceData.paidAmount;

          const totalAmount =
            originalData.financial?.totalAmount || 0;

          const updatedBalanceDue =
            totalAmount - updatedAdvance;

          // Update original invoice
          await updateDoc(originalInvoiceRef, {
            'financial.advancePayment': updatedAdvance,
            'financial.balanceDue': updatedBalanceDue,
            status:
              updatedBalanceDue <= 0
                ? 'paid'
                : 'pending'
          });
        }
      }

      // Delete balance invoice
      await deleteDoc(balanceInvoiceRef);

      alert(
        `Balance invoice ${balanceInvoiceNumber} deleted successfully!`
      );

      await fetchAllBalanceInvoices();

    } catch (error) {

      console.error(
        'Error deleting balance invoice:',
        error
      );

      alert(
        'Error deleting balance invoice: ' +
        error.message
      );
    }
  }
};







// View balance invoice details
const viewBalanceInvoiceDetails = (invoice) => {
  setSelectedBalanceInvoice(invoice);
  setShowBalanceInvoiceDetails(true);
};



// Generate summary report
// Generate summary report for Balance Invoices
const generateBalanceSummaryReport = async () => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const primaryColor = [15, 23, 42];

  let yPosition = 0;
  let rowCount = 0;

  // Draw header on each page
  const drawHeader = (isFirstPage) => {
    // Compact header background
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 28, "F");

    // Logo
    try {
      doc.addImage("/house-of-vision-logo.png", "PNG", 10, 4, 65, 17);
    } catch (err) {}

    // Company details
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("HOUSE OF VISION", 85, 11);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.text("No. 355, Maharagama Road, Boralesgamuwa", 85, 18);
    doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150 | E-Mail: Info@houseofvision.lk", 85, 23);

    // Report title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(0, 0, 0);
    
    if (isFirstPage) {
      doc.text("BALANCE PAYMENT REPORT", pageWidth / 2, 42, { align: "center" });
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 50, { align: "center" });
      return 58;
    } else {
      doc.text("BALANCE PAYMENT REPORT (Continued)", pageWidth / 2, 40, { align: "center" });
      return 48;
    }
  };

  // Draw compact summary row
  const drawSummaryRow = (startY) => {
    const totalPaid = filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.paidAmount || 0), 0);
    const totalRemaining = filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.remainingBalance || 0), 0);
    const settledCount = filteredBalanceInvoices.filter(inv => inv.remainingBalance <= 0).length;
    const partialCount = filteredBalanceInvoices.filter(inv => inv.remainingBalance > 0).length;

    const summaryItems = [
      { label: "Total Transactions", value: filteredBalanceInvoices.length, color: [59, 130, 246] },
      { label: "Settled", value: settledCount, color: [34, 197, 94] },
      { label: "Partial", value: partialCount, color: [245, 158, 11] },
      { label: "Total Paid", value: `Rs. ${totalPaid.toLocaleString()}`, color: [34, 197, 94] },
      { label: "Total Remaining", value: `Rs. ${totalRemaining.toLocaleString()}`, color: [239, 68, 68] }
    ];

    const itemWidth = (pageWidth - 20) / 5;
    let x = 10;

    summaryItems.forEach((item) => {
      doc.setFillColor(248, 250, 252);
      doc.rect(x, startY, itemWidth - 1, 12, "F");
      
      doc.setFillColor(...item.color);
      doc.rect(x, startY, itemWidth - 1, 2, "F");
      
      doc.setTextColor(100, 116, 139);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.text(item.label, x + 3, startY + 6);
      
      doc.setTextColor(15, 23, 42);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(item.value.toString(), x + 3, startY + 11);
      
      x += itemWidth;
    });

    return startY + 16;
  };

  // Draw table headers
const drawTableHeaders = (y) => {
  doc.setFillColor(...primaryColor);
  doc.rect(10, y, pageWidth - 20, 7, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);

  doc.text("Balance Invoice", 13, y + 5);
  doc.text("Invoice No.", 52, y + 5);
  doc.text("Customer Name", 88, y + 5);
  doc.text("Contact No.", 140, y + 5);

  doc.text("Paid (Rs.)", 195, y + 5, { align: "right" });
  doc.text("Remaining (Rs.)", 230, y + 5, { align: "right" });

  doc.text("Date", 255, y + 5, { align: "center" });
  doc.text("Status", 282, y + 5, { align: "center" });

  return y + 7;
};

// Draw first page
let startY = drawHeader(true);
startY = drawSummaryRow(startY);
yPosition = drawTableHeaders(startY);

// Loop through balance invoices
for (let invoice of filteredBalanceInvoices) {

  if (yPosition > 170) {
    doc.addPage();
    startY = drawHeader(false);
    startY = drawSummaryRow(startY);
    yPosition = drawTableHeaders(startY);
    rowCount = 0;
  }

  // Alternate row background
  if (rowCount % 2 === 0) {
    doc.setFillColor(248, 250, 252);
    doc.rect(10, yPosition, pageWidth - 20, 7.5, "F");
  }

  // Row border
  doc.setDrawColor(226, 232, 240);
  doc.rect(10, yPosition, pageWidth - 20, 7.5);

  const paidAmount = invoice.paidAmount || 0;
  const remainingBalance = invoice.remainingBalance || 0;

  const status = remainingBalance <= 0 ? "PAID" : "DUE";
  const statusColor =
    remainingBalance <= 0
      ? [34, 197, 94]
      : [245, 158, 11];

  // Balance Invoice No
  doc.setTextColor(59, 130, 246);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);

  const balanceInv = invoice.balanceInvoiceNumber || "-";
  doc.text(
    balanceInv.length > 18
      ? balanceInv.substring(0, 16) + ".."
      : balanceInv,
    13,
    yPosition + 5
  );

  // Original Invoice
  doc.setTextColor(51, 65, 85);
  doc.setFont("helvetica", "normal");

  const originalInv = invoice.originalInvoiceNumber || "-";
  doc.text(
    originalInv.length > 16
      ? originalInv.substring(0, 14) + ".."
      : originalInv,
    52,
    yPosition + 5
  );

  // Customer Name
  const customerName = invoice.customerName || "-";
  doc.text(
    customerName.length > 22
      ? customerName.substring(0, 20) + ".."
      : customerName,
    88,
    yPosition + 5
  );

  // Contact Number
  doc.setTextColor(100, 116, 139);
  doc.text(invoice.customerPhone || "-", 140, yPosition + 5);

  // Paid Amount
  doc.setTextColor(34, 197, 94);
  doc.setFont("helvetica", "bold");
  doc.text(
    paidAmount.toLocaleString(),
    195,
    yPosition + 5,
    { align: "right" }
  );

  // Remaining Balance
  doc.setTextColor(
    remainingBalance > 0 ? 239 : 34,
    remainingBalance > 0 ? 68 : 197,
    remainingBalance > 0 ? 68 : 94
  );

  doc.text(
    remainingBalance.toLocaleString(),
    230,
    yPosition + 5,
    { align: "right" }
  );

  // Date
  doc.setTextColor(100, 116, 139);
  doc.setFont("helvetica", "normal");
  doc.text(
    invoice.formattedDate || "-",
    255,
    yPosition + 5,
    { align: "center" }
  );

  // Status Badge
  doc.setFillColor(...statusColor);
  doc.roundedRect(275, yPosition + 1, 14, 5, 2, 2, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(5.5);
  doc.text(status, 282, yPosition + 4.3, {
    align: "center",
  });

  yPosition += 7.5;
  rowCount++;
}








  // Add footer with page numbers
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setTextColor(148, 163, 184);
    doc.setFont("helvetica", "normal");
    doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: "center" });
  }

  doc.save(`BALANCE_PAYMENT_REPORT_${Date.now()}.pdf`);
};






// Fetch balance invoices when component mounts
useEffect(() => {
  if (selectedOption === "viewBalanceInvoice") {
    fetchAllBalanceInvoices();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterBalanceInvoices();
}, [balanceInvoiceSearchTerm, balanceInvoiceFilterStatus, allBalanceInvoices]);

// Reset filters
const resetBalanceFilters = () => {
  setBalanceInvoiceSearchTerm('');
  setBalanceInvoiceFilterStatus('all');
  setFilteredBalanceInvoices(allBalanceInvoices);
};


// Add these new states for UPIN/Receipt in balance invoices
const [showUpinReceiptModalForBalance, setShowUpinReceiptModalForBalance] = useState(false);
const [selectedBalanceForEdit, setSelectedBalanceForEdit] = useState(null);
const [balanceUpinNo, setBalanceUpinNo] = useState("");
const [balanceReceiptNo, setBalanceReceiptNo] = useState("");

// OPEN EDIT MODAL FOR BALANCE INVOICE
const openUpinReceiptEditorForBalance = (invoice) => {
  setSelectedBalanceForEdit(invoice);
  setBalanceUpinNo(invoice.upinNo || "");
  setBalanceReceiptNo(invoice.receiptNo || "");
  setShowUpinReceiptModalForBalance(true);
};

// SAVE UPIN + RECEIPT FOR BALANCE INVOICE
const saveUpinAndReceiptForBalance = async () => {
  try {
    if (!selectedBalanceForEdit?.id) {
      alert("Balance invoice not found");
      return;
    }

    await updateDoc(doc(db, "balance_invoices", selectedBalanceForEdit.id), {
      upinNo: balanceUpinNo,
      receiptNo: balanceReceiptNo,
      updatedAt: new Date()
    });

    // UPDATE LOCAL STATE
    const updatedInvoices = allBalanceInvoices.map((inv) =>
      inv.id === selectedBalanceForEdit.id
        ? {
            ...inv,
            upinNo: balanceUpinNo,
            receiptNo: balanceReceiptNo
          }
        : inv
    );

    setAllBalanceInvoices(updatedInvoices);
    setFilteredBalanceInvoices(updatedInvoices);

    alert("Updated successfully!");

    setShowUpinReceiptModalForBalance(false);

  } catch (error) {
    console.error("Error updating balance invoice:", error);
    alert("Failed to update data");
  }
};

// EXCEL DOWNLOAD FOR BALANCE INVOICES
const downloadUpinReceiptExcelForBalance = () => {
  // SORT OLDEST TOP -> LATEST BOTTOM
  const sortedInvoices = [...filteredBalanceInvoices].sort((a, b) => {
    const dateA = a.createdAt?.seconds
      ? new Date(a.createdAt.seconds * 1000)
      : new Date(a.date || 0);

    const dateB = b.createdAt?.seconds
      ? new Date(b.createdAt.seconds * 1000)
      : new Date(b.date || 0);

    return dateA - dateB;
  });

  const excelData = sortedInvoices.map((invoice, index) => ({
    "No": index + 1,
    "Date": invoice.formattedDate || "",
    "Balance Invoice No": invoice.balanceInvoiceNumber || "",
    "Original Invoice": invoice.originalInvoiceNumber || "",
    "Customer Name": invoice.customerName || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "BALANCE_REPORT"
  );

  XLSX.writeFile(
    workbook,
    `BALANCE_REPORT_${Date.now()}.xlsx`
  );
};



 


//////////////////////////// view all invoices /////////////////////////////////////////////////



const [invoiceFilterEyeCamp, setInvoiceFilterEyeCamp] = useState('all');


// Add these optimized state variables
const [allInvoices, setAllInvoices] = useState([]);
const [invoiceSearchTerm, setInvoiceSearchTerm] = useState('');
const [invoiceFilterStatus, setInvoiceFilterStatus] = useState('all');
const [invoiceFilterPaymentMethod, setInvoiceFilterPaymentMethod] = useState('all');
const [invoiceDateRange, setInvoiceDateRange] = useState({ start: '', end: '' });
const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);
const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);

// OPTIMIZED: Fetch invoices with pagination and caching
const fetchAllInvoices = async () => {
  try {
    setIsLoadingInvoices(true);
    
    // Use limit for faster initial load
    const invoicesQuery = query(
      collection(db, 'invoices'),
      orderBy('createdAt', 'desc'),
      limit(100) // Limit to last 100 invoices for faster load
    );
    
    const invoicesSnapshot = await getDocs(invoicesQuery);
    const invoicesList = [];
    
    // Batch process invoices
    const batchPromises = invoicesSnapshot.docs.map(async (doc) => {
      const data = doc.data();
      
      // Fetch balance invoices in parallel
      const balanceQuery = query(
        collection(db, 'balance_invoices'),
        where('originalInvoiceNumber', '==', data.invoiceNumber)
      );
      const balanceSnapshot = await getDocs(balanceQuery);
      
      const balancePayments = [];
      let totalBalancePaid = 0;
      
      balanceSnapshot.forEach(balanceDoc => {
        const balanceData = balanceDoc.data();
        balancePayments.push({
          id: balanceDoc.id,
          amount: balanceData.paidAmount,
          date: balanceData.createdAt,
          method: balanceData.paymentMethod,
          invoiceNumber: balanceData.balanceInvoiceNumber
        });
        totalBalancePaid += balanceData.paidAmount || 0;
      });
      
      return {
        id: doc.id,
        ...data,
        formattedDate: data.createdAt?.toDate ? 
          data.createdAt.toDate().toLocaleDateString() : 
          new Date(data.createdAt).toLocaleDateString(),
        formattedTime: data.createdAt?.toDate ?
          data.createdAt.toDate().toLocaleTimeString() :
          new Date(data.createdAt).toLocaleTimeString(),
        balancePayments: balancePayments,
        totalBalancePaid: totalBalancePaid,
        status: data.status || (data.financial?.balanceDue <= 0 ? 'paid' : 'pending'),
        statusColor: data.financial?.balanceDue <= 0 ? '#4CAF50' : '#ff9800'
      };
    });
    
    const results = await Promise.all(batchPromises);
    invoicesList.push(...results);
    
    setAllInvoices(invoicesList);
    setFilteredInvoices(invoicesList);
    setIsLoadingInvoices(false);
  } catch (error) {
    console.error('Error fetching invoices:', error);
    setIsLoadingInvoices(false);
    alert('Error fetching invoices: ' + error.message);
  }
};

// OPTIMIZED: Memoized filter function
const filterInvoices = useCallback(() => {
  let filtered = [...allInvoices];

  if (invoiceSearchTerm) {
    const searchLower = invoiceSearchTerm.toLowerCase();
    filtered = filtered.filter(invoice =>
      invoice.invoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.customer?.fullName?.toLowerCase().includes(searchLower) ||
      invoice.customer?.tpNo?.toLowerCase().includes(searchLower) ||
      invoice.customer?.email?.toLowerCase().includes(searchLower)
    );
  }

  if (invoiceFilterStatus !== 'all') {
    filtered = filtered.filter(invoice =>
      invoiceFilterStatus === 'paid'
        ? invoice.financial?.balanceDue <= 0
        : invoice.financial?.balanceDue > 0
    );
  }

  if (invoiceFilterPaymentMethod !== 'all') {
    filtered = filtered.filter(invoice =>
      invoice.financial?.paymentMethod === invoiceFilterPaymentMethod
    );
  }

  if (invoiceFilterEyeCamp !== 'all') {
  const selectedCamp = eyeCamps.find(
    c => c.id === invoiceFilterEyeCamp
  );

  console.log("Selected Camp:", selectedCamp);

  filtered = filtered.filter((invoice) => {
    const matches =
      invoice.eyeCampId === invoiceFilterEyeCamp ||
      invoice.campId === invoiceFilterEyeCamp ||
      invoice.eyeCamp === invoiceFilterEyeCamp ||
      invoice.eyeCamp === selectedCamp?.name;

    if (matches) {
      console.log("Matched invoice:", invoice.invoiceNumber);
    }

    return matches;
  });

  console.log("Filtered count:", filtered.length);
}

  if (invoiceDateRange.start) {
    const startDate = new Date(invoiceDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(invoice => {
      const invoiceDate = invoice.createdAt?.toDate?.() || new Date(invoice.createdAt);
      return invoiceDate >= startDate;
    });
  }

  if (invoiceDateRange.end) {
    const endDate = new Date(invoiceDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(invoice => {
      const invoiceDate = invoice.createdAt?.toDate?.() || new Date(invoice.createdAt);
      return invoiceDate <= endDate;
    });
  }

  filtered.sort((a, b) => {
    const dateA = a.createdAt?.toDate?.() || new Date(a.createdAt);
    const dateB = b.createdAt?.toDate?.() || new Date(b.createdAt);
    return dateB - dateA; // Newest first for better UX
  });

  setFilteredInvoices(filtered);
}, [allInvoices, invoiceSearchTerm, invoiceFilterStatus, invoiceFilterPaymentMethod, invoiceFilterEyeCamp, invoiceDateRange]);

// Use debounce for search to improve performance
useEffect(() => {
  const timeoutId = setTimeout(() => {
    if (selectedOption === "viewInvoice") {
      filterInvoices();
    }
  }, 300);

  return () => clearTimeout(timeoutId);
}, [
  invoiceSearchTerm,
  invoiceFilterStatus,
  invoiceFilterPaymentMethod,
  invoiceFilterEyeCamp,   // <-- ADD THIS
  invoiceDateRange,
  filterInvoices,
  selectedOption
]);

// Fetch on mount only once
useEffect(() => {
  if (selectedOption === "viewInvoice") {
    fetchAllInvoices();
      fetchEyeCamps();
  }
}, [selectedOption]);

// Reset filters
const resetInvoiceFilters = () => {
  setInvoiceSearchTerm('');
  setInvoiceFilterStatus('all');
  setInvoiceFilterPaymentMethod('all');
  setInvoiceDateRange({ start: '', end: '' });
  setFilteredInvoices(allInvoices);
};

// View invoice details (memoized to prevent re-renders)
const viewInvoiceDetails = useCallback((invoice) => {
  setSelectedInvoiceDetails(invoice);
  setShowInvoiceDetails(true);
}, []);








// Add this function to restore stock when invoice is deleted
const restoreStockFromDeletedInvoice = async (invoiceData) => {
  try {
    const restorePromises = [];

    // 1. RESTORE FRAME STOCK
    if (invoiceData.products?.frameModel && invoiceData.products?.framePrice) {
      // Find the frame in stock
      const framesQuery = query(
        collection(db, "stock"),
        where("category", "==", "frame")
      );
      
      const framesSnapshot = await getDocs(framesQuery);
      let frameRestored = false;
      
      for (const stockDoc of framesSnapshot.docs) {
        const stockData = stockDoc.data();
        
        // Check if this stock document contains the frame
        if (stockData.items && Array.isArray(stockData.items)) {
          const frameIndex = stockData.items.findIndex(
            item => item.modelNo === invoiceData.products.frameModel &&
                    item.brand === invoiceData.products.brand &&
                    item.colour === invoiceData.products.colour
          );
          
          if (frameIndex !== -1) {
            // Restore quantity
            const updatedItems = [...stockData.items];
            updatedItems[frameIndex] = {
              ...updatedItems[frameIndex],
              qty: (updatedItems[frameIndex].qty || 0) + 1
            };
            
            await updateDoc(doc(db, "stock", stockDoc.id), { items: updatedItems });
            frameRestored = true;
            console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
            break;
          }
        } else if (stockData.modelNo === invoiceData.products.frameModel) {
          // Simple stock structure
          await updateDoc(doc(db, "stock", stockDoc.id), {
            quantity: (stockData.quantity || 0) + 1
          });
          frameRestored = true;
          console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
          break;
        }
      }
      
      if (!frameRestored) {
        console.warn(`Frame not found in stock: ${invoiceData.products.frameModel}`);
      }
    }
    
    // 2. RESTORE LENS STOCK
    if (invoiceData.products?.lensModel) {
      // Get lens brand and type from either regular or high index lens
      let lensBrand = null;
      let lensType = null;
      let lensName = null;
      
      // Check if it's high index lens
      if (invoiceData.products?.highIndexLens && invoiceData.products?.highIndexLeft) {
        lensBrand = invoiceData.products.highIndexLeft.brand;
        lensType = invoiceData.products.highIndexLeft.type;
        lensName = invoiceData.products.highIndexLeft.name;
      } else {
        // Regular lens - use left lens as reference (since both eyes are same type)
        const leftLens = invoiceData.products?.leftLens;
        if (leftLens) {
          lensBrand = leftLens.brand;
          lensType = leftLens.type;
          lensName = leftLens.name;
        }
      }
      
      if (lensBrand || lensName) {
        const lensesQuery = query(
          collection(db, 'stock'),
          where('type', '==', 'lens')
        );
        
        const lensesSnapshot = await getDocs(lensesQuery);
        let lensRestored = false;
        
        for (const stockDoc of lensesSnapshot.docs) {
          const stockData = stockDoc.data();
          
          // Try to match by multiple criteria
          let matched = false;
          
          if (lensBrand && stockData.brand === lensBrand) {
            matched = true;
          }
          if (lensName && stockData.name === lensName) {
            matched = true;
          }
          if (lensType && stockData.type === lensType) {
            matched = true;
          }
          
          if (matched || stockData.name === invoiceData.products.lensModel) {
            await updateDoc(doc(db, 'stock', stockDoc.id), {
              quantity: (stockData.quantity || 0) + 1
            });
            lensRestored = true;
            console.log(`Restored lens stock: ${stockData.name || invoiceData.products.lensModel}`);
            break;
          }
        }
        
        if (!lensRestored) {
          console.warn(`Lens not found in stock: ${invoiceData.products.lensModel}`);
        }
      }
    }
    
    // 3. DELETE ASSOCIATED STOCK_OUT RECORDS
    const stockOutQuery = query(
      collection(db, 'stock_out'),
      where('invoiceNumber', '==', invoiceData.invoiceNumber)
    );
    
    const stockOutSnapshot = await getDocs(stockOutQuery);
    
    for (const stockOutDoc of stockOutSnapshot.docs) {
      await deleteDoc(doc(db, 'stock_out', stockOutDoc.id));
      console.log(`Deleted stock_out record: ${stockOutDoc.id}`);
    }
    
    console.log('Stock restoration completed successfully');
    return true;
    
  } catch (error) {
    console.error('Error restoring stock:', error);
    throw error;
  }
};







// Add this state at the top of your component
const [editingPhone, setEditingPhone] = useState(false);
const [tempPhoneNumber, setTempPhoneNumber] = useState('');

// Function to handle phone number edit
const handleEditPhone = () => {
  setTempPhoneNumber(selectedInvoiceDetails?.customer?.tpNo || '');
  setEditingPhone(true);
};

// Function to save phone number
const handleSavePhone = async () => {
  if (!selectedInvoiceDetails) return;
  
  try {
    // Update the invoice document in Firestore
    const invoiceRef = doc(db, 'invoices', selectedInvoiceDetails.id);
    await updateDoc(invoiceRef, {
      'customer.tpNo': tempPhoneNumber
    });
    
    // Update the local state
    setSelectedInvoiceDetails({
      ...selectedInvoiceDetails,
      customer: {
        ...selectedInvoiceDetails.customer,
        tpNo: tempPhoneNumber
      }
    });
    
    // Update in the allInvoices list
    setAllInvoices(prevInvoices => 
      prevInvoices.map(inv => 
        inv.id === selectedInvoiceDetails.id 
          ? {
              ...inv,
              customer: {
                ...inv.customer,
                tpNo: tempPhoneNumber
              }
            }
          : inv
      )
    );
    
    // Update in filteredInvoices list
    setFilteredInvoices(prevInvoices => 
      prevInvoices.map(inv => 
        inv.id === selectedInvoiceDetails.id 
          ? {
              ...inv,
              customer: {
                ...inv.customer,
                tpNo: tempPhoneNumber
              }
            }
          : inv
      )
    );
    
    setEditingPhone(false);
    alert('Phone number updated successfully!');
    
  } catch (error) {
    console.error('Error updating phone number:', error);
    alert('Failed to update phone number: ' + error.message);
  }
};

// Function to cancel editing
const handleCancelEditPhone = () => {
  setEditingPhone(false);
  setTempPhoneNumber('');
};






// Replace your existing deleteInvoice function with this updated version
// Enhanced delete function that handles both regular and direct sale invoices
// const deleteInvoice = async (invoiceId, invoiceNumber) => {
//   const password = prompt(
//     `Enter password to delete invoice ${invoiceNumber}`
//   );

//   if (password !== "Hov@355") {
//     alert("Incorrect password!");
//     return;
//   }

//   if (
//     window.confirm(
//       `Are you sure you want to delete invoice ${invoiceNumber}?\n\nThis will:\n- Restore all stock (frames, lenses, sunglass, other products)\n- Delete all related balance invoices\n- Delete stock_out records\n\nThis action cannot be undone!`
//     )
//   ) {
//     try {
//       // Get the invoice data first
//       const invoiceRef = doc(db, 'invoices', invoiceId);
//       const invoiceDoc = await getDoc(invoiceRef);
      
//       if (!invoiceDoc.exists()) {
//         alert('Invoice not found!');
//         return;
//       }
      
//       const invoiceData = invoiceDoc.data();
      
//       // Check if it's a direct sale or regular invoice
//       const isDirectSale = invoiceData.type === 'direct-sale';
      
//       if (isDirectSale) {
//         // RESTORE STOCK FOR DIRECT SALE
//         console.log('Restoring stock for direct sale invoice...');
//         await restoreDirectSaleStock(invoiceData);
        
//         // DELETE STOCK_OUT RECORDS FOR DIRECT SALE
//         console.log('Deleting stock_out records...');
//         await deleteDirectSaleStockOutRecords(invoiceNumber);
        
//       } else {
//         // RESTORE STOCK FOR REGULAR INVOICE (frames and lenses)
//         console.log('Restoring stock for regular invoice...');
        
//         // Restore Frame Stock
//         if (invoiceData.products?.frameModel && invoiceData.products?.framePrice) {
//           const framesQuery = query(
//             collection(db, "stock"),
//             where("category", "==", "frame")
//           );
          
//           const framesSnapshot = await getDocs(framesQuery);
//           let frameRestored = false;
          
//           for (const stockDoc of framesSnapshot.docs) {
//             const stockData = stockDoc.data();
//             const stockRef = doc(db, 'stock', stockDoc.id);
            
//             if (stockData.items && Array.isArray(stockData.items)) {
//               const frameIndex = stockData.items.findIndex(
//                 item => item.modelNo === invoiceData.products.frameModel &&
//                         item.brand === invoiceData.products.brand &&
//                         item.colour === invoiceData.products.colour
//               );
              
//               if (frameIndex !== -1) {
//                 const updatedItems = [...stockData.items];
//                 updatedItems[frameIndex] = {
//                   ...updatedItems[frameIndex],
//                   qty: (updatedItems[frameIndex].qty || 0) + 1
//                 };
                
//                 await updateDoc(stockRef, { items: updatedItems });
//                 frameRestored = true;
//                 console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
//                 break;
//               }
//             } else if (stockData.modelNo === invoiceData.products.frameModel) {
//               await updateDoc(stockRef, {
//                 quantity: (stockData.quantity || 0) + 1
//               });
//               frameRestored = true;
//               console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
//               break;
//             }
//           }
          
//           if (!frameRestored) {
//             console.warn(`Frame not found in stock: ${invoiceData.products.frameModel}`);
//           }
//         }
        
//         // Restore Lens Stock
//         if (invoiceData.products?.lensModel) {
//           let lensIdentifier = invoiceData.products.lensModel;
          
//           const lensesQuery = query(
//             collection(db, 'stock'),
//             where('type', '==', 'lens')
//           );
          
//           const lensesSnapshot = await getDocs(lensesQuery);
//           let lensRestored = false;
          
//           for (const stockDoc of lensesSnapshot.docs) {
//             const stockData = stockDoc.data();
//             const stockRef = doc(db, 'stock', stockDoc.id);
            
//             // Check for high index or regular lens
//             if (invoiceData.products?.highIndexLens) {
//               // High index lens restoration
//               if (stockData.name === invoiceData.products.highIndexLeft?.name ||
//                   stockData.name === invoiceData.products.highIndexRight?.name) {
//                 await updateDoc(stockRef, {
//                   quantity: (stockData.quantity || 0) + 1
//                 });
//                 lensRestored = true;
//                 console.log(`Restored high index lens stock: ${stockData.name}`);
//                 break;
//               }
//             } else if (stockData.name === lensIdentifier || 
//                        stockData.modelNo === lensIdentifier ||
//                        (invoiceData.products?.leftLens && stockData.name === invoiceData.products.leftLens.name)) {
              
//               await updateDoc(stockRef, {
//                 quantity: (stockData.quantity || 0) + 1
//               });
//               lensRestored = true;
//               console.log(`Restored lens stock: ${stockData.name}`);
//               break;
//             }
//           }
          
//           if (!lensRestored) {
//             console.warn(`Lens not found in stock: ${invoiceData.products.lensModel}`);
//           }
//         }
        
//         // Delete stock_out records for regular invoice
//         const stockOutQuery = query(
//           collection(db, 'stock_out'),
//           where('invoiceNumber', '==', invoiceNumber)
//         );
        
//         const stockOutSnapshot = await getDocs(stockOutQuery);
        
//         for (const stockOutDoc of stockOutSnapshot.docs) {
//           await deleteDoc(doc(db, 'stock_out', stockOutDoc.id));
//           console.log(`Deleted stock_out record: ${stockOutDoc.id}`);
//         }
//       }
      
//       // Delete related balance invoices (common for both types)
//       const balanceQuery = query(
//         collection(db, 'balance_invoices'),
//         where('originalInvoiceNumber', '==', invoiceNumber)
//       );
      
//       const balanceSnapshot = await getDocs(balanceQuery);
      
//       for (const balanceDoc of balanceSnapshot.docs) {
//         await deleteDoc(doc(db, 'balance_invoices', balanceDoc.id));
//         console.log(`Deleted balance invoice: ${balanceDoc.id}`);
//       }
      
//       // Delete main invoice
//       await deleteDoc(doc(db, 'invoices', invoiceId));
      
//       alert(`Invoice ${invoiceNumber} deleted successfully!\nStock has been restored.`);
      
//       // Refresh the invoices list
//       await fetchAllInvoices();
      
//     } catch (error) {
//       console.error('Error deleting invoice:', error);
//       alert('Error deleting invoice: ' + error.message);
//     }
//   }
// };


const deleteInvoice = async (invoiceId, invoiceNumber) => {
  const password = prompt(
    `Enter password to delete invoice ${invoiceNumber}`
  );

  if (password !== "Hov@355") {
    alert("Incorrect password!");
    return;
  }

  if (
    window.confirm(
      `Are you sure you want to delete invoice ${invoiceNumber}?\n\nThis will:\n- Restore all stock (frames, lenses, sunglass, other products)\n- Delete all related balance invoices\n- Delete stock_out records\n\nThis action cannot be undone!`
    )
  ) {
    try {
      // Get the invoice data first
      const invoiceRef = doc(db, 'invoices', invoiceId);
      const invoiceDoc = await getDoc(invoiceRef);
      
      if (!invoiceDoc.exists()) {
        alert('Invoice not found!');
        return;
      }
      
      const invoiceData = invoiceDoc.data();
      
      console.log('Full invoice data for deletion:', invoiceData);
      console.log('Invoice type:', invoiceData.type);
      console.log('Products:', invoiceData.products);
      console.log('Box Items:', invoiceData.boxItems);
      
      // =============================================
      // 1. RESTORE BOX ITEMS (FOR BOTH DIRECT SALE AND MAIN INVOICES)
      // =============================================
      // Check if invoice has box items
      if (invoiceData.boxItems && Array.isArray(invoiceData.boxItems) && invoiceData.boxItems.length > 0) {
        console.log('Found box items to restore:', invoiceData.boxItems.length);
        console.log('Box items data:', JSON.stringify(invoiceData.boxItems, null, 2));
        
        // Create a structure that restoreDirectSaleStock expects
        const boxData = {
          ...invoiceData,
          products: invoiceData.boxItems
        };
        
        try {
          await restoreDirectSaleStock(boxData);
          console.log('Box items stock restored successfully');
        } catch (restoreError) {
          console.error('Error restoring box items stock:', restoreError);
          // Continue with other restoration even if box items fail
        }
      } else {
        console.log('No box items found in invoice');
      }
      
      // =============================================
      // 2. RESTORE DIRECT SALE ITEMS (for direct-sale type invoices)
      // =============================================
      if (invoiceData.type === 'direct-sale') {
        console.log('This is a direct sale invoice - restoring direct sale products');
        
        // The products are stored in the products array
        let productsToRestore = [];
        
        // Check if products exist and is an array
        if (invoiceData.products && Array.isArray(invoiceData.products) && invoiceData.products.length > 0) {
          productsToRestore = invoiceData.products;
          console.log('Found products to restore:', productsToRestore.length);
        } else {
          console.warn('No products found in invoice data');
        }
        
        // Restore each product's stock
        if (productsToRestore.length > 0) {
          console.log('Starting stock restoration for products...');
          
          for (const product of productsToRestore) {
            try {
              console.log(`Processing product:`, product);
              
              // Get the stock document ID
              let stockDocId = product.stockDocId;
              
              if (!stockDocId) {
                console.warn(`No stockDocId for product ${product.modelNo}, trying to find...`);
                
                // Try to find the stock document by modelNo and category
                const stockQuery = query(
                  collection(db, "stock"),
                  where("category", "==", product.category || "other")
                );
                
                const stockSnapshot = await getDocs(stockQuery);
                
                for (const doc of stockSnapshot.docs) {
                  const data = doc.data();
                  if (data.items && Array.isArray(data.items)) {
                    const found = data.items.some(item => 
                      item.modelNo === product.modelNo && 
                      item.colour === product.colour
                    );
                    if (found) {
                      stockDocId = doc.id;
                      console.log(`Found stock document: ${stockDocId}`);
                      break;
                    }
                  }
                }
                
                if (!stockDocId) {
                  console.warn(`Could not find stock for product: ${product.modelNo}`);
                  continue;
                }
              }
              
              // Restore the stock
              const stockRef = doc(db, "stock", stockDocId);
              const stockSnap = await getDoc(stockRef);
              
              if (!stockSnap.exists()) {
                console.warn(`Stock document ${stockDocId} not found`);
                continue;
              }
              
              const stockData = stockSnap.data();
              const quantityToRestore = product.qty || 1;
              
              console.log(`Restoring ${quantityToRestore} units of ${product.modelNo}`);
              
              if (stockData.items && Array.isArray(stockData.items)) {
                let itemFound = false;
                
                const updatedItems = stockData.items.map(stockItem => {
                  // Try to match by model and color
                  if (stockItem.modelNo === product.modelNo && 
                      stockItem.colour === product.colour) {
                    itemFound = true;
                    const currentQty = stockItem.qty || 0;
                    const restoredQty = currentQty + quantityToRestore;
                    console.log(`Updating stock for ${product.modelNo}: ${currentQty} -> ${restoredQty}`);
                    return {
                      ...stockItem,
                      qty: restoredQty
                    };
                  }
                  return stockItem;
                });
                
                if (!itemFound) {
                  // Try to match by model only
                  const updatedItemsFallback = stockData.items.map(stockItem => {
                    if (stockItem.modelNo === product.modelNo) {
                      itemFound = true;
                      const currentQty = stockItem.qty || 0;
                      const restoredQty = currentQty + quantityToRestore;
                      console.log(`Updating stock (fallback) for ${product.modelNo}: ${currentQty} -> ${restoredQty}`);
                      return {
                        ...stockItem,
                        qty: restoredQty
                      };
                    }
                    return stockItem;
                  });
                  
                  if (itemFound) {
                    await updateDoc(stockRef, { items: updatedItemsFallback });
                    console.log(`Stock restored (fallback) for product: ${product.modelNo}`);
                  } else {
                    console.warn(`Item not found in stock: ${product.modelNo}`);
                  }
                } else {
                  await updateDoc(stockRef, { items: updatedItems });
                  console.log(`Stock restored for product: ${product.modelNo}`);
                }
                
              } else {
                // Simple stock structure
                const currentQty = stockData.quantity || 0;
                const restoredQty = currentQty + quantityToRestore;
                await updateDoc(stockRef, { quantity: restoredQty });
                console.log(`Stock restored for simple product: ${product.modelNo}`);
              }
              
            } catch (productError) {
              console.error(`Error restoring product ${product.modelNo}:`, productError);
            }
          }
          
          console.log('Stock restoration completed for all products');
        } else {
          console.warn('No products to restore');
        }
        
        // =============================================
        // DELETE STOCK_OUT RECORDS FOR DIRECT SALE
        // =============================================
        try {
          const stockOutQuery = query(
            collection(db, 'stock_out'),
            where('invoiceNumber', '==', invoiceNumber)
          );
          
          const stockOutSnapshot = await getDocs(stockOutQuery);
          let deletedCount = 0;
          
          for (const stockOutDoc of stockOutSnapshot.docs) {
            await deleteDoc(doc(db, 'stock_out', stockOutDoc.id));
            deletedCount++;
            console.log(`Deleted stock_out record: ${stockOutDoc.id}`);
          }
          
          console.log(`Deleted ${deletedCount} stock_out records`);
        } catch (error) {
          console.warn('Error deleting stock_out records:', error);
        }
        
      } else {
        // =============================================
        // 3. RESTORE REGULAR FRAME AND LENS STOCK (for main-invoice type)
        // =============================================
        console.log('Restoring regular frame and lens stock...');
        
        // Restore Frame Stock
        if (invoiceData.products?.frameModel) {
          const framesQuery = query(
            collection(db, "stock"),
            where("category", "==", "frame")
          );
          
          const framesSnapshot = await getDocs(framesQuery);
          let frameRestored = false;
          
          for (const stockDoc of framesSnapshot.docs) {
            const stockData = stockDoc.data();
            const stockRef = doc(db, 'stock', stockDoc.id);
            
            if (stockData.items && Array.isArray(stockData.items)) {
              const frameIndex = stockData.items.findIndex(
                item => item.modelNo === invoiceData.products.frameModel &&
                        item.brand === invoiceData.products.brand &&
                        item.colour === invoiceData.products.colour
              );
              
              if (frameIndex !== -1) {
                const updatedItems = [...stockData.items];
                updatedItems[frameIndex] = {
                  ...updatedItems[frameIndex],
                  qty: (updatedItems[frameIndex].qty || 0) + 1
                };
                
                await updateDoc(stockRef, { items: updatedItems });
                frameRestored = true;
                console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
                break;
              }
            } else if (stockData.modelNo === invoiceData.products.frameModel) {
              await updateDoc(stockRef, {
                quantity: (stockData.quantity || 0) + 1
              });
              frameRestored = true;
              console.log(`Restored frame stock (simple): ${invoiceData.products.frameModel}`);
              break;
            }
          }
          
          if (!frameRestored) {
            console.warn(`Frame not found in stock: ${invoiceData.products.frameModel}`);
          }
        }
        
        // Restore Lens Stock
        if (invoiceData.products?.lensModel) {
          const lensesQuery = query(
            collection(db, 'stock'),
            where('type', '==', 'lens')
          );
          
          const lensesSnapshot = await getDocs(lensesQuery);
          let lensRestored = false;
          
          for (const stockDoc of lensesSnapshot.docs) {
            const stockData = stockDoc.data();
            const stockRef = doc(db, 'stock', stockDoc.id);
            
            if (stockData.name === invoiceData.products.lensModel ||
                stockData.modelNo === invoiceData.products.lensModel) {
              
              await updateDoc(stockRef, {
                quantity: (stockData.quantity || 0) + 1
              });
              lensRestored = true;
              console.log(`Restored lens stock: ${stockData.name || invoiceData.products.lensModel}`);
              break;
            }
          }
          
          if (!lensRestored) {
            console.warn(`Lens not found in stock: ${invoiceData.products.lensModel}`);
          }
        }
        
        // Delete stock_out records for regular invoices
        try {
          const stockOutQuery = query(
            collection(db, 'stock_out'),
            where('invoiceNumber', '==', invoiceNumber)
          );
          
          const stockOutSnapshot = await getDocs(stockOutQuery);
          for (const stockOutDoc of stockOutSnapshot.docs) {
            await deleteDoc(doc(db, 'stock_out', stockOutDoc.id));
            console.log(`Deleted stock_out record: ${stockOutDoc.id}`);
          }
        } catch (error) {
          console.warn('Error deleting stock_out records:', error);
        }
      }
      
      // =============================================
      // 4. DELETE BALANCE INVOICES
      // =============================================
      try {
        const balanceQuery = query(
          collection(db, 'balance_invoices'),
          where('originalInvoiceNumber', '==', invoiceNumber)
        );
        
        const balanceSnapshot = await getDocs(balanceQuery);
        let balanceDeleted = 0;
        
        for (const balanceDoc of balanceSnapshot.docs) {
          await deleteDoc(doc(db, 'balance_invoices', balanceDoc.id));
          balanceDeleted++;
          console.log(`Deleted balance invoice: ${balanceDoc.id}`);
        }
        
        console.log(`Deleted ${balanceDeleted} balance invoices`);
      } catch (error) {
        console.warn('Error deleting balance invoices:', error);
      }
      
      // =============================================
      // 5. DELETE MAIN INVOICE
      // =============================================
      await deleteDoc(doc(db, 'invoices', invoiceId));
      
      alert(`Invoice ${invoiceNumber} deleted successfully!\nStock has been restored.`);
      
      // Refresh the invoices list
      await fetchAllInvoices();
      
      // Close the details modal if open
      if (showInvoiceDetails) {
        setShowInvoiceDetails(false);
        setSelectedInvoiceDetails(null);
      }
      
    } catch (error) {
      console.error('Error deleting invoice:', error);
      alert('Error deleting invoice: ' + error.message);
    }
  }
};






///////////////////////////////////// View invoice details //////////////



const generateInvoiceSummaryReport = async () => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const primaryColor = [15, 23, 42];

  let yPosition = 0;
  let rowCount = 0;

  // Draw header on each page
  const drawHeader = (isFirstPage) => {
    // Compact header background
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 28, "F");

    // Logo space
    // try {
    //   doc.addImage("/house-of-vision-logo.png", "PNG", 10, 4, 60, 17);
    // } catch (err) {}

    // Company details
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("HOUSE OF VISION", 75, 11);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.text("No. 355, Maharagama Road, Boralesgamuwa", 75, 18);
    doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150 | E-Mail: Info@houseofvision.lk", 75, 23);

    // Report title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    
    if (isFirstPage) {
      doc.text("INVOICE SUMMARY REPORT", pageWidth / 2, 42, { align: "center" });
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 50, { align: "center" });
      return 58;
    } else {
      doc.text("INVOICE SUMMARY REPORT (Continued)", pageWidth / 2, 40, { align: "center" });
      return 48;
    }
  };

  // Draw compact summary row
  const drawSummaryRow = (startY) => {
    const totalAmount = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.totalAmount || 0), 0);
    const totalPaid = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.advancePayment || 0), 0);
    const totalDue = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.balanceDue || 0), 0);
    const paidCount = filteredInvoices.filter(inv => inv.financial?.balanceDue <= 0).length;
    const pendingCount = filteredInvoices.filter(inv => inv.financial?.balanceDue > 0).length;

    const summaryItems = [
      { label: "Total Invoices", value: filteredInvoices.length, color: [59, 130, 246] },
      { label: "Paid", value: paidCount, color: [34, 197, 94] },
      { label: "Pending", value: pendingCount, color: [245, 158, 11] },
      { label: "Total Amount", value: `Rs. ${totalAmount.toLocaleString()}`, color: [15, 23, 42] },
      { label: "Paid Amount", value: `Rs. ${totalPaid.toLocaleString()}`, color: [34, 197, 94] },
      { label: "Due Amount", value: `Rs. ${totalDue.toLocaleString()}`, color: [239, 68, 68] }
    ];

    const itemWidth = (pageWidth - 20) / 6;
    let x = 10;

    summaryItems.forEach((item, idx) => {
      // Light background
      doc.setFillColor(248, 250, 252);
      doc.rect(x, startY, itemWidth - 1, 12, "F");
      
      // Top color bar
      doc.setFillColor(...item.color);
      doc.rect(x, startY, itemWidth - 1, 2, "F");
      
      // Label
      doc.setTextColor(100, 116, 139);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.text(item.label, x + 3, startY + 6);
      
      // Value
      doc.setTextColor(15, 23, 42);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(item.value.toString(), x + 3, startY + 11);
      
      x += itemWidth;
    });

    return startY + 16;
  };

  // Draw table headers - UPDATED with more space for Frame & Lens
  const drawTableHeaders = (y) => {
    doc.setFillColor(...primaryColor);
    doc.rect(10, y, pageWidth - 20, 8, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(6.5);

    // Column widths - INCREASED for Frame and Lens
    const startX = 12;
    const colWidths = {
      invoice: 16,
      customer: 36,
      eyeCamp: 30,
      tpNo: 18,
      date: 26,
      frame: 28,      // INCREASED from 18 to 28
      lens: 38,       // INCREASED from 20 to 30
      total: 16,
      paid: 16,
      due: 16,
      status: 14
    };

    let currentX = startX;
    const colPositions = {
      invoice: currentX,
      customer: (currentX += colWidths.invoice),
      eyeCamp: (currentX += colWidths.customer),
      tpNo: (currentX += colWidths.eyeCamp),
      date: (currentX += colWidths.tpNo),
      frame: (currentX += colWidths.date),
      lens: (currentX += colWidths.frame),
      total: (currentX += colWidths.lens),
      paid: (currentX += colWidths.total),
      due: (currentX += colWidths.paid),
      status: (currentX += colWidths.due)
    };

    // Headers array
    const headers = [
      { text: "Invoice #", pos: colPositions.invoice },
      { text: "Customer", pos: colPositions.customer },
      { text: "Eye Camp", pos: colPositions.eyeCamp },
      { text: "TP No", pos: colPositions.tpNo },
      { text: "Date", pos: colPositions.date },
      { text: "Frame", pos: colPositions.frame },
      { text: "Lens", pos: colPositions.lens },
      { text: "Total", pos: colPositions.total },
      { text: "Paid", pos: colPositions.paid },
      { text: "Due", pos: colPositions.due },
      { text: "Status", pos: colPositions.status }
    ];

    // Draw each header
    headers.forEach(header => {
      doc.text(header.text, header.pos, y + 5.5);
    });

    return { y: y + 8, colPositions };
  };

  // Draw first page
  let startY = drawHeader(true);
  startY = drawSummaryRow(startY);
  const headerResult = drawTableHeaders(startY);
  yPosition = headerResult.y;
  const colPositions = headerResult.colPositions;

  // Loop through invoices
  for (let invoice of filteredInvoices) {
    // Check if need new page
    if (yPosition > 175) {
      doc.addPage();
      startY = drawHeader(false);
      startY = drawSummaryRow(startY);
      const newHeader = drawTableHeaders(startY);
      yPosition = newHeader.y;
      Object.assign(colPositions, newHeader.colPositions);
      rowCount = 0;
    }

    // Alternate row background
    if (rowCount % 2 === 0) {
      doc.setFillColor(248, 250, 252);
      doc.rect(10, yPosition, pageWidth - 20, 9, "F");
    }

    // Draw row borders
    doc.setDrawColor(226, 232, 240);
    doc.rect(10, yPosition, pageWidth - 20, 9);

    const totalAmount = invoice.financial?.totalAmount || 0;
    const dueAmount = invoice.financial?.balanceDue || 0;
    const status = dueAmount <= 0 ? "PAID" : "DUE";
    const statusColor = dueAmount <= 0 ? [34, 197, 94] : [239, 68, 68];

    // Invoice #
    doc.setTextColor(59, 130, 246);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.text(invoice.invoiceNumber || '-', colPositions.invoice, yPosition + 6);

    // Customer Name
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    let customerName = invoice.customer?.fullName || '-';
    doc.text(
      customerName.length > 22 ? customerName.substring(0, 20) + '..' : customerName,
      colPositions.customer,
      yPosition + 6
    );

//Eye Camp
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal"); 
       doc.setFontSize(6.5);
    const eyeCamp = invoice.eyeCamp || '-';
  doc.text(
      eyeCamp.length > 22 ? eyeCamp.substring(0, 20) + '..' : eyeCamp,
      colPositions.eyeCamp,
      yPosition + 6
    );

    // TP No
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.5);
    const tpNo = invoice.customer?.tpNo || '-';
    doc.text(
      tpNo.length > 14 ? tpNo.substring(0, 12) + '..' : tpNo,
      colPositions.tpNo,
      yPosition + 6
    );

    // Date
    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    if (invoice.formattedDate) {
      doc.text(invoice.formattedDate, colPositions.date, yPosition + 4.5);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(5.5);
      doc.setTextColor(100, 116, 139);
      doc.text(invoice.formattedTime || '', colPositions.date, yPosition + 8);
    } else {
      doc.text('-', colPositions.date, yPosition + 6);
    }

    // Frame - with increased character limit
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.5);
    
    const frameModel = invoice.products?.frameModel || '-';
    let frameDisplay = frameModel;
    if (frameModel === "Own Frame" || frameModel === "Own frame" || frameModel === "own frame") {
      frameDisplay = "Own Frame";
    } else if (frameModel !== '-') {
      frameDisplay = frameModel;
    }
    
    // Allow up to 28 characters before truncating
    doc.text(
      frameDisplay.length > 28 ? frameDisplay.substring(0, 26) + '..' : frameDisplay,
      colPositions.frame,
      yPosition + 6
    );

    // Lens - with increased character limit
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    
    let lensDisplay = '-';
    if (invoice.products?.highIndexLens) {
      const leftLensName = invoice.products?.highIndexLeft?.name || '';
      const rightLensName = invoice.products?.highIndexRight?.name || '';
      if (leftLensName && rightLensName) {
        lensDisplay = `${leftLensName} / ${rightLensName}`;
      } else if (leftLensName) {
        lensDisplay = leftLensName;
      } else if (rightLensName) {
        lensDisplay = rightLensName;
      } else {
        lensDisplay = '-';
      }
    } else {
      lensDisplay = invoice.products?.lensModel || '-';
      lensDisplay = lensDisplay.replace(/^(LEFT:|RIGHT:)\s*/, '');
    }
    
    // Allow up to 30 characters before truncating
    doc.text(
      lensDisplay.length > 30 ? lensDisplay.substring(0, 28) + '..' : lensDisplay,
      colPositions.lens,
      yPosition + 6
    );

    // Total Amount
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(
      totalAmount.toLocaleString(),
      colPositions.total + 14,
      yPosition + 6,
      { align: "right" }
    );

    // Paid Amount
    doc.setTextColor(34, 197, 94);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(
      (totalAmount - dueAmount).toLocaleString(),
      colPositions.paid + 14,
      yPosition + 6,
      { align: "right" }
    );

    // Due Amount
    doc.setTextColor(dueAmount > 0 ? 239 : 34, dueAmount > 0 ? 68 : 197, dueAmount > 0 ? 68 : 94);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(
      dueAmount.toLocaleString(),
      colPositions.due + 14,
      yPosition + 6,
      { align: "right" }
    );

    // Status Badge
    doc.setFillColor(...statusColor);
    doc.roundedRect(colPositions.status + 1, yPosition + 2, 14, 5.5, 2, 2, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(5);
    doc.text(status, colPositions.status + 8, yPosition + 5.5, { align: "center" });

    yPosition += 9;
    rowCount++;
  }

  // Add footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setTextColor(148, 163, 184);
    doc.setFont("helvetica", "normal");
    doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: "center" });
  }

  doc.save(`INVOICES_SUMMARY_${Date.now()}.pdf`);
};




// Reset filters
// const resetInvoiceFilters = () => {
//   setInvoiceSearchTerm('');
//   setInvoiceFilterStatus('all');
//   setInvoiceFilterPaymentMethod('all');
//   setInvoiceDateRange({ start: '', end: '' });
//   setFilteredInvoices(allInvoices);
// };

//////////////////////////////////////////////////////////
// SORT OLD DATE TOP -> NEW DATE BOTTOM
//////////////////////////////////////////////////////////

useEffect(() => {

  if (allInvoices.length > 0) {

    const sortedInvoices = [...allInvoices].sort((a, b) => {

      const dateA = a.createdAt?.seconds
        ? new Date(a.createdAt.seconds * 1000)
        : new Date(a.createdAt || 0);

      const dateB = b.createdAt?.seconds
        ? new Date(b.createdAt.seconds * 1000)
        : new Date(b.createdAt || 0);

      return dateA - dateB;

    });

    setFilteredInvoices(sortedInvoices);

  }

}, [allInvoices]);

// Apply filters when filter criteria change
useEffect(() => {
  filterInvoices();
}, [invoiceSearchTerm, invoiceFilterStatus, invoiceFilterPaymentMethod, invoiceDateRange.start, invoiceDateRange.end, allInvoices]);




/////////////////////////////////////// NEW STATES ///////////////////////////////////////

const [showUpinReceiptModal, setShowUpinReceiptModal] = useState(false);
const [selectedInvoiceForEdit, setSelectedInvoiceForEdit] = useState(null);

const [upinNo, setUpinNo] = useState("");
const [receiptNo, setReceiptNo] = useState("");




/////////////////////////////////////// OPEN EDIT MODAL ///////////////////////////////////////

const openUpinReceiptEditor = (invoice) => {
  setSelectedInvoiceForEdit(invoice);
  setUpinNo(invoice.upinNo || "");
  setReceiptNo(invoice.receiptNo || "");
  setShowUpinReceiptModal(true);
};





/////////////////////////////////////// SAVE UPIN + RECEIPT //////////////////////////////////////

const saveUpinAndReceipt = async () => {
  try {
    if (!selectedInvoiceForEdit?.id) {
      alert("Invoice not found");
      return;
    }

    await updateDoc(doc(db, "invoices", selectedInvoiceForEdit.id), {
      upinNo: upinNo,
      receiptNo: receiptNo,
      updatedAt: new Date()
    });

    // UPDATE LOCAL STATE
    const updatedInvoices = allInvoices.map((inv) =>
      inv.id === selectedInvoiceForEdit.id
        ? {
            ...inv,
            upinNo,
            receiptNo
          }
        : inv
    );

    setAllInvoices(updatedInvoices);

    alert("Frame Remark updated successfully!");

    setShowUpinReceiptModal(false);

  } catch (error) {
    console.error("Error updating invoice:", error);
    alert("Failed to update data");
  }
};







/////////////////////////////////////// EXCEL DOWNLOAD ///////////////////////////////////////

const downloadUpinReceiptExcel = () => {

  // SORT OLDEST TOP -> LATEST BOTTOM
  const sortedInvoices = [...filteredInvoices].sort((a, b) => {
    const dateA = a.createdAt?.seconds
      ? new Date(a.createdAt.seconds * 1000)
      : new Date(a.date || 0);

    const dateB = b.createdAt?.seconds
      ? new Date(b.createdAt.seconds * 1000)
      : new Date(b.date || 0);

    return dateA - dateB;
  });

  const excelData = sortedInvoices.map((invoice, index) => ({
    "No": index + 1,
    "Date": invoice.formattedDate || "",
    "2nd Frame": invoice.upinNo || "",
    "Remark": invoice.receiptNo || "",

   
   
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "2ND_FRAME_REPORT"
  );

  XLSX.writeFile(
    workbook,
    `2ND_FRAME_REPORT_${Date.now()}.xlsx`
  );
};





/////////////////////////////////////////// direct invoice direct sale////////////////////////////////////////////////////////
const [isSavingDirectSale, setIsSavingDirectSale] = useState(false);

const fetchDirectSaleProducts = async () => {
  try {
    const q = query(collection(db, "stock"));

    const snap = await getDocs(q);

    let products = [];

    snap.forEach((docSnap) => {
      const data = docSnap.data();

      if (["other", "sunglass"].includes(data.category)) {

        if (Array.isArray(data.items)) {

          data.items.forEach((item) => {
            products.push({
              stockDocId: docSnap.id,
              category: data.category,
              ...item
            });
          });

        }

      }
    });

    console.log("DIRECT PRODUCTS LOADED:", products);

    setAvailableDirectProducts(products);

  } catch (err) {
    console.log("fetch error", err);
  }
};



useEffect(() => {
  fetchDirectSaleProducts();
}, []);









const handleDirectSaleSearch = (text) => {

  setDirectSaleSearch(text);

  if (text.trim().length < 1) {
    setShowDirectSaleSuggestions(false);
    setDirectSaleSuggestions([]);
    return;
  }

  const search = text.toLowerCase();

  const filtered = availableDirectProducts.filter((item) => {

    const model =
      item.modelNo?.toLowerCase().includes(search);

    const brand =
      item.brand?.toLowerCase().includes(search);

    const colour =
      item.colour?.toLowerCase().includes(search);

    return (
      (model || brand || colour) &&
      Number(item.qty) > 0
    );

  });

  setDirectSaleSuggestions(filtered);

  setShowDirectSaleSuggestions(true);

};



const selectDirectProduct = (item) => {

  const existing = directSaleItems.find(
    (p) =>
      p.modelNo === item.modelNo &&
      p.colour === item.colour
  );

  if (existing) {

    setDirectSaleItems(prev =>
      prev.map(p =>
        p.modelNo === item.modelNo &&
        p.colour === item.colour
          ? {
              ...p,
              qty: p.qty + 1,
              total:
                (p.qty + 1) * p.sellingPrice
            }
          : p
      )
    );

  } else {

    setDirectSaleItems(prev => [
      ...prev,
      {
        stockDocId: item.stockDocId,
        modelNo: item.modelNo,
        brand: item.brand,
        colour: item.colour,
        category: item.category || "other",

        sellingPrice: Number(item.sellingPrice),

        qty: 1,

        stockQty: Number(item.qty),

        total: Number(item.sellingPrice)
      }
    ]);

  }

  setDirectSaleSearch("");

  setShowDirectSaleSuggestions(false);

};





const updateDirectSaleQty = (index, qty) => {

  const updated = [...directSaleItems];

  const item = updated[index];

  let numericQty = Number(qty);

  if (isNaN(numericQty) || numericQty < 1) {
    numericQty = 1;
  }

  if (numericQty > item.stockQty) {

    alert(
      `Only ${item.stockQty} items available in stock`
    );

    numericQty = item.stockQty;
  }

  updated[index] = {
    ...item,
    qty: numericQty,
    total:
      numericQty *
      Number(item.sellingPrice)
  };

  setDirectSaleItems(updated);

};








const removeDirectSaleItem = (index) => {

  const updated = [...directSaleItems];

  updated.splice(index, 1);

  setDirectSaleItems(updated);

};





/* =====================================================
   TOTALS
===================================================== */

const directSaleSubtotal = directSaleItems.reduce(
  (sum, item) => sum + item.total,
  0
);

const calculatedDiscount =
  discountType === "percentage"
    ? (
        directSaleSubtotal *
        (Number(formData.discount || 0) / 100)
      )
    : Number(formData.discount || 0);

/* GRAND TOTAL */
const directSaleTotal =
  directSaleSubtotal - calculatedDiscount;

/* USER PAYMENT */
const directSaleAdvanceAmount =
  Number(formData.advancePayment || 0);

/* BALANCE */
const directSaleBalance =
  Math.max(
    0,
    directSaleTotal -
    directSaleAdvanceAmount
  );


/* PAYMENT STATUS */
const paymentStatus =
  directSaleAdvanceAmount >= directSaleTotal
    ? "fully-paid"
    : directSaleAdvanceAmount > 0
    ? "advance-paid"
    : "pending";







// Add these state declarations with your other useState hooks
const [showPrescription, setShowPrescription] = useState(false);





const handleSaveDirectSale = async () => {
  if (isSavingDirectSale) return;
  setIsSavingDirectSale(true);

  try {
    if (directSaleItems.length === 0) {
      alert("Please add at least one product");
      setIsSavingDirectSale(false);
      return;
    }

if (!selectedSalesPerson || selectedSalesPerson.trim() === "") {
  alert("Please select a Sales Person");
  setIsSavingDirectSale(false);
  return;
}

    if (Number(formData.advancePayment || 0) > Number(directSaleTotal)) {
      alert("Payment cannot exceed total amount");
      setIsSavingDirectSale(false);
      return;
    }

    const invoiceNumber = await refreshInvoiceNumber();

    // Build prescription data ONLY if prescription checkbox is checked
    let prescriptionData = null;
    let hbRxData = null;

    if (showPrescription) {
      prescriptionData = {
        rightEye: {
          sph: formData.rightSph || "",
          cyl: formData.rightCyl || "",
          axis: formData.rightAxis || "",
          add: formData.rightAdd || "",
          visualAcuity: formData.rightVisualAcuity || "",
          nearVA: formData.rightNearVA || ""
        },
        leftEye: {
          sph: formData.leftSph || "",
          cyl: formData.leftCyl || "",
          axis: formData.leftAxis || "",
          add: formData.leftAdd || "",
          visualAcuity: formData.leftVisualAcuity || "",
          nearVA: formData.leftNearVA || ""
        },
        bc: formData.bc || "",
        dm: formData.dm || "",
        prescriptionDate: formData.prescriptionDate || "",
        referredBy: formData.referredBy || ""
      };

      // Build HB Rx data if HB Rx checkbox is checked
      if (showHBRx) {
        hbRxData = {
          rightEye: {
            sph: formData.hbRxRightSph || "",
            cyl: formData.hbRxRightCyl || "",
            axis: formData.hbRxRightAxis || "",
            add: formData.hbRxRightAdd || "",
            visualAcuity: formData.hbRxRightVisualAcuity || "",
            nearVA: formData.hbRxRightNearVA || ""
          },
          leftEye: {
            sph: formData.hbRxLeftSph || "",
            cyl: formData.hbRxLeftCyl || "",
            axis: formData.hbRxLeftAxis || "",
            add: formData.hbRxLeftAdd || "",
            visualAcuity: formData.hbRxLeftVisualAcuity || "",
            nearVA: formData.hbRxLeftNearVA || ""
          }
        };
      }
    }

    const invoiceData = {
      type: "direct-sale",
       salePerson:
    selectedSalesPerson || "",
      billingDate: billingDate || "",
      customer: {
        title: formData.title || "",
        firstName: formData.firstName,
        lastName: formData.lastName,
        fullName: `${formData.title} ${formData.firstName} ${formData.lastName}`,
        tpNo: formData.tpNo,
        address: formData.address || "",
        note: formData.note || ""
      },
      products: directSaleItems.map(item => ({
        stockDocId: item.stockDocId,
        modelNo: item.modelNo,
        brand: item.brand,
        colour: item.colour,
        category: item.category || "other",
        qty: Number(item.qty) || 1,
        price: Number(item.sellingPrice) || 0,
        total: Number(item.total) || 0
      })),
      financial: {
        subtotal: directSaleSubtotal,
        discountType,
        discount: Number(formData.discount) || 0,
        calculatedDiscount,
        totalAmount: directSaleTotal,
        advancePayment: directSaleAdvanceAmount,
        balanceDue: directSaleBalance,
        paymentType: directSaleAdvanceAmount >= directSaleTotal ? "full" : "advance",
        paymentMethod: formData.paymentMethod || "Cash"
      },
      invoiceNumber,
      paymentStatus,
      createdAt: new Date().toISOString(),
      status: directSaleBalance <= 0 ? "fully-paid" : "advance-paid",
      prescription: prescriptionData,
      hbRx: hbRxData,
      includePrescription: showPrescription,
      includeHB: showHBRx
    };

    const cleanData = JSON.parse(JSON.stringify(invoiceData));
    await addDoc(collection(db, "invoices"), cleanData);
    await reduceDirectSaleStock();
    await createStockOutForDirectSale(invoiceNumber);

    // Generate INVOICE PDF (always)
    await generateDirectSaleInvoicePDF(cleanData);

    // Generate PRESCRIPTION PDF (ONLY if prescription checkbox is checked)
    if (showPrescription) {
      await generatePrescriptionPDF(cleanData);
    }

    alert("Direct Sale Saved Successfully!");

    // Reset everything after successful save
    handleDirectResetForm();

  } catch (error) {
    console.log(error);
    alert("Error saving direct sale: " + error.message);
  } finally {
    setIsSavingDirectSale(false);
  }
};













const generatePrescriptionPDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 15;

  const formatDateSafe = (dateValue) => {
    if (!dateValue) return "-";
    try {
      if (dateValue.toDate) {
        return dateValue.toDate().toLocaleDateString();
      } else if (dateValue.seconds) {
        return new Date(dateValue.seconds * 1000).toLocaleDateString();
      } else if (typeof dateValue === 'string') {
        return new Date(dateValue).toLocaleDateString();
      } else if (dateValue instanceof Date) {
        return dateValue.toLocaleDateString();
      }
      return "Invalid Date";
    } catch (e) {
      return "Invalid Date";
    }
  };

  // HEADER
  // try {
  //   doc.addImage("/house-of-vision-logo.png", "PNG", 10, y, 60, 17);
  // } catch (logoError) {
  //   console.error("Logo not found");
  // }

  // doc.setFont("Times New Roman", "bold");
  // doc.setFontSize(12);
  // doc.text("HOUSE OF VISION", pageWidth - 10, 20, { align: "right" });

  // doc.setFont("Times New Roman", "normal");
  // doc.setFontSize(8);
  // doc.text("No. 355, Maharagama Road, Boralesgamuwa", pageWidth - 10, 27, { align: "right" });
  // doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", pageWidth - 10, 33, { align: "right" });
  // doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", pageWidth - 10, 39, { align: "right" });
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.text(`Date: ${formatDateSafe(invoiceData.createdAt)}`, pageWidth - 10, 45, { align: "right" });

  y = 49;

  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("PRESCRIPTION", pageWidth / 2, y, { align: "center" });
  y += 6;

  // WATERMARK
  // try {
  //   const imgProps = doc.getImageProperties("/watermark.png");
  //   const watermarkWidth = 120;
  //   const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  //   const centerX = pageWidth / 2 - watermarkWidth / 2;
  //   doc.setGState(new doc.GState({ opacity: 0.10 }));
  //   doc.addImage("/watermark.png", "PNG", centerX, 90, watermarkWidth, watermarkHeight);
  //   doc.setGState(new doc.GState({ opacity: 1 }));
  // } catch (watermarkError) {
  //   console.error("Watermark not found");
  // }

  // PATIENT DETAILS
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Patient Details", 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text(`Invoice: ${invoiceData.invoiceNumber}`, 10, y);
  y += 6;
  // doc.text(`Prescription Date: ${formatDateSafe(invoiceData.prescription?.prescriptionDate) || '-'}`, 105, y);
  // y += 5;


  // In generatePrescriptionPDF function

const calculateAge = (dob) => {
  if (!dob || dob === '-') return '-';
  
  try {
    let birthDate;
    
    if (dob.includes('-')) {
      const parts = dob.split('-');
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          birthDate = new Date(parts[0], parts[1] - 1, parts[2]);
        } else if (parts[2].length === 4) {
          birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
        }
      }
    } else if (dob.includes('.')) {
      const parts = dob.split('.');
      if (parts.length === 3 && parts[2].length === 4) {
        birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
      }
    } else {
      birthDate = new Date(dob);
    }
    
    if (!birthDate || isNaN(birthDate.getTime())) {
      return dob;
    }
    
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return `${age} years`;
  } catch (error) {
    return dob;
  }
};

// In the patient details section
const dobValue = invoiceData.customer?.age || invoiceData.customer?.dob || '-';
const ageDisplay = calculateAge(dobValue);

doc.text(`Name: ${invoiceData.customer.fullName}`, 10, y);
doc.text(`Age: ${ageDisplay}`, 105, y);










  y += 5;
  doc.text(`Address: ${invoiceData.customer.address || "-"}`, 10, y);
  doc.text(`Tel: ${invoiceData.customer.tpNo}`, 105, y);
  y += 5;
  doc.text(`Referred By: ${invoiceData.prescription?.referredBy || "-"}`, 10, y);
  y += 6;

  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // PRESCRIPTION SECTION
 doc.setFillColor(200, 200, 200);
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Prescription (Rx)", 12, y);
  y += 8;

  // BC and DM info
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text(`BC: ${invoiceData.prescription?.bc || "-"}`, 10, y);
  doc.text(`DM: ${invoiceData.prescription?.dm || "-"}`, 60, y);
  y += 6;

  // PRESCRIPTION TABLE - WITHOUT AXIS
  const p = invoiceData.prescription || {};
  const tableWidth = 130;
  const tableStartX = (pageWidth - tableWidth) / 2;
  const rowHeight = 8;
  const fontSize = 9;

  // Removed AXIS column
  const colWidths = {
    eye: 30, sph: 22, cyl: 22, add: 18, va: 18, nearVA: 20
  };

  const totalCols = 6;
  const remainingWidth = tableWidth - (colWidths.eye + colWidths.sph + colWidths.cyl + colWidths.add + colWidths.va + colWidths.nearVA);
  const extraWidth = remainingWidth / totalCols;

  // Removed axis from colPos
  let colPos = {
    eye: tableStartX,
    sph: tableStartX + colWidths.eye + extraWidth,
    cyl: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth,
    add: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth + colWidths.cyl + extraWidth,
    va: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth + colWidths.cyl + extraWidth + colWidths.add + extraWidth,
    nearVA: tableStartX + colWidths.eye + extraWidth + colWidths.sph + extraWidth + colWidths.cyl + extraWidth + colWidths.add + extraWidth + colWidths.va + extraWidth
  };

  doc.setLineWidth(0.2);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(fontSize);
  doc.setFillColor(0, 0, 128);
  doc.rect(tableStartX, y, tableWidth, rowHeight, "F");
  doc.setTextColor(255, 255, 255);

  // Removed AXIS from header
  const headerLabels = ["Eye", "SPH", "CYL", "ADD", "D VA", "N VA"];
  const colKeys = ["eye", "sph", "cyl", "add", "va", "nearVA"];

  headerLabels.forEach((label, i) => {
    const key = colKeys[i];
    const x = colPos[key] + (colWidths[key] + extraWidth) / 2;
    doc.text(label, x, y + 5.5, { align: "center" });
  });

  doc.setDrawColor(255, 255, 255);
  colKeys.forEach(key => {
    doc.line(colPos[key], y, colPos[key], y + rowHeight);
  });
  doc.line(tableStartX + tableWidth, y, tableStartX + tableWidth, y + rowHeight);

  y += rowHeight;
  doc.setTextColor(0, 0, 0);
  doc.setDrawColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");

  // Removed AXIS from data
  const rightEyeData = [
    "Right Eye",
    p.rightEye?.sph || "-",
    p.rightEye?.cyl || "-",
    p.rightEye?.add || "-",
    p.rightEye?.visualAcuity || "-",
    p.rightEye?.nearVA || "-"
  ];

  const leftEyeData = [
    "Left Eye",
    p.leftEye?.sph || "-",
    p.leftEye?.cyl || "-",
    p.leftEye?.add || "-",
    p.leftEye?.visualAcuity || "-",
    p.leftEye?.nearVA || "-"
  ];

  function drawRow(data, yPos) {
    data.forEach((value, i) => {
      const key = colKeys[i];
      const x = colPos[key] + (colWidths[key] + extraWidth) / 2;
      doc.text(String(value), x, yPos + 5.5, { align: "center" });
    });
    colKeys.forEach(key => {
      doc.line(colPos[key], yPos, colPos[key], yPos + rowHeight);
    });
    doc.line(tableStartX + tableWidth, yPos, tableStartX + tableWidth, yPos + rowHeight);
  }

  doc.setFillColor(248, 250, 252);
  doc.rect(tableStartX, y, tableWidth, rowHeight, "F");
  doc.rect(tableStartX, y, tableWidth, rowHeight);
  drawRow(rightEyeData, y);
  y += rowHeight;

  doc.rect(tableStartX, y, tableWidth, rowHeight);
  drawRow(leftEyeData, y);
  y += rowHeight + 4;

  doc.line(10, y, pageWidth - 10, y);
  y += 4;

  // HB Rx SECTION (if present) - WITHOUT AXIS
  const hasHbRx = invoiceData.hbRx && (
    (invoiceData.hbRx.rightEye?.sph && invoiceData.hbRx.rightEye?.sph !== '') ||
    (invoiceData.hbRx.rightEye?.cyl && invoiceData.hbRx.rightEye?.cyl !== '') ||
    (invoiceData.hbRx.leftEye?.sph && invoiceData.hbRx.leftEye?.sph !== '') ||
    (invoiceData.hbRx.leftEye?.cyl && invoiceData.hbRx.leftEye?.cyl !== '')
  );

  if (hasHbRx) {
    y += 4;
     doc.setFillColor(200, 200, 200);
    doc.rect(10, y - 4, pageWidth - 20, 6, "F");
    doc.setTextColor(0, 0, 0);
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(10);
    doc.text("HB Rx", 12, y);
    doc.setTextColor(0, 0, 0);
    y += 8;

    const hbTableWidth = 130;
    const hbTableStartX = (pageWidth - hbTableWidth) / 2;
    const hbRowHeight = 8;
    const hbFontSize = 9;

    // Removed AXIS from HB Rx
    const hbColWidths = {
      eye: 30, sph: 22, cyl: 22, add: 18, va: 18, nearVA: 20
    };

    const hbTotalCols = 6;
    const hbRemainingWidth = hbTableWidth - (hbColWidths.eye + hbColWidths.sph + hbColWidths.cyl + hbColWidths.add + hbColWidths.va + hbColWidths.nearVA);
    const hbExtraWidth = hbRemainingWidth / hbTotalCols;

    let hbColPos = {
      eye: hbTableStartX,
      sph: hbTableStartX + hbColWidths.eye + hbExtraWidth,
      cyl: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth,
      add: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth + hbColWidths.cyl + hbExtraWidth,
      va: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth + hbColWidths.cyl + hbExtraWidth + hbColWidths.add + hbExtraWidth,
      nearVA: hbTableStartX + hbColWidths.eye + hbExtraWidth + hbColWidths.sph + hbExtraWidth + hbColWidths.cyl + hbExtraWidth + hbColWidths.add + hbExtraWidth + hbColWidths.va + hbExtraWidth
    };

    doc.setLineWidth(0.2);
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(hbFontSize);
    doc.setFillColor(0, 100, 0);
    doc.rect(hbTableStartX, y, hbTableWidth, hbRowHeight, "F");
    doc.setTextColor(255, 255, 255);

    // Removed AXIS from HB Rx header
    const hbHeaderLabels = ["Eye", "SPH", "CYL", "ADD", "D VA", "N VA"];
    const hbColKeys = ["eye", "sph", "cyl", "add", "va", "nearVA"];

    hbHeaderLabels.forEach((label, i) => {
      const key = hbColKeys[i];
      const x = hbColPos[key] + (hbColWidths[key] + hbExtraWidth) / 2;
      doc.text(label, x, y + 5.5, { align: "center" });
    });

    doc.setDrawColor(255, 255, 255);
    hbColKeys.forEach(key => {
      doc.line(hbColPos[key], y, hbColPos[key], y + hbRowHeight);
    });
    doc.line(hbTableStartX + hbTableWidth, y, hbTableStartX + hbTableWidth, y + hbRowHeight);

    y += hbRowHeight;
    doc.setTextColor(0, 0, 0);
    doc.setDrawColor(0, 0, 0);
    doc.setFont("Times New Roman", "bold");

    // Removed AXIS from HB Rx data
    const hbRightEyeData = [
      "Right Eye",
      invoiceData.hbRx?.rightEye?.sph || "-",
      invoiceData.hbRx?.rightEye?.cyl || "-",
      invoiceData.hbRx?.rightEye?.add || "-",
      invoiceData.hbRx?.rightEye?.visualAcuity || "-",
      invoiceData.hbRx?.rightEye?.nearVA || "-"
    ];

    const hbLeftEyeData = [
      "Left Eye",
      invoiceData.hbRx?.leftEye?.sph || "-",
      invoiceData.hbRx?.leftEye?.cyl || "-",
      invoiceData.hbRx?.leftEye?.add || "-",
      invoiceData.hbRx?.leftEye?.visualAcuity || "-",
      invoiceData.hbRx?.leftEye?.nearVA || "-"
    ];

    function drawHbRow(data, yPos) {
      data.forEach((value, i) => {
        const key = hbColKeys[i];
        const x = hbColPos[key] + (hbColWidths[key] + hbExtraWidth) / 2;
        doc.text(String(value), x, yPos + 5.5, { align: "center" });
      });
      hbColKeys.forEach(key => {
        doc.line(hbColPos[key], yPos, hbColPos[key], yPos + hbRowHeight);
      });
      doc.line(hbTableStartX + hbTableWidth, yPos, hbTableStartX + hbTableWidth, yPos + hbRowHeight);
    }

    doc.setFillColor(248, 250, 252);
    doc.rect(hbTableStartX, y, hbTableWidth, hbRowHeight, "F");
    doc.rect(hbTableStartX, y, hbTableWidth, hbRowHeight);
    drawHbRow(hbRightEyeData, y);
    y += hbRowHeight;

    doc.rect(hbTableStartX, y, hbTableWidth, hbRowHeight);
    drawHbRow(hbLeftEyeData, y);
    y += hbRowHeight + 4;

    doc.line(10, y, pageWidth - 10, y);
    y += 8;
  }

  y += 4;

  // Note
  doc.setFontSize(9);
  doc.setFont("Times New Roman", "normal");
  doc.text(`Note: ${invoiceData.customer?.note || "-"}`, 10, y);
  y += 4;

  // Footer
  // doc.setFont("Times New Roman", "bold");
  // doc.setFontSize(9);
  // doc.setTextColor(0, 0, 0);
  // doc.text("Member of Mount Apollo Hospitals", pageWidth / 2, y + 5, { align: "center" });

  // SAVE PDF
  doc.save(`${invoiceData.invoiceNumber}_PRESCRIPTION.pdf`);
};



const reduceDirectSaleStock = async () => {
  console.log("Starting stock reduction for items:", directSaleItems);

  for (const item of directSaleItems) {
    try {
      const stockRef = doc(db, "stock", item.stockDocId);
      const snap = await getDoc(stockRef);

      if (!snap.exists()) {
        console.error(`Stock document ${item.stockDocId} not found!`);
        continue;
      }

      const data = snap.data();
      
      // Handle both array-based and simple stock structures
      if (data.items && Array.isArray(data.items)) {
        let itemFound = false;
        
        const updatedItems = data.items.map(stockItem => {
          // Try multiple matching strategies
          const matchByModelAndColor = 
            stockItem.modelNo === item.modelNo && 
            stockItem.colour === item.colour;
          
          const matchByModelOnly = 
            stockItem.modelNo === item.modelNo && 
            (!item.colour || item.colour === "");
          
          const matchByBrandAndModel = 
            stockItem.brand === item.brand && 
            stockItem.modelNo === item.modelNo;
          
          const isMatch = matchByModelAndColor || matchByModelOnly || matchByBrandAndModel;
          
          if (isMatch) {
            itemFound = true;
            const currentQty = stockItem.qty || 0;
            const newQty = currentQty - item.qty;
            
            if (newQty < 0) {
              console.warn(`Warning: Stock would become negative for ${item.modelNo}! Current: ${currentQty}, Reducing by: ${item.qty}`);
            }
            
            console.log(`Reducing stock: ${item.modelNo} from ${currentQty} to ${Math.max(0, newQty)}`);
            
            return {
              ...stockItem,
              qty: Math.max(0, newQty)
            };
          }
          return stockItem;
        });
        
        if (!itemFound) {
          console.error(`Item not found in stock: ${item.modelNo}, Color: ${item.colour}`);
          console.log("Available items:", data.items.map(i => ({modelNo: i.modelNo, colour: i.colour, brand: i.brand})));
          throw new Error(`Product ${item.modelNo} not found in stock`);
        }
        
        await updateDoc(stockRef, { items: updatedItems });
        console.log(`Successfully updated stock for ${item.modelNo}`);
        
      } else if (data.quantity !== undefined) {
        // Simple stock structure
        const currentQty = data.quantity || 0;
        const newQty = currentQty - item.qty;
        
        if (newQty < 0) {
          console.warn(`Warning: Stock would become negative for ${item.modelNo}! Current: ${currentQty}, Reducing by: ${item.qty}`);
        }
        
        await updateDoc(stockRef, { 
          quantity: Math.max(0, newQty)
        });
        console.log(`Updated simple stock: ${item.modelNo} from ${currentQty} to ${Math.max(0, newQty)}`);
        
      } else {
        console.error(`Unknown stock structure for ${item.stockDocId}`);
      }
      
    } catch (error) {
      console.error(`Error reducing stock for item ${item.modelNo}:`, error);
      throw error; // Re-throw to stop the save process
    }
  }
  
  console.log("Stock reduction completed successfully");
};















const createStockOutForDirectSale = async (invoiceNumber) => {
  console.log("Creating stock_out records for invoice:", invoiceNumber);
  
  for (const item of directSaleItems) {
    try {
      // Get the actual remaining stock after reduction
      const stockRef = doc(db, "stock", item.stockDocId);
      const snap = await getDoc(stockRef);
      
      let remainingStock = 0;
      
      if (snap.exists()) {
        const data = snap.data();
        if (data.items && Array.isArray(data.items)) {
          const foundItem = data.items.find(
            i => i.modelNo === item.modelNo && i.colour === item.colour
          );
          remainingStock = foundItem ? (foundItem.qty || 0) : 0;
        } else if (data.quantity !== undefined) {
          remainingStock = data.quantity || 0;
        }
      }
      
      const stockOutRecord = {
        productId: item.stockDocId,
        productType: item.productType || item.category || "",
        productModel: item.modelNo,
        brand: item.brand,
        colour: item.colour,
        quantity: item.qty,
        price: item.sellingPrice,
        remainingStock: remainingStock,
        customerName: `${formData.title} ${formData.firstName} ${formData.lastName}`,
        invoiceNumber: invoiceNumber,
        type: "sale",
        date: new Date().toISOString(),
        createdAt: new Date().toISOString()
      };
      
      console.log("Creating stock_out record:", stockOutRecord);
      await addDoc(collection(db, "stock_out"), stockOutRecord);
      
    } catch (error) {
      console.error(`Error creating stock_out for ${item.modelNo}:`, error);
      throw error;
    }
  }
  
  console.log("Stock_out records created successfully");
};
















const generateDirectSaleInvoicePDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 15;

  // ------------------------------
  // HEADER WITH LOGO
  // ------------------------------
  // doc.addImage("/house-of-vision-logo.png", "PNG", 10, y, 60, 17);

  // doc.setFont("Times New Roman", "bold");
  // doc.setFontSize(12);
  // doc.text("HOUSE OF VISION", pageWidth - 10, 20, { align: "right" });

  // doc.setFont("Times New Roman", "normal");
  // doc.setFontSize(8);
  // doc.text("No. 355, Maharagama Road, Boralesgamuwa", pageWidth - 10, 27, { align: "right" });
  // doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", pageWidth - 10, 33, { align: "right" });
  // doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", pageWidth - 10, 39, { align: "right" });
    doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.text(`Date: ${new Date(invoiceData.createdAt).toLocaleDateString()}`, pageWidth - 10, 45, { align: "right" });

  y = 47;

  // ------------------------------
  // DIVIDER LINE
  // ------------------------------
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // ------------------------------
  // INVOICE TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("INVOICE", pageWidth / 2, y, { align: "center" });
  y += 4;

  // ------------------------------
  // INVOICE DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text(`Invoice No: ${invoiceData.invoiceNumber}`, 10, y);
  y += 6;

  // ------------------------------
  // WATERMARK (CENTERED)
  // ------------------------------
  // const imgProps = doc.getImageProperties("/watermark.png");
  // const watermarkWidth = 120;
  // const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  // const centerX = pageWidth / 2 - watermarkWidth / 2;

  // doc.setGState(new doc.GState({ opacity: 0.10 }));
  // doc.addImage("/watermark.png", "PNG", centerX, 90, watermarkWidth, watermarkHeight);
  // doc.setGState(new doc.GState({ opacity: 1 }));

  // ------------------------------
  // CUSTOMER DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Customer Details", 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text(
    `Name: ${invoiceData.customer?.title || ""} ${invoiceData.customer?.fullName || ""}`.trim(),
    10,
    y
  );

  y += 6;
  doc.text(`TP: ${invoiceData.customer.tpNo}`, 10, y);
  y += 6;
  doc.text(`Address: ${invoiceData.customer.address || "-"}`, 10, y);
  y += 4;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // ------------------------------
  // PRODUCT DETAILS SECTION WITH NAVY BLUE BAR
  // ------------------------------
  doc.setFillColor(200, 200, 200);
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");
  
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Product Details", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 7;

  // TABLE HEADER
  doc.setFillColor(240, 240, 240);
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(8);
  doc.text("Model No. | Brand | Color", 12, y);
  doc.text("Qty", 95, y);
  doc.text("Price", 110, y);
  doc.text("Total", pageWidth - 10, y, { align: "right" });
  y += 5;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  
  invoiceData.products.forEach((item, index) => {
    // Page break check
    if (y > 180) {
      doc.addPage();
      y = 20;
    }
    
    // Product row
    const productLine = `${item.modelNo || "-"} | ${item.brand || "-"} | ${item.colour || "-"}`;
    doc.text(`${index + 1}`, 15, y);
    doc.text(productLine.substring(0, 35), 20, y);
    doc.text(`${item.qty || 1}`, 95, y);
    doc.text(`Rs. ${Number(item.price || 0).toFixed(0)}`, 110, y);
    doc.text(`Rs. ${Number(item.total || 0).toFixed(0)}`, pageWidth - 10, y, { align: "right" });
    y += 5;
  });

  y += 3;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // ------------------------------
  // PAYMENT DETAILS SECTION WITH NAVY BLUE BAR
  // ------------------------------
  doc.setFillColor(200, 200, 200);
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");
  
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text("Payment Details", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 7;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  
  doc.text("Subtotal", 10, y);
  doc.text(`Rs. ${Number(invoiceData.financial.subtotal || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  // DISCOUNT SECTION - SHOW BOTH PERCENTAGE AND AMOUNT
  let discount = 0;
  let discountType = 'amount';
  let discountValue = 0;
  let calculatedDiscount = 0;

  // Get discount from financial data
  if (invoiceData.financial.discount !== undefined) {
    discount = invoiceData.financial.discount;
  }
  if (invoiceData.financial.discountType) {
    discountType = invoiceData.financial.discountType;
  }
  if (invoiceData.financial.discountValue) {
    discountValue = invoiceData.financial.discountValue;
  }
  if (invoiceData.financial.calculatedDiscount) {
    calculatedDiscount = invoiceData.financial.calculatedDiscount;
  }

  // If calculatedDiscount is not provided but we have discount and discountType
  if (!calculatedDiscount && discount > 0 && discountType === 'percentage') {
    const subtotal = Number(invoiceData.financial.subtotal || 0);
    calculatedDiscount = (subtotal * discount) / 100;
  }

  // Only show discount if it's greater than 0
  if (discount > 0 || calculatedDiscount > 0) {
    let discountLabel = "Discount";
    let discountDisplay = "";
    
    if (discountType === 'percentage') {
      // Show both percentage and amount
      discountLabel = `Discount (${discount}%)`;
      discountDisplay = `Rs. ${(calculatedDiscount || 0).toFixed(2)}`;
    } else {
      // Amount discount
      discountLabel = "Discount";
      discountDisplay = `Rs. ${discount.toFixed(2)}`;
    }
    
    doc.text(discountLabel, 10, y);
    doc.text(discountDisplay, pageWidth - 10, y, { align: "right" });
    y += 4;
  }

  doc.setFont("Times New Roman", "bold");
  doc.text("Grand Total", 10, y);
  doc.text(`Rs. ${Number(invoiceData.financial.totalAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.text("Paid Amount", 10, y);
  doc.text(`Rs. ${Number(invoiceData.financial.advancePayment || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 8;

  doc.setFont("Times New Roman", "normal");
  doc.text("Balance Due", 10, y);
  doc.text(`Rs. ${Number(invoiceData.financial.balanceDue || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 4;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 6;
  
  doc.setFontSize(8);
  doc.text(`Served By: ${invoiceData.salePerson || "-"}`, 10, y);
  y += 5;

  doc.text(`Note: ${invoiceData.customer.note || "-"}`, 10, y);
  y += 6;

  // ------------------------------
  // TERMS & CONDITIONS
  // ------------------------------
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Terms & Conditions", 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);

  const terms = [
    "* Collect your order within 90 days; otherwise, it will be canceled.",
    "* Bring your order form for proper after-service assistance.",
    "* Any frame repairs or adjustments are at customer's risk and Physical damage is excluded from warranty coverage.",
    "* No cancellations once the order is confirmed.",
    "* Warranty coverage depends on the brand and service and All sales are final, No refunds after purchase",
  ];

  terms.forEach(term => {
    const lines = doc.splitTextToSize(term, pageWidth - 20);
    lines.forEach(line => {
      doc.text(line, 12, y);
      y += 4;
    });
  });

  y += 5;

  // ------------------------------
  // FOOTER THANK YOU
  // ------------------------------
  // doc.setFontSize(7);
  // doc.setTextColor(0, 0, 0);
  // doc.setFont("Times New Roman", "bolditalic");
  // doc.text("Member of Mount Apollo Hospitals", pageWidth / 2, y + 5, { align: "center" });

  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`${invoiceData.invoiceNumber}_DIRECT_SALE.pdf`);
};






// Function to restore stock for a direct sale invoice
const restoreDirectSaleStock = async (invoiceData) => {
  try {
    if (!invoiceData.products || invoiceData.products.length === 0) {
      console.log('No products to restore');
      return;
    }

    console.log('Restoring stock for direct sale invoice:', invoiceData.invoiceNumber);

    for (const product of invoiceData.products) {
      const stockRef = doc(db, "stock", product.stockDocId);
      const stockSnap = await getDoc(stockRef);

      if (!stockSnap.exists()) {
        console.warn(`Stock document not found for product: ${product.modelNo}`);
        continue;
      }

      const stockData = stockSnap.data();

      if (stockData.items && Array.isArray(stockData.items)) {
        let itemFound = false;
        
        const updatedItems = stockData.items.map(stockItem => {
          // Multiple matching strategies for different categories
          const matchByModelAndColor = 
            stockItem.modelNo === product.modelNo && 
            stockItem.colour === product.colour;
          
          const matchByModelOnly = 
            stockItem.modelNo === product.modelNo && 
            (!product.colour || product.colour === "" || !stockItem.colour);
          
          const matchByBrandAndModel = 
            stockItem.brand === product.brand && 
            stockItem.modelNo === product.modelNo;
          
          // For lens category (uses sph, cyl, axis instead of modelNo)
          const matchByLensSpecs = 
            stockItem.sph === product.sph &&
            stockItem.cyl === product.cyl &&
            stockItem.axis === product.axis &&
            stockItem.add === product.add;
          
          // For other category (uses itemName)
          const matchByItemName = 
            stockItem.itemName === product.itemName &&
            stockItem.brand === product.brand;
          
          const isMatch = matchByModelAndColor || matchByModelOnly || 
                         matchByBrandAndModel || matchByLensSpecs || matchByItemName;
          
          if (isMatch) {
            itemFound = true;
            const currentQty = stockItem.qty || 0;
            const restoredQty = currentQty + (product.qty || 0);
            console.log(`Restoring ${product.qty} units of ${product.modelNo || product.itemName} (Current: ${currentQty}, New: ${restoredQty})`);
            return {
              ...stockItem,
              qty: restoredQty
            };
          }
          return stockItem;
        });

        if (!itemFound) {
          console.warn(`Item not found in stock for restoration: ${product.modelNo || product.itemName}, Colour: ${product.colour}`);
          // Try fallback - find by any matching field
          const fallbackMatch = stockData.items.find(item => 
            item.modelNo === product.modelNo || 
            item.itemName === product.itemName ||
            item.brand === product.brand
          );
          
          if (fallbackMatch) {
            console.log(`Using fallback match for ${product.modelNo || product.itemName}`);
            const updatedItemsWithFallback = stockData.items.map(stockItem => {
              if (stockItem.modelNo === product.modelNo || 
                  stockItem.itemName === product.itemName ||
                  (stockItem.brand === product.brand && stockItem.modelNo === product.modelNo)) {
                const currentQty = stockItem.qty || 0;
                const restoredQty = currentQty + (product.qty || 0);
                return {
                  ...stockItem,
                  qty: restoredQty
                };
              }
              return stockItem;
            });
            await updateDoc(stockRef, { items: updatedItemsWithFallback });
            console.log(`Stock restored using fallback for product: ${product.modelNo || product.itemName}`);
          } else {
            console.error(`No matching item found for product:`, product);
          }
        } else {
          await updateDoc(stockRef, { items: updatedItems });
          console.log(`Stock restored for product: ${product.modelNo || product.itemName}`);
        }
        
      } else {
        // Simple stock structure
        const currentQty = stockData.quantity || 0;
        const restoredQty = currentQty + (product.qty || 0);
        await updateDoc(stockRef, { quantity: restoredQty });
        console.log(`Stock restored for simple product: ${product.modelNo || product.itemName}`);
      }
    }

    console.log('Direct sale stock restoration completed');
    return true;

  } catch (error) {
    console.error('Error restoring direct sale stock:', error);
    throw error;
  }
};







// Delete stock_out records for a direct sale invoice
const deleteDirectSaleStockOutRecords = async (invoiceNumber) => {
  try {
    const stockOutQuery = query(
      collection(db, 'stock_out'),
      where('invoiceNumber', '==', invoiceNumber)
    );

    const stockOutSnapshot = await getDocs(stockOutQuery);
    let deletedCount = 0;

    for (const stockOutDoc of stockOutSnapshot.docs) {
      await deleteDoc(doc(db, 'stock_out', stockOutDoc.id));
      deletedCount++;
      console.log(`Deleted stock_out record: ${stockOutDoc.id}`);
    }

    console.log(`Deleted ${deletedCount} stock_out records`);
    return deletedCount;

  } catch (error) {
    console.error('Error deleting stock_out records:', error);
    throw error;
  }
};





const handleDirectResetForm = () => {
  // Reset all form data
  setFormData({
    title: '',
    firstName: '',
    lastName: '',
    address: '',
    tpNo: '',
    note: '',
    prescriptionDate: new Date().toISOString().split('T')[0],
    referredBy: '',
    bc: '',
    dm: '',
    rightVisualAcuity: '',
    rightSph: '',
    rightCyl: '',
    rightAxis: '',
    rightAdd: '',
    rightNearVA: '',
    leftVisualAcuity: '',
    leftSph: '',
    leftCyl: '',
    leftAxis: '',
    leftAdd: '',
    leftNearVA: '',
    hbRxRightVisualAcuity: '',
    hbRxRightSph: '',
    hbRxRightCyl: '',
    hbRxRightAxis: '',
    hbRxRightAdd: '',
    hbRxRightNearVA: '',
    hbRxLeftVisualAcuity: '',
    hbRxLeftSph: '',
    hbRxLeftCyl: '',
    hbRxLeftAxis: '',
    hbRxLeftAdd: '',
    hbRxLeftNearVA: '',
    discount: 0,
    advancePayment: 0,
    paymentMethod: 'Cash'
  });

  // Reset direct sale items
  setDirectSaleItems([]);

  // Reset sale form
  setSaleForm({ 
    salePerson: '' 
  });

  // Reset billing date to today
  setBillingDate(new Date().toISOString().split('T')[0]);

  // Reset discount type
  setDiscountType('amount');

  // Reset prescription checkboxes
  setShowPrescription(false);
  setShowHBRx(false);

  // Reset customer search
  resetCustomerForm();

  // Clear search
  setDirectSaleSearch('');
  setShowDirectSaleSuggestions(false);
  setDirectSaleSuggestions([]);

  // Clear errors
  setErrors({});

  // Reset customer data
  setExistingCustomerData(null);
  setIsEditingCustomer(false);

  // Reset invoice number (will be generated fresh)
  generateNextInvoiceNumber();
};



















///////////////////////////////////////// service invoice  service bill ///////////////////////////////////////////////

const [isSavingServiceInvoice, setIsSavingServiceInvoice] = useState(false);


const serviceSubtotal =
  Number(serviceAmount || 0);

const serviceCalculatedDiscount =
  discountType === "percentage"
    ? (
        serviceSubtotal *
        (Number(formData.discount || 0) / 100)
      )
    : Number(formData.discount || 0);

const serviceGrandTotal =
  serviceSubtotal -
  serviceCalculatedDiscount;

// const serviceBalance =
//   serviceGrandTotal -
//   Number(formData.advancePayment || 0);

const serviceAdvanceAmount =
  servicePaymentType === "full"
    ? serviceGrandTotal
    : Number(
        formData.advancePayment || 0
      );

const serviceBalance =
  serviceGrandTotal -
  serviceAdvanceAmount;








const handleSaveServiceInvoice = async () => {

  // PREVENT MULTIPLE CLICKS
  if (isSavingServiceInvoice) return;

  setIsSavingServiceInvoice(true);

  try {

    if (!serviceDescription) {
      alert("Please enter service description");
      return;
    }

    if (!serviceAmount) {
      alert("Please enter service amount");
      return;
    }

        // ✅ NEW VALIDATION: Make Sales Person compulsory
    if (!selectedSalesPerson || selectedSalesPerson.trim() === "") {
      alert("Please select a Sales Person");
      return;
    }

    // SAME INVOICE SEQUENCE
    const invoiceNumber =
      await refreshInvoiceNumber();

    const invoiceData = {

      type: "service-invoice",

      salePerson:
    selectedSalesPerson || "",

      billingDate:
        billingDate || "",

      customer: {

        title:
          formData.title || "",

        firstName:
          formData.firstName || "",

        lastName:
          formData.lastName || "",

        fullName:
          `${formData.title} ${formData.firstName} ${formData.lastName}`,

        tpNo:
          formData.tpNo || "",

        address:
          formData.address || ""

      },

      service: {

        description:
          serviceDescription || "",

        amount:
          Number(serviceAmount) || 0

      },

      financial: {

        paymentType:
          servicePaymentType || "full",

        subtotal:
          Number(serviceSubtotal) || 0,

        discountType:
          discountType || "amount",

        discount:
          Number(formData.discount) || 0,

        calculatedDiscount:
          Number(serviceCalculatedDiscount) || 0,

        advancePayment:
          Number(serviceAdvanceAmount) || 0,

        paymentMethod:
          formData.paymentMethod || "Cash",

        totalAmount:
          Number(serviceGrandTotal) || 0,

        balanceDue:
          Number(serviceBalance) || 0

      },

      invoiceNumber,

      createdAt:
        new Date().toISOString(),

      status:
        serviceBalance <= 0
          ? "fully-paid"
          : "advance-paid"

    };

    const cleanData =
      JSON.parse(
        JSON.stringify(invoiceData)
      );

    await addDoc(
      collection(db, "invoices"),
      cleanData
    );

    await generateServiceInvoicePDF(
      cleanData
    );

    alert(
      "Service Invoice Saved"
    );

    setServiceDescription("");
    setServiceAmount("");

    handleResetForm();

    await generateNextInvoiceNumber();

  } catch (error) {

    console.log(error);

    alert(
      "Error saving service invoice"
    );

  } finally {

    // ALWAYS ENABLE AGAIN
    setIsSavingServiceInvoice(false);

  }

};









const generateServiceInvoicePDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 15;

  // ------------------------------
  // HEADER WITH LOGO
  // ------------------------------
  // Add logo (adjust path as needed)
  // doc.addImage("/house-of-vision-logo.png", "PNG", 10, y, 60, 17);

  // doc.setFont("Times New Roman", "bold");
  // doc.setFontSize(12);
  // doc.text("HOUSE OF VISION", pageWidth - 10, 20, { align: "right" });

  // doc.setFont("Times New Roman", "normal");
  // doc.setFontSize(8);
  // doc.text("No. 355, Maharagama Road, Boralesgamuwa", pageWidth - 10, 27, { align: "right" });
  // doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", pageWidth - 10, 33, { align: "right" });
  // doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", pageWidth - 10, 39, { align: "right" });
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.text(`Date: ${new Date().toLocaleDateString()}`, pageWidth - 10, 45, { align: "right" });

  y = 47;



  // ------------------------------
  // DIVIDER LINE
  // ------------------------------
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // ------------------------------
  // INVOICE TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(14);
  doc.text("SERVICE INVOICE", pageWidth / 2, y, { align: "center" });
  y += 4;




// ------------------------------
  // WATERMARK (CENTERED)
  // ------------------------------
  // const imgProps = doc.getImageProperties("/watermark.png");
  // const watermarkWidth = 120;
  // const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  // const centerX = pageWidth / 2 - watermarkWidth / 2;

  // doc.setGState(new doc.GState({ opacity: 0.10 }));
  // doc.addImage("/watermark.png", "PNG", centerX, 90, watermarkWidth, watermarkHeight);
  // doc.setGState(new doc.GState({ opacity: 1 }));




  // ------------------------------
  // INVOICE DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text(`Invoice No: ${invoiceData.invoiceNumber}`, 10, y);
  y += 6;

  
  // ------------------------------
  // CUSTOMER DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Customer Details", 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text(`Name: ${invoiceData.customer.fullName}`, 10, y);
  y += 6;
  doc.text(`TP: ${invoiceData.customer.tpNo}`, 10, y);
  y += 4;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;


  // ------------------------------
  // SERVICE DETAILS SECTION WITH NAVY BLUE BAR (REDUCED HEIGHT)
  // ------------------------------
  // Navy blue background bar for "Service Details" heading
  doc.setFillColor(200, 200, 200); 
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");  // Changed from 8 to 6
  


  // White text on  bar
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Service Details", 12, y);
  
  // Reset text color for content
  doc.setTextColor(0, 0, 0);
  y += 7;  // Reduced from 6 to 5

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  
  const splitText = doc.splitTextToSize(invoiceData.service.description, pageWidth - 20);
  doc.text(splitText, 10, y);
  y += splitText.length * 5 + 5;

  doc.text(`Service Charge: Rs. ${Number(invoiceData.service.amount).toFixed(2)}`, 10, y);
  y += 4;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // ------------------------------
  // PAYMENT DETAILS SECTION WITH NAVY BLUE BAR (REDUCED HEIGHT)
  // ------------------------------
  // Navy blue background bar for "Payment Details" heading
  doc.setFillColor(200, 200, 200); // Navy blue
  doc.rect(10, y - 4, pageWidth - 20, 6, "F");  // Changed from 8 to 6
  
  // White text on navy blue bar
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Payment Details", 12, y);
  
  // Reset text color for content
  doc.setTextColor(0, 0, 0);
  y += 7;  // Reduced from 8 to 5

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  
  doc.text("Subtotal", 10, y);
  doc.text(`Rs. ${invoiceData.financial.subtotal.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.text("Discount", 10, y);
  doc.text(`Rs. ${invoiceData.financial.calculatedDiscount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.text("Paid Amount", 10, y);
  doc.text(`Rs. ${invoiceData.financial.advancePayment.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 8;

  doc.setFont("Times New Roman", "normal");
  doc.text("Balance Due", 10, y);
  doc.text(`Rs. ${invoiceData.financial.balanceDue.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 4;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  doc.setFont("Times New Roman", "normal");
  doc.text(`Served By: ${invoiceData.salePerson || "-"}`, 10, y);
  y += 6;

  // ------------------------------
  // TERMS & CONDITIONS
  // ------------------------------
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("Terms & Conditions", 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);

  const terms = [
    "* Collect your order within 90 days; otherwise, it will be canceled.",
    "* Bring your order form for proper after-service assistance.",
    "* Any frame repairs or adjustments are at customer's risk and Physical damage is excluded from warranty coverage.",
    "* No cancellations once the order is confirmed.",
    "* Warranty coverage depends on the brand and service and All sales are final, No refunds after purchase",
  "• The deposite/advance will be forfeited within a period of two months of uncollected orders.",
 ];

  terms.forEach(term => {
    const lines = doc.splitTextToSize(term, pageWidth - 20);
    lines.forEach(line => {
      doc.text(line, 12, y);
      y += 4;
    });
  });

  y += 3;

  // ------------------------------
  // FOOTER THANK YOU
  // ------------------------------
//   doc.setFontSize(8);
// doc.setTextColor(0, 0, 0);  // RED
// doc.setFont("Times New Roman", "bolditalic");
//   doc.text("Member of Mount Apollo Hospitals", pageWidth / 2, y + 5, { align: "center" });

  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`${invoiceData.invoiceNumber}_SERVICE_INVOICE.pdf`);
};





////////////////////////////////////////////////////// view all patient //////////////////////////////////////////////////////////////////////////

// Add state for patient directory
const [patients, setPatients] = useState([]);
const [filteredPatients, setFilteredPatients] = useState([]);
const [patientSearchTerm, setPatientSearchTerm] = useState('');
const [patientFilterAge, setPatientFilterAge] = useState('all');
const [patientFilterGender, setPatientFilterGender] = useState('all');
const [selectedPatient, setSelectedPatient] = useState(null);
const [showPatientDetails, setShowPatientDetails] = useState(false);
const [isLoadingPatients, setIsLoadingPatients] = useState(false);
const [patientDateRange, setPatientDateRange] = useState({ start: '', end: '' });

// Fetch all patients from invoices
// Fetch and group all patients with their invoices
// Fetch all patients from invoices and group them
// Fetch all patients (keeps separate rows per invoice)
const fetchAllPatients = async () => {
  try {
    setIsLoadingPatients(true);

    const invoiceSnap = await getDocs(
      query(collection(db, "invoices"), orderBy("createdAt", "desc"))
    );

    const qcSnap = await getDocs(collection(db, "patient_qc"));
    const trackSnap = await getDocs(collection(db, "track_spectacles"));

    // QC map (invoiceNumber -> qc)
    const qcMap = new Map();
    qcSnap.forEach(doc => {
      const d = doc.data();
      qcMap.set(d.invoiceNumber, d);
    });

    // Tracking map (invoiceNumber -> tracking)
    const trackMap = new Map();
    trackSnap.forEach(doc => {
      const d = doc.data();
      trackMap.set(d.invoiceNumber, d);
    });

    const invoiceList = [];

    invoiceSnap.forEach(docSnap => {
      const data = docSnap.data();
      const customer = data.customer || {};

      const invoiceNumber = data.invoiceNumber;
      const createdAt = data.createdAt || new Date();
      const totalAmount = Number(data.financial?.totalAmount || 0);
      const paidAmount = Number(data.financial?.advancePayment || 0) + Number(data.totalBalancePaid || 0);
      const balanceDue = Number(data.financial?.balanceDue || 0);

      // Create single invoice object for this row
      const singleInvoice = {
        id: docSnap.id,
        invoiceNumber: invoiceNumber,
        date: createdAt,
        totalAmount: totalAmount,
        paidAmount: paidAmount,
        balanceDue: balanceDue,
        status: balanceDue <= 0 ? "paid" : "pending",
        products: data.products || {},
        spectacleTracking: trackMap.get(invoiceNumber) || null,
        qcData: qcMap.get(invoiceNumber) || null
      };

      invoiceList.push({
        // Basic info (for table row)
        id: docSnap.id,
        invoiceNumber: invoiceNumber,
        date: createdAt,
        fullName: customer.fullName || `${customer.title || ""} ${customer.firstName || ""} ${customer.lastName || ""}`.trim(),
        tpNo: customer.tpNo || "",
        email: customer.email || "",
        age: customer.age || "",
        gender: customer.gender || "",
        address: customer.address || "",
        title: customer.title || "",
        
        // Financial (for table)
        totalAmount: totalAmount,
        paidAmount: paidAmount,
        balanceDue: balanceDue,
        status: balanceDue <= 0 ? "paid" : "pending",
        
        // For summary cards and modal
        totalSpent: totalAmount,      // This invoice amount
        totalDue: balanceDue,         // This invoice balance
        totalInvoices: 1,             // Each row is 1 invoice
        
        // For modal invoice history (wrap as array with 1 item)
        invoices: [singleInvoice],
        
        // For visit dates (same for this single invoice)
        firstVisit: createdAt,
        lastVisit: createdAt,
        
        // Tracking & QC
        spectacleTracking: trackMap.get(invoiceNumber) || null,
        qcData: qcMap.get(invoiceNumber) || null
      });
    });

    setPatients(invoiceList);
    setFilteredPatients(invoiceList);

  } catch (error) {
    console.error(error);
    alert(error.message);
  } finally {
    setIsLoadingPatients(false);
  }
};


// Filter patients
const filterPatients = () => {
  let filtered = [...patients];
  
  // Search filter
  if (patientSearchTerm) {
    const searchLower = patientSearchTerm.toLowerCase();
    filtered = filtered.filter(patient => 
      patient.fullName?.toLowerCase().includes(searchLower) ||
      patient.tpNo?.toLowerCase().includes(searchLower) ||
      patient.email?.toLowerCase().includes(searchLower) ||
      patient.address?.toLowerCase().includes(searchLower)
    );
  }
  
  // Age filter
  if (patientFilterAge !== 'all') {
    filtered = filtered.filter(patient => {
      const age = parseInt(patient.age);
      if (patientFilterAge === 'child') return age < 18;
      if (patientFilterAge === 'adult') return age >= 18 && age < 60;
      if (patientFilterAge === 'senior') return age >= 60;
      return true;
    });
  }
  
  // Gender filter
  if (patientFilterGender !== 'all') {
    filtered = filtered.filter(patient => 
      patient.gender?.toLowerCase() === patientFilterGender.toLowerCase()
    );
  }
  
  // Date range filter (last visit)
  if (patientDateRange.start) {
    const startDate = new Date(patientDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(patient => new Date(patient.lastVisit) >= startDate);
  }
  
  if (patientDateRange.end) {
    const endDate = new Date(patientDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(patient => new Date(patient.lastVisit) <= endDate);
  }
  
  setFilteredPatients(filtered);
};

// View patient details
const viewPatientDetails = (patient) => {
  setSelectedPatient(patient);
  setShowPatientDetails(true);
};



// QC STATES
const [showQCModal, setShowQCModal] = useState(false);
const [selectedQCPatient, setSelectedQCPatient] = useState(null);

const [qcForm, setQcForm] = useState({
  qcPerson: '',
  qcDate: '',
  qcTime: ''
});

// OPEN QC MODAL
const openQCModal = (patient) => {
  const now = new Date();
  const currentDate = now.toISOString().split("T")[0];
  const currentTime = now.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit"
  });

  setSelectedQCPatient(patient);
  
  // Get the latest invoice number
  const latestInvoice = patient.invoices && patient.invoices.length > 0 
    ? patient.invoices[patient.invoices.length - 1] 
    : null;

  setQcForm({
    qcPerson: '',
    qcDate: currentDate,
    qcTime: currentTime,
    invoiceNumber: latestInvoice?.invoiceNumber || ''  // Store invoice number
  });

  setShowQCModal(true);
};

// SAVE QC - FIXED VERSION
const saveQC = async () => {
  try {
    if (!qcForm.qcPerson || !qcForm.qcDate) {
      alert("Please fill all QC details");
      return;
    }

    // Get the patient ID correctly - check multiple possible field names
    let patientId = null;
    
    if (selectedQCPatient) {
      // Try different possible field names for patient ID
      patientId = selectedQCPatient.patientKey || 
                  selectedQCPatient.id || 
                  selectedQCPatient._id ||
                  selectedQCPatient.patientId ||
                  selectedQCPatient.userId;
      
      // If still no ID, try to generate from email or name
      if (!patientId && selectedQCPatient.email) {
        patientId = selectedQCPatient.email.replace(/[^a-zA-Z0-9]/g, '_');
      } else if (!patientId && selectedQCPatient.fullName) {
        patientId = selectedQCPatient.fullName.replace(/\s/g, '_').toLowerCase();
      }
    }

    // Validate we have a patient ID
    if (!patientId) {
      console.error("Patient data:", selectedQCPatient);
      alert("Error: Could not find patient ID. Please check patient data.");
      return;
    }

    const qcData = {
      patientId: patientId,
      patientName: selectedQCPatient.fullName || selectedQCPatient.name || 'Unknown',
      tpNo: selectedQCPatient.tpNo || selectedQCPatient.phone || selectedQCPatient.mobile || '',
      invoiceNumber: qcForm.invoiceNumber || '',
      qcPerson: qcForm.qcPerson,
      qcDate: qcForm.qcDate,
      qcTime: qcForm.qcTime,
      createdAt: new Date(),
      status: 'pending' // Add status for tracking
    };

    // Remove any undefined values
    Object.keys(qcData).forEach(key => {
      if (qcData[key] === undefined) {
        delete qcData[key];
      }
    });

    console.log("Saving QC Data:", qcData); // Debug log
    await addDoc(collection(db, "patient_qc"), qcData);
    alert("QC Saved Successfully");
    setShowQCModal(false);
    
    // Reset form
    setQcForm({
      qcPerson: '',
      qcDate: '',
      qcTime: ''
    });
    setSelectedQCPatient(null);
    
    // Refresh patient data
    if (typeof fetchAllPatients === 'function') {
      fetchAllPatients();
    }
  } catch (error) {
    console.error("QC Save Error:", error);
    alert("Error saving QC: " + error.message);
  }
};









// Generate patient report PDF
// Generate patient report PDF
const generatePatientReportPDF = async () => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const primaryColor = [15, 23, 42];

  let currentPage = 1;
  let rowCount = 0;
  let y = 0;

  // Function to draw complete header for any page
  const drawFullHeader = (isFirstPage) => {
    // Header background
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 38, "F");
    
    // Logo
    try {
      doc.addImage("/house-of-vision-logo.png", "PNG", 12, 5,50, 20);
    } catch (err) {}
    
    // Company details
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text("HOUSE OF VISION", 45, 14);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("No. 355, Maharagama Road, Boralesgamuwa", 65, 21);
    doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", 65, 27);
    doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", 65, 33);
    
    // Title
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    
    if (isFirstPage) {
      doc.text("PATIENT DIRECTORY", pageWidth / 2, 52, { align: "center" });
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 60, { align: "center" });
      
      // Summary
      // const totalPatients = filteredPatients.length;
      // const totalRevenue = filteredPatients.reduce((sum, p) => sum + (p.totalSpent || 0), 0);
      // const totalDue = filteredPatients.reduce((sum, p) => sum + (p.totalDue || 0), 0);
      
      // doc.setFontSize(10);
      // doc.setTextColor(0, 0, 0);
      // doc.text(`Total Patients: ${totalPatients}`, 10, 72);
      // doc.text(`Total Revenue: Rs. ${totalRevenue.toLocaleString()}`, 80, 72);
      // doc.text(`Total Due: Rs. ${totalDue.toLocaleString()}`, 160, 72);
      
      return 82; // Return Y position after summary
    } else {
      doc.text("PATIENT DIRECTORY (Continued)", pageWidth / 2, 52, { align: "center" });
      return 62; // Return Y position for continued pages
    }
  };

  // Function to draw table headers
  const drawTableHeaders = (y) => {
    doc.setFillColor(...primaryColor);
    doc.rect(10, y, 40, 8, 'F');
    doc.rect(52, y, 45, 8, 'F');
    doc.rect(99, y, 35, 8, 'F');
    doc.rect(136, y, 25, 8, 'F');
    doc.rect(163, y, 20, 8, 'F');
    doc.rect(185, y, 35, 8, 'F');
    doc.rect(222, y, 35, 8, 'F');
    doc.rect(259, y, 30, 8, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");

    doc.text("Invoice No.", 12, y + 5);
    doc.text("Patient Name", 54, y + 5);
    doc.text("Address", 101, y + 5);
    doc.text("Phone", 138, y + 5);
    doc.text("Age", 165, y + 5);
    doc.text("Total Spent", 187, y + 5);
    doc.text("Balance Due", 224, y + 5);
    doc.text("Last Visit", 261, y + 5);

    return y + 8;
  };

  // Draw first page
  let startY = drawFullHeader(true);
  y = drawTableHeaders(startY);
  
  // Loop through patients
  for (let patient of filteredPatients) {
    // Check if need new page
    if (y > 200) {
      doc.addPage();
      startY = drawFullHeader(false);
      y = drawTableHeaders(startY);
      rowCount = 0;
    }
    
    // Alternate row background
    if (rowCount % 2 === 0) {
      doc.setFillColor(245, 248, 250);
      doc.rect(10, y, 280, 7, 'F');
    }
    
    // Draw borders
    doc.setDrawColor(200, 200, 200);
    doc.rect(10, y, 40, 7);
    doc.rect(52, y, 45, 7);
    doc.rect(99, y, 35, 7);
    doc.rect(136, y, 25, 7);
    doc.rect(163, y, 20, 7);
    doc.rect(185, y, 35, 7);
    doc.rect(222, y, 35, 7);
    doc.rect(259, y, 30, 7);
    
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    
    doc.text((patient.invoiceNumber || '-').substring(0, 15), 12, y + 5);
    
    let name = patient.fullName || '-';
    doc.text(name.length > 20 ? name.substring(0, 18) + '..' : name, 54, y + 5);
    
    let address = patient.address || '-';
    doc.text(address.length > 18 ? address.substring(0, 16) + '..' : address, 101, y + 5);
    
    doc.text(patient.tpNo || '-', 138, y + 5);
    doc.text(patient.age ? patient.age.toString() : '-', 165, y + 5);
    doc.text(`Rs. ${(patient.totalSpent || 0).toLocaleString()}`, 218, y + 5, { align: 'right' });
    
    if ((patient.totalDue || 0) > 0) {
      doc.setTextColor(220, 38, 38);
      doc.setFont("helvetica", "bold");
    }
    doc.text(`Rs. ${(patient.totalDue || 0).toLocaleString()}`, 255, y + 5, { align: 'right' });
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    
    let lastVisit = patient.lastVisit ? new Date(patient.lastVisit).toLocaleDateString() : '-';
    doc.text(lastVisit, 261, y + 5);
    
    y += 7;
    rowCount++;
  }

  // Add page numbers

const pageCount = doc.internal.getNumberOfPages();
for (let i = 1; i <= pageCount; i++) {
  doc.setPage(i);
  doc.setFontSize(8);
  doc.setTextColor(128, 128, 128);
  doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 3, { align: "center" });
}

  doc.save(`PATIENT_REPORT_${Date.now()}.pdf`);
};




// Reset filters
const resetPatientFilters = () => {
  setPatientSearchTerm('');
  setPatientFilterAge('all');
  setPatientFilterGender('all');
  setPatientDateRange({ start: '', end: '' });
  setFilteredPatients(patients);
};

// Fetch patients when component mounts
useEffect(() => {
  if (selectedOption === "viewPatient") {
    fetchAllPatients();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterPatients();
}, [patientSearchTerm, patientFilterAge, patientFilterGender, patientDateRange.start, patientDateRange.end, patients]);

// Get age group label
const getAgeGroup = (age) => {
  const ageNum = parseInt(age);
  if (ageNum < 18) return 'Child';
  if (ageNum >= 18 && ageNum < 60) return 'Adult';
  if (ageNum >= 60) return 'Senior';
  return 'Unknown';
};










//////////////////////////////////////////////   dashboard panel    /////////////////////////////////////////////////////////////////////////




// OPTIMIZED STATE with caching
const [dashboardStats, setDashboardStats] = useState({
  totalRevenue: 0,
  totalReceived: 0,
  totalInvoices: 0,
  totalPatients: 0,
  pendingBalance: 0,
  monthlyRevenue: Array(12).fill(0),
  topProducts: [],
  recentInvoices: [],
  paymentMethods: [],
  dailySales: [],
  framesSold: 0,
  lensesSold: 0,
  averageInvoiceValue: 0
});
const [isLoadingDashboard, setIsLoadingDashboard] = useState(false);
const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
const [dashboardCache, setDashboardCache] = useState({});

// OPTIMIZED: Fetch only current month's data with date range filter

const fetchDashboardData = async () => {
  try {
    setIsLoadingDashboard(true);
    
    // Get ALL invoices first (no date filter in query)
    const invoicesSnapshot = await getDocs(collection(db, 'invoices'));
    
    console.log(`Total invoices in DB: ${invoicesSnapshot.size}`);
    
    if (invoicesSnapshot.empty) {
      console.log("No invoices found");
      setIsLoadingDashboard(false);
      return;
    }
    
    const invoices = [];
    const invoiceNumbers = [];
    
    for (const doc of invoicesSnapshot.docs) {
      const data = doc.data();
      
      // Get the date from the invoice
      let createdDate = null;
      if (data.createdAt?.toDate) {
        createdDate = data.createdAt.toDate();
      } else if (data.createdAt) {
        createdDate = new Date(data.createdAt);
      } else if (data.date) {
        createdDate = new Date(data.date);
      }
      
      if (!createdDate || isNaN(createdDate.getTime())) {
        console.log(`Skipping invoice ${data.invoiceNumber} - invalid date`);
        continue;
      }
      
      const year = createdDate.getFullYear();
      const month = createdDate.getMonth() + 1;
      
      // Filter by selected month/year in JavaScript
      if (year === selectedYear && month === selectedMonth) {
        console.log(`✅ Including invoice ${data.invoiceNumber} (${createdDate.toLocaleDateString()})`);
        invoiceNumbers.push(data.invoiceNumber);
        invoices.push({
          ...data,
          id: doc.id,
          createdAt: createdDate,
          year,
          month,
          day: createdDate.getDate()
        });
      }
    }
    
    console.log(`Found ${invoices.length} invoices for ${selectedMonth}/${selectedYear}`);
    
    if (invoices.length === 0) {
      setDashboardStats({
        totalRevenue: 0,
        totalReceived: 0,
        totalInvoices: 0,
        totalPatients: 0,
        pendingBalance: 0,
        monthlyRevenue: Array(12).fill(0),
        topProducts: [],
        recentInvoices: [],
        paymentMethods: [],
        dailySales: Array(new Date(selectedYear, selectedMonth, 0).getDate()).fill(0),
        framesSold: 0,
        lensesSold: 0,
        averageInvoiceValue: 0
      });
      setIsLoadingDashboard(false);
      return;
    }
    
    // Fetch balance invoices for these invoice numbers
    let balancePaymentsMap = new Map();
    
    if (invoiceNumbers.length > 0) {
      for (let i = 0; i < invoiceNumbers.length; i += 30) {
        const batch = invoiceNumbers.slice(i, i + 30);
        const balanceQuery = query(
          collection(db, 'balance_invoices'),
          where('originalInvoiceNumber', 'in', batch)
        );
        const balanceSnapshot = await getDocs(balanceQuery);
        
        balanceSnapshot.forEach((balanceDoc) => {
          const balanceData = balanceDoc.data();
          const invNum = balanceData.originalInvoiceNumber;
          const paidAmount = balanceData.paidAmount || 0;
          balancePaymentsMap.set(invNum, (balancePaymentsMap.get(invNum) || 0) + paidAmount);
        });
      }
    }
    
    // Calculate all metrics
    let totalRevenue = 0;
    let totalReceived = 0;
    let pendingBalance = 0;
    let framesSold = 0;
    let lensesSold = 0;
    const uniquePatients = new Map();
    const productSales = new Map();
    const paymentMethods = new Map();
    const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
    const dailySales = Array(daysInMonth).fill(0);
    const monthlyRevenue = Array(12).fill(0);
    
    for (const inv of invoices) {
      const totalPaid = (inv.financial?.advancePayment || 0);
      const totalAmount = inv.financial?.totalAmount || 0;
      
      totalRevenue += totalAmount;
      totalReceived += totalPaid;
      pendingBalance += (totalAmount - totalPaid);
      
      if (inv.products?.frameModel) {
        framesSold++;
        productSales.set(inv.products.frameModel, (productSales.get(inv.products.frameModel) || 0) + 1);
      }
      if (inv.products?.lensModel) {
        lensesSold++;
        productSales.set(inv.products.lensModel, (productSales.get(inv.products.lensModel) || 0) + 1);
      }
      
      const patientKey = `${inv.customer?.fullName || inv.customer?.firstName || ''}_${inv.customer?.tpNo || ''}`;
      if (patientKey !== '_') uniquePatients.set(patientKey, inv.customer);
      
      const method = inv.financial?.paymentMethod || 'Cash';
      paymentMethods.set(method, (paymentMethods.get(method) || 0) + totalPaid);
      
      const dayIndex = inv.day - 1;
      if (dayIndex >= 0 && dayIndex < dailySales.length) {
        dailySales[dayIndex] += totalPaid;
      }
      
      if (inv.year === selectedYear) {
        monthlyRevenue[inv.month - 1] += totalPaid;
      }
    }
    
    const dashboardData = {
      totalRevenue,
      totalReceived,
      totalInvoices: invoices.length,
      totalPatients: uniquePatients.size,
      pendingBalance,
      monthlyRevenue,
      topProducts: Array.from(productSales.entries()).map(([name, count]) => ({ name, count })).sort((a, b) => b.count - a.count).slice(0, 5),
      recentInvoices: invoices.slice(0, 5).map(inv => ({
        invoiceNumber: inv.invoiceNumber,
        customerName: inv.customer?.fullName || inv.customer?.firstName || '-',
        totalAmount: inv.financial?.totalAmount || 0,
        paidAmount: (inv.financial?.advancePayment || 0) + (balancePaymentsMap.get(inv.invoiceNumber) || 0),
        balanceDue: (inv.financial?.totalAmount || 0) - ((inv.financial?.advancePayment || 0) + (balancePaymentsMap.get(inv.invoiceNumber) || 0)),
        date: inv.createdAt
      })),
      paymentMethods: Array.from(paymentMethods.entries()).map(([name, value]) => ({ name, value })),
      dailySales,
      framesSold,
      lensesSold,
      averageInvoiceValue: invoices.length > 0 ? totalRevenue / invoices.length : 0
    };
    
    console.log("Dashboard Data Summary:", {
      totalRevenue,
      totalInvoices: invoices.length,
      framesSold,
      lensesSold
    });
    
    setDashboardStats(dashboardData);
    setIsLoadingDashboard(false);
    
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    setIsLoadingDashboard(false);
    alert('Error loading dashboard: ' + error.message);
  }
};

const debugAllInvoiceDates = async () => {
  try {
    console.log("=== CHECKING ALL INVOICE DATES IN DATABASE ===");
    const invoicesSnapshot = await getDocs(collection(db, 'invoices'));
    
    if (invoicesSnapshot.empty) {
      console.log("No invoices found at all!");
      return;
    }
    
    console.log(`Total invoices in database: ${invoicesSnapshot.size}`);
    
    const yearMonthMap = new Map();
    
    invoicesSnapshot.docs.forEach((doc) => {
      const data = doc.data();
      let createdDate = null;
      
      // Try different date formats
      if (data.createdAt?.toDate) {
        createdDate = data.createdAt.toDate();
      } else if (data.createdAt) {
        createdDate = new Date(data.createdAt);
      } else if (data.date) {
        createdDate = new Date(data.date);
      } else if (data.invoiceDate) {
        createdDate = new Date(data.invoiceDate);
      }
      
      if (createdDate && !isNaN(createdDate.getTime())) {
        const year = createdDate.getFullYear();
        const month = createdDate.getMonth() + 1;
        const key = `${year}-${month}`;
        yearMonthMap.set(key, (yearMonthMap.get(key) || 0) + 1);
        
        console.log(`Invoice ${data.invoiceNumber}: ${createdDate.toLocaleDateString()} (Year: ${year}, Month: ${month})`);
      } else {
        console.log(`Invoice ${data.invoiceNumber}: NO VALID DATE found. Raw createdAt:`, data.createdAt);
      }
    });
    
    console.log("\n=== SUMMARY BY YEAR/MONTH ===");
    const sortedKeys = Array.from(yearMonthMap.keys()).sort();
    sortedKeys.forEach(key => {
      console.log(`${key}: ${yearMonthMap.get(key)} invoices`);
    });
    
    // Also check if there are any invoices with the current year
    const currentYear = new Date().getFullYear();
    const currentYearInvoices = invoicesSnapshot.docs.filter(doc => {
      const data = doc.data();
      let date = data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt);
      return date.getFullYear() === currentYear;
    });
    console.log(`\nInvoices from ${currentYear}: ${currentYearInvoices.length}`);
    
  } catch (error) {
    console.error("Debug error:", error);
  }
};

// Call this in useEffect
useEffect(() => {
  if (selectedOption === "dashboard") {
    debugAllInvoiceDates(); // This will show you what dates you actually have
  }
}, [selectedOption]);







// OPTIMIZED: Fetch products with pagination and limit
const [productSearch, setProductSearch] = useState("");
const [allProducts, setAllProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [isLoadingProducts, setIsLoadingProducts] = useState(false);

// OPTIMIZED: Fetch only necessary products with limit
useEffect(() => {
  const fetchProducts = async () => {
    setIsLoadingProducts(true);

    try {
      const snap = await getDocs(collection(db, "stock"));

      let data = [];

      snap.forEach((doc) => {
        const d = doc.data();

        if (d.items && Array.isArray(d.items)) {
          d.items.forEach((item) => {
            data.push({
              id: doc.id,
              category: d.category || "-",
              supplierName: d.supplierName || "-",
              purchaseDate: d.purchaseDate || "-",
              purchaseOrderNo: d.purchaseOrderNo || "-",
              modelNo: item.modelNo || "",
              brand: item.brand || "",
              itemCode: item.itemCode || "",
              colour: item.colour || "",
              sex: item.sex || "",
              qty: Number(item.qty || 0),
              supplyQty: Number(item.supplyQty || 0),
              sellingPrice: Number(item.sellingPrice || 0),
            });
          });
        }
      });

      // Group products with same attributes
      const groupedProducts = groupProducts(data);
      
      setAllProducts(groupedProducts);
      setFilteredProducts(groupedProducts);

      console.log(`Loaded ${data.length} products, grouped into ${groupedProducts.length} unique products`);
    } catch (error) {
      console.error("Error loading products:", error);
    } finally {
      setIsLoadingProducts(false);
    }
  };

  fetchProducts();
}, [selectedOption]);

// Function to group products with same attributes
const groupProducts = (products) => {
  const groupedMap = new Map();

  products.forEach((product) => {
    // Create a unique key based on attributes
    const key = `${product.modelNo}|${product.brand}|${product.colour}|${product.sex}|${product.sellingPrice}`;
    
    if (groupedMap.has(key)) {
      // If product exists, sum the quantities
      const existing = groupedMap.get(key);
      existing.qty += product.qty;
      existing.supplyQty += product.supplyQty;
      // Keep the first id (or you can combine them)
      // existing.id = existing.id + ',' + product.id; // Optional: combine IDs
    } else {
      // Add new product
      groupedMap.set(key, { ...product });
    }
  });

  // Convert map values back to array
  return Array.from(groupedMap.values());
};

// Debounced product search
useEffect(() => {
  const timeoutId = setTimeout(() => {
    const term = productSearch.toLowerCase();
    const filtered = allProducts.filter(p =>
      p.modelNo?.toLowerCase().includes(term) ||
      p.brand?.toLowerCase().includes(term) ||
      p.itemCode?.toLowerCase().includes(term) ||
      p.colour?.toLowerCase().includes(term)
    );
    setFilteredProducts(filtered);
  }, 300);
  
  return () => clearTimeout(timeoutId);
}, [productSearch, allProducts]);












// Chart configurations (move these inside component)
const revenueChartData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [{
    label: 'Monthly Revenue (Rs.)',
    data: dashboardStats.monthlyRevenue,
    backgroundColor: 'rgba(41, 128, 185, 0.8)',
    borderColor: 'rgba(41, 128, 185, 1)',
    borderWidth: 2,
    borderRadius: 5,
  }],
};

const revenueChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top' },
    title: { display: true, text: `Monthly Revenue - ${selectedYear}` }
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: { callback: (value) => `Rs. ${value.toLocaleString()}` }
    }
  }
};

const paymentMethodChartData = {
  labels: dashboardStats.paymentMethods.map(m => m.name),
  datasets: [{
    data: dashboardStats.paymentMethods.map(m => m.value),
    backgroundColor: ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#F44336'],
    borderWidth: 0,
  }],
};

const paymentMethodOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'bottom' },
    title: { display: true, text: 'Payment Methods Distribution' }
  }
};

const dailySalesChartData = {
  labels: Array.from({ length: dashboardStats.dailySales.length }, (_, i) => i + 1),
  datasets: [{
    label: `Daily Sales - ${selectedMonth}/${selectedYear}`,
    data: dashboardStats.dailySales,
    backgroundColor: 'rgba(76, 175, 80, 0.6)',
    borderColor: 'rgba(76, 175, 80, 1)',
    borderWidth: 1,
    fill: true,
  }],
};

const dailySalesOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top' },
    title: { display: true, text: `Daily Sales Performance` }
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: { callback: (value) => `Rs. ${value.toLocaleString()}` }
    }
  }
};

// Fetch data on component mount and when year/month changes
useEffect(() => {
  if (selectedOption === "dashboard") {
    fetchDashboardData();
  }
}, [selectedOption, selectedYear, selectedMonth]);

// Format currency
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'LKR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};










///////////////////////////////////////////////////////// view consultation ////////////////////////////////////////////////////////////////////

// Add state for consultations
const [consultations, setConsultations] = useState([]);
const [filteredConsultations, setFilteredConsultations] = useState([]);
const [consultationSearchTerm, setConsultationSearchTerm] = useState('');
const [consultationFilterStatus, setConsultationFilterStatus] = useState('all');
const [consultationDateRange, setConsultationDateRange] = useState({ start: '', end: '' });
const [isLoadingConsultations, setIsLoadingConsultations] = useState(false);
const [selectedConsultation, setSelectedConsultation] = useState(null);
const [showConsultationDetails, setShowConsultationDetails] = useState(false);
const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);
const [selectedItemForStatus, setSelectedItemForStatus] = useState(null);
const [newStatus, setNewStatus] = useState('');

// Fetch all consultations
const fetchAllConsultations = async () => {
  try {
    setIsLoadingConsultations(true);
    const consultationsQuery = query(
      collection(db, 'consultations'),
      orderBy('createdAt', 'desc')
    );
    const consultationsSnapshot = await getDocs(consultationsQuery);
    const consultationsList = [];
    
    for (const doc of consultationsSnapshot.docs) {
      const data = doc.data();
      const items = data.items || [];
      
      // Calculate totals
      const totalAmount = items.reduce((sum, item) => sum + (item.price || 0), 0);
      const completedItems = items.filter(item => item.status === 'completed').length;
      const pendingItems = items.filter(item => item.status === 'pending').length;
      const cancelledItems = items.filter(item => item.status === 'cancelled').length;
      
      consultationsList.push({
        id: doc.id,
        ...data,
        items: items,
        totalAmount: totalAmount,
        completedItems: completedItems,
        pendingItems: pendingItems,
        cancelledItems: cancelledItems,
        formattedDate: data.createdAt ? new Date(data.createdAt.toDate()).toLocaleDateString() : '-',
        formattedTime: data.createdAt ? new Date(data.createdAt.toDate()).toLocaleTimeString() : '-',
        fullDate: data.createdAt ? new Date(data.createdAt.toDate()) : new Date()
      });
    }
    
    setConsultations(consultationsList);
    setFilteredConsultations(consultationsList);
    setIsLoadingConsultations(false);
  } catch (error) {
    console.error('Error fetching consultations:', error);
    setIsLoadingConsultations(false);
    alert('Error fetching consultations: ' + error.message);
  }
};

// Filter consultations
const filterConsultations = () => {
  let filtered = [...consultations];
  
  // Search filter
  if (consultationSearchTerm) {
    const searchLower = consultationSearchTerm.toLowerCase();
    filtered = filtered.filter(consultation => 
      consultation.customerName?.toLowerCase().includes(searchLower) ||
      consultation.id?.toLowerCase().includes(searchLower)
    );
  }
  
  // Status filter
  if (consultationFilterStatus !== 'all') {
    filtered = filtered.filter(consultation => {
      if (consultationFilterStatus === 'completed') {
        return consultation.pendingItems === 0 && consultation.cancelledItems === 0;
      } else if (consultationFilterStatus === 'pending') {
        return consultation.pendingItems > 0;
      } else if (consultationFilterStatus === 'cancelled') {
        return consultation.cancelledItems > 0;
      }
      return true;
    });
  }
  
  // Date range filter
  if (consultationDateRange.start) {
    const startDate = new Date(consultationDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(consultation => consultation.fullDate >= startDate);
  }
  
  if (consultationDateRange.end) {
    const endDate = new Date(consultationDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(consultation => consultation.fullDate <= endDate);
  }
  
  setFilteredConsultations(filtered);
};

// Update consultation item status
const updateConsultationItemStatus = async (consultationId, itemId, status) => {
  try {
    const consultationRef = doc(db, 'consultations', consultationId);
    const consultationDoc = await getDoc(consultationRef);
    
    if (consultationDoc.exists()) {
      const data = consultationDoc.data();
      const updatedItems = data.items.map(item => 
        item.id === itemId ? { ...item, status: status } : item
      );
      
      await updateDoc(consultationRef, { items: updatedItems });
      alert(`Item status updated to ${status}`);
      await fetchAllConsultations(); // Refresh the list
      setShowUpdateStatusModal(false);
      setSelectedItemForStatus(null);
    }
  } catch (error) {
    console.error('Error updating item status:', error);
    alert('Error updating item status: ' + error.message);
  }
};

// Delete consultation
const deleteConsultation = async (consultationId, customerName) => {
  if (window.confirm(`Are you sure you want to delete consultation for ${customerName}?\n\nThis action cannot be undone!`)) {
    try {
      await deleteDoc(doc(db, 'consultations', consultationId));
      alert('Consultation deleted successfully!');
      await fetchAllConsultations();
    } catch (error) {
      console.error('Error deleting consultation:', error);
      alert('Error deleting consultation: ' + error.message);
    }
  }
};




// Generate consultation report PDF
const generateConsultationReportPDF = async () => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const primaryColor = [41, 128, 185];

  // Header
  pdf.setFillColor(...primaryColor);
  pdf.rect(0, 0, pageWidth, 25, "F");

  pdf.setFontSize(18);
  pdf.setTextColor(255, 255, 255);
  pdf.text("CONSULTATIONS REPORT", pageWidth / 2, 10, { align: "center" });

  pdf.setFontSize(10);
  pdf.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 18, { align: "center" });

  let y = 35;

  // Summary stats
  const totalConsultations = filteredConsultations.length;
  const totalRevenue = filteredConsultations.reduce((sum, c) => sum + c.totalAmount, 0);
  const completedCount = filteredConsultations.filter(c => c.pendingItems === 0 && c.cancelledItems === 0).length;
  const pendingCount = filteredConsultations.filter(c => c.pendingItems > 0).length;

  pdf.setFontSize(12);
  pdf.setTextColor(...primaryColor);
  pdf.text("SUMMARY", 10, y);

  y += 7;
  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  pdf.text(`Total Consultations: ${totalConsultations}`, 10, y);
  pdf.text(`Total Revenue: Rs. ${totalRevenue.toFixed(2)}`, 80, y);
  pdf.text(`Completed: ${completedCount}`, 150, y);
  pdf.text(`Pending: ${pendingCount}`, 200, y);

  y += 15;

  // Table headers
  pdf.setFillColor(...primaryColor);
  pdf.rect(10, y, 30, 8, 'F');
  pdf.rect(40, y, 40, 8, 'F');
  pdf.rect(80, y, 30, 8, 'F');
  pdf.rect(110, y, 25, 8, 'F');
  pdf.rect(135, y, 25, 8, 'F');
  pdf.rect(160, y, 25, 8, 'F');
  pdf.rect(185, y, 30, 8, 'F');

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text("Date", 12, y + 5);
  pdf.text("Customer", 42, y + 5);
  pdf.text("Delivery Date", 82, y + 5);
  pdf.text("Items", 112, y + 5);
  pdf.text("Total", 137, y + 5);
  pdf.text("Completed", 162, y + 5);
  pdf.text("Status", 187, y + 5);

  y += 8;

  // Table rows
  pdf.setTextColor(0, 0, 0);
  for (let consultation of filteredConsultations.slice(0, 20)) {
    if (y > 250) {
      pdf.addPage();
      y = 20;
    }
    
    pdf.rect(10, y, 30, 7);
    pdf.rect(40, y, 40, 7);
    pdf.rect(80, y, 30, 7);
    pdf.rect(110, y, 25, 7);
    pdf.rect(135, y, 25, 7);
    pdf.rect(160, y, 25, 7);
    pdf.rect(185, y, 30, 7);
    
    pdf.text(consultation.formattedDate, 12, y + 5);
    pdf.text(consultation.customerName.substring(0, 20), 42, y + 5);
    pdf.text(consultation.deliveryDate || '-', 82, y + 5);
    pdf.text(consultation.items.length.toString(), 112, y + 5);
    pdf.text(`Rs. ${consultation.totalAmount.toFixed(2)}`, 137, y + 5);
    pdf.text(consultation.completedItems.toString(), 162, y + 5);
    
    const status = consultation.pendingItems === 0 && consultation.cancelledItems === 0 ? 'Completed' : 
                   consultation.cancelledItems > 0 ? 'Cancelled' : 'Pending';
    pdf.text(status, 187, y + 5);
    
    y += 7;
  }

  pdf.save(`CONSULTATIONS_REPORT_${Date.now()}.pdf`);
};

// Reset filters
const resetConsultationFilters = () => {
  setConsultationSearchTerm('');
  setConsultationFilterStatus('all');
  setConsultationDateRange({ start: '', end: '' });
  setFilteredConsultations(consultations);
};

// Fetch consultations when component mounts
useEffect(() => {
  if (selectedOption === "viewConsultation") {
    fetchAllConsultations();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterConsultations();
}, [consultationSearchTerm, consultationFilterStatus, consultationDateRange.start, consultationDateRange.end, consultations]);

// Get status badge color
const getStatusBadge = (consultation) => {
  if (consultation.pendingItems === 0 && consultation.cancelledItems === 0) {
    return { text: 'Completed', color: '#4CAF50' };
  } else if (consultation.cancelledItems > 0) {
    return { text: 'Partially Cancelled', color: '#f44336' };
  } else {
    return { text: 'Pending', color: '#ff9800' };
  }
};



/////////////////////////////////////////// customer card - optica membership /////////////////////////////////////////////////////////

const [membershipData, setMembershipData] = useState({
  customerName: '',
  telephone: '',
  issueDate: '',
  expireDate: '',
  discount: 15, // 15% discount
  status: 'active',
  cardNumber: ''
});

const [membershipErrors, setMembershipErrors] = useState({});
const [isSavingCard, setIsSavingCard] = useState(false);
const [cardSuccess, setCardSuccess] = useState(false);

// Function to generate unique card number
const generateCardNumber = () => {
  const prefix = 'OPT';
  const timestamp = Date.now().toString().slice(-8);
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `${prefix}-${timestamp}-${random}`;
};
// Handle membership form input changes
const handleMembershipInputChange = (e) => {
  const { name, value } = e.target;
  
  setMembershipData(prev => ({
    ...prev,
    [name]: value
  }));
  
  // Auto-calculate expire date when issue date is selected
  if (name === 'issueDate' && value) {
    const issueDateObj = new Date(value);
    const expireDateObj = new Date(issueDateObj);
    expireDateObj.setFullYear(expireDateObj.getFullYear() + 1);
    
    const expireDateStr = expireDateObj.toISOString().split('T')[0];
    
    setMembershipData(prev => ({
      ...prev,
      issueDate: value,
      expireDate: expireDateStr
    }));
  }
  
  // Clear error when user starts typing
  if (membershipErrors[name]) {
    setMembershipErrors(prev => ({
      ...prev,
      [name]: ''
    }));
  }
};

// Validate membership form
const validateMembershipForm = () => {
  const errors = {};
  
  if (!membershipData.customerName.trim()) {
    errors.customerName = 'Customer name is required';
  }
  
  if (!membershipData.telephone.trim()) {
    errors.telephone = 'Telephone number is required';
  } else if (!/^[0-9+\-\s]{10,15}$/.test(membershipData.telephone)) {
    errors.telephone = 'Valid phone number is required';
  }
  
  if (!membershipData.issueDate) {
    errors.issueDate = 'Issue date is required';
  }
  
  if (!membershipData.expireDate) {
    errors.expireDate = 'Expire date is required';
  } else {
    const expireDateObj = new Date(membershipData.expireDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (expireDateObj < today) {
      errors.expireDate = 'Expire date cannot be in the past';
    }
  }
  
  return errors;
};

// Reset membership form
const handleResetMembershipForm = () => {
  setMembershipData({
    customerName: '',
    telephone: '',
    issueDate: '',
    expireDate: '',
    discount: 15,
    status: 'active',
    cardNumber: ''
  });
  setMembershipErrors({});
};

// Save membership card to Firestore
const handleSaveMembershipCard = async () => {
  // Validate form
  const errors = validateMembershipForm();
  if (Object.keys(errors).length > 0) {
    setMembershipErrors(errors);
    return;
  }
  
  setIsSavingCard(true);
  
  try {
    // Check if customer already has an active card
    const cardsRef = collection(db, 'customer-cards');
    const q = query(
      cardsRef,
      where('telephone', '==', membershipData.telephone),
      where('status', '==', 'active')
    );
    const existingCards = await getDocs(q);
    
    if (!existingCards.empty) {
      const confirmReplace = window.confirm(
        'This customer already has an active membership card. Do you want to deactivate the old card and create a new one?'
      );
      
      if (confirmReplace) {
        // Deactivate old cards
        const updatePromises = [];
        existingCards.forEach(doc => {
          updatePromises.push(updateDoc(doc.ref, { status: 'inactive' }));
        });
        await Promise.all(updatePromises);
      } else {
        setIsSavingCard(false);
        return;
      }
    }
    
    // Generate unique card number
    const cardNumber = generateCardNumber();
    
    // Prepare card data
    const cardData = {
      cardNumber: cardNumber,
      customerName: membershipData.customerName.trim(),
      telephone: membershipData.telephone.trim(),
      issueDate: membershipData.issueDate,
      expireDate: membershipData.expireDate,
      discount: 15, // 15% discount
      status: 'active',
      createdAt: new Date(),
      updatedAt: new Date(),
      isActive: true
    };
    
    // Save to Firestore
    await addDoc(collection(db, 'customer-cards'), cardData);
    
    // Show success message
    setCardSuccess(true);
    setTimeout(() => setCardSuccess(false), 3000);
    
    // Reset form
    handleResetMembershipForm();
    
    // Show alert with card number
    alert(`✅ Membership card created successfully!\n\nCard Number: ${cardNumber}\nCustomer: ${cardData.customerName}\nValid until: ${cardData.expireDate}\nDiscount: 15%`);
    
  } catch (error) {
    console.error('Error saving membership card:', error);
    alert('❌ Error saving membership card: ' + error.message);
  } finally {
    setIsSavingCard(false);
  }
};

// CSS Styles
const membershipCardStyles = `
  .membership-card-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background: #f5f5f5;
    border-radius: 10px;
  }
  
  .membership-card-container h1 {
    text-align: center;
    color: #2c3e50;
    margin-bottom: 30px;
  }
  
  .info-text {
    background: #e8f4f8;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #2980b9;
  }
  
  .membership-form {
    background: white;
    padding: 20px;
    border-radius: 8px;
  }
  
  .membership-form-group {
    margin-bottom: 20px;
  }
  
  .membership-form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
    color: #333;
  }
  
  .membership-form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
  }
  
  .membership-form-group input:focus {
    outline: none;
    border-color: #27ae60;
  }
  
  .membership-form-group input.error-input {
    border-color: #e74c3c;
  }
  
  .membership-error-message {
    color: #e74c3c;
    font-size: 12px;
    margin-top: 5px;
    display: block;
  }
  
  .membership-card-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
  }
  
  .btn-save-card {
    background: #27ae60;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    flex: 1;
  }
  
  .btn-save-card:hover:not(:disabled) {
    background: #229954;
  }
  
  .btn-save-card:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .btn-reset-card {
    background: #95a5a6;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    flex: 1;
  }
  
  .btn-reset-card:hover {
    background: #7f8c8d;
  }
  
  .card-success-toast {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #27ae60;
    color: white;
    padding: 15px 20px;
    border-radius: 5px;
    z-index: 1000;
    animation: slideIn 0.3s ease;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;




////////////////////////// view customer card ////////////////////////////////////////////////////////
// Add these state declarations with your other states
const [allMembershipCards, setAllMembershipCards] = useState([]);
const [filteredCards, setFilteredCards] = useState([]);
const [isLoadingCards, setIsLoadingCards] = useState(false);
const [searchFilters, setSearchFilters] = useState({
  customerName: '',
  telephone: '',
  issueYear: ''
});
const [selectedCard, setSelectedCard] = useState(null);
const [showCardDetails, setShowCardDetails] = useState(false);

// Fetch all membership cards from Firestore
const fetchMembershipCards = async () => {
  setIsLoadingCards(true);
  try {
    const cardsRef = collection(db, 'customer-cards');
    const q = query(cardsRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const cards = [];
    querySnapshot.forEach(doc => {
      cards.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    setAllMembershipCards(cards);
    setFilteredCards(cards);
  } catch (error) {
    console.error('Error fetching membership cards:', error);
    alert('Error loading membership cards: ' + error.message);
  } finally {
    setIsLoadingCards(false);
  }
};

// Load cards when component mounts
useEffect(() => {
  if (selectedOption === "viewMembershipCard") {
    fetchMembershipCards();
  }
}, [selectedOption]);

// Handle search filter changes
const handleSearchFilterChange = (e) => {
  const { name, value } = e.target;
  setSearchFilters(prev => ({
    ...prev,
    [name]: value
  }));
};

// Apply filters to cards
const applyFilters = () => {
  let filtered = [...allMembershipCards];
  
  // Filter by customer name
  if (searchFilters.customerName) {
    filtered = filtered.filter(card => 
      card.customerName.toLowerCase().includes(searchFilters.customerName.toLowerCase())
    );
  }
  
  // Filter by telephone
  if (searchFilters.telephone) {
    filtered = filtered.filter(card => 
      card.telephone.includes(searchFilters.telephone)
    );
  }
  
  // Filter by issue year
  if (searchFilters.issueYear) {
    filtered = filtered.filter(card => {
      const issueYear = card.issueDate ? new Date(card.issueDate).getFullYear().toString() : '';
      return issueYear === searchFilters.issueYear;
    });
  }
  
  setFilteredCards(filtered);
};

// Reset filters
const resetFilters = () => {
  setSearchFilters({
    customerName: '',
    telephone: '',
    issueYear: ''
  });
  setFilteredCards(allMembershipCards);
  setSelectedSalesPerson("all");
  setSelectedEyeCamp("all");
};

// Get unique years from cards for year filter dropdown
const getAvailableYears = () => {
  const years = new Set();
  allMembershipCards.forEach(card => {
    if (card.issueDate) {
      const year = new Date(card.issueDate).getFullYear();
      years.add(year);
    }
  });
  return Array.from(years).sort().reverse();
};

// Format date for display
const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

// Check if card is expired
const isCardExpired = (expireDate) => {
  if (!expireDate) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expire = new Date(expireDate);
  return expire < today;
};

// Get days until expiry
const getDaysUntilExpiry = (expireDate) => {
  if (!expireDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expire = new Date(expireDate);
  const diffTime = expire - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

// View card details
const viewCardDetails = (card) => {
  setSelectedCard(card);
  setShowCardDetails(true);
};

// Close card details modal
const closeCardDetails = () => {
  setShowCardDetails(false);
  setSelectedCard(null);
};

// Deactivate card
const deactivateCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`Are you sure you want to deactivate card ${cardNumber}?`);
  if (!confirm) return;
  
  try {
    const cardRef = doc(db, 'customer-cards', cardId);
    await updateDoc(cardRef, {
      status: 'inactive',
      isActive: false,
      updatedAt: new Date()
    });
    
    alert('Card deactivated successfully!');
    fetchMembershipCards(); // Refresh the list
  } catch (error) {
    console.error('Error deactivating card:', error);
    alert('Error deactivating card: ' + error.message);
  }
};


const reactivateCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`Reactivate card ${cardNumber} and extend expiry?`);
  if (!confirm) return;

  try {
    const cardRef = doc(db, 'customer-cards', cardId);

    // 🔑 Set NEW expiry date (1 year from today)
    const newExpireDate = new Date();
    newExpireDate.setFullYear(newExpireDate.getFullYear() + 1);

    await updateDoc(cardRef, {
      status: 'active',
      isActive: true,
      expireDate: newExpireDate.toISOString(), // ✅ update expiry
      updatedAt: new Date()
    });

    alert('Card reactivated and renewed successfully!');
    fetchMembershipCards();
  } catch (error) {
    console.error('Error reactivating card:', error);
    alert('Error reactivating card: ' + error.message);
  }
};







// Delete card permanently
const deleteCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`⚠️ WARNING: This will permanently delete card ${cardNumber}. This action cannot be undone. Are you sure?`);
  if (!confirm) return;
  
  try {
    const cardRef = doc(db, 'customer-cards', cardId);
    await deleteDoc(cardRef);
    
    alert('Card deleted permanently!');
    fetchMembershipCards(); // Refresh the list
  } catch (error) {
    console.error('Error deleting card:', error);
    alert('Error deleting card: ' + error.message);
  }
}; 

const viewMembershipCardStyles = `
  .view-membership-card-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .view-membership-card-container h1 {
    color: #2c3e50;
    margin-bottom: 10px;
  }
  
  .filters-section {
    background: white;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .filters-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }
  
  .filters-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 15px;
    margin-bottom: 15px;
  }
  
  .filter-group {
    display: flex;
    flex-direction: column;
  }
  
  .filter-group label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #555;
  }
  
  .filter-group input,
  .filter-group select {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
  }
  
  .filter-group input:focus,
  .filter-group select:focus {
    outline: none;
    border-color: #27ae60;
  }
  
  .filter-buttons {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }
  
  .btn-apply-filters {
    background: #27ae60;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-reset-filters {
    background: #95a5a6;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .stats-badge {
    background: #ecf0f1;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
  }
  
  .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 20px;
  }
  
  .card-item {
    background: white;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: transform 0.2s;
    cursor: pointer;
  }
  
  .card-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  .card-item.expired {
    background: #fef5f5;
    border-left: 4px solid #e74c3c;
  }
  
  .card-item.active {
    border-left: 4px solid #27ae60;
  }
  
  .card-item.inactive {
    background: #f5f5f5;
    opacity: 0.7;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .card-number {
    font-weight: bold;
    color: #2c3e50;
    font-size: 14px;
  }
  
  .card-status {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: bold;
  }
  
  .status-active {
    background: #27ae60;
    color: white;
  }
  
  .status-inactive {
    background: #95a5a6;
    color: white;
  }
  
  .status-expired {
    background: #e74c3c;
    color: white;
  }
  
  .card-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
    color: #333;
  }
  
  .card-details {
    font-size: 13px;
    color: #666;
    margin-top: 8px;
  }
  
  .card-details div {
    margin-bottom: 5px;
  }
  
  .expiry-warning {
    color: #e74c3c;
    font-weight: bold;
    margin-top: 8px;
    font-size: 12px;
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    padding: 25px;
    border-radius: 10px;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .modal-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
  }
  
  .modal-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    justify-content: flex-end;
  }
  
  .loading-spinner {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #666;
  }
  
  .no-results {
    text-align: center;
    padding: 40px;
    color: #999;
  }
`;








//////////////////////////////////////////////////// sales report //////////////////////////////////////////////////////////

const [eyeCampsList, setEyeCampsList] = useState([]);

// Add these state variables at the top of your component
const [report, setReport] = useState([]);
const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');
const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('all');
const [dateFilterType, setDateFilterType] = useState('month'); // 'month' or 'range'

 // ========== FETCH DATA ==========

useEffect(() => {
  if (selectedOption === "salesReport") {
    fetchData();
    fetchEyeCampsForFilter();
  }
}, [selectedOption]);

// Also fetch on initial mount if salesReport is the default tab
useEffect(() => {
  if (selectedOption === "salesReport") {
    fetchData();
    fetchEyeCampsForFilter();
  }
}, []);





  const fetchData = async () => {
    setLoading(true);
    try {
      const invoiceSnap = await getDocs(collection(db, "invoices"));
      const balanceSnap = await getDocs(collection(db, "balance_invoices"));

      const invoices = invoiceSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      const balances = balanceSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      generateReport(invoices, balances);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setLoading(false);
    }
  };

  const fetchEyeCampsForFilter = async () => {
    try {
      const snapshot = await getDocs(collection(db, "eye_camps"));
      const camps = snapshot.docs.map(doc => ({
        id: doc.id,
        name: doc.data().name
      }));
      setEyeCampsList(camps);
    } catch (error) {
      console.error("Error fetching eye camps:", error);
    }
  };


  // ========== GENERATE REPORT ==========
const generateReport = (invoices, balances) => {
  const rows = [];

  // 1. INVOICE ROWS
  invoices.forEach(inv => {
    const invoiceNumber = inv.invoiceNumber || inv.financial?.invoiceNumber || "";
    const customer = inv.customer?.fullName || "-";
    const totalAmount = Number(inv.financial?.totalAmount || 0);
    const advancePaid = Number(inv.financial?.advancePayment || 0);
    const paymentMethod = inv.financial?.paymentMethod || "-";
    const salePerson = inv.products?.salePerson || inv.salePerson || "-";
    const eyeCamp = inv.eyeCamp || "-";

    let invoiceDate;
    if (typeof inv.createdAt === "string") {
      invoiceDate = new Date(inv.createdAt);
    } else if (inv.createdAt?.toDate) {
      invoiceDate = inv.createdAt.toDate();
    } else if (inv.createdAt?.seconds) {
      invoiceDate = new Date(inv.createdAt.seconds * 1000);
    } else {
      invoiceDate = new Date(inv.createdAt);
    }

    // ✅ Check if there's a balance payment for this invoice
    const hasBalancePayment = balances.some(b => 
      b.originalInvoiceNumber === invoiceNumber
    );

    // ✅ If there's a balance payment, treat received as 0 on invoice date
    //    The payment will be shown on the balance payment date
    // ✅ If no balance payment, use the actual advance amount
    const effectiveReceived = hasBalancePayment ? 0 : advancePaid;

    rows.push({
      invoiceNumber,
      customer,
      salePerson,
      eyeCamp,
      paymentMethod,
      date: invoiceDate,
      totalAmount: totalAmount,
      advancePaid: effectiveReceived,
      received: effectiveReceived,
      laterPayments: 0,
      remaining: totalAmount - effectiveReceived,
      paymentType: hasBalancePayment ? "Invoice Created" : (advancePaid > 0 ? "Advance Payment" : "Invoice Created (No Payment)"),
      isInvoiceRow: true,
      isAdvancePayment: advancePaid > 0 && !hasBalancePayment
    });
  });

  // 2. BALANCE PAYMENT ROWS
  balances.forEach(balance => {
    const originalInvoice = invoices.find(inv => {
      const no = inv.invoiceNumber || inv.financial?.invoiceNumber || "";
      return no === balance.originalInvoiceNumber;
    });

    let paymentDate;
    if (balance.paymentDate) {
      if (typeof balance.paymentDate === 'string') {
        paymentDate = new Date(balance.paymentDate);
      } else if (balance.paymentDate.toDate) {
        paymentDate = balance.paymentDate.toDate();
      } else if (balance.paymentDate.seconds) {
        paymentDate = new Date(balance.paymentDate.seconds * 1000);
      } else {
        paymentDate = new Date(balance.paymentDate);
      }
    } else if (balance.createdAt) {
      if (typeof balance.createdAt === 'string') {
        paymentDate = new Date(balance.createdAt);
      } else if (balance.createdAt.toDate) {
        paymentDate = balance.createdAt.toDate();
      } else if (balance.createdAt.seconds) {
        paymentDate = new Date(balance.createdAt.seconds * 1000);
      } else {
        paymentDate = new Date(balance.createdAt);
      }
    } else {
      paymentDate = new Date();
    }

    const totalAmount = originalInvoice?.financial?.totalAmount || 0;
    const advancePaid = originalInvoice?.financial?.advancePayment || 0;
    const paidAmount = Number(balance.paidAmount || 0);
    const remainingBalance = Number(balance.remainingBalance || 0);
    const balancePaymentMethod = balance.paymentMethod || originalInvoice?.financial?.paymentMethod || "-";

    rows.push({
      invoiceNumber: balance.originalInvoiceNumber,
      customer: originalInvoice?.customer?.fullName || balance.customerName || "-",
      salePerson: originalInvoice?.products?.salePerson || originalInvoice?.salePerson || "-",
      eyeCamp: originalInvoice?.eyeCamp || "-",
      paymentMethod: balancePaymentMethod,
      date: paymentDate,
      totalAmount: totalAmount,
      advancePaid: advancePaid,
      received: paidAmount,
      laterPayments: paidAmount,
      remaining: remainingBalance,
      paymentType: "Balance Payment",
      isInvoiceRow: false,
      isAdvancePayment: false
    });
  });

  rows.sort((a, b) => b.date - a.date);
  setReport(rows);
};










  // ========== GET PAYMENT METHOD BREAKDOWN ==========
  const getPaymentMethodBreakdown = (data) => {
    const breakdown = {
      cash: 0,
      card: 0,
      GiftCard: 0, 
      bankTransfer: 0,
      deposit: 0
    };

    data.forEach(item => {
      const isActualPayment = (item.isInvoiceRow && item.isAdvancePayment) || !item.isInvoiceRow;
      
      if (isActualPayment) {
        const amount = item.received || 0;
        const method = (item.paymentMethod || '').toLowerCase();
        
        if (method === 'cash') {
          breakdown.cash += amount;
        } else if (method === 'card') {
          breakdown.card += amount;

     } else if (method === 'giftcard') {
      breakdown.GiftCard += amount;

        } else if (method === 'bank transfer' || method === 'bank_transfer') {
          breakdown.bankTransfer += amount;
        } else if (method === 'deposit') {
          breakdown.deposit += amount;
        }
      }
    });

    return breakdown;
  };



  // ========== FILTERED REPORT ==========

// const filteredReport = report.filter(r => {
//   if (!r.date) return false;
  
//   let matchesDate = true;
  
//   if (dateFilterType === 'range' && startDate && endDate) {
//     const rowDate = new Date(r.date);
//     rowDate.setHours(0, 0, 0, 0);
    
//     const start = new Date(startDate);
//     start.setHours(0, 0, 0, 0);
    
//     const end = new Date(endDate);
//     end.setHours(23, 59, 59, 999);
    
//     // ✅ ONLY include rows where the row's date is within the range
//     matchesDate = rowDate >= start && rowDate <= end;
//   } else if (dateFilterType === 'month') {
//     const month = r.date.getMonth() + 1;
//     const year = r.date.getFullYear();
//     const matchMonth = selectedMonth === "all" || month === parseInt(selectedMonth);
//     const matchYear = selectedYear === "all" || year === parseInt(selectedYear);
//     matchesDate = matchMonth && matchYear;
//   }
  
//   const matchesPayment = selectedPaymentMethod === "all" || 
//                          r.paymentMethod === selectedPaymentMethod;
//   const matchesSalesPerson = selectedSalesPerson === "all" || 
//                              r.salePerson === selectedSalesPerson;

//   const matchesEyeCamp = selectedEyeCamp === "all" || 
//                          r.eyeCamp === selectedEyeCamp;
  
//   // ✅ Return true ONLY if ALL conditions match
//   return matchesDate && matchesPayment && matchesSalesPerson && matchesEyeCamp;
// });

// ========== FILTERED REPORT ==========
const filteredReport = useMemo(() => {
  return report.filter(r => {
    if (!r.date) return false;
    
    let matchesDate = true;
    
    if (dateFilterType === 'range' && startDate && endDate) {
      const rowDate = new Date(r.date);
      rowDate.setHours(0, 0, 0, 0);
      
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      
      matchesDate = rowDate >= start && rowDate <= end;
    } else if (dateFilterType === 'month') {
      const month = r.date.getMonth() + 1;
      const year = r.date.getFullYear();
      const matchMonth = selectedMonth === "all" || month === parseInt(selectedMonth);
      const matchYear = selectedYear === "all" || year === parseInt(selectedYear);
      matchesDate = matchMonth && matchYear;
    }
    
    const matchesPayment = selectedPaymentMethod === "all" || 
                           r.paymentMethod === selectedPaymentMethod;
    const matchesSalesPerson = selectedSalesPerson === "all" || 
                               r.salePerson === selectedSalesPerson;
    const matchesEyeCamp = selectedEyeCamp === "all" || 
                           r.eyeCamp === selectedEyeCamp;
    
    return matchesDate && matchesPayment && matchesSalesPerson && matchesEyeCamp;
  });
}, [report, dateFilterType, startDate, endDate, selectedMonth, selectedYear, selectedPaymentMethod, selectedSalesPerson, selectedEyeCamp]);





// ========== SALES SUMMARY ==========
const salesSummary = useMemo(() => {
  // ✅ Total Sales: Count each invoice ONCE from invoice rows
  const uniqueInvoices = new Map();
  filteredReport.forEach(r => {
    if (r.isInvoiceRow) {
      if (!uniqueInvoices.has(r.invoiceNumber)) {
        uniqueInvoices.set(r.invoiceNumber, r.totalAmount);
      }
    }
  });
  const totalSales = Array.from(uniqueInvoices.values()).reduce((sum, val) => sum + val, 0);
  
  // ✅ Total Received: Count ALL payments within date range
  // Includes: Advance payments (advance > 0) + Balance payments
  // Excludes: Invoice rows with advance = 0
  const totalReceived = filteredReport
    .filter(r => {
      if (r.isInvoiceRow && r.isAdvancePayment) return true;
      if (!r.isInvoiceRow) return true;
      return false;
    })
    .reduce((sum, r) => sum + (r.received || 0), 0);
  


    
  // ✅ Total Pending: Only calculate for Advance Payment invoices
  // Formula: totalAmount - received (for Advance Payment rows only)
  const pendingInvoices = filteredReport.filter(r => 
    r.isInvoiceRow && r.paymentType === "Advance Payment"
  );
  
  const totalPending = pendingInvoices.reduce((sum, r) => {
    // For advance payment invoices, pending = totalAmount - received
    return sum + (r.totalAmount - r.received);
  }, 0);
  
  return { totalSales, totalReceived, totalPending };
}, [filteredReport]);







  // ========== RESET FILTERS ==========
  const resetSalesFilters = () => {
    setDateFilterType("month");
    setSelectedMonth("all");
    setSelectedYear("all");
    setStartDate("");
    setEndDate("");
    setSelectedPaymentMethod("all");
    setSelectedSalesPerson("all");
    setSelectedEyeCamp("all");
  };





  // ========== DOWNLOAD EXCEL ==========
  const downloadExcel = () => {
    const exportData = filteredReport.map(r => ({
      'Invoice Number': r.invoiceNumber,
      'Customer Name': r.customer,
      'Sales Person': r.salePerson,
      'Eye Camp': r.eyeCamp,
      'Payment Method': r.paymentMethod,
      'Payment Type': r.paymentType,
      'Date': r.date ? r.date.toLocaleDateString() : '-',
      'Total Amount (Rs.)': r.totalAmount.toLocaleString(),
      'Received (Rs.)': r.received.toLocaleString(),
      'Later Payments (Rs.)': r.laterPayments.toLocaleString(),
      'Advance (Rs.)': r.advancePaid.toLocaleString(),
      'Remaining (Rs.)': r.remaining.toLocaleString(),
    }));
    
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");
    XLSX.writeFile(workbook, `Sales_Report_${Date.now()}.xlsx`);
  };

  // ========== DOWNLOAD PDF ==========
  const downloadPDF = () => {
    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const leftMargin = 12;
    const rightMargin = 12;

    // Header
    doc.setFillColor(15, 23, 42);
    doc.rect(0, 0, pageWidth, 38, "F");

    try {
      doc.addImage("/house-of-vision-logo.png", "PNG", 12, 5, 60, 17);
    } catch (err) {
      console.log("Logo not found");
    }

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text("HOUSE OF VISION", 85, 14);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("No. 355, Maharagama Road, Boralesgamuwa", 85, 21);
    doc.text("Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150", 85, 27);
    doc.text("Email: Info@houseofvision.lk | Web: www.houseofvision.lk", 85, 33);

    // Title
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text("SALES REPORT", pageWidth / 2, 52, { align: "center" });

    // Filter Info
    let filterText = "All Records";
    if (dateFilterType === 'range' && startDate && endDate) {
      filterText = `Date Range: ${new Date(startDate).toLocaleDateString()} - ${new Date(endDate).toLocaleDateString()}`;
    } else if (dateFilterType === 'month') {
      if (selectedMonth !== "all" && selectedYear !== "all") {
        const monthNames = ["", "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"];
        filterText = `${monthNames[selectedMonth]} ${selectedYear}`;
      } else if (selectedYear !== "all") {
        filterText = `Year ${selectedYear}`;
      }
    }
    
    if (selectedPaymentMethod !== "all") {
      filterText += filterText ? ` | Payment: ${selectedPaymentMethod}` : `Payment: ${selectedPaymentMethod}`;
    }

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Report Filter: ${filterText}`, leftMargin, 62);
    doc.text(`Generated Date: ${new Date().toLocaleDateString()}`, pageWidth - rightMargin, 62, { align: "right" });

    // Summary
    const breakdown = getPaymentMethodBreakdown(filteredReport);

    const summaryY = 72;
    const boxWidth = 48;
    const boxHeight = 22;
    const gap = 6;

    const boxes = [
      { title: "Total Sales", value: `Rs. ${salesSummary.totalSales.toLocaleString()}` },
      { title: "Total Received", value: `Rs. ${salesSummary.totalReceived.toLocaleString()}` },
      { title: "Pending Amount", value: `Rs. ${salesSummary.totalPending.toLocaleString()}` },
    ];

    boxes.forEach((box, i) => {
      const x = leftMargin + (i * (boxWidth + gap));
      doc.setFillColor(241, 245, 249);
      doc.roundedRect(x, summaryY, boxWidth, boxHeight, 3, 3, "F");
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text(box.title, x + 4, summaryY + 8);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.text(box.value, x + 4, summaryY + 16);
    });

    // Payment Breakdown
    const breakdownX = leftMargin + (boxes.length * (boxWidth + gap)) + 10;
    doc.setFillColor(232, 245, 233);
    doc.roundedRect(breakdownX, summaryY, 90, boxHeight, 3, 3, "F");
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    doc.text("Payment Breakdown", breakdownX + 4, summaryY + 7);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`Cash: Rs. ${breakdown.cash.toLocaleString()}`, breakdownX + 4, summaryY + 14);
    doc.text(`Card: Rs. ${breakdown.card.toLocaleString()}`, breakdownX + 45, summaryY + 14);
    doc.text(`Bank Transfer: Rs. ${breakdown.bankTransfer.toLocaleString()}`, breakdownX + 4, summaryY + 20);
    doc.text(`Deposit: Rs. ${breakdown.deposit.toLocaleString()}`, breakdownX + 45, summaryY + 20);
      doc.text(`Gift Card: Rs. ${breakdown.GiftCard.toLocaleString()}`, breakdownX + 4, summaryY + 26);

    // Table
    const tableRows = filteredReport.map(r => [
      r.invoiceNumber,
      r.customer,
      r.paymentMethod,
      r.paymentType,
      r.date ? r.date.toLocaleDateString() : '-',
      `Rs. ${Number(r.totalAmount).toLocaleString()}`,
      `Rs. ${Number(r.received).toLocaleString()}`,
      `Rs. ${Number(r.laterPayments).toLocaleString()}`,
      `Rs. ${Number(r.advancePaid).toLocaleString()}`,
      `Rs. ${Number(r.remaining).toLocaleString()}`,
    ]);

    autoTable(doc, {
      startY: 105,
      head: [[
        "Invoice", "Customer", "Payment Method", "Payment Type", "Date", 
        "Total", "Received", "Later Payments", "Advance", "Remaining"
      ]],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: [15, 23, 42],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center"
      },
      bodyStyles: { fontSize: 7, cellPadding: 2 },
      styles: { overflow: "linebreak" },
      columnStyles: {
        0: { cellWidth: 22 },
        1: { cellWidth: 35 },
        2: { cellWidth: 25 },
        3: { cellWidth: 28 },
        4: { cellWidth: 20 },
        5: { halign: "right", cellWidth: 22 },
        6: { halign: "right", cellWidth: 22 },
        7: { halign: "right", cellWidth: 22 },
        8: { halign: "right", cellWidth: 22 },
        9: { halign: "right", cellWidth: 22 },
      }
    });

    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(120);
      doc.text(`Generated by Optical Management System`, leftMargin, pageHeight - 8);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - rightMargin, pageHeight - 8, { align: "right" });
    }

    doc.save(`Sales_Report_${Date.now()}.pdf`);
  };




//////////////////////////////////////////////// track spectacles /////////////////////////////////////////////////////////


/* =========================================================
TRACK SPECTACLES - UPDATED VERSION
========================================================= */

/* STATES */
const [trackInvoices, setTrackInvoices] = useState([]);
const [trackLoading, setTrackLoading] = useState(false);
const [trackDataMap, setTrackDataMap] = useState({});

/* FILTER STATES */
const [trackSearchInvoice, setTrackSearchInvoice] = useState("");
const [trackFilterStatus, setTrackFilterStatus] = useState("all");
const [trackFilterDate, setTrackFilterDate] = useState("");
const [trackFilterMonth, setTrackFilterMonth] = useState("");
const [trackFilterYear, setTrackFilterYear] = useState("");



/* =========================================================
FETCH INVOICES + TRACK DATA (EXCLUDING DIRECT SALE)
========================================================= */
const fetchTrackSpectacles = async () => {
  try {
    setTrackLoading(true);

    // Fetch invoices
    const invoiceSnap = await getDocs(
      query(collection(db, "invoices"), orderBy("createdAt", "desc"))
    );

    // Filter out direct-sale invoices
    const invoiceList = invoiceSnap.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter((invoice) => invoice.type !== "direct-sale"); // EXCLUDE DIRECT SALE

    // Fetch track data
    const trackSnap = await getDocs(collection(db, "track_spectacles"));

    const map = {};

    trackSnap.forEach((doc) => {
      const data = doc.data();
      map[data.invoiceId] = {
        docId: doc.id,
        ...data,
      };
    });

    setTrackInvoices(invoiceList);
    setTrackDataMap(map);
    setTrackLoading(false);
  } catch (error) {
    console.error(error);
    setTrackLoading(false);
  }
};






useEffect(() => {
  if (selectedOption === "trackSpectacle") {
    fetchTrackSpectacles();
  }
}, [selectedOption]);

/* =========================================================
SAVE SAME DOCUMENT (status1,status2,status3...)
========================================================= */
const saveTrackStatus = async (invoice, newStatus, newDate) => {
  try {
    if (!newStatus || !newDate) {
      alert("Select status and date");
      return;
    }

    const existing = trackDataMap[invoice.id];

    if (existing?.docId) {
      const updateData = {};
      let count = existing.totalSteps || 0;
      count += 1;

      updateData[`status${count}`] = newStatus;
      updateData[`date${count}`] = newDate;
      updateData.totalSteps = count;
      updateData.latestStatus = newStatus;
      updateData.latestDate = newDate;

      await updateDoc(
        doc(db, "track_spectacles", existing.docId),
        updateData
      );
    } else {
      await addDoc(collection(db, "track_spectacles"), {
        invoiceId: invoice.id,
        invoiceNumber: invoice.invoiceNumber,
        
        customerName: invoice.customer?.fullName || "",
        totalSteps: 1,
        status1: newStatus,
        date1: newDate,
        latestStatus: newStatus,
        latestDate: newDate,
        createdAt: serverTimestamp(),
      });
    }

    fetchTrackSpectacles();
    alert("Saved");
  } catch (error) {
    console.error(error);
    alert("Error");
  }
};








const handleStatusChange = (e) => {

  const value = e.target.value;

  // Only check QC statuses
  if (value.startsWith("QC - ")) {

    const person = value.replace("QC - ", "");

    const expectedPassword = salesPersonCodes[person];

    const enteredPassword = window.prompt(
      `Enter QC password for ${person}`
    );

    if (enteredPassword === null) {
      e.target.value = "";
      return;
    }

    if (enteredPassword !== expectedPassword) {
      alert("Incorrect password");
      e.target.value = "";
      return;
    }

    alert(`QC verified: ${person}`);
  }
};













/* =========================================================
FILTER DATA
========================================================= */
const filteredTrackInvoices = trackInvoices.filter((inv) => {
  const track = trackDataMap[inv.id];

  const invoiceOk =
    trackSearchInvoice === "" ||
    inv.invoiceNumber
      ?.toLowerCase()
      .includes(trackSearchInvoice.toLowerCase());

  const statusOk =
    trackFilterStatus === "all" ||
    track?.latestStatus === trackFilterStatus;

  const dateOk =
    trackFilterDate === "" ||
    track?.latestDate === trackFilterDate;

  const monthOk =
    trackFilterMonth === "" ||
    (track?.latestDate &&
      new Date(track.latestDate).getMonth() + 1 ===
        Number(trackFilterMonth));

  const yearOk =
    trackFilterYear === "" ||
    (track?.latestDate &&
      new Date(track.latestDate).getFullYear() ===
        Number(trackFilterYear));

  return invoiceOk && statusOk && dateOk && monthOk && yearOk;
});





const sendWhatsAppMessage = (invoice) => {
  let phone = invoice.customer?.tpNo || "";

  // Remove spaces and special characters
  phone = phone.replace(/\D/g, "");

  // Convert 0771234567 -> 94771234567
  if (phone.startsWith("0")) {
    phone = "94" + phone.substring(1);
  }

  const customerName = invoice.customer?.fullName || "Customer";

  // Combined message with all 3 languages
  const message = `හිතවත් ${customerName},




*HOUSE OF VISION @ Boralesgamuwa*

ඔබගේ ඇස් කණ්ණාඩිය ලබා ගැනීමට සූදානම් බව සතුටින් දැනුම් දෙමු.

ඔබට පහසු වේලාවක අපගේ Optical අංශයට පැමිණ එය ලබා ගන්න.

HOUSE OF VISION ආයතනය තෝරාගැනීම පිළිබඳ ඔබට ස්තුතියි. ඔබගේ විශ්වාසය අපි අගය කරමු.


HOUSE OF VISION
Boralesgamuwa



---------------------------------------------------


Dear ${customerName},

Greetings from *HOUSE OF VISION @ Boralesgamuwa*.

We are pleased to inform you that your spectacles are now ready for collection.

Kindly visit our optical department at your convenience to collect them. 
Thank you for choosing HOUSE OF VISION. We appreciate your trust and look forward to serving you.

Best regards,
HOUSE OF VISION
Boralesgamuwa`;

  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(
    message
  )}`;

  window.open(whatsappUrl, "_blank");
};













////////////////////////////////////////////// View Purchasing order //////////////////////////////////////////////////////////



const [loadingPO, setLoadingPO] = useState(false);

useEffect(() => {
  if (selectedOption === "viewPurchasingOrders") {
    fetchPurchasingOrders();
  }
}, [selectedOption]);

const fetchPurchasingOrders = async () => {
  try {
    setLoadingPO(true);

    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(q);

    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setPurchaseOrders(data);
  } catch (error) {
    console.error("Error fetching purchase orders:", error);
  } finally {
    setLoadingPO(false);
  }
};









/////////////////////////////  Create Eye Examination Report ///////////////////////////////////////////////////////////////////////////////////////////////

  // Patient Information
  const [patientName, setPatientName] = useState('');
  const [examDate, setExamDate] = useState('');
  const [patientId, setPatientId] = useState('');
  const [dob, setDob] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [email, setEmail] = useState('');
  const [fundi, setFundi] = useState('');
  const [addition, setAddition] = useState("");

  // History Taking
  const [chiefComplaint, setChiefComplaint] = useState('');
  const [hpc, setHpc] = useState('');
  const [pastOcularHistory, setPastOcularHistory] = useState('');
  const [medicalHistory, setMedicalHistory] = useState('');
  const [familyOcularHistory, setFamilyOcularHistory] = useState('');
  const [socialHistory, setSocialHistory] = useState('');




const [lids, setLids] = useState('');
const [conjunctiva, setConjunctiva] = useState('');
const [cornea, setCornea] = useState('');
const [sclera, setSclera] = useState('');
const [ac, setAc] = useState('');
const [vitreous, setVitreous] = useState('');


// External Examination (Left and Right Eye - separate states)
const [lidsLeft, setLidsLeft] = useState('');
const [lidsRight, setLidsRight] = useState('');

const [conjunctivaLeft, setConjunctivaLeft] = useState('');
const [conjunctivaRight, setConjunctivaRight] = useState('');

const [corneaLeft, setCorneaLeft] = useState('');
const [corneaRight, setCorneaRight] = useState('');

const [scleraLeft, setScleraLeft] = useState('');
const [scleraRight, setScleraRight] = useState('');

const [acLeft, setAcLeft] = useState('');
const [acRight, setAcRight] = useState('');

const [lensLeft, setLensLeft] = useState('');
const [lensRight, setLensRight] = useState('');

const [vitreousLeft, setVitreousLeft] = useState('');
const [vitreousRight, setVitreousRight] = useState('');



  // Family History
  const [familyHistory, setFamilyHistory] = useState({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  // Visual Acuity
  const [visualAcuity, setVisualAcuity] = useState({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    od_pd: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    os_pd: '',
    seg_va: '',
    ct: '',
    npc: '',
    om: '',
  });


  //HbRx

  const [hbrx, setHbrx] = useState({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
    add: '',
  });




  // Refraction
  const [refraction, setRefraction] = useState({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',
  });

  // Follow Up
  const [needsFollowUp, setNeedsFollowUp] = useState(false);
  const [followUpDate, setFollowUpDate] = useState('');
  const [remarks, setRemarks] = useState('');

  const handleFamilyHistoryChange = (e) => {
    const { name, checked, value } = e.target;
    if (name === 'other') {
      setFamilyHistory({ ...familyHistory, other: value });
    } else {
      setFamilyHistory({ ...familyHistory, [name]: checked });
    }
  };

  const handleVisualAcuityChange = (e) => {
    const { name, value } = e.target;
    setVisualAcuity({ ...visualAcuity, [name]: value });
  };

  const handleHbrxChange = (e) => {
    const { name, value } = e.target;
    setHbrx({ ...hbrx, [name]: value });
  };


  const handleRefractionChange = (e) => {
    const { name, value } = e.target;
    setRefraction({ ...refraction, [name]: value });
  };

  const handleEyeExamSubmit = async (e) => {
    e.preventDefault();

    if (!patientName || !examDate) {
      alert('Please fill in patient name and date');
      return;
    }

    const eyeExamData = {
      patientInfo: {
       
        name: patientName,
        date: examDate,
        id: patientId,
        dob: dob,
        age,
        gender,
        contactNo,
        email,
        fundi,
      },
      history: {
        chiefComplaint,
        hpc,
        pastOcularHistory,
        medicalHistory,
        familyOcularHistory,
        socialHistory,
        addition,
      },

      externalExam: {
        lids,
        conjunctiva,
        cornea,
        sclera,
        ac,
        lens,
        vitreous,
      },


      familyHistory,
      visualAcuity,
      hbrx,
      refraction,
      followUp: {
        needed: needsFollowUp,
        date: followUpDate,
        remarks,
      },
      createdAt: new Date(),
    };

    try {
      // Save to Firestore
      await addDoc(collection(db, 'eyeExams'), eyeExamData);
      
      // Generate PDF
      generateEyeExamPDF(eyeExamData);
      
    // Reset form after everything is done
    resetForm();

      alert('Eye exam report saved successfully!');
    } catch (error) {
      console.error('Error saving eye exam: ', error);
      alert('Failed to save eye exam');
    }
  };


const resetForm = () => {
  setPatientName('');
  setExamDate('');
  setPatientId('');
  setDob('');
  setAge('');
  setGender('');
  setContactNo('');
  setEmail('');
  setFundi('');

  setChiefComplaint('');
  setHpc('');
  setPastOcularHistory('');
  setMedicalHistory('');
  setFamilyOcularHistory('');
  setSocialHistory('');

  setLids('');
  setConjunctiva('');
  setCornea('');
  setSclera('');
  setAc('');
  setLens('');
  setVitreous('');

  setLidsLeft('');
  setLidsRight('');
  setConjunctivaLeft('');
  setConjunctivaRight('');
  setCorneaLeft('');
  setCorneaRight('');
  setScleraLeft('');
  setScleraRight('');
  setAcLeft('');
  setAcRight('');
  setLensLeft('');
  setLensRight('');
  setVitreousLeft('');
  setVitreousRight('');

  setFamilyHistory({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  setVisualAcuity({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    od_pd: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    os_pd: '',
    seg_va: '',
    ct: '',
    npc: '',
    om: '',
  });

  setHbrx({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
    add: '',
  });

  setRefraction({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',

  });

  setNeedsFollowUp(false);
  setFollowUpDate('');
  setRemarks('');
};





  const generateEyeExamPDF = (data) => {
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
    });

    // Set default font styles
    doc.setFont('helvetica');
    doc.setTextColor(0, 0, 0); // Black text



    // Constants for layout
const leftMargin = 15;
const rightMargin = 15;
const pageWidth = 210 - leftMargin - rightMargin;
const column1 = leftMargin;
const column2 = 100;
const columnWidth = 80;

// Header settings
const headerHeight = 50;
const logoWidth = 50;
const logoHeight = 20;

// Vertically center logo inside header
const logoY = (headerHeight - logoHeight) / 2;

// Header Section
doc.addImage(
  '/house-of-vision-logo.png',
  'PNG',
  leftMargin,
  logoY,
  logoWidth,
  logoHeight
);



    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('HOUSE OF VISION ', leftMargin + 65, 18);
    doc.setFontSize(10);
    doc.text('No. 355, Maharagama Road, Boralesgamuwa', leftMargin + 65, 23);
    doc.text('Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150', leftMargin + 65, 28);
    doc.text('Email: Info@houseofvision.lk', leftMargin + 65, 33);
    doc.text(`Date: ${data.patientInfo.date}`, 180, 33, { align: 'right' });


    // Report Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    // Patient Information (Two Columns)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PATIENT INFORMATION', leftMargin, 50);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Column 1
    
    doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
    // doc.text(`Patient ID: ${data.patientInfo.id || '-'}`, column1, 62);
    doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 62);
    doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 68);
    
    // Column 2
    
    doc.text(`Job No: ${data.patientInfo.jobNo || '-'}`, column2, 56);
    doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 62);
    doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 66);
    doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

    // Helper functions
    const addSection = (title, content, y, maxWidth = pageWidth) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        
        const lines = doc.splitTextToSize(content || '-', maxWidth);
        doc.text(lines, leftMargin + 5, y + 6);
        return y + (lines.length * 5) + 10;
    };

    const addExamTable = (title, data, y, columns) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        y += 6;
        
        // Table header
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        columns.forEach((col, i) => {
            doc.text(col.label, leftMargin + (i * 40), y);
        });
        y += 6;
        
        // Table data
        doc.setFont('helvetica', 'normal');
        data.forEach(row => {
            columns.forEach((col, i) => {
                doc.text(row[col.key] || '-', leftMargin + (i * 40), y);
            });
            y += 6;
        });
        
        return y + 6;
    };

    let yPos = 82;

// History Sections (inline, label + value)
doc.setFontSize(10);
doc.setFont('helvetica', 'normal');

doc.text(`Chief Complaint : ${data.history.chiefComplaint || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`History Of Present Complaint : ${data.history.hpc || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Past Ocular History : ${data.history.pastOcularHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Medical History : ${data.history.medicalHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Family Ocular History : ${data.history.familyOcularHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Social History : ${data.history.socialHistory || '-'}`, leftMargin, yPos);
yPos += 10; // small gap after history section

    // Check for page break
    if (yPos > 250) {
        doc.addPage();
        yPos = 20;
    }

 // External Examination Table
yPos = addExamTable('External Examination', [
  { structure: 'Lids', left: lidsLeft || '-', right: lidsRight || '-' },
  { structure: 'Conjunctiva', left: conjunctivaLeft || '-', right: conjunctivaRight || '-' },
  { structure: 'Cornea', left: corneaLeft || '-', right: corneaRight || '-' },
  { structure: 'Sclera', left: scleraLeft || '-', right: scleraRight || '-' },
  { structure: 'A/C', left: acLeft || '-', right: acRight || '-' },
  { structure: 'Lens', left: lensLeft || '-', right: lensRight || '-' },
  { structure: 'Vitreous', left: vitreousLeft || '-', right: vitreousRight || '-' }
], yPos, [
  { label: 'Structure', key: 'structure' },
  { label: 'Left Eye', key: 'left' },
  { label: 'Right Eye', key: 'right' }
]);





    // Family History
    yPos = addSection('Family History', 
        `POAG: ${data.familyHistory.poag ? 'Yes' : 'No'}, ` +
        `AMD: ${data.familyHistory.amd ? 'Yes' : 'No'}, ` +
        `DM: ${data.familyHistory.dm ? 'Yes' : 'No'}` +
        (data.familyHistory.other ? `, Other: ${data.familyHistory.other}` : ''), 
        yPos);

    // Visual Acuity
    yPos = addExamTable('Visual Acuity', [
        { test: 'C/C', od: data.visualAcuity.od_cg, os: data.visualAcuity.os_cg },
        { test: 'S/C', od: data.visualAcuity.od_sg, os: data.visualAcuity.os_sg },
        { test: 'P/H', od: data.visualAcuity.od_ph, os: data.visualAcuity.os_ph },
        { test: 'PD', od: data.visualAcuity.od_pd, os: data.visualAcuity.os_pd },
       { test: 'SEG', od: data.visualAcuity.seg_va, os: '-' }
    ], yPos, [
        { label: 'Test', key: 'test' },
        { label: 'OD', key: 'od' },
        { label: 'OS', key: 'os' }
    ]);


// After Visual Acuity + Accessory Tests
if (
  (data.visualAcuity.ct && data.visualAcuity.ct.trim() !== '') ||
  (data.visualAcuity.npc && data.visualAcuity.npc.trim() !== '') ||
  (data.visualAcuity.om && data.visualAcuity.om.trim() !== '')
) {
  yPos = addSection('Accessory Tests',
      `CT: ${data.visualAcuity.ct || '-'}, ` +
      `NPC: ${data.visualAcuity.npc || '-'}, ` +
      `OM: ${data.visualAcuity.om || '-'}`, 
      yPos
  );
}


doc.addPage();
yPos = 20;




    // Fundus Examination
    if (data.patientInfo.fundi) {
        yPos = addSection('Fundus Examination', data.patientInfo.fundi, yPos);
    }


      //Hb Rx

      if (data.hbrx) {
       const hbRxData = [
  { eye: 'OD',
    sph: data.hbrx.hb_od_sph,
    cyl: data.hbrx.hb_od_cyl,
    axis: data.hbrx.hb_od_axis,
    vision: data.hbrx.hb_od_vision },
  { eye: 'OS',
    sph: data.hbrx.rx_os_sph,   // ✅ use rx_os_* here
    cyl: data.hbrx.rx_os_cyl,
    axis: data.hbrx.rx_os_axis,
    vision: data.hbrx.rx_os_vision }
];
        yPos = addExamTable('Hb Rx', hbRxData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);

        
      }

doc.text(`Addition (Near) : ${data.hbrx.add  || '-'}`, leftMargin, yPos);
yPos += 6;

    // Refraction and Hb Rx
    const refractionData = [
        { eye: 'OD', 
          sph: data.refraction.od_sph, 
          cyl: data.refraction.od_cyl, 
          axis: data.refraction.od_axis, 
          vision: data.refraction.od_vision },
        { eye: 'OS', 
          sph: data.refraction.os_sph, 
          cyl: data.refraction.os_cyl, 
          axis: data.refraction.os_axis, 
          vision: data.refraction.os_vision }
    ];

    yPos = addExamTable('Refraction', refractionData, yPos, [
        { label: 'Eye', key: 'eye' },
        { label: 'Sph', key: 'sph' },
        { label: 'Cyl', key: 'cyl' },
        { label: 'Axis', key: 'axis' },
        { label: 'Vision', key: 'vision' }
    ]);


doc.setFontSize(10);
doc.setFont('helvetica', 'bold');

doc.text(`Near Vision (ADD) : ${data.history.addition || '-'}`, leftMargin, yPos);
yPos += 6;



    // Follow Up
    yPos = addSection('Follow Up', 
        `Needed: ${data.followUp.needed ? 'Yes' : 'No'}` +
        (data.followUp.needed ? `, Date: ${data.followUp.date}` : '') +
        (data.followUp.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
        yPos);

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('"All kinds of Eye wear, Sunglasses, Color Lenses, and All Eyeware accessories"', 105, 287, { align: 'center' });
    doc.text('© HOUSE OF VISION', 105, 292, { align: 'center' });

    // Save PDF
    doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};













//fetch all the eye exam report

useEffect(() => {
  const fetchEyeExamRecords = async () => {
    if (selectedOption === "viewEyeExamReport") {
      try {
        const querySnapshot = await getDocs(collection(db, 'eyeExams'));
        const records = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setEyeExamRecords(records);
      } catch (error) {
        console.error("Error fetching eye exam records: ", error);
      }
    }
  };

  fetchEyeExamRecords();
}, [selectedOption]);






const filteredRecords = eyeExamRecords.filter(record => {
  // Search term filtering
  const matchesSearch = 
    record.patientInfo?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    record.patientInfo?.id?.toLowerCase().includes(searchTerm.toLowerCase());
  
  // Date filtering
  const recordDate = new Date(record.patientInfo?.date);
  const today = new Date();
  
  let matchesDate = true;
  if (filterOption === 'today') {
    matchesDate = recordDate.toDateString() === today.toDateString();
  } else if (filterOption === 'week') {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    matchesDate = recordDate >= weekAgo;
  } else if (filterOption === 'month') {
    const monthAgo = new Date();
    monthAgo.setMonth(monthAgo.getMonth() - 1);
    matchesDate = recordDate >= monthAgo;
  }
  
  return matchesSearch && matchesDate;
});








//patient's eye examination report
const generatePatientEyeExam = (data) => {

  const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
    });

    // Set default font styles
    doc.setFont('helvetica');
    doc.setTextColor(0, 0, 0); // Black text

    // Constants for layout
    // const leftMargin = 15;
    // const rightMargin = 15;
    // const pageWidth = 210 - leftMargin - rightMargin;
    // const column1 = leftMargin;
    // const column2 = 100;
    // const columnWidth = 80;

    // // Header Section
    // doc.addImage('/eye-world-logo.png', 'PNG', leftMargin, 12, 40, 40); // Larger logo


    // Constants for layout
const leftMargin = 15;
const rightMargin = 15;
const pageWidth = 210 - leftMargin - rightMargin;
const column1 = leftMargin;
const column2 = 100;
const columnWidth = 80;

// Header settings
const headerHeight = 50;
const logoWidth = 50;
const logoHeight = 20;

// Vertically center logo inside header
const logoY = (headerHeight - logoHeight) / 2;

// Header Section
doc.addImage(
  '/house-of-vision-logo.png',
  'PNG',
  leftMargin,
  logoY,
  logoWidth,
  logoHeight
);


    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('HOUSE OF VISION', leftMargin + 65, 18);
    doc.setFontSize(10);
    doc.text('No. 355, Maharagama Road, Boralesgamuwa', leftMargin + 65, 23);
    doc.text('Tel: 077 20 20 261 / 077 20 20 578 / 0112 150 150', leftMargin + 65, 28);
    doc.text('Email: Info@houseofvision.lk', leftMargin + 65, 33);
    doc.text(`Date: ${data.patientInfo.date}`, 180, 33, { align: 'right' });
    // doc.line(leftMargin, 32, 210 - rightMargin, 32); // Horizontal line


    // Report Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    // Patient Information (Two Columns)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PATIENT INFORMATION', leftMargin, 50);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Column 1
    doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
    doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 62);
    doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 68);
    
    // Column 2
    doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 56);
    doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 62);
    doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

    // Helper functions
    const addSection = (title, content, y, maxWidth = pageWidth) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        
        const lines = doc.splitTextToSize(content || '-', maxWidth);
        doc.text(lines, leftMargin + 5, y + 6);
        return y + (lines.length * 5) + 10;
    };

    const addExamTable = (title, data, y, columns) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        y += 6;
        
        // Table header
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        columns.forEach((col, i) => {
            doc.text(col.label, leftMargin + (i * 40), y);
        });
        y += 6;
        
        // Table data
        doc.setFont('helvetica', 'normal');
        data.forEach(row => {
            columns.forEach((col, i) => {
                doc.text(row[col.key] || '-', leftMargin + (i * 40), y);
            });
            y += 6;
        });
        
        return y + 6;
    };

    let yPos = 82;

    // History Sections (inline, label + value)
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    doc.text(`Chief Complaint : ${data.history?.chiefComplaint || '-'}`, leftMargin, yPos);
    yPos += 6;
    doc.text(`History Of Present Complaint : ${data.history?.hpc || '-'}`, leftMargin, yPos);
    yPos += 6;
    doc.text(`Past Ocular History : ${data.history?.pastOcularHistory || '-'}`, leftMargin, yPos);
    yPos += 6;


    // Visual Acuity
    yPos = addExamTable('Visual Acuity', [
        { test: 'C/C', od: data.visualAcuity?.od_cg || '-', os: data.visualAcuity?.os_cg || '-' },
        { test: 'S/C', od: data.visualAcuity?.od_sg || '-', os: data.visualAcuity?.os_sg || '-' },
        { test: 'P/H', od: data.visualAcuity?.od_ph || '-', os: data.visualAcuity?.os_ph || '-' },
        { test: 'PD', od: data.visualAcuity?.od_pd || '-', os: data.visualAcuity?.os_pd || '-' },
        { test: 'SEG', od: data.visualAcuity?.seg_va || '-', os: '-' }
    ], yPos, [
        { label: 'Test', key: 'test' },
        { label: 'OD', key: 'od' },
        { label: 'OS', key: 'os' }
    ]);

    // Accessory Tests (CT, NPC, OM)
    if (
        (data.visualAcuity?.ct && data.visualAcuity.ct.trim() !== '') ||
        (data.visualAcuity?.npc && data.visualAcuity.npc.trim() !== '') ||
        (data.visualAcuity?.om && data.visualAcuity.om.trim() !== '')
    ) {
        yPos = addSection('Accessory Tests',
            `CT: ${data.visualAcuity.ct || '-'}, ` +
            `NPC: ${data.visualAcuity.npc || '-'}, ` +
            `OM: ${data.visualAcuity.om || '-'}`, 
            yPos
        );
    }

    // Check if we need a new page before Hb Rx and Refraction
    if (yPos > 200) {
        doc.addPage();
        yPos = 20;
    }

    // Hb Rx
    if (data.hbrx) {
        const hbRxData = [
            { 
                eye: 'OD',
                sph: data.hbrx.hb_od_sph || '-',
                cyl: data.hbrx.hb_od_cyl || '-',
                axis: data.hbrx.hb_od_axis || '-',
                vision: data.hbrx.hb_od_vision || '-' 
            },
            { 
                eye: 'OS',
                sph: data.hbrx.rx_os_sph || '-',
                cyl: data.hbrx.rx_os_cyl || '-',
                axis: data.hbrx.rx_os_axis || '-',
                vision: data.hbrx.rx_os_vision || '-' 
            }
        ];
        
        yPos = addExamTable('Hb Rx', hbRxData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
    }

    // Refraction
    if (data.refraction) {
        const refractionData = [
            { 
                eye: 'OD', 
                sph: data.refraction.od_sph || '-', 
                cyl: data.refraction.od_cyl || '-', 
                axis: data.refraction.od_axis || '-', 
                vision: data.refraction.od_vision || '-' 
            },
            { 
                eye: 'OS', 
                sph: data.refraction.os_sph || '-', 
                cyl: data.refraction.os_cyl || '-', 
                axis: data.refraction.os_axis || '-', 
                vision: data.refraction.os_vision || '-' 
            }
        ];

        yPos = addExamTable('Refraction', refractionData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
    }


doc.setFontSize(10);
doc.setFont('helvetica', 'bold');

doc.text(`Near Vision (ADD) : ${data.history.addition || '-'}`, leftMargin, yPos);
yPos += 6;


    // Follow Up
    if (yPos > 260) {
        doc.addPage();
        yPos = 20;
    }

    yPos = addSection('Follow Up', 
        `Needed: ${data.followUp?.needed ? 'Yes' : 'No'}` +
        (data.followUp?.needed ? `, Date: ${data.followUp.date || '-'}` : '') +
        (data.followUp?.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
        yPos);

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('"All kinds of Eye wear, Sunglasses, Color Lenses, and All Eyeware accessories"', 105, 287, { align: 'center' });
    doc.text('© HOUSE OF VISION', 105, 292, { align: 'center' });

    // Save PDF
    doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};

// ADD THIS FUNCTION INSIDE COMPONENT
const handleDeleteEyeExam = async (recordId) => {
  const password = prompt("Enter authorization password to delete this record");

  if (password !== "Hov@355") {
    alert("Invalid authorization password");
    return;
  }

  const confirmDelete = window.confirm(
    "Are you sure you want to permanently delete this eye examination record?"
  );

  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "eyeExams", recordId));

    alert("Record deleted successfully");

    // Update main records state
    setEyeExamRecords((prev) =>
      prev.filter((item) => item.id !== recordId)
    );

  } catch (error) {
    console.error("Delete error:", error);
    alert("Failed to delete record");
  }
};











//////////////////////////////////////// patient follow up ///////////////////////////////////////////////

const [followUpPatients, setFollowUpPatients] = useState([]);
const [loadingFollowUps, setLoadingFollowUps] = useState(true);

const loadFollowUps = async () => {
  try {
    setLoadingFollowUps(true);

    const snapshot = await getDocs(collection(db, "eyeExams"));

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const patients = snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter((exam) => {
        if (!exam.followUp?.needed) return false;
        if (!exam.followUp?.date) return false;

        const followDate = new Date(exam.followUp.date);

        // Hide expired follow-ups
        return followDate >= today;
      })
      .sort(
        (a, b) =>
          new Date(a.followUp.date) -
          new Date(b.followUp.date)
      );

    setFollowUpPatients(patients);
  } catch (error) {
    console.error("Error loading follow-ups:", error);
  } finally {
    setLoadingFollowUps(false);
  }
};




useEffect(() => {
  loadFollowUps();

  const interval = setInterval(() => {
    loadFollowUps();
  }, 60000);

  return () => clearInterval(interval);
}, []);



const sendFollowUpWhatsApp = (patient) => {
  const patientName = patient.patientInfo?.name || "";
  const phone = patient.patientInfo?.contactNo || "";

  const cleaned = phone.replace(/\D/g, "");

  const isMobile =
    cleaned.startsWith("07") &&
    cleaned.length === 10;

  if (!isMobile) {
    alert(
      "This number is not WhatsApp enabled. Please make a normal call."
    );
    return;
  }

  const whatsappNo = `94${cleaned.substring(1)}`;

  // Combined message with all 3 languages
  const message = `*HOUSE OF VISION @ Boralesgamuwa*

Dear ${patientName},

This is a kindly reminder from *HOUSE OF VISION @ Boralesgamuwa*

Follow-up Date: ${patient.followUp?.date}

Follow-Up Description: ${patient.followUp?.remarks || ""}

Please contact us if you need any assistance.

Thank you.

------------------------------------------------------------------

*HOUSE OF VISION @ Boralesgamuwa*

මෙය ඔබගේ වෙන්කරගත් වේලාව පිළිබඳ මතක් කිරීමකි.

ඔබගේ හමුවීමේ විස්තර:

රෝගියා: ${patientName || '-'}
දිනය: ${patient.followUp?.date}
විස්තර: ${patient.followUp?.remarks || ""}

කරුණාකර අපව අමතන්න.

ස්තුතියි!

HOUSE OF VISION
Boralesgamuwa`;

  window.open(
    `https://wa.me/${whatsappNo}?text=${encodeURIComponent(
      message
    )}`,
    "_blank"
  );
};











/////////////////////////////////////////////////////// birthday wish ////////////////////////////////////////////

// =========================
// Birthday State
// =========================
const [birthdayPatients, setBirthdayPatients] = useState([]);
const [loadingBirthdays, setLoadingBirthdays] = useState(true);

// =========================
// Load Birthday Patients
// =========================
const loadBirthdays = async () => {
  try {
    setLoadingBirthdays(true);

    const snapshot = await getDocs(collection(db, "invoices"));

    const patients = snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter((patient) => patient.customer?.age);

    console.log("Birthday Patients:", patients);

    setBirthdayPatients(patients);
  } catch (error) {
    console.error("Birthday Load Error:", error);
  } finally {
    setLoadingBirthdays(false);
  }
};

useEffect(() => {
  loadBirthdays();
}, []);

// =========================
// Birthday Matching
// =========================
const isBirthdayMatch = (dob, targetDate) => {
  if (!dob) return false;

  const birthDate = new Date(dob);

  if (isNaN(birthDate.getTime())) return false;

  return (
    birthDate.getDate() === targetDate.getDate() &&
    birthDate.getMonth() === targetDate.getMonth()
  );
};

const today = new Date();

const tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1);

const dayAfterTomorrow = new Date();
dayAfterTomorrow.setDate(today.getDate() + 2);

// =========================
// Birthday Lists
// =========================
const todayBirthdays = birthdayPatients.filter((patient) =>
  isBirthdayMatch(patient.customer?.age, today)
);

const tomorrowBirthdays = birthdayPatients.filter((patient) =>
  isBirthdayMatch(patient.customer?.age, tomorrow)
);

const dayAfterTomorrowBirthdays = birthdayPatients.filter((patient) =>
  isBirthdayMatch(patient.customer?.age, dayAfterTomorrow)
);

console.log("Today's Birthdays:", todayBirthdays);

// =========================
// WhatsApp Birthday Wish
// =========================
const sendBirthdayWish = (patient) => {
  const patientName = patient.customer?.fullName || "";
  const phone = patient.customer?.tpNo || "";

  if (!phone) {
    alert("Phone number not available.");
    return;
  }

  const cleaned = phone.replace(/\D/g, "");

  const isMobile =
    cleaned.startsWith("07") && cleaned.length === 10;

  if (!isMobile) {
    alert("This number is not WhatsApp enabled.");
    return;
  }

  const whatsappNo = `94${cleaned.substring(1)}`;

  const message = `Dear ${patientName},

Happy Birthday!

Wishing you a wonderful day filled with happiness, good health, and success.

Warm wishes from all of us at *HOUSE OF VISION @ Boralesgamuwa*.

Have a fantastic birthday!

--------------------------------------------------------------

හිතවත් ${patientName},

සුභ උපන්දිනයක් වේවා!

සතුට, යහපත් සෞඛ්‍යය සහ සාර්ථකත්වයෙන් පිරුණු සුන්දර දිනයක් ඔබට ප්‍රාර්ථනා කරමු.

*HOUSE OF VISION @ Boralesgamuwa* කාර්ය මණ්ඩලයේ සියලු දෙනාගේ උණුසුම් සුභ පැතුම්.

ඔබට සුභ උපන්දිනයක් වේවා!`;

  window.open(
    `https://wa.me/${whatsappNo}?text=${encodeURIComponent(message)}`,
    "_blank"
  );
};

// =========================
// Birthday Card
// =========================
const BirthdayCard = ({ patient, color }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: 14,
      padding: 14,
      marginBottom: 10,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      border: "1px solid #e2e8f0",
      boxShadow: "0 2px 8px rgba(0,0,0,.05)",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <div
        style={{
          width: 15,
          height: 15,
          borderRadius: "50%",
          background: color,
        }}
      />

      <div>
        <div
          style={{
            fontWeight: 600,
            color: "#0f172a",
          }}
        >
          {patient.customer?.fullName}
        </div>

        <div
          style={{
            fontSize: 13,
            color: "#64748b",
          }}
        >
          🎂 {patient.customer?.age}
        </div>
      </div>
    </div>

    <button
      onClick={() => sendBirthdayWish(patient)}
      style={{
        background: "#25D366",
        color: "#fff",
        border: "none",
        borderRadius: 8,
        padding: "8px 12px",
        cursor: "pointer",
        fontWeight: 600,
      }}
    >
      {patient.customer?.tpNo}
    </button>
  </div>
);








/////////////////////////////////// Add Eye Camp ////////////////////////////////////

// Add these state variables at the top of your component with other states
const [eyeCampName, setEyeCampName] = useState('');
const [eyeCampCity, setEyeCampCity] = useState('');
const [addingEyeCamp, setAddingEyeCamp] = useState(false);

// Function to add eye camp
const handleAddEyeCamp = async () => {
  // Validation
  if (!eyeCampName.trim()) {
    alert("Please enter Eye Camp Name");
    return;
  }
  
  if (!eyeCampCity.trim()) {
    alert("Please enter City");
    return;
  }

  setAddingEyeCamp(true);
  
  try {
    // Create eye camp object
    const eyeCampData = {
      name: eyeCampName.trim(),
      city: eyeCampCity.trim(),
      createdAt: new Date(),
      updatedAt: new Date(),
      status: "active"
    };
    
    // Save to Firestore
    const docRef = await addDoc(collection(db, "eye_camps"), eyeCampData);
    
    console.log("Eye Camp added with ID: ", docRef.id);
    alert("Eye Camp added successfully!");
    
    // Clear form
    handleClearEyeCamp();
    
  } catch (error) {
    console.error("Error adding eye camp:", error);
    alert("Error adding eye camp: " + error.message);
  } finally {
    setAddingEyeCamp(false);
  }
};

// Function to clear form
const handleClearEyeCamp = () => {
  setEyeCampName('');
  setEyeCampCity('');
};




/////////////////////////////////////////////////// view  eye camp ////////////////////////


const [editingEyeCamp, setEditingEyeCamp] = useState(null); // { id, name, city }

// ==================== DELETE MODAL STATES ====================
const [showDeleteCampModal, setShowDeleteCampModal] = useState(false);
const [deleteCampPassword, setDeleteCampPassword] = useState('');
const [deleteCampError, setDeleteCampError] = useState('');
const [selectedCampToDelete, setSelectedCampToDelete] = useState(null);

// ==================== FETCH EYE CAMPS ====================
const fetchEyeCamps = async () => {
  try {
    const snapshot = await getDocs(collection(db, "eye_camps"));
    const camps = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setEyeCamps(camps);
  } catch (error) {
    console.error("Error fetching eye camps:", error);
  }
};

useEffect(() => {
  fetchEyeCamps();
}, []);




// ==================== UPDATE EYE CAMP ====================
const handleUpdateEyeCamp = async () => {
  if (!editingEyeCamp) return;
  
  if (!editingEyeCamp.name.trim()) {
    alert("Please enter Eye Camp Name");
    return;
  }
  
  if (!editingEyeCamp.city.trim()) {
    alert("Please enter City");
    return;
  }

  try {
    const campRef = doc(db, "eye_camps", editingEyeCamp.id);
    await updateDoc(campRef, {
      name: editingEyeCamp.name.trim(),
      city: editingEyeCamp.city.trim(),
      updatedAt: new Date()
    });
    
    alert("✅ Eye Camp updated successfully!");
    setEditingEyeCamp(null);
    await fetchEyeCamps();
    
  } catch (error) {
    console.error("Error updating eye camp:", error);
    alert("Error updating eye camp: " + error.message);
  }
};

// ==================== DELETE EYE CAMP ====================
const handleDeleteEyeCamp = (camp) => {
  setSelectedCampToDelete(camp);
  setShowDeleteCampModal(true);
  setDeleteCampPassword('');
  setDeleteCampError('');
};

const confirmDeleteEyeCamp = async () => {
  const CORRECT_PASSWORD = 'Hov@355';
  
  if (deleteCampPassword !== CORRECT_PASSWORD) {
    setDeleteCampError('❌ Incorrect password! Please try again.');
    return;
  }
  
  try {
    await deleteDoc(doc(db, "eye_camps", selectedCampToDelete.id));
    alert("✅ Eye Camp deleted successfully!");
    setShowDeleteCampModal(false);
    setSelectedCampToDelete(null);
    setDeleteCampPassword('');
    await fetchEyeCamps();
    
  } catch (error) {
    console.error("Error deleting eye camp:", error);
    alert("Error deleting eye camp: " + error.message);
  }
};

// ==================== FILTERED CAMPS ====================
const filteredCamps = eyeCamps.filter(camp => 
  camp.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  camp.city?.toLowerCase().includes(searchTerm.toLowerCase())
);










/////////////////////////////////////// download direct sale invoice ///////////////////////////////////////////////////////////////////

const [directSaleInvoices, setDirectSaleInvoices] = useState([]);
const [invoiceSearch, setInvoiceSearch] = useState("");


const fetchDirectSaleInvoices = async () => {
  try {
const q = query(
  collection(db, "invoices"),
  where("type", "==", "direct-sale"),
  orderBy("createdAt", "desc")
);

    const snapshot = await getDocs(q);

    const invoices = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setDirectSaleInvoices(invoices);

  } catch (error) {
    console.log(error);
  }
};


const filteredDirectSaleInvoices = directSaleInvoices.filter((invoice) => {
  const search = invoiceSearch
    .toLowerCase()
    .replace("inv-", "")
    .trim();

  const invoiceNo = (invoice.invoiceNumber || "")
    .toLowerCase()
    .replace("inv-", "");

  const customerName = (
    invoice.customer?.fullName ||
    `${invoice.customer?.firstName || ""} ${invoice.customer?.lastName || ""}`
  ).toLowerCase();

  const phoneNumber = (
    invoice.customer?.tpNo || ""
  ).toLowerCase();

  return (
    invoiceNo.includes(search) ||
    customerName.includes(search) ||
    phoneNumber.includes(search)
  );
});


useEffect(() => {
  if (selectedOption === "downloadDirectSaleInvoice") {
    fetchDirectSaleInvoices();
  }
}, [selectedOption]);




const handleViewInvoice = (invoice) => {
  setSelectedInvoice(invoice);
};


















///////////////////////////////// download service invoice //////////////////////////


const [serviceInvoices, setServiceInvoices] = useState([]);
const [serviceInvoiceSearch, setServiceInvoiceSearch] = useState("");




const fetchServiceInvoices = async () => {
  try {
    const q = query(
      collection(db, "invoices"),
      where("type", "==", "service-invoice")
    );

    const snapshot = await getDocs(q);

    const invoices = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setServiceInvoices(invoices);

  } catch (error) {
    console.log(error);
  }
};

useEffect(() => {
  if (selectedOption === "downloadServiceInvoice") {
    fetchServiceInvoices();
  }
}, [selectedOption]);





const filteredServiceInvoices = serviceInvoices.filter((invoice) => {
  const search = serviceInvoiceSearch
    .toLowerCase()
    .replace("inv-", "")
    .trim();

  const invoiceNo = (invoice.invoiceNumber || "")
    .toLowerCase()
    .replace("inv-", "");

  const customerName = (
    invoice.customer?.fullName ||
    `${invoice.customer?.firstName || ""} ${invoice.customer?.lastName || ""}`
  ).toLowerCase();

  const phoneNumber = (
    invoice.customer?.tpNo || ""
  ).toLowerCase();

  return (
    invoiceNo.includes(search) ||
    customerName.includes(search) ||
    phoneNumber.includes(search)
  );
});











///////////////////////////////// Download main invoice //////////////////////////

// Add these state variables with your other states
const [mainInvoices, setMainInvoices] = useState([]);
const [mainInvoiceSearch, setMainInvoiceSearch] = useState("");

// Add this function with your other fetch functions
const fetchMainInvoices = async () => {
  try {
    const q = query(
      collection(db, "invoices"),
      where("type", "==", "main-invoice")
    );

    const snapshot = await getDocs(q);

    const invoices = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // Sort by createdAt descending (newest first)
    invoices.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setMainInvoices(invoices);
    console.log("Fetched main invoices:", invoices.length); // Debug log

  } catch (error) {
    console.error("Error fetching main invoices:", error);
  }
};

// Add this filtered logic
const filteredMainInvoices = mainInvoices.filter((invoice) => {
  const search = mainInvoiceSearch
    .toLowerCase()
    .replace("inv-", "")
    .trim();

  const invoiceNo = (invoice.invoiceNumber || "")
    .toLowerCase()
    .replace("inv-", "");

  const customerName = (
    invoice.customer?.fullName ||
    `${invoice.customer?.firstName || ""} ${invoice.customer?.lastName || ""}`
  ).toLowerCase();

  const phoneNumber = (
    invoice.customer?.tpNo || ""
  ).toLowerCase();

  return (
    invoiceNo.includes(search) ||
    customerName.includes(search) ||
    phoneNumber.includes(search)
  );
});






// Add this to your existing useEffect
useEffect(() => {
  if (selectedOption === "downloadServiceInvoice") {
    fetchServiceInvoices();
  }
  if (selectedOption === "downloadMainInvoice") {
    fetchMainInvoices();
  }
}, [selectedOption]);


// Toggle panel function
const togglePanel = () => {
  setIsPanelOpen(!isPanelOpen);
};








const [isSameLens, setIsSameLens] = useState(false);







//////////////////////////// notification /////////////////////////////////////////

// Add these state variables inside your AdminPanel component
const [notifications, setNotifications] = useState({
  deliveries: [],
  followups: [],
  birthdays: [],
  annualCheckups: []
});


const [totalNotifications, setTotalNotifications] = useState(0);
const [isPanelOpen, setIsPanelOpen] = useState(false);

// Helper functions
const getNotificationIcon = (type) => {
  switch (type) {
    case "delivery":
      return <FaEye className="icon delivery-icon" />;

    case "followup":
      return <FaEnvelope className="icon followup-icon" />;

    case "birthday":
      return <FaBirthdayCake className="icon birthday-icon" />;

    case "annual":
      return <FaCalendarCheck className="icon annual-icon" />;

    default:
      return <FaBell />;
  }
};




const getTimeAgo = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = parseISO(dateStr);
    const diff = differenceInDays(new Date(), date);
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Yesterday';
    return `${diff} days ago`;
  } catch {
    return '';
  }
};





// FETCH NOTIFICATIONS - COMPLETE WORKING VERSION
// FETCH NOTIFICATIONS - CORRECT COLLECTION NAMES
useEffect(() => {
  const fetchNotifications = async () => {
    const today = new Date();
    const todayStr = format(today, 'yyyy-MM-dd');
    
    try {
      console.log('========== FETCHING NOTIFICATIONS ==========');
      console.log('Today date:', todayStr);
      
      // ===== FETCH INVOICES DATA =====
      const invoicesQuery = query(collection(db, "invoices"));
      const invoicesSnapshot = await getDocs(invoicesQuery);
      const invoicesData = invoicesSnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data() 
      }));
      
      console.log('Total invoices:', invoicesData.length);
      
      // ===== SECTION 1: SPECTACLE DELIVERIES =====
      const todayDeliveries = invoicesData
        .filter(invoice => {
          if (!invoice.delivery?.date) return false;
          return invoice.delivery.date === todayStr;
        })
        .map(invoice => ({
          id: invoice.id,
          invoiceNo: invoice.invoiceNo || 'N/A',
          customer: invoice.customer || {},
          date: invoice.delivery?.date,
          status: invoice.delivery?.status || 'Pending'
        }));

      console.log('📦 Deliveries today:', todayDeliveries.length);
      
      // ===== SECTION 3: BIRTHDAY WISHES (from invoices) =====
      const todayBirthdays = invoicesData
        .filter(invoice => {
          if (!invoice.customer?.age) return false;
          try {
            const dob = parseISO(invoice.customer.age);
            return dob.getDate() === today.getDate() && 
                   dob.getMonth() === today.getMonth();
          } catch (error) {
            return false;
          }
        })
        .map(invoice => ({
          id: invoice.id,
          customer: invoice.customer,
          dob: invoice.customer.age
        }));

      console.log('🎂 Birthdays today:', todayBirthdays.length);







// ===== SECTION 4: ANNUAL EYE CHECK-UP =====

const todayAnnualCheckups = invoicesData
  .filter((invoice) => {
    if (!invoice.prescription?.date) return false;

    try {
      const examDate = new Date(invoice.prescription.date);

      if (isNaN(examDate.getTime())) return false;

      const dueDate = new Date(examDate);
      dueDate.setFullYear(dueDate.getFullYear() + 1);

      const todayOnly = new Date(today);
      todayOnly.setHours(0, 0, 0, 0);

      dueDate.setHours(0, 0, 0, 0);

      const diffDays = Math.ceil(
        (dueDate.getTime() - todayOnly.getTime()) /
          (1000 * 60 * 60 * 24)
      );

      return diffDays >= 0 && diffDays <= 30;

    } catch {
      return false;
    }
  })
  .map((invoice) => {
    const examDate = new Date(invoice.prescription.date);

    const dueDate = new Date(examDate);
    dueDate.setFullYear(dueDate.getFullYear() + 1);

    const todayOnly = new Date(today);
    todayOnly.setHours(0, 0, 0, 0);
    dueDate.setHours(0, 0, 0, 0);

    const diffDays = Math.ceil(
      (dueDate.getTime() - todayOnly.getTime()) /
        (1000 * 60 * 60 * 24)
    );

    return {
      id: invoice.id,
      customer: invoice.customer,
      prescriptionDate: invoice.prescription.date,
      dueDate: format(dueDate, "yyyy-MM-dd"),
      daysRemaining: diffDays
    };
  });

console.log(
  "👁 Annual Checkups:",
  todayAnnualCheckups.length
);









      // ===== FETCH EYE EXAMS DATA (NOT eye_camps!) =====
      const eyeExamsQuery = query(collection(db, "eyeExams"));  // ← CHANGED FROM eye_camps
      const eyeExamsSnapshot = await getDocs(eyeExamsQuery);
      const eyeExamsData = eyeExamsSnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data() 
      }));
      
      console.log('Total eye exams:', eyeExamsData.length);
      console.log('All eye exams data:', JSON.stringify(eyeExamsData, null, 2));
      
      // ===== SECTION 2: FOLLOW-UP MESSAGES (from eyeExams) =====
      const todayFollowups = [];
      
      eyeExamsData.forEach(exam => {
        console.log('Checking exam:', exam.id);
        console.log('exam.followUp:', exam.followUp);
        
        // Check if followUp exists and has date
        if (exam.followUp && exam.followUp.date) {
          console.log('Follow-up date found:', exam.followUp.date);
          console.log('Comparing with today:', todayStr);
          
          if (exam.followUp.date === todayStr) {
            console.log('✅ MATCH FOUND! Adding follow-up for:', exam.patientInfo?.name);
            todayFollowups.push({
              id: exam.id,
              patientInfo: exam.patientInfo || {},
              date: exam.followUp.date,
              remarks: exam.followUp.remarks || '',
              needed: exam.followUp.needed || false,
              eyeExam: exam.externalExam || null,
              refraction: exam.refraction || null,
              visualAcuity: exam.visualAcuity || null
            });
          }
        } else {
          console.log('❌ No followUp or no date in exam:', exam.id);
        }
      });

      console.log('📋 Follow-ups today:', todayFollowups.length);
      console.log('Follow-up data:', JSON.stringify(todayFollowups, null, 2));

      // UPDATE ALL NOTIFICATIONS
setNotifications({
  deliveries: todayDeliveries,
  followups: todayFollowups,
  birthdays: todayBirthdays,
  annualCheckups: todayAnnualCheckups
});

     const total =
  todayDeliveries.length +
  todayFollowups.length +
  todayBirthdays.length +
  todayAnnualCheckups.length;
      setTotalNotifications(total);
      console.log('🔔 TOTAL NOTIFICATIONS:', total);
      console.log('==========================================');
      
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  fetchNotifications();
}, []);











const [showHBRx, setShowHBRx] = useState(false);






////////////////////////// // Annual Eye Check-up ////////////////////////////////////////////////////////////////////

// Annual Eye Check-up Reminder Component - SHOWS UPCOMING TOO
const [annualCheckupPatients, setAnnualCheckupPatients] = useState([]);
const [loadingAnnualCheckup, setLoadingAnnualCheckup] = useState(true);

const loadAnnualCheckupPatients = async () => {
  try {
    setLoadingAnnualCheckup(true);

    const snapshot = await getDocs(
      collection(db, "invoices")
    );

    console.log("📊 Total invoices found:", snapshot.docs.length);

    const patients = snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter((patient) => {
        const prescriptionDate = patient.prescription?.date;
        
        if (!prescriptionDate) {
          return false;
        }

        try {
          const examDate = new Date(prescriptionDate);
          
          if (isNaN(examDate.getTime())) {
            return false;
          }
          
          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          
          // Calculate one year later
          const oneYearLater = new Date(examDate);
          oneYearLater.setFullYear(examDate.getFullYear() + 1);
          oneYearLater.setHours(0, 0, 0, 0);
          
          // Calculate days until due
          const timeDiff = oneYearLater.getTime() - currentDate.getTime();
          const daysUntilDue = Math.ceil(timeDiff / (1000 * 3600 * 24));
          
          // SHOW: Due today OR in the next 30 days (so you can see upcoming)
          // This will show your patient since it's due tomorrow
          const isUpcoming = daysUntilDue >= 0 && daysUntilDue <= 30;
          
          if (isUpcoming) {
            console.log(`📅 ${patient.customer?.fullName}: Due in ${daysUntilDue} days (${prescriptionDate})`);
          }
          
          return isUpcoming;
          
        } catch (error) {
          console.error(`Error processing ${patient.id}:`, error);
          return false;
        }
      });

    console.log("✅ Total upcoming patients found:", patients.length);
    setAnnualCheckupPatients(patients);
  } catch (error) {
    console.error("❌ Error loading annual checkup patients:", error);
  } finally {
    setLoadingAnnualCheckup(false);
  }
};

useEffect(() => {
  loadAnnualCheckupPatients();
}, []);

// Send WhatsApp message
const sendAnnualCheckupReminder = (patient) => {
  const patientName = patient.customer?.fullName || patient.customer?.firstName || "Sir/Madam";
  const phone = patient.customer?.tpNo || "";

  if (!phone) {
    alert("No phone number found for this patient");
    return;
  }

  const cleaned = phone.replace(/\D/g, "");

  const isMobile = cleaned.startsWith("07") && cleaned.length === 10;

  if (!isMobile) {
    alert("This number is not WhatsApp enabled. Please make a normal call.");
    return;
  }

  const whatsappNo = `94${cleaned.substring(1)}`;

  const message = `Dear ${patientName},

It's time for your annual eye check-up! 

Regular eye examinations are essential for maintaining good vision and overall eye health. We recommend that you schedule your appointment at your earliest convenience.

Please call us at 077 20 20 261 / 077 20 20 578 / 0112 150 150 to schedule your appointment at HOUSE OF VISION.

We look forward to seeing you soon!

Warm regards,
*HOUSE OF VISION @ Boralesgamuwa*

--------------------------------------------------------------

හිතවත් ${patientName},

ඔබගේ වාර්ෂික අක්ෂි පරීක්ෂාව සඳහා කාලය පැමිණ ඇත! 

නිතිපතා අක්ෂි පරීක්ෂාවන් යහපත් දෘෂ්ටිය හා සමස්ත අක්ෂි සෞඛ්‍යය පවත්වා ගැනීම සඳහා අත්‍යවශ්‍ය වේ. ඔබගේ වාර්ෂික අක්ෂි පරීක්ෂාව සඳහා ඔබට පහසු වේලාවක් වෙන්කරවා ගන්නා ලෙස අපි නිර්දේශ කරමු.

කරුණාකර HOUSE OF VISION හි වේලාවක් වෙන්කරවා ගැනීම සඳහා 077 20 20 261 / 077 20 20 578 හෝ 0112 150 150 අමතන්න.

ඔබව ඉක්මනින් හමුවීමට බලාපොරොත්තු වෙමු!


*HOUSE OF VISION
Boralesgamuwa*`;

  window.open(
    `https://wa.me/${whatsappNo}?text=${encodeURIComponent(message)}`,
    "_blank"
  );
};

// The JSX Component
{selectedOption === "AnnualEyeCheckup" && (
  <div
    style={{
      padding: "20px",
      background: "#f8fafc",
      minHeight: "100vh",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        flexWrap: "wrap",
        gap: "10px",
      }}
    >
      <h2
        style={{
          margin: 0,
          color: "#1e293b",
        }}
      >
        👁️ Annual Eye Check-Up Reminders
      </h2>

      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            background: "#22c55e",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "30px",
            fontWeight: "600",
            fontSize: "14px",
          }}
        >
          📆 Upcoming (30 days): {annualCheckupPatients.length}
        </div>
      </div>
    </div>

    {loadingAnnualCheckup ? (
      <p>Loading...</p>
    ) : (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "20px",
        }}
      >
        {/* Debug Info */}
        {/* <div
          style={{
            background: "#fff",
            padding: "15px",
            borderRadius: "8px",
            border: "1px solid #e2e8f0",
            fontSize: "13px",
            color: "#64748b",
          }}
        >
          <strong>📊 Database Info:</strong>
          <br />
          Total upcoming patients (next 30 days): {annualCheckupPatients.length}
          <br />
          <br />
          <strong>ℹ️ Check browser console (F12) for detailed logs</strong>
          {annualCheckupPatients.length === 0 && (
            <div style={{ marginTop: "10px", color: "#ef4444" }}>
              ⚠️ No patients found in next 30 days.
            </div>
          )}
        </div> */}

        {/* All Upcoming Patients */}
        <div>
          <h3
            style={{
              color: "#22c55e",
              marginBottom: "12px",
              borderBottom: "2px solid #22c55e",
              paddingBottom: "8px",
            }}
          >
            📆 Patients Due in Next 30 Days
          </h3>

          {annualCheckupPatients.length === 0 ? (
            <p style={{ color: "#64748b" }}>
              No patients due in the next 30 days
            </p>
          ) : (
            annualCheckupPatients.map((patient) => {
              const examDate = patient.prescription?.date;
              const dueDate = new Date(examDate);
              dueDate.setFullYear(dueDate.getFullYear() + 1);
              
              const currentDate = new Date();
              currentDate.setHours(0, 0, 0, 0);
              const timeDiff = dueDate.getTime() - currentDate.getTime();
              const daysUntilDue = Math.ceil(timeDiff / (1000 * 3600 * 24));

              // Determine status
              let statusColor = "#22c55e"; // green
              let statusText = `${daysUntilDue} days remaining`;
              
              if (daysUntilDue === 0) {
                statusColor = "#f97316";
                statusText = "📅 Due Today!";
              } else if (daysUntilDue < 0) {
                statusColor = "#ef4444";
                statusText = `⏰ ${Math.abs(daysUntilDue)} days overdue`;
              } else if (daysUntilDue <= 7) {
                statusColor = "#f97316";
                statusText = `📅 ${daysUntilDue} days remaining`;
              }

              return (
                <div
                  key={patient.id}
                  style={{
                    background: "#fff",
                    borderRadius: "14px",
                    padding: "14px",
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 2px 8px rgba(0,0,0,.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        background: statusColor,
                      }}
                    />

                    <div>
                      <div
                        style={{
                          fontWeight: 600,
                          color: "#0f172a",
                        }}
                      >
                        {patient.customer?.fullName || patient.customer?.firstName || "Unknown"}
                      </div>

                      <div
                        style={{
                          color: "#64748b",
                          fontSize: "13px",
                        }}
                      >
                        📋 Last Exam: {examDate} | Due: {dueDate.toISOString().split('T')[0]}
                      </div>
                      
                      <div
                        style={{
                          color: statusColor,
                          fontSize: "12px",
                          fontWeight: "600",
                        }}
                      >
                        {statusText}
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() => sendAnnualCheckupReminder(patient)}
                    style={{
                      background: "#25D366",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      cursor: "pointer",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    📱 {patient.customer?.tpNo || "No Number"}
                  </button>
                </div>
              );
            })
          )}
        </div>
      </div>
    )}
  </div>
)}









/////////////////////////////////// manage lens stock ////////////////////////////////////
  // ==================== STATE VARIABLES ====================
  const [lensStockFormData, setLensStockFormData] = useState({
    jobNo: '',
    branch: '',
    model: '',
    sph: '',
    cyl: '',
    axis: '',
    add: '',
    sellingPrice: '',
    remark: '',
    selectedLensId: '',
    selectedItemIndex: '',
    selectedQty: 0,
    qtyToDeduct: 1
  });

  const [lensStockErrors, setLensStockErrors] = useState({});
  const [isLensStockLoading, setIsLensStockLoading] = useState(false);
  const [lensStockSuggestions, setLensStockSuggestions] = useState([]);
  const [showLensStockSuggestions, setShowLensStockSuggestions] = useState(false);
  const [lensStockOutHistory, setLensStockOutHistory] = useState([]);
  const [lensStockActiveTab, setLensStockActiveTab] = useState('manage');
  const [lensStockOptions, setLensStockOptions] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [deletePassword, setDeletePassword] = useState('');
  const [deleteError, setDeleteError] = useState('');

  // ==================== FETCH LENS DATA ====================
  const fetchLensStockItems = async () => {
    try {
      console.log("🔍 FETCHING LENSES...");
      
      const q = query(collection(db, "stock"), where("category", "==", "lens"));
      const querySnapshot = await getDocs(q);
      const lensesList = [];

      querySnapshot.forEach(docSnap => {
        const data = docSnap.data();
        if (Array.isArray(data.items)) {
          data.items.forEach((item, index) => {
            lensesList.push({
              id: docSnap.id,
              itemIndex: index,
              model: item.model || '',
              sph: item.sph || '',
              cyl: item.cyl || '',
              axis: item.axis || '',
              add: item.add || '',
              sellingPrice: item.sellingPrice || 0,
              qty: item.qty || 0,
              status: item.status || 'In Stock'
            });
          });
        } else if (data.qty !== undefined) {
          lensesList.push({
            id: docSnap.id,
            itemIndex: 0,
            model: data.model || '',
            sph: data.sph || '',
            cyl: data.cyl || '',
            axis: data.axis || '',
            add: data.add || '',
            sellingPrice: data.sellingPrice || 0,
            qty: data.qty || 0,
            status: data.status || 'In Stock'
          });
        }
      });

      console.log("✅ Lenses loaded:", lensesList.length);
      setLensStockOptions(lensesList);
    } catch (err) {
      console.log("Error loading lenses:", err);
    }
  };

  // ==================== FETCH HISTORY ====================
  const fetchLensStockOutHistory = async () => {
    try {
      const q = query(collection(db, "lens_stock_out"), orderBy("date", "desc"));
      const querySnapshot = await getDocs(q);
      const history = [];
      querySnapshot.forEach((doc) => {
        history.push({ id: doc.id, ...doc.data() });
      });
      setLensStockOutHistory(history);
    } catch (error) {
      console.error('Error fetching history:', error);
      setLensStockOutHistory([]);
    }
  };

  // ==================== SEARCH BY MODEL ====================
  const handleLensStockSearch = (text) => {
    setLensStockFormData(prev => ({ ...prev, model: text }));

    if (text.length < 2) {
      setShowLensStockSuggestions(false);
      setLensStockSuggestions([]);
      return;
    }

    const searchText = text.toLowerCase();
    
    const filtered = lensStockOptions.filter((lens) => {
      const modelMatch = lens.model && lens.model.toLowerCase().includes(searchText);
      const hasStock = Number(lens.qty) > 0;
      return modelMatch && hasStock;
    });

    console.log("🔍 Found suggestions:", filtered.length);
    setLensStockSuggestions(filtered);
    setShowLensStockSuggestions(filtered.length > 0);
  };

  // ==================== SELECT LENS ====================
  const selectLensStockItem = (lens) => {
    if (lens.qty <= 0) {
      alert(`Lens "${lens.model}" is out of stock!`);
      return;
    }
    
    setLensStockFormData(prev => ({
      ...prev,
      model: lens.model,
      sph: lens.sph || '',
      cyl: lens.cyl || '',
      axis: lens.axis || '',
      add: lens.add || '',
      sellingPrice: lens.sellingPrice || 0,
      selectedLensId: lens.id || "",
      selectedItemIndex: lens.itemIndex,
      selectedQty: lens.qty || 0,
      qtyToDeduct: 1
    }));
    
    setShowLensStockSuggestions(false);
    setLensStockSuggestions([]);
  };

  // ==================== SAVE ORDER WITH QUANTITY ====================
  const handleLensStockSave = async () => {
    const errors = {};
    if (!lensStockFormData.jobNo.trim()) errors.jobNo = 'Job number is required';
    if (!lensStockFormData.branch) errors.branch = 'Please select a branch';
    if (!lensStockFormData.model.trim()) errors.model = 'Please search and select a lens';
    
    const qtyToDeduct = parseInt(lensStockFormData.qtyToDeduct) || 0;
    if (qtyToDeduct <= 0) {
      errors.qtyToDeduct = 'Quantity must be at least 1';
    }
    if (qtyToDeduct > lensStockFormData.selectedQty) {
      errors.qtyToDeduct = `Only ${lensStockFormData.selectedQty} items available in stock`;
    }
    
    setLensStockErrors(errors);
    if (Object.keys(errors).length > 0) {
      alert('Please fix all errors before saving');
      return;
    }
    
    setIsLensStockLoading(true);
    
    try {
      let stockDocumentId = null;
      
      if (lensStockFormData.selectedLensId) {
        const lensRef = doc(db, 'stock', lensStockFormData.selectedLensId);
        const lensDoc = await getDoc(lensRef);
        
        if (lensDoc.exists()) {
          const lensData = lensDoc.data();
          stockDocumentId = lensStockFormData.selectedLensId;
          
          if (lensData.items && Array.isArray(lensData.items)) {
            const itemIndex = lensData.items.findIndex(item => item.model === lensStockFormData.model);
            
            if (itemIndex !== -1) {
              const currentQty = lensData.items[itemIndex].qty || 0;
              
              if (currentQty < qtyToDeduct) {
                alert(`Only ${currentQty} items available in stock!`);
                setIsLensStockLoading(false);
                return;
              }
              
              const updatedItems = [...lensData.items];
              const newQty = currentQty - qtyToDeduct;
              updatedItems[itemIndex] = {
                ...updatedItems[itemIndex],
                qty: newQty,
                status: newQty <= 0 ? 'Out of Stock' : 'In Stock'
              };
              
              await updateDoc(lensRef, { 
                items: updatedItems,
                updatedAt: new Date().toISOString()
              });
            }
          } else if (lensData.qty !== undefined) {
            const currentQty = lensData.qty || 0;
            
            if (currentQty < qtyToDeduct) {
              alert(`Only ${currentQty} items available in stock!`);
              setIsLensStockLoading(false);
              return;
            }
            
            const newQty = currentQty - qtyToDeduct;
            await updateDoc(lensRef, { 
              qty: newQty,
              status: newQty <= 0 ? 'Out of Stock' : 'In Stock',
              updatedAt: new Date().toISOString()
            });
          }
        }
      }
      
      const stockOutData = {
        jobNo: lensStockFormData.jobNo.trim(),
        branch: lensStockFormData.branch,
        model: lensStockFormData.model.trim(),
        sph: parseFloat(lensStockFormData.sph) || 0,
        cyl: parseFloat(lensStockFormData.cyl) || 0,
        axis: parseInt(lensStockFormData.axis) || 0,
        add: parseFloat(lensStockFormData.add) || 0,
        sellingPrice: parseFloat(lensStockFormData.sellingPrice) || 0,
        remark: lensStockFormData.remark || '',
        date: new Date().toISOString(),
        orderType: 'lens_stock_out',
        stockDocumentId: stockDocumentId,
        qtyDeducted: qtyToDeduct
      };
      
      await addDoc(collection(db, "lens_stock_out"), stockOutData);
      
      alert(`✅ ${qtyToDeduct} lens(es) ordered successfully!`);
      
      setLensStockFormData({
        jobNo: '',
        branch: '',
        model: '',
        sph: '',
        cyl: '',
        axis: '',
        add: '',
        sellingPrice: '',
        remark: '',
        selectedLensId: '',
        selectedItemIndex: '',
        selectedQty: 0,
        qtyToDeduct: 1
      });
      
      await fetchLensStockItems();
      await fetchLensStockOutHistory();
      
    } catch (error) {
      console.error('Error saving lens order:', error);
      alert('Error saving lens order. Please try again.');
    } finally {
      setIsLensStockLoading(false);
    }
  };

  // ==================== DELETE AND RESTOCK ====================
  const handleDeleteLensStockOut = (entry) => {
    setSelectedEntry(entry);
    setDeletePassword('');
    setDeleteError('');
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (deletePassword !== 'Hov@355') {
      setDeleteError('Incorrect password!');
      return;
    }

    if (!selectedEntry) return;

    try {
      if (selectedEntry.stockDocumentId) {
        const lensRef = doc(db, 'stock', selectedEntry.stockDocumentId);
        const lensDoc = await getDoc(lensRef);
        
        if (lensDoc.exists()) {
          const lensData = lensDoc.data();
          const qtyToRestore = selectedEntry.qtyDeducted || 1;
          
          if (lensData.items && Array.isArray(lensData.items)) {
            const itemIndex = lensData.items.findIndex(item => item.model === selectedEntry.model);
            if (itemIndex !== -1) {
              const updatedItems = [...lensData.items];
              const currentQty = updatedItems[itemIndex].qty || 0;
              const newQty = currentQty + qtyToRestore;
              
              updatedItems[itemIndex] = {
                ...updatedItems[itemIndex],
                qty: newQty,
                status: 'In Stock'
              };
              
              await updateDoc(lensRef, { 
                items: updatedItems,
                updatedAt: new Date().toISOString()
              });
            }
          } else if (lensData.qty !== undefined) {
            const newQty = (lensData.qty || 0) + qtyToRestore;
            await updateDoc(lensRef, { 
              qty: newQty,
              status: 'In Stock',
              updatedAt: new Date().toISOString()
            });
          }
        }
      }
      
      await deleteDoc(doc(db, "lens_stock_out", selectedEntry.id));
      
      alert(`✅ ${selectedEntry.qtyDeducted || 1} item(s) restored to stock!`);
      
      await fetchLensStockItems();
      await fetchLensStockOutHistory();
      
      setShowDeleteModal(false);
      setSelectedEntry(null);
      setDeletePassword('');
      
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('Error deleting record. Please try again.');
    }
  };

  // ==================== DOWNLOAD PDF (SINGLE DECLARATION) ====================
  const downloadLensStockReportPDF = () => {
    if (lensStockOutHistory.length === 0) {
      alert('No data to export!');
      return;
    }
    
    // Simple CSV export as fallback
    try {
      const headers = ['#', 'Job No', 'Branch', 'Model', 'Sph', 'Cyl', 'Axis', 'Add', 'Qty', 'Price', 'Remark', 'Date'];
      const rows = lensStockOutHistory.map((entry, index) => [
        index + 1,
        entry.jobNo || '',
        entry.branch || '',
        entry.model || '',
        entry.sph || 0,
        entry.cyl || 0,
        entry.axis || 0,
        entry.add || 0,
        entry.qtyDeducted || 1,
        entry.sellingPrice || 0,
        entry.remark || '',
        new Date(entry.date).toLocaleDateString()
      ]);
      
      const csvContent = [
        headers.join(','),
        ...rows.map(row => row.join(','))
      ].join('\n');
      
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `lens_stock_report_${new Date().toISOString().split('T')[0]}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
      
      alert('✅ Report downloaded successfully!');
    } catch (error) {
      console.error('Error downloading report:', error);
      alert('Error downloading report. Please try again.');
    }
  };

  // ==================== USE EFFECT ====================
  useEffect(() => {
    fetchLensStockItems();
    fetchLensStockOutHistory();
  }, []);

























  return (
    <>
      {/* 🔵 TOP NAVIGATION BAR */}
<nav className="top-nav">
  <div className="logo">Powered By Glaxmore IT</div>

  <ul className="nav-links">

    {/* Normal Tabs */}
    <li
      className={selectedOption === "dashboard" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("dashboard");
      }}
    >
      Dashboard
    </li>

    <li
      className={selectedOption === "viewPatient" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("viewPatient");
      }}
    >
      View Patients
    </li>

    {/* Invoice Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "invoice" ? null : "invoice");
      }}
    >
      Invoice ▾

      {openMenu === "invoice" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectInvoice("createInvoice")}>Create Invoice</p>
          <p onClick={() => handleSelectInvoice("directSales")}>Create Direct Sale Invoice</p>
          <p onClick={() => handleSelectInvoice("serviceInvoice")}>Create Service Invoice</p>
          <p onClick={() => handleSelectInvoice("viewInvoice")}>View All Invoice</p>
          <p onClick={() => handleSelectInvoice("createBalanceInvoice")}>Create Balance Invoice</p>
          <p onClick={() => handleSelectInvoice("viewBalanceInvoice")}>View All Balance Invoice</p>

        <p onClick={() => handleSelectInvoice("downloadMainInvoice")}>View & Download Invoice / Prescription</p>
        <p onClick={() => handleSelectInvoice("downloadDirectSaleInvoice")}>View & Download Direct-Sale Invoice</p>
        <p onClick={() => handleSelectInvoice("downloadServiceInvoice")}>View & Download Service Invoice</p>

        </div>
      )}
    </li>




    {/* Invoice Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "eyeExam" ? null : "eyeExam");
      }}
    >
      Eye Exam Report ▾

      {openMenu === "eyeExam" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectInvoice("createEyeExamReport")}>Create Eye Exam Report</p>
          <p onClick={() => handleSelectInvoice("viewEyeExamReport")}>View All Eye Exam Report</p>
          <p onClick={() => handleSelectInvoice("eyeExamReportForPatient")}>Eye Exam Report For Patient</p>

        </div>
      )}
    </li>








   


    {/* track the spectacles */}

        <li
      className={selectedOption === "trackSpectacle" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("trackSpectacle");
      }}
    >
      Spectacle Status Tracking
    </li>




    {/* Supplier Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "supplier" ? null : "supplier");
      }}
    >
      Supplier ▾

      {openMenu === "supplier" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectSupplier("addSupplier")}>Add Supplier</p>
          <p onClick={() => handleSelectSupplier("viewSupplier")}>View Supplier</p>
        </div>
      )}
    </li>

    {/* Stock Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "stock" ? null : "stock");
      }}
    >
      Stock ▾

      {openMenu === "stock" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectStock("quickAdd")}>Add Stock</p>
           <p onClick={() => handleSelectStock("manageLensStock")}>Manage Lens Stock</p>
        </div>
      )}
    </li>

    {/* Reports Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "report" ? null : "report");
      }}
    >
      Reports ▾

      {openMenu === "report" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectReport("StockHistory")}>Stock Report</p>
          <p onClick={() => handleSelectReport("viewStockOut")}>View Stock-Out Report</p>
          <p onClick={() => handleSelectReport("salesReport")}>Sales Report</p>
        </div>
      )}
    </li>






    {/* Send Message */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "sendmessage" ? null : "sendmessage");
      }}
    >
      Send Message ▾

      {openMenu === "sendmessage" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
           <p onClick={() => handleSelectReport("AnnualEyeCheckup")}>Annual Eye Check-Up</p>
          <p onClick={() => handleSelectReport("patientfollowup")}>Patient Follow-Up</p>
          <p onClick={() => handleSelectReport("birthdayWishes")}>Birthday Wishes</p>
         
        </div>
      )}
    </li>




<li 
  onClick={() => {
    setOpenMenu(null);
    setIsPanelOpen(true);
  }}
  style={{ position: 'relative', cursor: 'pointer' }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <FaBell className="bell-icon" />
    <span>Notifications</span>
    {totalNotifications > 0 && (
      <span className="notification-badge">
        {totalNotifications}
      </span>
    )}
  </div>
</li>




{/* Add To System*/}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "addSystem" ? null : "addSystem");
      }}
    >
      Add To System ▾

      {openMenu === "addSystem" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
      
          <p onClick={() => handleSelectReport("addEyeCamp")}>Add Eye Camp</p>
          <p onClick={() => handleSelectReport("viewEyeCamps")}>View Eye Camps</p>
      
        </div>
      )}
    </li>





    {/* Logout */}
    <li
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(null);
        handleLogout();
      }}
    >
      Logout
    </li>
  </ul>
</nav>

      {/* 🔵 PAGE BODY */}
      <div className="page-body">




{/***************************************** manage Lens Stock **********************************************/}


{selectedOption === "manageLensStock" && (
     <div className="mls-container">
      
      {/* TABS */}
      <div className="mls-tabs">
        <button 
          className={`mls-tab-btn ${lensStockActiveTab === 'manage' ? 'mls-tab-active' : ''}`}
          onClick={() => setLensStockActiveTab('manage')}
        >
          📋 Manage Lens Stock
        </button>
        <button 
          className={`mls-tab-btn ${lensStockActiveTab === 'report' ? 'mls-tab-active' : ''}`}
          onClick={() => setLensStockActiveTab('report')}
        >
          📊 Lens Stock Out Report
        </button>
      </div>

      {/* ==================== MANAGE TAB ==================== */}
      {lensStockActiveTab === 'manage' && (
        <div className="mls-tab-content">
          <h1 className="mls-title">📋 Manage Lens Stock</h1>
          
          <div className="mls-order-form">
            {/* JOB NO & BRANCH */}
            <div className="mls-form-row">
              <div className="mls-form-group">
                <label className="mls-label">Job No <span className="mls-required-star">*</span></label>
                <input 
                  type="text" 
                  value={lensStockFormData.jobNo}
                  onChange={(e) => {
                    setLensStockFormData(prev => ({ ...prev, jobNo: e.target.value }));
                    if (lensStockErrors.jobNo) setLensStockErrors(prev => ({ ...prev, jobNo: '' }));
                  }}
                  placeholder="Enter Job Number"
                  className={lensStockErrors.jobNo ? 'mls-error-input' : 'mls-input'}
                />
                {lensStockErrors.jobNo && <span className="mls-error-text">{lensStockErrors.jobNo}</span>}
              </div>
              
              <div className="mls-form-group">
                <label className="mls-label">Branch <span className="mls-required-star">*</span></label>
                <select 
                  value={lensStockFormData.branch}
                  onChange={(e) => {
                    setLensStockFormData(prev => ({ ...prev, branch: e.target.value }));
                    if (lensStockErrors.branch) setLensStockErrors(prev => ({ ...prev, branch: '' }));
                  }}
                  className={lensStockErrors.branch ? 'mls-error-input' : 'mls-select'}
                >
                  <option value="">Select Branch</option>
                     <option value="House of Vision Branc">House of Vision Branch</option>
                  {/* <option value="Batticaloa Branch">Batticaloa Branch</option>
                  <option value="Batticaloa Head Office">Batticaloa Head Office</option> */}
                </select>
                {lensStockErrors.branch && <span className="mls-error-text">{lensStockErrors.branch}</span>}
              </div>
            </div>

            {/* SEARCH */}
            <div className="mls-form-row mls-lens-search-row">
              <div className="mls-form-group">
                <label className="mls-label">Model <span className="mls-required-star">*</span></label>
                <div className="mls-search-wrapper">
                  <input 
                    type="text" 
                    value={lensStockFormData.model}
                    onChange={(e) => handleLensStockSearch(e.target.value)}
                    onFocus={() => {
                      if (lensStockFormData.model.length >= 2) {
                        handleLensStockSearch(lensStockFormData.model);
                      }
                    }}
                    placeholder="Type model name..."
                    className={lensStockErrors.model ? 'mls-error-input' : 'mls-input'}
                    autoComplete="off"
                  />
                  
                  {showLensStockSuggestions && lensStockSuggestions.length > 0 && (
                    <div className="mls-suggestions-dropdown">
                      {lensStockSuggestions.map((lens, index) => (
                        <div
                          key={index}
                          className="mls-suggestion-item"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => selectLensStockItem(lens)}
                        >
                          <div className="mls-suggestion-main">
                            <strong>{lens.model}</strong>
                            <span className="mls-suggestion-stock">Stock: {lens.qty}</span>
                          </div>
                          <div className="mls-suggestion-details">
                            SPH: {lens.sph || '0'} | CYL: {lens.cyl || '0'} | Axis: {lens.axis || '0'} | Add: {lens.add || '0'}
                            <span className="mls-suggestion-price">Rs. {lens.sellingPrice}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {lensStockErrors.model && <span className="mls-error-text">{lensStockErrors.model}</span>}
              </div>
            </div>

            {/* LENS DETAILS */}
            <div className="mls-details-grid">
              <div className="mls-form-group">
                <label className="mls-label">Sph <span className="mls-required-star">*</span></label>
                <input 
                  type="number" 
                  value={lensStockFormData.sph}
                  onChange={(e) => {
                    setLensStockFormData(prev => ({ ...prev, sph: e.target.value }));
                    if (lensStockErrors.sph) setLensStockErrors(prev => ({ ...prev, sph: '' }));
                  }}
                  placeholder="-2.5"
                  step="0.25"
                  className={lensStockErrors.sph ? 'mls-error-input' : 'mls-input'}
                />
                {lensStockErrors.sph && <span className="mls-error-text">{lensStockErrors.sph}</span>}
              </div>
              
              <div className="mls-form-group">
                <label className="mls-label">Cyl</label>
                <input 
                  type="number" 
                  value={lensStockFormData.cyl}
                  onChange={(e) => setLensStockFormData(prev => ({ ...prev, cyl: e.target.value }))}
                  placeholder="-1.25"
                  step="0.25"
                  className="mls-input"
                />
              </div>
              
              <div className="mls-form-group">
                <label className="mls-label">Axis</label>
                <input 
                  type="number" 
                  value={lensStockFormData.axis}
                  onChange={(e) => setLensStockFormData(prev => ({ ...prev, axis: e.target.value }))}
                  placeholder="30"
                  className="mls-input"
                />
              </div>
              
              <div className="mls-form-group">
                <label className="mls-label">Add</label>
                <input 
                  type="number" 
                  value={lensStockFormData.add}
                  onChange={(e) => setLensStockFormData(prev => ({ ...prev, add: e.target.value }))}
                  placeholder="+2.00"
                  step="0.25"
                  className="mls-input"
                />
              </div>
              
              {/* <div className="mls-form-group">
                <label className="mls-label">Selling Price <span className="mls-required-star">*</span></label>
                <input 
                  type="number" 
                  value={lensStockFormData.sellingPrice}
                  onChange={(e) => {
                    setLensStockFormData(prev => ({ ...prev, sellingPrice: e.target.value }));
                    if (lensStockErrors.sellingPrice) setLensStockErrors(prev => ({ ...prev, sellingPrice: '' }));
                  }}
                  placeholder="Enter selling price"
                  className={lensStockErrors.sellingPrice ? 'mls-error-input' : 'mls-input'}
                />
                {lensStockErrors.sellingPrice && <span className="mls-error-text">{lensStockErrors.sellingPrice}</span>}
              </div> */}

              {/* ==================== NEW QUANTITY FIELD ==================== */}
              <div className="mls-form-group">
                <label className="mls-label">Quantity <span className="mls-required-star">*</span></label>
                <div className="mls-qty-wrapper">
                  <input 
                    type="number" 
                    value={lensStockFormData.qtyToDeduct}
                    onChange={(e) => {
                      const val = parseInt(e.target.value) || 0;
                      setLensStockFormData(prev => ({ 
                        ...prev, 
                        qtyToDeduct: val 
                      }));
                      if (lensStockErrors.qtyToDeduct) {
                        setLensStockErrors(prev => ({ ...prev, qtyToDeduct: '' }));
                      }
                    }}
                    min="1"
                    max={lensStockFormData.selectedQty || 1}
                    className={lensStockErrors.qtyToDeduct ? 'mls-error-input' : 'mls-input'}
                  />
                  <span className={`mls-stock-info ${
                    lensStockFormData.selectedQty <= 0 ? 'out-of-stock' :
                    lensStockFormData.selectedQty <= 5 ? 'low-stock' : 'available'
                  }`}>
                    Available: {lensStockFormData.selectedQty}
                  </span>
                </div>
                {lensStockErrors.qtyToDeduct && <span className="mls-error-text">{lensStockErrors.qtyToDeduct}</span>}
              </div>
            </div>

            {/* REMARK */}
            <div className="mls-form-group mls-full-width">
              <label className="mls-label">Remark</label>
              <textarea 
                value={lensStockFormData.remark}
                onChange={(e) => setLensStockFormData(prev => ({ ...prev, remark: e.target.value }))}
                placeholder="Any special remarks or notes..."
                rows="3"
                className="mls-textarea"
              />
            </div>

            {/* SAVE BUTTON */}
            <div className="mls-form-actions">
              <button 
                className="mls-save-btn"
                onClick={handleLensStockSave}
                disabled={isLensStockLoading}
              >
                {isLensStockLoading ? '⏳ Saving...' : '💾 Save Lens Order'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ==================== REPORT TAB ==================== */}
      {lensStockActiveTab === 'report' && (
        <div className="mls-tab-content">
          <h1 className="mls-title">📊 Lens Stock Out Report</h1>
          
          <div className="mls-report-actions">
            <div className="mls-report-left">
              <span className="mls-report-count">Total Records: {lensStockOutHistory.length}</span>
              {lensStockOutHistory.length > 0 && (
                <span className="mls-report-total">
                  Total Amount: Rs. {lensStockOutHistory.reduce((sum, entry) => sum + (entry.sellingPrice || 0), 0).toFixed(2)}
                </span>
              )}
            </div>
            <div className="mls-report-right">
              <button className="mls-refresh-btn" onClick={() => fetchLensStockOutHistory()}>
                🔄 Refresh
              </button>
              {lensStockOutHistory.length > 0 && (
                <button className="mls-download-btn" onClick={downloadLensStockReportPDF}>
                  📥 Download PDF
                </button>
              )}
            </div>
          </div>

          {lensStockOutHistory.length > 0 ? (
            <div className="mls-table-responsive">
              <table className="mls-history-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Job No</th>
                    <th>Branch</th>
                    <th>Model</th>
                    <th>Sph</th>
                    <th>Cyl</th>
                    <th>Axis</th>
                    <th>Add</th>
                    <th>Qty</th>
                    {/* <th>Price</th> */}
                    <th>Remark</th>
                    <th>Date</th>
                    <th className="mls-action-col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {lensStockOutHistory.map((entry, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{entry.jobNo}</td>
                      <td>{entry.branch}</td>
                      <td>{entry.model}</td>
                      <td>{entry.sph}</td>
                      <td>{entry.cyl}</td>
                      <td>{entry.axis}</td>
                      <td>{entry.add}</td>
                      <td>{entry.qtyDeducted || 1}</td>
                      {/* <td>Rs. {entry.sellingPrice}</td> */}
                      <td>{entry.remark || '-'}</td>
                      <td>{new Date(entry.date).toLocaleDateString()}</td>
                      <td>
                        <button 
                          className="mls-delete-btn"
                          onClick={() => handleDeleteLensStockOut(entry)}
                          title="Delete and Restock"
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="mls-no-data">📭 No records found</div>
          )}
        </div>
      )}

      {/* ==================== DELETE MODAL ==================== */}
      {showDeleteModal && (
        <div className="mls-modal-overlay">
          <div className="mls-modal">
            <div className="mls-modal-header">
              <h3>🔒 Confirm Delete & Restock</h3>
              <button 
                className="mls-modal-close"
                onClick={() => {
                  setShowDeleteModal(false);
                  setSelectedEntry(null);
                  setDeletePassword('');
                  setDeleteError('');
                }}
              >
                ✕
              </button>
            </div>
            <div className="mls-modal-body">
              <p>Are you sure you want to delete this record?</p>
              <p className="mls-modal-details">
                <strong>Model:</strong> {selectedEntry?.model}<br/>
                <strong>Quantity to Restock:</strong> {selectedEntry?.qtyDeducted || 1}<br/>
                <strong>Job No:</strong> {selectedEntry?.jobNo}
              </p>
              <div className="mls-modal-password">
                <label>Enter Password to Confirm:</label>
                <input 
                  type="password"
                  value={deletePassword}
                  onChange={(e) => {
                    setDeletePassword(e.target.value);
                    setDeleteError('');
                  }}
                  placeholder="Enter admin password"
                  onKeyPress={(e) => e.key === 'Enter' && confirmDelete()}
                />
                {deleteError && <span className="mls-error-text">{deleteError}</span>}
              </div>
            </div>
            <div className="mls-modal-footer">
              <button 
                className="mls-modal-cancel"
                onClick={() => {
                  setShowDeleteModal(false);
                  setSelectedEntry(null);
                  setDeletePassword('');
                  setDeleteError('');
                }}
              >
                Cancel
              </button>
              <button 
                className="mls-modal-confirm"
                onClick={confirmDelete}
              >
                Confirm Delete & Restock
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
)}





{/*******************************************  Annual Eye Checkup  *************************************************************/}


{selectedOption === "AnnualEyeCheckup" && (
  <div
    style={{
      padding: "20px",
      background: "#f8fafc",
      minHeight: "100vh",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        flexWrap: "wrap",
        gap: "10px",
      }}
    >
      <h2
        style={{
          margin: 0,
          color: "#1e293b",
        }}
      >
        👁️ Annual Eye Check-Up Reminders
      </h2>

      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            background: "#ef4444",
            color: "#fff",
            padding: "8px 16px",
            borderRadius: "30px",
            fontWeight: "600",
            fontSize: "14px",
          }}
        >
          ⏰ Overdue: {annualCheckupPatients.length}
        </div>
      </div>
    </div>

    {loadingAnnualCheckup ? (
      <p>Loading...</p>
    ) : (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "20px",
        }}
      >
    





            {/* Summary Stats */}
        <div
          style={{
            background: "#fff",
            borderRadius: "14px",
            padding: "20px",
            border: "1px solid #e2e8f0",
            marginTop: "10px",
          }}
        >
          <h4 style={{ marginBottom: "10px", color: "#1e293b" }}>
            📊 Summary
          </h4>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
              gap: "10px",
            }}
          >
            <div>
              <strong>Total Patients:</strong> {annualCheckupPatients.length}
            </div>
            <div style={{ color: "#ef4444" }}>
              <strong>Overdue &gt; 30 days:</strong>{" "}
              {annualCheckupPatients.filter((p) => {
                const examDate = new Date(p.prescription?.date);
                const dueDate = new Date(examDate);
                dueDate.setFullYear(examDate.getFullYear() + 1);
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                const diff = currentDate.getTime() - dueDate.getTime();
                return diff / (1000 * 3600 * 24) > 30;
              }).length}
            </div>
            <div style={{ color: "#f97316" }}>
              <strong>Overdue 7-30 days:</strong>{" "}
              {annualCheckupPatients.filter((p) => {
                const examDate = new Date(p.prescription?.date);
                const dueDate = new Date(examDate);
                dueDate.setFullYear(examDate.getFullYear() + 1);
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                const diff = currentDate.getTime() - dueDate.getTime();
                const days = diff / (1000 * 3600 * 24);
                return days >= 7 && days <= 30;
              }).length}
            </div>
            <div style={{ color: "#22c55e" }}>
              <strong>Due Today or 1-7 days:</strong>{" "}
              {annualCheckupPatients.filter((p) => {
                const examDate = new Date(p.prescription?.date);
                const dueDate = new Date(examDate);
                dueDate.setFullYear(examDate.getFullYear() + 1);
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                const diff = currentDate.getTime() - dueDate.getTime();
                const days = diff / (1000 * 3600 * 24);
                return days >= 0 && days < 7;
              }).length}
            </div>
          </div>
        </div>






        {/* All Overdue Patients */}
        <div>
          <h3
            style={{
              color: "#ef4444",
              marginBottom: "12px",
              borderBottom: "2px solid #ef4444",
              paddingBottom: "8px",
            }}
          >
            ⏰ Patients Due for Annual Check-Up
          </h3>

          {annualCheckupPatients.length === 0 ? (
            <p style={{ color: "#64748b" }}>
              No patients are due for their annual check-up yet
            </p>
          ) : (
            annualCheckupPatients.map((patient) => {
              const examDate = patient.prescription?.date;
              const dueDate = new Date(examDate);
              dueDate.setFullYear(dueDate.getFullYear() + 1);
              
              // Calculate days overdue
              const currentDate = new Date();
              currentDate.setHours(0, 0, 0, 0);
              const timeDiff = currentDate.getTime() - dueDate.getTime();
              const daysOverdue = Math.floor(timeDiff / (1000 * 3600 * 24));

              return (
                <div
                  key={patient.id}
                  style={{
                    background: "#fff",
                    borderRadius: "14px",
                    padding: "14px",
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 2px 8px rgba(0,0,0,.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        background: daysOverdue > 30 ? "#ef4444" : daysOverdue > 7 ? "#f97316" : "#22c55e",
                      }}
                    />

                    <div>
                      <div
                        style={{
                          fontWeight: 600,
                          color: "#0f172a",
                        }}
                      >
                        {patient.customer?.fullName || patient.customer?.firstName || "Unknown"}
                      </div>

                      <div
                        style={{
                          color: "#64748b",
                          fontSize: "13px",
                        }}
                      >
                        📋 Last Exam: {examDate} | Due Date: {dueDate.toISOString().split('T')[0]}
                      </div>
                      
                      <div
                        style={{
                          color: daysOverdue > 30 ? "#ef4444" : daysOverdue > 7 ? "#f97316" : "#22c55e",
                          fontSize: "12px",
                          fontWeight: "600",
                        }}
                      >
                        {daysOverdue === 0 ? '📅 Due Today!' : 
                         daysOverdue > 0 ? `⏰ ${daysOverdue} days overdue` : 
                         `${Math.abs(daysOverdue)} days remaining`}
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() => sendAnnualCheckupReminder(patient)}
                    style={{
                      background: "#25D366",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      cursor: "pointer",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    📱 {patient.customer?.tpNo || "No Number"}
                  </button>
                </div>
              );
            })
          )}
        </div>


      </div>
    )}
  </div>
)}



{/*******************************************  notification  *************************************************************/}


{isPanelOpen && (
  <div className="notification-panel-overlay" onClick={togglePanel}>
    <div className="notification-panel" onClick={(e) => e.stopPropagation()}>
      <div className="notification-header">
        <h2>
          <FaBell className="header-icon" />
          Today's Notifications
          <span className="notification-count">{totalNotifications}</span>
        </h2>
        <button className="close-panel" onClick={() => setIsPanelOpen(false)}>×</button>
      </div>

      {totalNotifications === 0 ? (
        <div className="no-notifications">
          <FaBell className="empty-icon" />
          <p>No notifications for today</p>
          <span>All caught up! Check back tomorrow</span>
        </div>
      ) : (
        <div className="notification-content">
          
          {/* SECTION 1: SPECTACLE DELIVERIES */}
          {notifications.deliveries.length > 0 && (
            <div className="notification-section">
              <div className="section-header">
                <FaEye className="section-icon" />
                <h3>Spectacle Deliveries ({notifications.deliveries.length})</h3>
                <span className="section-count">{notifications.deliveries.length}</span>
              </div>
              <div className="notification-list">
                {notifications.deliveries.map((item) => (
                  <div key={item.id} className="notification-item delivery-item">
                    <div className="item-icon-wrapper">
                      {getNotificationIcon('delivery')}
                    </div>
                    <div className="item-content">
                      <div className="item-title">
                        {item.customer?.fullName || 'Unknown Customer'}
                        <span className="invoice-badge">#{item.invoiceNo}</span>
                      </div>
                      <div className="item-details">
                        <span><FaMapMarkerAlt /> {item.customer?.address || 'N/A'}</span>
                        <span><FaPhone /> {item.customer?.tpNo || 'N/A'}</span>
                      </div>
                      <div className="item-time">
                        <FaClock className="time-icon" />
                        <span>Delivery: {getTimeAgo(item.date)}</span>
                      </div>
                    </div>
                    <div className="item-status">
                      <span className={`status-badge ${item.status?.toLowerCase() || 'pending'}`}>
                        {item.status || 'Pending'}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* SECTION 2: FOLLOW-UP MESSAGES */}
          {notifications.followups.length > 0 && (
            <div className="notification-section">
              <div className="section-header">
                <FaEnvelope className="section-icon" />
                <h3>Follow-up Messages ({notifications.followups.length})</h3>
                <span className="section-count">{notifications.followups.length}</span>
              </div>
              <div className="notification-list">
                {notifications.followups.map((item) => (
                  <div key={item.id} className="notification-item followup-item">
                    <div className="item-icon-wrapper">
                      {getNotificationIcon('followup')}
                    </div>
                    <div className="item-content">
                      <div className="item-title">
                        <FaUser /> {item.patientInfo?.name || 'Unknown Patient'}
                      </div>
                      <div className="item-details">
                        <span><FaPhone /> {item.patientInfo?.contactNo || 'N/A'}</span>
                        <span>Age: {item.patientInfo?.age || 'N/A'} yrs</span>
                        {item.patientInfo?.gender && (
                          <span>Gender: {item.patientInfo.gender}</span>
                        )}
                      </div>
                      {item.remarks && (
                        <div className="item-remarks">📝 {item.remarks}</div>
                      )}
                      {item.needed && (
                        <div className="item-exam">
                          <span className="exam-badge">⚠️ Today Follow-up</span>
                        </div>
                      )}
                      <div className="item-time">
                        <FaClock className="time-icon" />
                        <span>Follow-up: {getTimeAgo(item.date)}</span>
                      </div>
                    </div>
                    <div className="item-status">
                      <span className="status-badge urgent">⚠️ Urgent</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* SECTION 3: BIRTHDAY WISHES */}
          {notifications.birthdays.length > 0 && (
            <div className="notification-section">
              <div className="section-header">
                <FaBirthdayCake className="section-icon" />
                <h3>Birthday Wishes ({notifications.birthdays.length})</h3>
                <span className="section-count">{notifications.birthdays.length}</span>
              </div>
              <div className="notification-list">
                {notifications.birthdays.map((item) => (
                  <div key={item.id} className="notification-item birthday-item">
                    <div className="item-icon-wrapper">
                      {getNotificationIcon('birthday')}
                    </div>
                    <div className="item-content">
                      <div className="item-title">
                        🎂 {item.customer?.fullName || 'Unknown Customer'}
                      </div>
                      <div className="item-details">
                        <span>Happy Birthday!</span>
                        <span>🎈 {item.dob ? format(parseISO(item.dob), 'MMMM d, yyyy') : ''}</span>
                      </div>
                      {item.customer?.tpNo && (
                        <div className="item-time">
                          <FaPhone className="time-icon" />
                          <span>Contact: {item.customer.tpNo}</span>
                        </div>
                      )}
                      <div className="item-time" style={{ marginTop: '4px' }}>
                        <FaClock className="time-icon" />
                        <span style={{ color: '#ff9800', fontWeight: '600' }}>
                          🎉 Celebrate today!
                        </span>
                      </div>
                    </div>
                    <div className="item-status">
                      <span className="status-badge celebration">🎉</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}






{notifications.annualCheckups.length > 0 && (
  <div className="notification-section">
    <div className="section-header">
      <FaCalendarCheck className="section-icon" />
      <h3>
        Annual Eye Check-ups ({notifications.annualCheckups.length})
      </h3>
      <span className="section-count">
        {notifications.annualCheckups.length}
      </span>
    </div>

    <div className="notification-list">
      {notifications.annualCheckups.map((item) => (
        <div
          key={item.id}
          className="notification-item annual-item"
        >
          <div className="item-icon-wrapper">
            {getNotificationIcon("annual")}
          </div>

          <div className="item-content">
            <div className="item-title">
              👁 {item.customer?.fullName}
            </div>

            <div className="item-details">
              <span>
                Last Eye Exam: {item.prescriptionDate}
              </span>
            </div>

            <div className="item-time">
              <FaClock className="time-icon" />

              <span
                style={{
                  color:
                    item.daysRemaining === 0
                      ? "#dc2626"
                      : "#2563eb",
                  fontWeight: "600",
                }}
              >
                {item.daysRemaining === 0
                  ? "Due Today"
                  : `Due in ${item.daysRemaining} day${
                      item.daysRemaining > 1 ? "s" : ""
                    }`}
              </span>
            </div>
          </div>

          <div className="item-status">
            <span className="status-badge annual">
              👁
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
)}







        </div>
      )}

      <div className="notification-footer">
        <button 
          className="view-all-btn" 
          onClick={() => setIsPanelOpen(false)}
        >
          Close Notifications
        </button>
      </div>
    </div>
  </div>
)}








{/********************* download Direct Sale Invoice *********************/}

{/* {selectedOption === "downloadDirectSaleInvoice" && (
  <div className="download-Direct-Sale-Invoice-container">
    <div className="Direct-Sale-Invoice-container">
      <h2>View & Download Direct Sale Invoice</h2><br />


<div className="direct-sale-search">
  <input
    type="text"
     placeholder="Search Invoice No / Customer Name / Phone..."
    value={invoiceSearch}
    onChange={(e) => setInvoiceSearch(e.target.value)}
  />
</div>


<table className="direct-sale-table">
  <thead>
    <tr>
      <th>Invoice No</th>
      <th>Customer</th>
      <th>TP No</th>
      <th>Address</th>
      <th>Products</th>
      <th>Date</th>
      <th>Total</th>
      <th>Action</th>
    </tr>
  </thead>

  <tbody>
    {filteredDirectSaleInvoices.map((invoice) => (
      <tr key={invoice.id}>
        <td>{invoice.invoiceNumber}</td>

<td>
  {`${invoice.customer?.title || ""} ${invoice.customer?.fullName || ""}`.trim() || "-"}
</td>

        <td>
          {invoice.customer?.tpNo || "-"}
        </td>

        <td>
          {invoice.customer?.address || "-"}
        </td>

<td>
  {Array.isArray(invoice.products) ? (
    invoice.products.map((product) =>
      `${product.modelNo} qty: ${product.qty}`
    ).join(" | ")
  ) : (
    "-"
  )}
</td>

        <td>
          {new Date(
            invoice.createdAt
          ).toLocaleDateString()}
        </td>

        <td>
          Rs.{" "}
          {Number(
            invoice.financial?.totalAmount || 0
          ).toFixed(2)}
        </td>

        <td>
          <div className="action-buttons">
            <button
              className="download-btn"
              onClick={() =>
                generateDirectSaleInvoicePDF(invoice)
              }
            >
              Download ↓
            </button>
          </div>
        </td>
      </tr>
    ))}
  </tbody>
</table>

    </div>
  </div>
)}
 */}


{selectedOption === "downloadDirectSaleInvoice" && (
  <div className="download-Direct-Sale-Invoice-container">
    <div className="Direct-Sale-Invoice-container">
      <h2>View & Download Direct Sale Invoice</h2><br />

      <div className="direct-sale-search">
        <input
          type="text"
          placeholder="Search Invoice No / Customer Name / Phone..."
          value={invoiceSearch}
          onChange={(e) => setInvoiceSearch(e.target.value)}
        />
      </div>

      <table className="direct-sale-table">
        <thead>
          <tr>
            <th>Invoice No</th>
            <th>Customer</th>
            <th>TP No</th>
            <th>Address</th>
            <th>Products</th>
            <th>Date</th>
            <th>Total</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {filteredDirectSaleInvoices.map((invoice) => (
            <tr key={invoice.id}>
              <td>{invoice.invoiceNumber}</td>

              <td>
                {`${invoice.customer?.title || ""} ${invoice.customer?.fullName || ""}`.trim() || "-"}
              </td>

              <td>
                {invoice.customer?.tpNo || "-"}
              </td>

              <td>
                {invoice.customer?.address || "-"}
              </td>

              <td>
                {Array.isArray(invoice.products) ? (
                  invoice.products.map((product) =>
                    `${product.modelNo} qty: ${product.qty}`
                  ).join(" | ")
                ) : (
                  "-"
                )}
              </td>

              <td>
                {new Date(invoice.createdAt).toLocaleDateString()}
              </td>

              <td>
                Rs. {Number(invoice.financial?.totalAmount || 0).toFixed(2)}
              </td>

              <td>
                <div className="action-buttons">
                  <button
                    className="download-btn"
                    onClick={() => generateDirectSaleInvoicePDF(invoice)}
                  >
                    Download Invoice ↓
                  </button>
                  
                  {/* Download Prescription Button - Only shows if prescription exists */}
                  {invoice.prescription && (
                    <button
                      className="download-prescription-btn"
                      onClick={() => generatePrescriptionPDF(invoice)}
                      style={{
                        marginTop: '5px',
                        padding: '5px 10px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        width: '100%'
                      }}
                    >
                      Download Prescription ↓
                    </button>
                  )}





                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}


{/********************* download Service Invoice *********************/}

{selectedOption === "downloadServiceInvoice" && (
  <div className="download-Service-Invoice-container">

    <div className="Service-Invoice-container">

      <h2>View & Download Service Invoice</h2> <br />

      <div className="direct-sale-search">
        <input
          type="text"
          placeholder="Search Invoice No / Customer Name / Phone..."
          value={serviceInvoiceSearch}
          onChange={(e) =>
            setServiceInvoiceSearch(e.target.value)
          }
        />
      </div>

      <table className="direct-sale-table">
        <thead>
          <tr>
            <th>Invoice No</th>
            <th>Customer</th>
            <th>TP No</th>
            <th>Address</th>
            <th>Service</th>
            <th>Date</th>
            <th>Total</th>
            <th>Balance</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {filteredServiceInvoices.map((invoice) => (

            <tr key={invoice.id}>

              <td>{invoice.invoiceNumber}</td>

<td>
  {` ${invoice.customer?.fullName || ""}`.trim() || "-"}
</td>

              <td>
                {invoice.customer?.tpNo || "-"}
              </td>

              <td>
                {invoice.customer?.address || "-"}
              </td>

              <td>
                {invoice.service?.description || "-"}
              </td>

              <td>
                {new Date(
                  invoice.createdAt
                ).toLocaleDateString()}
              </td>

              <td>
                Rs.
                {Number(
                  invoice.financial?.totalAmount || 0
                ).toFixed(2)}
              </td>

              <td>
                Rs.
                {Number(
                  invoice.financial?.balanceDue || 0
                ).toFixed(2)}
              </td>

              <td>
                <div className="action-buttons">

                  <button
                    className="download-btn"
                    onClick={() =>
                      generateServiceInvoicePDF(invoice)
                    }
                  >
                    Download ↓
                  </button>

                </div>
              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

  </div>
)}






{/********************* download main Invoice *********************/}

{selectedOption === "downloadMainInvoice" && (
  <div className="download-Service-Invoice-container">
    <div className="Service-Invoice-container">
      <h2>View & Download Invoice / Prescription</h2> <br />



  <div className="direct-sale-search">
  <input
    type="text"
    placeholder="Search Invoice No / Customer Name / Phone..."
    value={mainInvoiceSearch}
    onChange={(e) => setMainInvoiceSearch(e.target.value)}
  />
</div>



      <table className="direct-sale-table">
        <thead>
          <tr>
            <th>Invoice No</th>
            <th>Customer</th>
            <th>TP No</th>
            <th>Address</th>
            <th>Frame Model</th>
            <th>Lens Type</th>
            <th>Date</th>
            <th>Total</th>
            <th>Balance</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredMainInvoices.length > 0 ? (
            filteredMainInvoices.map((invoice) => (
              <tr key={invoice.id}>
                <td>{invoice.invoiceNumber}</td>
                <td>{invoice.customer?.fullName || "-"}</td>
                <td>{invoice.customer?.tpNo || "-"}</td>
                <td>{invoice.customer?.address || "-"}</td>
                <td>{invoice.products?.frameModel || "-"}</td>

{/* <td>
  {invoice.products?.highIndexLens
    ? (
        invoice.products?.highIndexLeft?.name ||
        invoice.products?.highIndexRight?.name
      )
      ? `${invoice.products.highIndexLeft?.name || ''}${
          invoice.products.highIndexRight?.name
            ? ' / ' + invoice.products.highIndexRight.name
            : ''
        }`
      : '-'
    : (
        invoice.products?.leftLens?.name ||
        invoice.products?.rightLens?.name
      )
      ? `${invoice.products.leftLens?.name || ''}${
          invoice.products.rightLens?.name
            ? ' / ' + invoice.products.rightLens.name
            : ''
        }`
      : '-'
  }
</td> */}


<td>
  {(() => {
    // Check if it's a main invoice with products array or products object
    const productData = invoice.products || {};
    
    // Check for high index lenses first
    if (productData.highIndexLens === true) {
      const leftLens = productData.highIndexLeft;
      const rightLens = productData.highIndexRight;
      
      let lensDisplay = '';
      if (leftLens?.name) lensDisplay += leftLens.name;
      if (rightLens?.name) {
        if (lensDisplay) lensDisplay += ' / ';
        lensDisplay += rightLens.name;
      }
      return lensDisplay || '-';
    }
    
    // Check for regular lenses (leftLens/rightLens)
    if (productData.leftLens || productData.rightLens) {
      const leftLens = productData.leftLens;
      const rightLens = productData.rightLens;
      
      let lensDisplay = '';
      if (leftLens?.name) lensDisplay += leftLens.name;
      if (rightLens?.name) {
        if (lensDisplay) lensDisplay += ' / ';
        lensDisplay += rightLens.name;
      }
      return lensDisplay || '-';
    }
    
    // Check for lensModel (string format)
    if (productData.lensModel) {
      return productData.lensModel;
    }
    
    // Fallback to checking products array for lens info
    if (invoice.productsArray && invoice.productsArray.length > 0) {
      // Filter for lens items (assuming they might have a different category)
      const lensItems = invoice.productsArray.filter(item => 
        item.category === 'lens' || 
        item.category === 'lenses' ||
        item.category === 'other' // if lenses are stored as 'other' category
      );
      
      if (lensItems.length > 0) {
        return lensItems.map(item => 
          `${item.brand || ''} ${item.modelNo || ''}`.trim()
        ).join(' / ') || '-';
      }
    }
    
    // If nothing found, return '-'
    return '-';
  })()}
</td>




                <td>{new Date(invoice.createdAt).toLocaleDateString()}</td>
                <td>Rs.{Number(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                <td>Rs.{Number(invoice.financial?.balanceDue || 0).toFixed(2)}</td>
                <td>



<div className="action-buttons">
  <button className="download-btn" onClick={() => generateFullInvoicePDF(invoice)}>
    Invoice ↓
  </button>

  {invoice.prescription && (
    <>
      <button className="download-prescription-btn" onClick={() => generateCustomerPrescriptionPDF(invoice)}>
        Prescription ↓
      </button>

    </>
  )}




    {invoice.prescription && (
    <>
      <button className="download-prescription-btn" onClick={() => generateOrderForm(invoice)}>
        Order Form ↓
      </button>

    </>
  )}
</div>




                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                No main invoices found
              </td>
            </tr>
          )}
        </tbody>
       </table>
    </div>
  </div>
)}










{/****************************************************  add eye camp  ************************************************************/}


{selectedOption === "addEyeCamp" && (
  <div className="add-eye-camp-container">
    <div className="add-eye-camp-card">
      <h2>Add Eye Camp</h2>

      {/* Eye Camp Name */}
      <label>
        Eye Camp Name <span className="required-star">*</span>
      </label>
      <input
        type="text"
        value={eyeCampName}
        onChange={(e) => setEyeCampName(e.target.value)}
        placeholder="Enter eye camp name (e.g., Vision Care Camp 2024)"
      />

      {/* City */}
      <label>
        City <span className="required-star">*</span>
      </label>
      <input
        type="text"
        value={eyeCampCity}
        onChange={(e) => setEyeCampCity(e.target.value)}
        placeholder="Enter city (e.g., Colombo, Kandy)"
      />

      {/* Buttons */}
      <div className="button-group">
        <button 
          className="btn-clear-eye-camp" 
          onClick={handleClearEyeCamp}
          type="button"
        >
          Clear
        </button>
        <button 
          className="btn-add-eye-camp" 
          onClick={handleAddEyeCamp} 
          disabled={addingEyeCamp}
        >
          {addingEyeCamp ? "Adding..." : "Add Eye Camp"}
        </button>
      </div>
    </div>
  </div>
)}


{/****************************************************  view eye camp  ************************************************************/}

{selectedOption === "viewEyeCamps" && (
  <div className="view-eye-camps-container">
    <div className="view-eye-camps-header">
      <h2>Eye Camps</h2>
      <div className="search-section">
        <input
          type="text"
          className="search-input"
          placeholder="Search by name or city..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </div>



    {/* ==================== EDIT EYE CAMP FORM ==================== */}
    {editingEyeCamp && (
      <div className="edit-eye-camp-section">
        <h3>✏️ Edit Eye Camp</h3>
        <div className="add-camp-form">
          <input
            type="text"
            className="camp-input"
            placeholder="Enter Eye Camp Name"
            value={editingEyeCamp.name}
            onChange={(e) => setEditingEyeCamp({ 
              ...editingEyeCamp, 
              name: e.target.value 
            })}
          />
          <input
            type="text"
            className="camp-input"
            placeholder="Enter City"
            value={editingEyeCamp.city}
            onChange={(e) => setEditingEyeCamp({ 
              ...editingEyeCamp, 
              city: e.target.value 
            })}
          />
          <button 
            className="btn-update-camp"
            onClick={handleUpdateEyeCamp}
          >
            💾 Update
          </button>
          <button 
            className="btn-cancel-edit"
            onClick={() => setEditingEyeCamp(null)}
          >
            ❌ Cancel
          </button>
        </div>
      </div>
    )}

    {/* ==================== EYE CAMPS TABLE ==================== */}
    <table className="eye-camps-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Eye Camp Name</th>
          <th>City</th>
          <th className="action-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {filteredCamps.length === 0 ? (
          <tr>
            <td colSpan="4" className="no-data">No eye camps found</td>
          </tr>
        ) : (
          filteredCamps.map((camp, index) => (
            <tr key={camp.id}>
              <td>{index + 1}</td>
              <td>{camp.name}</td>
              <td>{camp.city}</td>
              <td className="action-col">
                <button 
                  className="btn-edit-camp"
                  onClick={() => setEditingEyeCamp({
                    id: camp.id,
                    name: camp.name,
                    city: camp.city
                  })}
                  title="Edit Eye Camp"
                >
                  ✏️
                </button>
                <button 
                  className="btn-delete-camp"
                  onClick={() => handleDeleteEyeCamp(camp)}
                  title="Delete Eye Camp"
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>

    {/* ==================== DELETE PASSWORD MODAL ==================== */}
    {showDeleteCampModal && (
      <div className="mls-modal-overlay" onClick={() => {
        setShowDeleteCampModal(false);
        setSelectedCampToDelete(null);
        setDeleteCampPassword('');
        setDeleteCampError('');
      }}>
        <div className="mls-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="mls-modal-header">
            <h3>🔐 Confirm Deletion</h3>
            <button 
              className="mls-modal-close"
              onClick={() => {
                setShowDeleteCampModal(false);
                setSelectedCampToDelete(null);
                setDeleteCampPassword('');
                setDeleteCampError('');
              }}
            >
              ✕
            </button>
          </div>
          <div className="mls-modal-body">
            <p>Are you sure you want to delete this eye camp?</p>
            <div className="mls-delete-info">
              <strong>Name:</strong> {selectedCampToDelete?.name}<br/>
              <strong>City:</strong> {selectedCampToDelete?.city}
            </div>
            <p className="mls-warning-text">⚠️ This action cannot be undone!</p>
            <div className="mls-password-input">
              <label>Enter Password to Confirm:</label>
              <input 
                type="password"
                value={deleteCampPassword}
                onChange={(e) => {
                  setDeleteCampPassword(e.target.value);
                  setDeleteCampError('');
                }}
                placeholder="Enter password..."
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    confirmDeleteEyeCamp();
                  }
                }}
                autoFocus
              />
              {deleteCampError && <span className="mls-error-text">{deleteCampError}</span>}
            </div>
          </div>
          <div className="mls-modal-footer">
            <button 
              className="mls-btn-cancel"
              onClick={() => {
                setShowDeleteCampModal(false);
                setSelectedCampToDelete(null);
                setDeleteCampPassword('');
                setDeleteCampError('');
              }}
            >
              Cancel
            </button>
            <button 
              className="mls-btn-delete"
              onClick={confirmDeleteEyeCamp}
            >
              🗑️ Delete
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}



{/*************************************** patient follow-up **********************************************************/}


{selectedOption === "patientfollowup" && (
  <div
    style={{
      padding: "20px",
      background: "#f8fafc",
      minHeight: "100vh",
    }}
  >
    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      <div>
        <h2
          style={{
            margin: 0,
            color: "#1e293b",
            fontWeight: "700",
          }}
        >
          Patient Follow-ups
        </h2>

        <small style={{ color: "#64748b" }}>
          Upcoming patient follow-up reminders
        </small>
      </div>

      <div
        style={{
          background: "#dc2626",
          color: "#fff",
          padding: "10px 18px",
          borderRadius: "30px",
          fontWeight: "600",
          boxShadow: "0 4px 12px rgba(220,38,38,.2)",
        }}
      >
        Today:{" "}
        {
          followUpPatients.filter((p) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const followDate = new Date(
              p.followUp?.date
            );

            return (
              followDate.getTime() ===
              today.getTime()
            );
          }).length
        }
      </div>
    </div>

    {loadingFollowUps ? (
      <div
        style={{
          textAlign: "center",
          padding: "50px",
          color: "#64748b",
        }}
      >
        Loading Follow-ups...
      </div>
    ) : (
      <div
        style={{
          display: "grid",
          gap: "12px",
        }}
      >
        {followUpPatients.map((patient) => {
          const followDate = new Date(
            patient.followUp.date
          );

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const diffDays = Math.ceil(
            (followDate - today) /
              (1000 * 60 * 60 * 24)
          );

          let statusColor = "#22c55e";
          let statusText = `${diffDays} Days Left`;

          if (diffDays <= 3) {
            statusColor = "#ef4444";
          } else if (diffDays <= 7) {
            statusColor = "#f97316";
          }

          if (diffDays === 0) {
            statusText = "Today";
          }

          if (diffDays === 1) {
            statusText = "Tomorrow";
          }

          return (
            <div
              key={patient.id}
              style={{
                background: "#fff",
                borderRadius: "14px",
                padding: "15px 18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow:
                  "0 2px 10px rgba(0,0,0,0.06)",
                border: "1px solid #e2e8f0",
              }}
            >
              {/* Left Side */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <div
                  style={{
                    width: "18px",
                    height: "18px",
                    borderRadius: "50%",
                    background: statusColor,
                    boxShadow: `0 0 10px ${statusColor}`,
                  }}
                />

                <div>
                  <div
                    style={{
                      fontWeight: "700",
                      color: "#0f172a",
                      fontSize: "15px",
                    }}
                  >
                    {patient.patientInfo?.name}
                  </div>

                  <div
                    style={{
                      color: "#64748b",
                      fontSize: "13px",
                      marginTop: "3px",
                    }}
                  >
                    📅 {patient.followUp?.date}
                  </div>

                  <div
                    style={{
                      color: "#475569",
                      fontSize: "13px",
                      marginTop: "2px",
                    }}
                  >
                    📝 {patient.followUp?.remarks}
                  </div>
                </div>
              </div>

              {/* Right Side */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    background: `${statusColor}15`,
                    color: statusColor,
                    padding: "6px 12px",
                    borderRadius: "30px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {statusText}
                </div>

                <button
                  onClick={() =>
                    sendFollowUpWhatsApp(patient)
                  }
                  style={{
                    background: "#25D366",
                    color: "#fff",
                    border: "none",
                    padding: "8px 14px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  {patient.patientInfo?.contactNo}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    )}
  </div>
)}








{/*********************************************  Birthday Wishes  *************************************************/}



{selectedOption === "birthdayWishes" && (
  <div
    style={{
      padding: "20px",
      background: "#f8fafc",
      minHeight: "100vh",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent:
          "space-between",
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      <h2
        style={{
          margin: 0,
          color: "#1e293b",
        }}
      >
        🎂 Patient Birthday Wishes
      </h2>

      <div
        style={{
          background: "#ec4899",
          color: "#fff",
          padding: "10px 18px",
          borderRadius: "30px",
          fontWeight: "600",
        }}
      >
        Today: {todayBirthdays.length}
      </div>
    </div>

    {loadingBirthdays ? (
      <p>Loading...</p>
    ) : (
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(350px,1fr))",
          gap: "20px",
        }}
      >
        {/* Today */}
        <div>
          <h3
            style={{
              color: "#ef4444",
              marginBottom: "12px",
            }}
          >
            🎉 Today
          </h3>

          {todayBirthdays.length ===
          0 ? (
            <p
              style={{
                color: "#64748b",
              }}
            >
              No birthdays today
            </p>
          ) : (
            todayBirthdays.map(
              (patient) => (
                <BirthdayCard
                  key={patient.id}
                  patient={patient}
                  color="#ef4444"
                />
              )
            )
          )}
        </div>

        {/* Tomorrow */}
        <div>
          <h3
            style={{
              color: "#f97316",
              marginBottom: "12px",
            }}
          >
            🎁 Tomorrow
          </h3>

          {tomorrowBirthdays.length ===
          0 ? (
            <p
              style={{
                color: "#64748b",
              }}
            >
              No birthdays tomorrow
            </p>
          ) : (
            tomorrowBirthdays.map(
              (patient) => (
                <BirthdayCard
                  key={patient.id}
                  patient={patient}
                  color="#f97316"
                />
              )
            )
          )}
        </div>

        {/* Day After Tomorrow */}
        <div>
          <h3
            style={{
              color: "#22c55e",
              marginBottom: "12px",
            }}
          >
            🎈 Day After Tomorrow
          </h3>

          {dayAfterTomorrowBirthdays.length ===
          0 ? (
            <p
              style={{
                color: "#64748b",
              }}
            >
              No birthdays
            </p>
          ) : (
            dayAfterTomorrowBirthdays.map(
              (patient) => (
                <BirthdayCard
                  key={patient.id}
                  patient={patient}
                  color="#22c55e"
                />
              )
            )
          )}
        </div>
      </div>
    )}
  </div>
)}







{/************************************************ create service Invoice  / service bill *****************************************************/}


{selectedOption === "serviceInvoice" && (

<div className="invoice-wrap">

  {/* HEADER */}

  <div className="invoice-header">

    <h2>Service Invoice</h2>

    <p className="invoice-subtitle">
      Eye Care Services & Professional Charges
    </p>

    <div className="invoice-number-display">
      Next Invoice: {currentInvoiceNumber}
    </div>

  </div>

  <div className="invoice-content">

    {/* =====================================================
       CUSTOMER SECTION
    ===================================================== */}

    <div className="invoice-section">

      {/* SERVED BY */}

<div style={{ marginTop: "15px" }}>

  <label style={{ marginRight: "10px" }}>
    Sales Person:
  </label>


  <select
    value={selectedSalesPerson}
    onChange={handleSalesPersonSelect}
  >

    <option value="">
      Please select sales person
    </option>


    <option value="Team A">
      Team A
      {verifiedSalesPerson === 'Team A' && ' ✅'}
    </option>


    <option value="Team B">
      Team B
      {verifiedSalesPerson === 'Team B' && ' ✅'}
    </option>


    <option value="Team C">
      Team C
      {verifiedSalesPerson === 'Team C' && ' ✅'}
    </option>


    <option value="Team D">
      Team D
      {verifiedSalesPerson === 'Team D' && ' ✅'}
    </option>


    <option value="Team E">
      Team E
      {verifiedSalesPerson === 'Team E' && ' ✅'}
    </option>


    <option value="Team F">
      Team F
      {verifiedSalesPerson === 'Team F' && ' ✅'}
    </option>


    <option value="Team G">
      Team G
      {verifiedSalesPerson === 'Team G' && ' ✅'}
    </option>


    <option value="Team H">
      Team H
      {verifiedSalesPerson === 'Team H' && ' ✅'}
    </option>


    <option value="Team I">
      Team I
      {verifiedSalesPerson === 'Team I' && ' ✅'}
    </option>


    <option value="Team J">
      Team J
      {verifiedSalesPerson === 'Team J' && ' ✅'}
    </option>


    <option value="Team K">
      Team K
      {verifiedSalesPerson === 'Team K' && ' ✅'}
    </option>


    <option value="Team L">
      Team L
      {verifiedSalesPerson === 'Team L' && ' ✅'}
    </option>

    <option value="Team M">
      Team M
      {verifiedSalesPerson === 'Team M' && ' ✅'}
    </option>


    <option value="Team N">
      Team N
      {verifiedSalesPerson === 'Team N' && ' ✅'}
    </option>

  </select>


  {verifiedSalesPerson && (

    <span
      style={{
        marginLeft: '10px',
        color: 'green',
        fontSize: '14px'
      }}
    >
      ✅ Verified: {verifiedSalesPerson}
    </span>

  )}

</div>


{/* PASSWORD MODAL */}

{isPasswordModalOpen && (

<div
style={{
 position:'fixed',
 top:0,
 left:0,
 right:0,
 bottom:0,
 backgroundColor:'rgba(0,0,0,0.5)',
 display:'flex',
 justifyContent:'center',
 alignItems:'center',
 zIndex:1000
}}
>


<div
style={{
 backgroundColor:'white',
 padding:'30px',
 borderRadius:'10px',
 width:'400px'
}}
>


<h3>
🔐 Verify Password for {modalPerson}
</h3>


<input
type="password"
value={enteredPassword}
onChange={(e)=>setEnteredPassword(e.target.value)}
placeholder="Enter password"

onKeyDown={(e)=>{
 if(e.key==="Enter"){
   handlePasswordSubmit();
 }
}}

style={{
 width:'100%',
 padding:'10px',
 marginBottom:'10px',
 fontSize:'16px'
}}
/>


{passwordError && (

<div
style={{
 color:'red',
 marginBottom:'10px'
}}
>
{passwordError}
</div>

)}


<div
style={{
display:'flex',
gap:'10px'
}}
>


<button
onClick={handlePasswordSubmit}
style={{
flex:1,
padding:'10px',
background:'#4CAF50',
color:'white',
border:'none'
}}
>
✅ Verify
</button>


<button
onClick={handleModalClose}
style={{
flex:1,
padding:'10px',
background:'#f44336',
color:'white',
border:'none'
}}
>
❌ Cancel
</button>


</div>


</div>

</div>

)}


</div>






     <div className="invoice-section">
  <div className="section-header">
    <h3>Customer Information</h3>
    <span className="section-badge">Required</span>
  </div>

  {/* Customer Search Bar */}
  <div className="customer-search-container" style={{ marginBottom: '15px' }}>
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
      <div style={{ flex: 1, minWidth: '200px', position: 'relative' }}>
        <input
          type="text"
          placeholder="🔍 Search existing customer (Name or Phone)"
          value={customerSearchTerm}
          onChange={(e) => {
            setCustomerSearchTerm(e.target.value);
            searchExistingCustomer(e.target.value);
            setShowCustomerSearch(true);
          }}
          onFocus={() => setShowCustomerSearch(true)}
          onBlur={() => {
            // Delay hiding to allow click on results
            setTimeout(() => setShowCustomerSearch(false), 200);
          }}
          style={{
            width: '100%',
            padding: '10px 15px',
            border: '2px solid #d0d8e8',
            borderRadius: '8px',
            fontSize: '14px',
            backgroundColor: '#f8f9fa'
          }}
        />
        {isSearchingCustomer && (
          <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
            ⏳
          </span>
        )}
        
        {/* Search Results Dropdown */}
        {showCustomerSearch && searchResults.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #d0d8e8',
            borderRadius: '8px',
            maxHeight: '200px',
            overflowY: 'auto',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            marginTop: '4px'
          }}>
            {searchResults.map((result, index) => (
              <div
                key={index}
                onMouseDown={(e) => e.preventDefault()} // Prevent blur
                onClick={() => selectExistingCustomer(result)}
                style={{
                  padding: '10px 15px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f0f0f0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                <div>
                  <strong>{result.customer.fullName || `${result.customer.firstName} ${result.customer.lastName}`}</strong>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    📞 {result.customer.tpNo}
                  </div>
                </div>
                <button
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={(e) => {
                    e.stopPropagation();
                    selectExistingCustomer(result);
                  }}
                  style={{
                    padding: '5px 12px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  Select
                </button>
              </div>
            ))}
          </div>
        )}
        
        {showCustomerSearch && customerSearchTerm && searchResults.length === 0 && !isSearchingCustomer && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #d0d8e8',
            borderRadius: '8px',
            padding: '15px',
            textAlign: 'center',
            color: '#666',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            marginTop: '4px'
          }}>
            No existing customer found. Enter new details below.
          </div>
        )}
      </div>
      
      {isEditingCustomer && (
        <button
          onClick={resetCustomerForm}
          style={{
            padding: '8px 16px',
            backgroundColor: '#ff9800',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
            whiteSpace: 'nowrap'
          }}
        >
          ✏️ New Customer
        </button>
      )}
      
      {existingCustomerData && (
        <span style={{
          fontSize: '13px',
          color: '#4CAF50',
          fontWeight: '500',
          backgroundColor: '#e8f5e9',
          padding: '5px 12px',
          borderRadius: '20px',
          whiteSpace: 'nowrap'
        }}>
          ✓ Editing existing customer
        </span>
      )}
    </div>
  </div>

  {/* Customer Form */}
  <div className="form-row">
    <div className="form-group">
      <label>Title</label>
      <select 
        className="form-control"
        name="title"
        value={formData.title}
        onChange={handleInputChange}
      >
        <option value="">Select</option>
        <option value="Mr">Mr.</option>
        <option value="Mrs">Mrs.</option>
        <option value="Ms">Ms.</option>
        <option value="Baby">Baby</option>
        <option value="Baby">Master</option>
        <option value="Dr">Dr.</option>
        <option value="Rev">Rev.</option>
      </select>
    </div>

    <div className="form-group">
      <label>First Name <span className="required-star">*</span></label>
      <input 
        type="text" 
        name="firstName"
        value={formData.firstName}
        onChange={handleInputChange}
        placeholder="Enter first name"
        className={errors.firstName ? 'error-input' : ''}
      />
      {errors.firstName && <span className="error-message">{errors.firstName}</span>}
    </div>
    
    <div className="form-group">
      <label>Last Name <span className="required-star">*</span></label>
      <input 
        type="text" 
        name="lastName"
        value={formData.lastName}
        onChange={handleInputChange}
        placeholder="Enter last name"
        className={errors.lastName ? 'error-input' : ''}
      />
      {errors.lastName && <span className="error-message">{errors.lastName}</span>}
    </div>
  </div>
  
  <div className="form-row">
    <div className="form-group">
      <label>Address <span className="required-star"></span></label>
      <input 
        type="text" 
        name="address"
        value={formData.address}
        onChange={handleInputChange}
        placeholder="Street, city, postal code"
        className={errors.address ? 'error-input' : ''}
      />

    </div>
    
    <div className="form-group">
      <label>TP No <span className="required-star"></span></label>
      <input 
        type="tel" 
        name="tpNo"
        value={formData.tpNo}
        onChange={handleInputChange}
        placeholder="Phone number"
        className={errors.tpNo ? 'error-input' : ''}
      />
    
    </div>
    
  </div>
</div>










    {/* =====================================================
       SERVICE DETAILS
    ===================================================== */}

    <div className="invoice-section">

      <div className="section-header">

        <h3>Service Details</h3>

        <span className="section-badge">
          Required
        </span>

      </div>

      <div className="form-group">

        <label>Service Description *</label>

        <textarea
          rows="5"
          placeholder="Enter service description"
          value={serviceDescription}
          onChange={(e) =>
            setServiceDescription(
              e.target.value
            )
          }
        />

      </div>

      <div className="form-row">

        <div className="form-group">

          <label>Service Charge *</label>

          <input
            type="number"
            value={serviceAmount}
            onChange={(e) =>
              setServiceAmount(
                e.target.value
              )
            }
             onWheel={(e) => e.target.blur()} // prevents scroll changing the value
            placeholder="Enter amount"
          />

        </div>

      </div>

    </div>

    {/* =====================================================
       BILLING
    ===================================================== */}

    <div className="invoice-section">

      <div className="section-header">

        <h3>Billing & Payment</h3>

      </div>

      <div className="form-row">

        <div className="form-group">

          <label>Billing Date</label>

          <input
            type="date"
            value={billingDate}
            onChange={(e) =>
              setBillingDate(e.target.value)
            }
          />

        </div>

        <div className="form-group">

          <label>Payment Method</label>

          <select
            name="paymentMethod"
            value={formData.paymentMethod}
            onChange={handleInputChange}
          >
          <option value="Cash">Cash</option>
          <option value="Card">Card</option>
            <option value="GiftCard">Gift Card</option>
          <option value="Bank Transfer">Bank Transfer</option>
          <option value="Deposit">Deposit</option>

          </select>

        </div>

      </div>

      <div className="form-row">

        <div className="form-group">

          <label>Discount Type</label>

          <select
            value={discountType}
            onChange={(e) =>
              setDiscountType(
                e.target.value
              )
            }
          >

            <option value="amount">
              Amount
            </option>

            <option value="percentage">
              Percentage %
            </option>

          </select>

        </div>

        <div className="form-group">

          <label>Discount</label>

          <input
            type="number"
            name="discount"
            value={formData.discount}
            onChange={handleInputChange}
             onWheel={(e) => e.target.blur()} // prevents scroll changing the value
          />

        </div>

<div className="form-group">

  <label>Payment Type</label>

  <select
    value={servicePaymentType}
    onChange={(e) =>
      setServicePaymentType(
        e.target.value
      )
    }
  >

    <option value="full">
      Full Payment
    </option>

    <option value="advance">
      Advance Payment
    </option>

  </select>

</div>

{/* SHOW ONLY FOR ADVANCE */}

{servicePaymentType === "advance" && (

<div className="form-group">

  <label>Advance Payment</label>

  <input
    type="number"
    name="advancePayment"
    value={formData.advancePayment}
    onChange={handleInputChange}
     onWheel={(e) => e.target.blur()} // prevents scroll changing the value
    placeholder="Enter advance amount"
  />

</div>

)}

      </div>

      {/* FINANCIAL */}

      <div className="financial-summary">

        <div data-label="Subtotal">
          Rs.{serviceSubtotal.toFixed(2)}
        </div>

        <div data-label="Discount">
          Rs.{serviceCalculatedDiscount.toFixed(2)}
        </div>

        <div data-label="Grand Total">
          Rs.{serviceGrandTotal.toFixed(2)}
        </div>

        {/* <div data-label="Balance">
          Rs.{serviceBalance.toFixed(2)}
        </div> */}

<div data-label="Paid">
  Rs.{serviceAdvanceAmount.toFixed(2)}
</div>

<div data-label="Balance">
  Rs.{serviceBalance.toFixed(2)}
</div>



      </div>

    </div>

    {/* =====================================================
       ACTIONS
    ===================================================== */}

    <div className="invoice-actions">

<button 
  className="btn-save"
  onClick={handleSaveServiceInvoice}
  disabled={isSavingServiceInvoice}
>
  {isSavingServiceInvoice
    ? "Creating..."
    : "Create Service Invoice"}
</button>

    </div>

  </div>

</div>

)}






{/********************************* direct sales direct invoice *******************************************************/}

{selectedOption === "directSales" && (
  <div className="invoice-wrap">
      <div className="invoice-header">
        <h2>Direct Sales Invoice</h2>
        <p className="invoice-subtitle">
          Sunglasses, Accessories & Other Products
        </p>
        <div className="invoice-number-display">
          Next Invoice: {currentInvoiceNumber}
        </div>
      </div>

      <div className="invoice-content">
        {/* Served By Section */}
        <div className="invoice-section">
<div style={{ marginTop: "15px" }}>

  <label style={{ marginRight: "10px" }}>
    Sales Person:
  </label>


  <select
    value={selectedSalesPerson}
    onChange={handleSalesPersonSelect}
  >

    <option value="">
      Please select sales person
    </option>


    <option value="Team A">
      Team A
      {verifiedSalesPerson === 'Team A' && ' ✅'}
    </option>


    <option value="Team B">
      Team B
      {verifiedSalesPerson === 'Team B' && ' ✅'}
    </option>


    <option value="Team C">
      Team C
      {verifiedSalesPerson === 'Team C' && ' ✅'}
    </option>


    <option value="Team D">
      Team D
      {verifiedSalesPerson === 'Team D' && ' ✅'}
    </option>


    <option value="Team E">
      Team E
      {verifiedSalesPerson === 'Team E' && ' ✅'}
    </option>


    <option value="Team F">
      Team F
      {verifiedSalesPerson === 'Team F' && ' ✅'}
    </option>


    <option value="Team G">
      Team G
      {verifiedSalesPerson === 'Team G' && ' ✅'}
    </option>


    <option value="Team H">
      Team H
      {verifiedSalesPerson === 'Team H' && ' ✅'}
    </option>


    <option value="Team I">
      Team I
      {verifiedSalesPerson === 'Team I' && ' ✅'}
    </option>


    <option value="Team J">
      Team J
      {verifiedSalesPerson === 'Team J' && ' ✅'}
    </option>


    <option value="Team K">
      Team K
      {verifiedSalesPerson === 'Team K' && ' ✅'}
    </option>


    <option value="Team L">
      Team L
      {verifiedSalesPerson === 'Team L' && ' ✅'}
    </option>

    <option value="Team M">
      Team M
      {verifiedSalesPerson === 'Team M' && ' ✅'}
    </option>


    <option value="Team N">
      Team N
      {verifiedSalesPerson === 'Team N' && ' ✅'}
    </option>

  </select>


  {verifiedSalesPerson && (

    <span
      style={{
        marginLeft: '10px',
        color: 'green',
        fontSize: '14px'
      }}
    >
      ✅ Verified: {verifiedSalesPerson}
    </span>

  )}

</div>


{/* PASSWORD MODAL */}

{isPasswordModalOpen && (

<div
style={{
 position:'fixed',
 top:0,
 left:0,
 right:0,
 bottom:0,
 backgroundColor:'rgba(0,0,0,0.5)',
 display:'flex',
 justifyContent:'center',
 alignItems:'center',
 zIndex:1000
}}
>


<div
style={{
 backgroundColor:'white',
 padding:'30px',
 borderRadius:'10px',
 width:'400px'
}}
>


<h3>
🔐 Verify Password for {modalPerson}
</h3>


<input
type="password"
value={enteredPassword}
onChange={(e)=>setEnteredPassword(e.target.value)}
placeholder="Enter password"

onKeyDown={(e)=>{
 if(e.key==="Enter"){
   handlePasswordSubmit();
 }
}}

style={{
 width:'100%',
 padding:'10px',
 marginBottom:'10px',
 fontSize:'16px'
}}
/>


{passwordError && (

<div
style={{
 color:'red',
 marginBottom:'10px'
}}
>
{passwordError}
</div>

)}


<div
style={{
display:'flex',
gap:'10px'
}}
>


<button
onClick={handlePasswordSubmit}
style={{
flex:1,
padding:'10px',
background:'#4CAF50',
color:'white',
border:'none'
}}
>
✅ Verify
</button>


<button
onClick={handleModalClose}
style={{
flex:1,
padding:'10px',
background:'#f44336',
color:'white',
border:'none'
}}
>
❌ Cancel
</button>


</div>


</div>

</div>

)}




        </div>

        {/* Customer Information Section */}
        <div className="invoice-section">
          <div className="section-header">
            <h3>Customer Information</h3>
            <span className="section-badge">Required</span>
          </div>

          {/* Customer Search Bar */}
          <div className="customer-search-container" style={{ marginBottom: '15px' }}>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: '200px', position: 'relative' }}>
                <input
                  type="text"
                  placeholder="🔍 Search existing customer (Name or Phone)"
                  value={customerSearchTerm}
                  onChange={(e) => {
                    setCustomerSearchTerm(e.target.value);
                    searchExistingCustomer(e.target.value);
                    setShowCustomerSearch(true);
                  }}
                  onFocus={() => setShowCustomerSearch(true)}
                  onBlur={() => {
                    setTimeout(() => setShowCustomerSearch(false), 200);
                  }}
                  style={{
                    width: '100%',
                    padding: '10px 15px',
                    border: '2px solid #d0d8e8',
                    borderRadius: '8px',
                    fontSize: '14px',
                    backgroundColor: '#f8f9fa'
                  }}
                />
                {isSearchingCustomer && (
                  <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                    ⏳
                  </span>
                )}
                
                {/* Search Results Dropdown */}
                {showCustomerSearch && searchResults.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #d0d8e8',
                    borderRadius: '8px',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    marginTop: '4px'
                  }}>
                    {searchResults.map((result, index) => (
                      <div
                        key={index}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => selectExistingCustomer(result)}
                        style={{
                          padding: '10px 15px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #f0f0f0',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        <div>
                          <strong>{result.customer.fullName || `${result.customer.firstName} ${result.customer.lastName}`}</strong>
                          <div style={{ fontSize: '12px', color: '#666' }}>
                            📞 {result.customer.tpNo}
                          </div>
                        </div>
                        <button
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectExistingCustomer(result);
                          }}
                          style={{
                            padding: '5px 12px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px'
                          }}
                        >
                          Select
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                
                {showCustomerSearch && customerSearchTerm && searchResults.length === 0 && !isSearchingCustomer && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #d0d8e8',
                    borderRadius: '8px',
                    padding: '15px',
                    textAlign: 'center',
                    color: '#666',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    marginTop: '4px'
                  }}>
                    No existing customer found. Enter new details below.
                  </div>
                )}
              </div>
              
              {isEditingCustomer && (
                <button
                  onClick={resetCustomerForm}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#ff9800',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: '500',
                    whiteSpace: 'nowrap'
                  }}
                >
                  ✏️ New Customer
                </button>
              )}
              
              {existingCustomerData && (
                <span style={{
                  fontSize: '13px',
                  color: '#4CAF50',
                  fontWeight: '500',
                  backgroundColor: '#e8f5e9',
                  padding: '5px 12px',
                  borderRadius: '20px',
                  whiteSpace: 'nowrap'
                }}>
                  ✓ Editing existing customer
                </span>
              )}
            </div>
          </div>

          {/* Customer Form */}
          <div className="form-row">
            <div className="form-group">
              <label>Title</label>
              <select 
                className="form-control"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
              >
                <option value="">Select</option>
                <option value="Mr">Mr.</option>
                <option value="Mrs">Mrs.</option>
                <option value="Ms">Ms.</option>
                <option value="Baby">Baby</option>
                <option value="Master">Master</option>
                <option value="Dr">Dr.</option>
                <option value="Rev">Rev.</option>
              </select>
            </div>

            <div className="form-group">
              <label>First Name <span className="required-star">*</span></label>
              <input 
                type="text" 
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                placeholder="Enter first name"
                className={errors.firstName ? 'error-input' : ''}
              />
              {errors.firstName && <span className="error-message">{errors.firstName}</span>}
            </div>
            
            <div className="form-group">
              <label>Last Name <span className="required-star">*</span></label>
              <input 
                type="text" 
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Enter last name"
                className={errors.lastName ? 'error-input' : ''}
              />
              {errors.lastName && <span className="error-message">{errors.lastName}</span>}
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label>Address <span className="required-star">*</span></label>
              <input 
                type="text" 
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Street, city, postal code"
                className={errors.address ? 'error-input' : ''}
              />
              {errors.address && <span className="error-message">{errors.address}</span>}
            </div>
            
            <div className="form-group">
              <label>TP No <span className="required-star">*</span></label>
              <input 
                type="tel" 
                name="tpNo"
                value={formData.tpNo}
                onChange={handleInputChange}
                placeholder="Phone number"
                className={errors.tpNo ? 'error-input' : ''}
              />
              {errors.tpNo && <span className="error-message">{errors.tpNo}</span>}
            </div>


    <div className="form-group">
      <label>Date of Birth <span className="required-star"></span></label>
      <input 
        type="date" 
        name="age"
        value={formData.age}
        onChange={handleInputChange}
        className={errors.age ? 'error-input' : ''}
      />
     
    </div>


          </div>
        </div>

        {/* Optical Prescription Section */}
{/* Optical Prescription Section */}
<div className="invoice-section">
  <div className="section-header">
    <h3>Optical Prescription</h3>
    <span className="section-badge">Eye Details</span>
  </div>
  
  {/* Prescription Toggle Checkbox */}
  <div className="form-row" style={{ marginBottom: '15px' }}>
    <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={showPrescription}
          onChange={(e) => setShowPrescription(e.target.checked)}
          style={{ width: '18px', height: '18px', cursor: 'pointer' }}
        />
        <span style={{ fontWeight: '500' }}>Include Prescription</span>
      </label>
      <span style={{ fontSize: '12px', color: '#666' }}>
        (Check to add optical prescription details)
      </span>
    </div>
  </div>

  {/* ALL Prescription fields - Only shown when checkbox is checked */}
  {showPrescription && (
    <>
      <div className="form-row">
        <div className="form-group">
          <label>Prescription Date</label>
          <input 
            type="date" 
            name="prescriptionDate"
            value={formData.prescriptionDate}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label>Referred By</label>
          <select
            name="referredBy"
            value={formData.referredBy}
            onChange={handleInputChange}
          >
            <option value="">-- Select Referrer --</option>
            <option value="Own">Own</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="form-group">
          <label>BC:</label>
          <input
            type="text"
            name="bc"
            value={formData.bc}
            onChange={handleInputChange}
            placeholder="Base Curve"
          />
        </div>

        <div className="form-group">
          <label>DM:</label>
          <input
            type="text"
            name="dm"
            value={formData.dm}
            onChange={handleInputChange}
            placeholder="DM"
          />
        </div>
      </div>

      <div className="prescription-grid">
        {/* Right Eye */}
        <div className="eye-section">
          <h4>Right Eye (OD)</h4>

          <div className="eye-field-group">
            <label>Visual Acuity</label>
            <select 
              className="form-control"
              name="rightVisualAcuity"
              value={formData.rightVisualAcuity}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="6/6">6/6</option>
              <option value="6/9">6/9</option>
              <option value="6/12">6/12</option>
              <option value="6/18">6/18</option>
              <option value="6/24">6/24</option>
              <option value="6/36">6/36</option>
              <option value="6/60">6/60</option>  
            </select>
          </div>

          <div className="eye-fields">
            <div className="eye-field-group">
              <label>Distance</label>
              <div className="presc-inputs">
                <div className="eye-field-group">
                  <label>SPH</label>
                  <select 
                    name="rightSph"
                    value={formData.rightSph}
                    onChange={handleInputChange}
                    style={{ width: '100px' }}
                  >
                    <option value="">Select SPH</option>
                    <option value="Plano (0.00)">Plano (0.00)</option>
                    <option value="-0.25">-0.25</option>
                    <option value="-0.50">-0.50</option>
                    <option value="-0.75">-0.75</option>
                    <option value="-1.00">-1.00</option>
                    <option value="-1.25">-1.25</option>
                    <option value="-1.50">-1.50</option>
                    <option value="-1.75">-1.75</option>
                    <option value="-2.00">-2.00</option>
                    <option value="-2.25">-2.25</option>
                    <option value="-2.50">-2.50</option>
                    <option value="-2.75">-2.75</option>
                    <option value="-3.00">-3.00</option>
                    <option value="-3.25">-3.25</option>
                    <option value="-3.50">-3.50</option>
                    <option value="-3.75">-3.75</option>
                    <option value="-4.00">-4.00</option>
                    <option value="-4.25">-4.25</option>
                    <option value="-4.50">-4.50</option>
                    <option value="-4.75">-4.75</option>
                    <option value="-5.00">-5.00</option>
                    <option value="-5.25">-5.25</option>
                    <option value="-5.50">-5.50</option>
                    <option value="-5.75">-5.75</option>
                    <option value="-6.00">-6.00</option>
                    <option value="-6.25">-6.25</option>
                    <option value="-6.50">-6.50</option>
                    <option value="-6.75">-6.75</option>
                    <option value="-7.00">-7.00</option>
                    <option value="-7.25">-7.25</option>
                    <option value="-7.50">-7.50</option>
                    <option value="-7.75">-7.75</option>
                    <option value="-8.00">-8.00</option>
                    <option value="-8.25">-8.25</option>
                    <option value="-8.50">-8.50</option>
                    <option value="-8.75">-8.75</option>
                    <option value="-9.00">-9.00</option>
                    <option value="-9.25">-9.25</option>
                    <option value="-9.50">-9.50</option>
                    <option value="-9.75">-9.75</option>
                    <option value="-10.00">-10.00</option>
                    <option value="+0.25">+0.25</option>
                    <option value="+0.50">+0.50</option>
                    <option value="+0.75">+0.75</option>
                    <option value="+1.00">+1.00</option>
                    <option value="+1.25">+1.25</option>
                    <option value="+1.50">+1.50</option>
                    <option value="+1.75">+1.75</option>
                    <option value="+2.00">+2.00</option>
                    <option value="+2.25">+2.25</option>
                    <option value="+2.50">+2.50</option>
                    <option value="+2.75">+2.75</option>
                    <option value="+3.00">+3.00</option>
                    <option value="+3.25">+3.25</option>
                    <option value="+3.50">+3.50</option>
                    <option value="+3.75">+3.75</option>
                    <option value="+4.00">+4.00</option>
                    <option value="+4.25">+4.25</option>
                    <option value="+4.50">+4.50</option>
                    <option value="+4.75">+4.75</option>
                    <option value="+5.00">+5.00</option>
                    <option value="+5.25">+5.25</option>
                    <option value="+5.50">+5.50</option>
                    <option value="+5.75">+5.75</option>
                    <option value="+6.00">+6.00</option>
                    <option value="+6.25">+6.25</option>
                    <option value="+6.50">+6.50</option>
                    <option value="+6.75">+6.75</option>
                    <option value="+7.00">+7.00</option>
                    <option value="+7.25">+7.25</option>
                    <option value="+7.50">+7.50</option>
                    <option value="+7.75">+7.75</option>
                    <option value="+8.00">+8.00</option>
                    <option value="+8.25">+8.25</option>
                    <option value="+8.50">+8.50</option>
                    <option value="+8.75">+8.75</option>
                    <option value="+9.00">+9.00</option>
                    <option value="+9.25">+9.25</option>
                    <option value="+9.50">+9.50</option>
                    <option value="+9.75">+9.75</option>
                    <option value="+10.00">+10.00</option>
                  </select>
                </div>

                <div className="eye-field-group">
                  <label>CYL</label>
                  <select 
                    name="rightCyl"
                    value={formData.rightCyl}
                    onChange={handleInputChange}
                    style={{ width: '100px' }}
                  >
                    <option value="">Select CYL</option>
                    <option value="-0.25">-0.25</option>
                    <option value="-0.50">-0.50</option>
                    <option value="-0.75">-0.75</option>
                    <option value="-1.00">-1.00</option>
                    <option value="-1.25">-1.25</option>
                    <option value="-1.50">-1.50</option>
                    <option value="-1.75">-1.75</option>
                    <option value="-2.00">-2.00</option>
                    <option value="-2.25">-2.25</option>
                    <option value="-2.50">-2.50</option>
                    <option value="-2.75">-2.75</option>
                    <option value="-3.00">-3.00</option>
                    <option value="-3.25">-3.25</option>
                    <option value="-3.50">-3.50</option>
                    <option value="-3.75">-3.75</option>
                    <option value="-4.00">-4.00</option>
                    <option value="-4.25">-4.25</option>
                    <option value="-4.50">-4.50</option>
                    <option value="-4.75">-4.75</option>
                    <option value="-5.00">-5.00</option>
                    <option value="-5.25">-5.25</option>
                    <option value="-5.50">-5.50</option>
                    <option value="-5.75">-5.75</option>
                    <option value="-6.00">-6.00</option>
                  </select>
                </div>


              </div>
            </div>

            <div className="eye-field-group">
              <label>Reading</label>
              <select 
                name="rightAdd"
                value={formData.rightAdd}
                onChange={handleInputChange}
              >
                <option value="">Select addition</option>
                <option value="+1.00">+1.00</option>
                <option value="+1.25">+1.25</option>
                <option value="+1.50">+1.50</option>
                <option value="+1.75">+1.75</option>
                <option value="+2.00">+2.00</option>
                <option value="+2.25">+2.25</option>
                <option value="+2.50">+2.50</option>
                <option value="+2.75">+2.75</option>
                <option value="+3.00">+3.00</option>
                <option value="+3.25">+3.25</option>
                <option value="+3.50">+3.50</option>
                <option value="+3.75">+3.75</option>
                <option value="+4.00">+4.00</option>
              </select>
            </div>

            <div className="eye-field-group">
              <label>Near VA</label>
              <select 
                className="form-control"
                name="rightNearVA"
                value={formData.rightNearVA}
                onChange={handleInputChange}
              >
                <option value="">Select</option>
                <option value="N5">N5</option>
                <option value="N6">N6</option>
                <option value="N8">N8</option>
                <option value="N10">N10</option>
                <option value="N14">N14</option>
                <option value="N24">N24</option>
                <option value="N36">N36</option>  
              </select>
            </div>
          </div>
        </div>

        {/* Left Eye */}
        <div className="eye-section">
          <h4>Left Eye (OS)</h4>

          <div className="eye-field-group">
            <label>Visual Acuity</label>
            <select 
              className="form-control"
              name="leftVisualAcuity"
              value={formData.leftVisualAcuity}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="6/6">6/6</option>
              <option value="6/9">6/9</option>
              <option value="6/12">6/12</option>
              <option value="6/18">6/18</option>
              <option value="6/24">6/24</option>
              <option value="6/36">6/36</option>
              <option value="6/60">6/60</option>  
            </select>
          </div>

          <div className="eye-fields">
            <div className="eye-field-group">
              <label>Distance</label>
              <div className="presc-inputs">
                <div className="eye-field-group">
                  <label>SPH</label>
                  <select 
                    name="leftSph"
                    value={formData.leftSph}
                    onChange={handleInputChange}
                    style={{ width: '100px' }}
                  >
                    <option value="">Select SPH</option>
                    <option value="Plano (0.00)">Plano (0.00)</option>
                    <option value="-0.25">-0.25</option>
                    <option value="-0.50">-0.50</option>
                    <option value="-0.75">-0.75</option>
                    <option value="-1.00">-1.00</option>
                    <option value="-1.25">-1.25</option>
                    <option value="-1.50">-1.50</option>
                    <option value="-1.75">-1.75</option>
                    <option value="-2.00">-2.00</option>
                    <option value="-2.25">-2.25</option>
                    <option value="-2.50">-2.50</option>
                    <option value="-2.75">-2.75</option>
                    <option value="-3.00">-3.00</option>
                    <option value="-3.25">-3.25</option>
                    <option value="-3.50">-3.50</option>
                    <option value="-3.75">-3.75</option>
                    <option value="-4.00">-4.00</option>
                    <option value="-4.25">-4.25</option>
                    <option value="-4.50">-4.50</option>
                    <option value="-4.75">-4.75</option>
                    <option value="-5.00">-5.00</option>
                    <option value="-5.25">-5.25</option>
                    <option value="-5.50">-5.50</option>
                    <option value="-5.75">-5.75</option>
                    <option value="-6.00">-6.00</option>
                    <option value="-6.25">-6.25</option>
                    <option value="-6.50">-6.50</option>
                    <option value="-6.75">-6.75</option>
                    <option value="-7.00">-7.00</option>
                    <option value="-7.25">-7.25</option>
                    <option value="-7.50">-7.50</option>
                    <option value="-7.75">-7.75</option>
                    <option value="-8.00">-8.00</option>
                    <option value="-8.25">-8.25</option>
                    <option value="-8.50">-8.50</option>
                    <option value="-8.75">-8.75</option>
                    <option value="-9.00">-9.00</option>
                    <option value="-9.25">-9.25</option>
                    <option value="-9.50">-9.50</option>
                    <option value="-9.75">-9.75</option>
                    <option value="-10.00">-10.00</option>
                    <option value="+0.25">+0.25</option>
                    <option value="+0.50">+0.50</option>
                    <option value="+0.75">+0.75</option>
                    <option value="+1.00">+1.00</option>
                    <option value="+1.25">+1.25</option>
                    <option value="+1.50">+1.50</option>
                    <option value="+1.75">+1.75</option>
                    <option value="+2.00">+2.00</option>
                    <option value="+2.25">+2.25</option>
                    <option value="+2.50">+2.50</option>
                    <option value="+2.75">+2.75</option>
                    <option value="+3.00">+3.00</option>
                    <option value="+3.25">+3.25</option>
                    <option value="+3.50">+3.50</option>
                    <option value="+3.75">+3.75</option>
                    <option value="+4.00">+4.00</option>
                    <option value="+4.25">+4.25</option>
                    <option value="+4.50">+4.50</option>
                    <option value="+4.75">+4.75</option>
                    <option value="+5.00">+5.00</option>
                    <option value="+5.25">+5.25</option>
                    <option value="+5.50">+5.50</option>
                    <option value="+5.75">+5.75</option>
                    <option value="+6.00">+6.00</option>
                    <option value="+6.25">+6.25</option>
                    <option value="+6.50">+6.50</option>
                    <option value="+6.75">+6.75</option>
                    <option value="+7.00">+7.00</option>
                    <option value="+7.25">+7.25</option>
                    <option value="+7.50">+7.50</option>
                    <option value="+7.75">+7.75</option>
                    <option value="+8.00">+8.00</option>
                    <option value="+8.25">+8.25</option>
                    <option value="+8.50">+8.50</option>
                    <option value="+8.75">+8.75</option>
                    <option value="+9.00">+9.00</option>
                    <option value="+9.25">+9.25</option>
                    <option value="+9.50">+9.50</option>
                    <option value="+9.75">+9.75</option>
                    <option value="+10.00">+10.00</option>
                  </select>
                </div>

                <div className="eye-field-group">
                  <label>CYL</label>
                  <select 
                    name="leftCyl"
                    value={formData.leftCyl}
                    onChange={handleInputChange}
                    style={{ width: '100px' }}
                  >
                    <option value="">Select CYL</option>
                    <option value="-0.25">-0.25</option>
                    <option value="-0.50">-0.50</option>
                    <option value="-0.75">-0.75</option>
                    <option value="-1.00">-1.00</option>
                    <option value="-1.25">-1.25</option>
                    <option value="-1.50">-1.50</option>
                    <option value="-1.75">-1.75</option>
                    <option value="-2.00">-2.00</option>
                    <option value="-2.25">-2.25</option>
                    <option value="-2.50">-2.50</option>
                    <option value="-2.75">-2.75</option>
                    <option value="-3.00">-3.00</option>
                    <option value="-3.25">-3.25</option>
                    <option value="-3.50">-3.50</option>
                    <option value="-3.75">-3.75</option>
                    <option value="-4.00">-4.00</option>
                    <option value="-4.25">-4.25</option>
                    <option value="-4.50">-4.50</option>
                    <option value="-4.75">-4.75</option>
                    <option value="-5.00">-5.00</option>
                    <option value="-5.25">-5.25</option>
                    <option value="-5.50">-5.50</option>
                    <option value="-5.75">-5.75</option>
                    <option value="-6.00">-6.00</option>
                  </select>
                </div>


              </div>
            </div>

            <div className="eye-field-group">
              <label>Reading</label>
              <select 
                name="leftAdd"
                value={formData.leftAdd}
                onChange={handleInputChange}
              >
                <option value="">Select addition</option>
                <option value="+1.00">+1.00</option>
                <option value="+1.25">+1.25</option>
                <option value="+1.50">+1.50</option>
                <option value="+1.75">+1.75</option>
                <option value="+2.00">+2.00</option>
                <option value="+2.25">+2.25</option>
                <option value="+2.50">+2.50</option>
                <option value="+2.75">+2.75</option>
                <option value="+3.00">+3.00</option>
                <option value="+3.25">+3.25</option>
                <option value="+3.50">+3.50</option>
                <option value="+3.75">+3.75</option>
                <option value="+4.00">+4.00</option>
              </select>
            </div>

            <div className="eye-field-group">
              <label>Near VA</label>
              <select 
                className="form-control"
                name="leftNearVA"
                value={formData.leftNearVA}
                onChange={handleInputChange}
              >
                <option value="">Select</option>
                <option value="N5">N5</option>
                <option value="N6">N6</option>
                <option value="N8">N8</option>
                <option value="N10">N10</option>
                <option value="N14">N14</option>
                <option value="N24">N24</option>
                <option value="N36">N36</option>  
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* HB Rx Section - Only shown when main prescription is checked */}
      <div className="form-row" style={{ marginTop: '20px' }}>
        <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={showHBRx}
              onChange={(e) => setShowHBRx(e.target.checked)}
              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
            />
            <span style={{ fontWeight: '500' }}>Include HB Rx</span>
          </label>
          <span style={{ fontSize: '12px', color: '#666' }}>
            (Check to add Hard Back Rx prescription)
          </span>
        </div>
      </div>

      {/* HB Rx Section - Conditional */}
{/* HB Rx Section - Conditional */}
{showHBRx && (
  <div className="hb-rx-section" style={{
    marginTop: '20px',
    padding: '16px',
    border: '2px solid #2563eb',
    borderRadius: '8px',
    backgroundColor: '#f8faff'
  }}>
    <h3 style={{
      fontSize: '16px',
      fontWeight: '700',
      color: '#2563eb',
      marginBottom: '12px'
    }}>
      HB Rx
    </h3>

    <div className="prescription-grid">
      {/* Right Eye - HB Rx */}
      <div className="eye-section">
        <h4>Right Eye (OD) - HB Rx</h4>

        <div className="eye-field-group">
          <label>Visual Acuity</label>
          <select 
            className="form-control"
            name="hbRxRightVisualAcuity"
            value={formData.hbRxRightVisualAcuity}
            onChange={handleInputChange}
          >
            <option value="">Select</option>
            <option value="6/6">6/6</option>
            <option value="6/9">6/9</option>
            <option value="6/12">6/12</option>
            <option value="6/18">6/18</option>
            <option value="6/24">6/24</option>
            <option value="6/36">6/36</option>
            <option value="6/60">6/60</option>  
          </select>
        </div>

        <div className="eye-fields">
          <div className="eye-field-group">
            <label>Distance</label>
            <div className="presc-inputs">
              <div className="eye-field-group">
                <label>SPH</label>
                <select 
                  name="hbRxRightSph"
                  value={formData.hbRxRightSph}
                  onChange={handleInputChange}
                  style={{ width: '100px' }}
                >
                  <option value="">Select SPH</option>
                  <option value="Plano (0.00)">Plano (0.00)</option>
                  <option value="-0.25">-0.25</option>
                  <option value="-0.50">-0.50</option>
                  <option value="-0.75">-0.75</option>
                  <option value="-1.00">-1.00</option>
                  <option value="-1.25">-1.25</option>
                  <option value="-1.50">-1.50</option>
                  <option value="-1.75">-1.75</option>
                  <option value="-2.00">-2.00</option>
                  <option value="-2.25">-2.25</option>
                  <option value="-2.50">-2.50</option>
                  <option value="-2.75">-2.75</option>
                  <option value="-3.00">-3.00</option>
                  <option value="-3.25">-3.25</option>
                  <option value="-3.50">-3.50</option>
                  <option value="-3.75">-3.75</option>
                  <option value="-4.00">-4.00</option>
                  <option value="-4.25">-4.25</option>
                  <option value="-4.50">-4.50</option>
                  <option value="-4.75">-4.75</option>
                  <option value="-5.00">-5.00</option>
                  <option value="-5.25">-5.25</option>
                  <option value="-5.50">-5.50</option>
                  <option value="-5.75">-5.75</option>
                  <option value="-6.00">-6.00</option>
                  <option value="-6.25">-6.25</option>
                  <option value="-6.50">-6.50</option>
                  <option value="-6.75">-6.75</option>
                  <option value="-7.00">-7.00</option>
                  <option value="-7.25">-7.25</option>
                  <option value="-7.50">-7.50</option>
                  <option value="-7.75">-7.75</option>
                  <option value="-8.00">-8.00</option>
                  <option value="-8.25">-8.25</option>
                  <option value="-8.50">-8.50</option>
                  <option value="-8.75">-8.75</option>
                  <option value="-9.00">-9.00</option>
                  <option value="-9.25">-9.25</option>
                  <option value="-9.50">-9.50</option>
                  <option value="-9.75">-9.75</option>
                  <option value="-10.00">-10.00</option>
                  <option value="+0.25">+0.25</option>
                  <option value="+0.50">+0.50</option>
                  <option value="+0.75">+0.75</option>
                  <option value="+1.00">+1.00</option>
                  <option value="+1.25">+1.25</option>
                  <option value="+1.50">+1.50</option>
                  <option value="+1.75">+1.75</option>
                  <option value="+2.00">+2.00</option>
                  <option value="+2.25">+2.25</option>
                  <option value="+2.50">+2.50</option>
                  <option value="+2.75">+2.75</option>
                  <option value="+3.00">+3.00</option>
                  <option value="+3.25">+3.25</option>
                  <option value="+3.50">+3.50</option>
                  <option value="+3.75">+3.75</option>
                  <option value="+4.00">+4.00</option>
                  <option value="+4.25">+4.25</option>
                  <option value="+4.50">+4.50</option>
                  <option value="+4.75">+4.75</option>
                  <option value="+5.00">+5.00</option>
                  <option value="+5.25">+5.25</option>
                  <option value="+5.50">+5.50</option>
                  <option value="+5.75">+5.75</option>
                  <option value="+6.00">+6.00</option>
                  <option value="+6.25">+6.25</option>
                  <option value="+6.50">+6.50</option>
                  <option value="+6.75">+6.75</option>
                  <option value="+7.00">+7.00</option>
                  <option value="+7.25">+7.25</option>
                  <option value="+7.50">+7.50</option>
                  <option value="+7.75">+7.75</option>
                  <option value="+8.00">+8.00</option>
                  <option value="+8.25">+8.25</option>
                  <option value="+8.50">+8.50</option>
                  <option value="+8.75">+8.75</option>
                  <option value="+9.00">+9.00</option>
                  <option value="+9.25">+9.25</option>
                  <option value="+9.50">+9.50</option>
                  <option value="+9.75">+9.75</option>
                  <option value="+10.00">+10.00</option>
                </select>
              </div>

              <div className="eye-field-group">
                <label>CYL</label>
                <select 
                  name="hbRxRightCyl"
                  value={formData.hbRxRightCyl}
                  onChange={handleInputChange}
                  style={{ width: '100px' }}
                >
                  <option value="">Select CYL</option>
                  <option value="-0.25">-0.25</option>
                  <option value="-0.50">-0.50</option>
                  <option value="-0.75">-0.75</option>
                  <option value="-1.00">-1.00</option>
                  <option value="-1.25">-1.25</option>
                  <option value="-1.50">-1.50</option>
                  <option value="-1.75">-1.75</option>
                  <option value="-2.00">-2.00</option>
                  <option value="-2.25">-2.25</option>
                  <option value="-2.50">-2.50</option>
                  <option value="-2.75">-2.75</option>
                  <option value="-3.00">-3.00</option>
                  <option value="-3.25">-3.25</option>
                  <option value="-3.50">-3.50</option>
                  <option value="-3.75">-3.75</option>
                  <option value="-4.00">-4.00</option>
                  <option value="-4.25">-4.25</option>
                  <option value="-4.50">-4.50</option>
                  <option value="-4.75">-4.75</option>
                  <option value="-5.00">-5.00</option>
                  <option value="-5.25">-5.25</option>
                  <option value="-5.50">-5.50</option>
                  <option value="-5.75">-5.75</option>
                  <option value="-6.00">-6.00</option>
                </select>
              </div>

            </div>
          </div>

          <div className="eye-field-group">
            <label>Reading</label>
            <select 
              name="hbRxRightAdd"
              value={formData.hbRxRightAdd}
              onChange={handleInputChange}
            >
              <option value="">Select addition</option>
              <option value="+1.00">+1.00</option>
              <option value="+1.25">+1.25</option>
              <option value="+1.50">+1.50</option>
              <option value="+1.75">+1.75</option>
              <option value="+2.00">+2.00</option>
              <option value="+2.25">+2.25</option>
              <option value="+2.50">+2.50</option>
              <option value="+2.75">+2.75</option>
              <option value="+3.00">+3.00</option>
              <option value="+3.25">+3.25</option>
              <option value="+3.50">+3.50</option>
              <option value="+3.75">+3.75</option>
              <option value="+4.00">+4.00</option>
            </select>
          </div>

          <div className="eye-field-group">
            <label>Near VA</label>
            <select 
              className="form-control"
              name="hbRxRightNearVA"
              value={formData.hbRxRightNearVA}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="N5">N5</option>
              <option value="N6">N6</option>
              <option value="N8">N8</option>
              <option value="N10">N10</option>
              <option value="N14">N14</option>
              <option value="N24">N24</option>
              <option value="N36">N36</option>  
            </select>
          </div>
        </div>
      </div>

      {/* Left Eye - HB Rx */}
      <div className="eye-section">
        <h4>Left Eye (OS) - HB Rx</h4>

        <div className="eye-field-group">
          <label>Visual Acuity</label>
          <select 
            className="form-control"
            name="hbRxLeftVisualAcuity"
            value={formData.hbRxLeftVisualAcuity}
            onChange={handleInputChange}
          >
            <option value="">Select</option>
            <option value="6/6">6/6</option>
            <option value="6/9">6/9</option>
            <option value="6/12">6/12</option>
            <option value="6/18">6/18</option>
            <option value="6/24">6/24</option>
            <option value="6/36">6/36</option>
            <option value="6/60">6/60</option>  
          </select>
        </div>

        <div className="eye-fields">
          <div className="eye-field-group">
            <label>Distance</label>
            <div className="presc-inputs">
              <div className="eye-field-group">
                <label>SPH</label>
                <select 
                  name="hbRxLeftSph"
                  value={formData.hbRxLeftSph}
                  onChange={handleInputChange}
                  style={{ width: '100px' }}
                >
                  <option value="">Select SPH</option>
                  <option value="Plano (0.00)">Plano (0.00)</option>
                  <option value="-0.25">-0.25</option>
                  <option value="-0.50">-0.50</option>
                  <option value="-0.75">-0.75</option>
                  <option value="-1.00">-1.00</option>
                  <option value="-1.25">-1.25</option>
                  <option value="-1.50">-1.50</option>
                  <option value="-1.75">-1.75</option>
                  <option value="-2.00">-2.00</option>
                  <option value="-2.25">-2.25</option>
                  <option value="-2.50">-2.50</option>
                  <option value="-2.75">-2.75</option>
                  <option value="-3.00">-3.00</option>
                  <option value="-3.25">-3.25</option>
                  <option value="-3.50">-3.50</option>
                  <option value="-3.75">-3.75</option>
                  <option value="-4.00">-4.00</option>
                  <option value="-4.25">-4.25</option>
                  <option value="-4.50">-4.50</option>
                  <option value="-4.75">-4.75</option>
                  <option value="-5.00">-5.00</option>
                  <option value="-5.25">-5.25</option>
                  <option value="-5.50">-5.50</option>
                  <option value="-5.75">-5.75</option>
                  <option value="-6.00">-6.00</option>
                  <option value="-6.25">-6.25</option>
                  <option value="-6.50">-6.50</option>
                  <option value="-6.75">-6.75</option>
                  <option value="-7.00">-7.00</option>
                  <option value="-7.25">-7.25</option>
                  <option value="-7.50">-7.50</option>
                  <option value="-7.75">-7.75</option>
                  <option value="-8.00">-8.00</option>
                  <option value="-8.25">-8.25</option>
                  <option value="-8.50">-8.50</option>
                  <option value="-8.75">-8.75</option>
                  <option value="-9.00">-9.00</option>
                  <option value="-9.25">-9.25</option>
                  <option value="-9.50">-9.50</option>
                  <option value="-9.75">-9.75</option>
                  <option value="-10.00">-10.00</option>
                  <option value="+0.25">+0.25</option>
                  <option value="+0.50">+0.50</option>
                  <option value="+0.75">+0.75</option>
                  <option value="+1.00">+1.00</option>
                  <option value="+1.25">+1.25</option>
                  <option value="+1.50">+1.50</option>
                  <option value="+1.75">+1.75</option>
                  <option value="+2.00">+2.00</option>
                  <option value="+2.25">+2.25</option>
                  <option value="+2.50">+2.50</option>
                  <option value="+2.75">+2.75</option>
                  <option value="+3.00">+3.00</option>
                  <option value="+3.25">+3.25</option>
                  <option value="+3.50">+3.50</option>
                  <option value="+3.75">+3.75</option>
                  <option value="+4.00">+4.00</option>
                  <option value="+4.25">+4.25</option>
                  <option value="+4.50">+4.50</option>
                  <option value="+4.75">+4.75</option>
                  <option value="+5.00">+5.00</option>
                  <option value="+5.25">+5.25</option>
                  <option value="+5.50">+5.50</option>
                  <option value="+5.75">+5.75</option>
                  <option value="+6.00">+6.00</option>
                  <option value="+6.25">+6.25</option>
                  <option value="+6.50">+6.50</option>
                  <option value="+6.75">+6.75</option>
                  <option value="+7.00">+7.00</option>
                  <option value="+7.25">+7.25</option>
                  <option value="+7.50">+7.50</option>
                  <option value="+7.75">+7.75</option>
                  <option value="+8.00">+8.00</option>
                  <option value="+8.25">+8.25</option>
                  <option value="+8.50">+8.50</option>
                  <option value="+8.75">+8.75</option>
                  <option value="+9.00">+9.00</option>
                  <option value="+9.25">+9.25</option>
                  <option value="+9.50">+9.50</option>
                  <option value="+9.75">+9.75</option>
                  <option value="+10.00">+10.00</option>
                </select>
              </div>

              <div className="eye-field-group">
                <label>CYL</label>
                <select 
                  name="hbRxLeftCyl"
                  value={formData.hbRxLeftCyl}
                  onChange={handleInputChange}
                  style={{ width: '100px' }}
                >
                  <option value="">Select CYL</option>
                  <option value="-0.25">-0.25</option>
                  <option value="-0.50">-0.50</option>
                  <option value="-0.75">-0.75</option>
                  <option value="-1.00">-1.00</option>
                  <option value="-1.25">-1.25</option>
                  <option value="-1.50">-1.50</option>
                  <option value="-1.75">-1.75</option>
                  <option value="-2.00">-2.00</option>
                  <option value="-2.25">-2.25</option>
                  <option value="-2.50">-2.50</option>
                  <option value="-2.75">-2.75</option>
                  <option value="-3.00">-3.00</option>
                  <option value="-3.25">-3.25</option>
                  <option value="-3.50">-3.50</option>
                  <option value="-3.75">-3.75</option>
                  <option value="-4.00">-4.00</option>
                  <option value="-4.25">-4.25</option>
                  <option value="-4.50">-4.50</option>
                  <option value="-4.75">-4.75</option>
                  <option value="-5.00">-5.00</option>
                  <option value="-5.25">-5.25</option>
                  <option value="-5.50">-5.50</option>
                  <option value="-5.75">-5.75</option>
                  <option value="-6.00">-6.00</option>
                </select>
              </div>

            </div>
          </div>

          <div className="eye-field-group">
            <label>Reading</label>
            <select 
              name="hbRxLeftAdd"
              value={formData.hbRxLeftAdd}
              onChange={handleInputChange}
            >
              <option value="">Select addition</option>
              <option value="+1.00">+1.00</option>
              <option value="+1.25">+1.25</option>
              <option value="+1.50">+1.50</option>
              <option value="+1.75">+1.75</option>
              <option value="+2.00">+2.00</option>
              <option value="+2.25">+2.25</option>
              <option value="+2.50">+2.50</option>
              <option value="+2.75">+2.75</option>
              <option value="+3.00">+3.00</option>
              <option value="+3.25">+3.25</option>
              <option value="+3.50">+3.50</option>
              <option value="+3.75">+3.75</option>
              <option value="+4.00">+4.00</option>
            </select>
          </div>

          <div className="eye-field-group">
            <label>Near VA</label>
            <select 
              className="form-control"
              name="hbRxLeftNearVA"
              value={formData.hbRxLeftNearVA}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="N5">N5</option>
              <option value="N6">N6</option>
              <option value="N8">N8</option>
              <option value="N10">N10</option>
              <option value="N14">N14</option>
              <option value="N24">N24</option>
              <option value="N36">N36</option>  
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
    </>
  )}
</div>

        {/* Product Search Section */}
        <div className="invoice-section">
          <div className="section-header">
            <h3>Products</h3>
            <span className="section-badge">Add Items</span>
          </div>

          <div className="form-group">
            <label>Search Product</label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                value={directSaleSearch}
                onChange={(e) => handleDirectSaleSearch(e.target.value)}
                placeholder="Search by model no / brand / colour"
              />

              {showDirectSaleSuggestions && directSaleSuggestions.length > 0 && (
                <div className="suggestions-dropdown">
                  {directSaleSuggestions.map((item, index) => (
                    <div
                      key={index}
                      className="suggestion-item"
                      onClick={() => selectDirectProduct(item)}
                    >
                      <strong>{item.modelNo}</strong>
                      <div className="suggestion-details">
                        {item.brand} | {item.colour} | Rs.{item.sellingPrice}
                        <span className="stock-badge">Stock: {item.qty}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Cart */}
          {directSaleItems.length > 0 && (
            <div className="direct-sale-cart">
              <table className="direct-sale-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Model</th>
                    <th>Brand</th>
                    <th>Colour</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Total</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {directSaleItems.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.modelNo}</td>
                      <td>{item.brand}</td>
                      <td>{item.colour}</td>
                      <td>Rs.{Number(item.sellingPrice).toFixed(2)}</td>
                      <td>
                        <input
                          type="number"
                          min="1"
                          max={item.stockQty}
                          value={item.qty}
                          className="qty-input"
                          onChange={(e) => {
                            let value = Number(e.target.value);
                            if (e.target.value === '') value = 1;
                            if (value < 1) value = 1;
                            if (value > item.stockQty) value = item.stockQty;
                            updateDirectSaleQty(index, value);
                          }}
                        />
                        <small className="stock-text">Available Stock: {item.stockQty}</small>
                      </td>
                      <td className="item-total">Rs.{Number(item.total).toFixed(2)}</td>
                      <td>
                        <button className="btn-delete-item" onClick={() => removeDirectSaleItem(index)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Billing Section */}
        <div className="invoice-section">
          <div className="section-header">
            <h3>Billing & Payment</h3>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Billing Date</label>
              <input
                type="date"
                value={billingDate}
                onChange={(e) => setBillingDate(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Payment Method</label>
              <select
                name="paymentMethod"
                value={formData.paymentMethod}
                onChange={handleInputChange}
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                  <option value="GiftCard">Gift Card</option>
                <option value="Bank Transfer">Bank Transfer</option>
                <option value="Deposit">Deposit</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Discount Type</label>
              <select
                value={discountType}
                onChange={(e) => setDiscountType(e.target.value)}
              >
                <option value="amount">Amount</option>
                <option value="percentage">Percentage %</option>
              </select>
            </div>

            <div className="form-group">
              <label>Discount</label>
              <input
                type="number"
                name="discount"
                value={formData.discount}
                onChange={handleInputChange}
                onWheel={(e) => e.target.blur()}
              />
            </div>

            <div className="form-group">
              <label>Paid Amount</label>
              <input
                type="number"
                name="advancePayment"
                value={formData.advancePayment}
                onChange={handleInputChange}
                onWheel={(e) => e.target.blur()}
              />
            </div>

            <div className="form-group">
              <label>Note:</label>
              <input
                type="text"
                name="note"
                value={formData.note}
                onChange={handleInputChange}
                placeholder="Additional notes or remarks"
              />
            </div>
          </div>

          <div className="financial-summary">
            <div data-label="Subtotal">Rs.{directSaleSubtotal.toFixed(2)}</div>
            <div data-label="Discount">Rs.{calculatedDiscount.toFixed(2)}</div>
            <div data-label="Grand Total">Rs.{directSaleTotal.toFixed(2)}</div>
            <div data-label="Paid">Rs.{directSaleAdvanceAmount.toFixed(2)}</div>
            <div data-label="Balance">Rs.{directSaleBalance.toFixed(2)}</div>
            <div data-label="Status">{paymentStatus.toUpperCase()}</div>
          </div>
        </div>

        {/* Actions */}
        <div className="invoice-actions">
          <button 
            className="btn-save"
            onClick={handleSaveDirectSale}
            disabled={isSavingDirectSale}
          >
            {isSavingDirectSale ? 'Creating...' : 'Create Direct Sale Bill'}
          </button>
        </div>
      </div>
    </div>

)}

{/* {selectedOption === "directSales" && (

<div className="invoice-wrap">

  <div className="invoice-header">

    <h2>Direct Sales Invoice</h2>

    <p className="invoice-subtitle">
      Sunglasses, Accessories & Other Products
    </p>

    <div className="invoice-number-display">
      Next Invoice: {currentInvoiceNumber}
    </div>

  </div>

  <div className="invoice-content">


    <div className="invoice-section">

  

<div className="detail-item">

  <label>Served By *</label>

  <select
  value={saleForm.salePerson}
  onChange={(e) =>
    setSaleForm({
      ...saleForm,
      salePerson: e.target.value
    })
  }
  className="sale-person-select"
>
  <option value="">
    Select Sales Person
  </option>



  
        <option value="Ms. Kumari">
            Ms. Kumari
          </option>

         <option value="Mr. Sanjeewa">
            Mr. Sanjeewa
          </option>

         <option value="Ms. Medha">
           Ms. Medha
          </option>

         <option value="Sey 1">
            Sey 1
          </option>

         <option value="Sey 2">
            Sey 2
          </option>


</select>
</div>

</div>


<div className="invoice-section">
  <div className="section-header">
    <h3>Customer Information</h3>
    <span className="section-badge">Required</span>
  </div>


  <div className="customer-search-container" style={{ marginBottom: '15px' }}>
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
      <div style={{ flex: 1, minWidth: '200px', position: 'relative' }}>
        <input
          type="text"
          placeholder="🔍 Search existing customer (Name or Phone)"
          value={customerSearchTerm}
          onChange={(e) => {
            setCustomerSearchTerm(e.target.value);
            searchExistingCustomer(e.target.value);
            setShowCustomerSearch(true);
          }}
          onFocus={() => setShowCustomerSearch(true)}
          onBlur={() => {
            // Delay hiding to allow click on results
            setTimeout(() => setShowCustomerSearch(false), 200);
          }}
          style={{
            width: '100%',
            padding: '10px 15px',
            border: '2px solid #d0d8e8',
            borderRadius: '8px',
            fontSize: '14px',
            backgroundColor: '#f8f9fa'
          }}
        />
        {isSearchingCustomer && (
          <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
            ⏳
          </span>
        )}
        
     
        {showCustomerSearch && searchResults.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #d0d8e8',
            borderRadius: '8px',
            maxHeight: '200px',
            overflowY: 'auto',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            marginTop: '4px'
          }}>
            {searchResults.map((result, index) => (
              <div
                key={index}
                onMouseDown={(e) => e.preventDefault()} // Prevent blur
                onClick={() => selectExistingCustomer(result)}
                style={{
                  padding: '10px 15px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f0f0f0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                <div>
                  <strong>{result.customer.fullName || `${result.customer.firstName} ${result.customer.lastName}`}</strong>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    📞 {result.customer.tpNo}
                  </div>
                </div>
                <button
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={(e) => {
                    e.stopPropagation();
                    selectExistingCustomer(result);
                  }}
                  style={{
                    padding: '5px 12px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  Select
                </button>
              </div>
            ))}
          </div>
        )}
        
        {showCustomerSearch && customerSearchTerm && searchResults.length === 0 && !isSearchingCustomer && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #d0d8e8',
            borderRadius: '8px',
            padding: '15px',
            textAlign: 'center',
            color: '#666',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            marginTop: '4px'
          }}>
            No existing customer found. Enter new details below.
          </div>
        )}
      </div>
      
      {isEditingCustomer && (
        <button
          onClick={resetCustomerForm}
          style={{
            padding: '8px 16px',
            backgroundColor: '#ff9800',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
            whiteSpace: 'nowrap'
          }}
        >
          ✏️ New Customer
        </button>
      )}
      
      {existingCustomerData && (
        <span style={{
          fontSize: '13px',
          color: '#4CAF50',
          fontWeight: '500',
          backgroundColor: '#e8f5e9',
          padding: '5px 12px',
          borderRadius: '20px',
          whiteSpace: 'nowrap'
        }}>
          ✓ Editing existing customer
        </span>
      )}
    </div>
  </div>


  <div className="form-row">
    <div className="form-group">
      <label>Title</label>
      <select 
        className="form-control"
        name="title"
        value={formData.title}
        onChange={handleInputChange}
      >
        <option value="">Select</option>
        <option value="Mr">Mr.</option>
        <option value="Mrs">Mrs.</option>
        <option value="Ms">Ms.</option>
        <option value="Baby">Baby</option>
        <option value="Baby">Master</option>
        <option value="Dr">Dr.</option>
        <option value="Rev">Rev.</option>
      </select>
    </div>

    <div className="form-group">
      <label>First Name <span className="required-star">*</span></label>
      <input 
        type="text" 
        name="firstName"
        value={formData.firstName}
        onChange={handleInputChange}
        placeholder="Enter first name"
        className={errors.firstName ? 'error-input' : ''}
      />
      {errors.firstName && <span className="error-message">{errors.firstName}</span>}
    </div>
    
    <div className="form-group">
      <label>Last Name <span className="required-star">*</span></label>
      <input 
        type="text" 
        name="lastName"
        value={formData.lastName}
        onChange={handleInputChange}
        placeholder="Enter last name"
        className={errors.lastName ? 'error-input' : ''}
      />
      {errors.lastName && <span className="error-message">{errors.lastName}</span>}
    </div>
  </div>
  
  <div className="form-row">
    <div className="form-group">
      <label>Address <span className="required-star">*</span></label>
      <input 
        type="text" 
        name="address"
        value={formData.address}
        onChange={handleInputChange}
        placeholder="Street, city, postal code"
        className={errors.address ? 'error-input' : ''}
      />
      {errors.address && <span className="error-message">{errors.address}</span>}
    </div>
    
    <div className="form-group">
      <label>TP No <span className="required-star">*</span></label>
      <input 
        type="tel" 
        name="tpNo"
        value={formData.tpNo}
        onChange={handleInputChange}
        placeholder="Phone number"
        className={errors.tpNo ? 'error-input' : ''}
      />
      {errors.tpNo && <span className="error-message">{errors.tpNo}</span>}
    </div>
    
  </div>
</div>













  

    <div className="invoice-section">

      <div className="section-header">
        <h3>Products</h3>
        <span className="section-badge">
          Add Items
        </span>
      </div>

      <div className="form-group">

        <label>
          Search Product
        </label>

        <div style={{ position: "relative" }}>

          <input
            type="text"
            value={directSaleSearch}
            onChange={(e) =>
              handleDirectSaleSearch(e.target.value)
            }
            placeholder="Search by model no / brand / colour"
          />

          {showDirectSaleSuggestions &&
            directSaleSuggestions.length > 0 && (

            <div className="suggestions-dropdown">

              {directSaleSuggestions.map(
                (item, index) => (

                <div
                  key={index}
                  className="suggestion-item"
                  onClick={() =>
                    selectDirectProduct(item)
                  }
                >

                  <strong>
                    {item.modelNo}
                  </strong>

                  <div className="suggestion-details">

                    {item.brand} |
                    {item.colour} |
                    Rs.{item.sellingPrice}

                    <span className="stock-badge">
                      Stock: {item.qty}
                    </span>

                  </div>

                </div>

              ))}

            </div>

          )}

        </div>

      </div>

     



{directSaleItems.length > 0 && (

<div className="direct-sale-cart">

  <table className="direct-sale-table">

    <thead>

      <tr>
        <th>#</th>
        <th>Model</th>
        <th>Brand</th>
        <th>Colour</th>
        <th>Price</th>
        <th>Qty</th>
        <th>Total</th>
        <th>Action</th>
      </tr>

    </thead>

    <tbody>

      {directSaleItems.map((item, index) => (

      <tr key={index}>

        <td>{index + 1}</td>

        <td>{item.modelNo}</td>

        <td>{item.brand}</td>

        <td>{item.colour}</td>

        <td>
          Rs.{Number(item.sellingPrice).toFixed(2)}
        </td>

        <td>

<input
  type="number"
  min="1"
  max={item.stockQty}
  value={item.qty}
  className="qty-input"
  onChange={(e) => {

    let value = Number(e.target.value);

    // if empty
    if (e.target.value === "") {
      value = 1;
    }

    // minimum qty
    if (value < 1) {
      value = 1;
    }

    // maximum stock limit
    if (value > item.stockQty) {
      value = item.stockQty;
    }

    updateDirectSaleQty(index, value);

  }}
/>

<small className="stock-text">
  Available Stock: {item.stockQty}
</small>

        </td>

        <td className="item-total">
          Rs.{Number(item.total).toFixed(2)}
        </td>

        <td>

          <button
            className="btn-delete-item"
            onClick={() =>
              removeDirectSaleItem(index)
            }
          >
            Delete
          </button>

        </td>

      </tr>

      ))}

    </tbody>

  </table>

</div>

)}

    </div>



    <div className="invoice-section">

      <div className="section-header">
        <h3>Billing & Payment</h3>
      </div>

      <div className="form-row">

        <div className="form-group">

          <label>Billing Date</label>

          <input
            type="date"
            value={billingDate}
            onChange={(e) =>
              setBillingDate(e.target.value)
            }
          />

        </div>

        <div className="form-group">

          <label>Payment Method</label>

          <select
            name="paymentMethod"
            value={formData.paymentMethod}
            onChange={handleInputChange}
          >
          <option value="Cash">Cash</option>
          <option value="Card">Card</option>
          <option value="Bank Transfer">Bank Transfer</option>
          <option value="Deposit">Deposit</option>
          </select>

        </div>

      </div>

      <div className="form-row">

        <div className="form-group">

          <label>Discount Type</label>

          <select
            value={discountType}
            onChange={(e) =>
              setDiscountType(e.target.value)
            }
          >
            <option value="amount">
              Amount
            </option>

            <option value="percentage">
              Percentage %
            </option>

          </select>

        </div>

        <div className="form-group">

          <label>
            Discount
          </label>

          <input
            type="number"
            name="discount"
            value={formData.discount}
            onChange={handleInputChange}
             onWheel={(e) => e.target.blur()} // prevents scroll changing the value
          />

        </div>

        <div className="form-group">

        <label>
          Paid Amount
        </label>
<input
  type="number"
  name="advancePayment"
  value={formData.advancePayment}
  onChange={handleInputChange}
  onWheel={(e) => e.target.blur()} // prevents scroll changing the value
/>


        </div>

            <div className="form-group">
      <label>Note:</label>
      <input 
        type="text" 
        name="note"
        value={formData.note}
        onChange={handleInputChange}
        placeholder="Additional notes or remarks"
      
      />
  
    </div>

      </div>





<div className="financial-summary">

  <div data-label="Subtotal">
    Rs.{directSaleSubtotal.toFixed(2)}
  </div>

  <div data-label="Discount">
    Rs.{calculatedDiscount.toFixed(2)}
  </div>

  <div data-label="Grand Total">
    Rs.{directSaleTotal.toFixed(2)}
  </div>

<div data-label="Paid">
  Rs.{directSaleAdvanceAmount.toFixed(2)}
</div>

  <div data-label="Balance">
    Rs.{directSaleBalance.toFixed(2)}
  </div>

  <div data-label="Status">
    {paymentStatus.toUpperCase()}
  </div>

</div>






    </div>

  

    <div className="invoice-actions">




<button 
  className="btn-save"
  onClick={handleSaveDirectSale}
  disabled={isSavingDirectSale}
>
  {isSavingDirectSale
    ? "Creating..."
    : "Create Direct Sale Bill"}
</button>



    </div>

  </div>

</div>

)} */}




{/*************************************************  eye exam report for patient *************************************************************/}


{selectedOption === "eyeExamReportForPatient" && (
<div className="peer-wrapper">
    <div className="peer-container">
      
      <div className="peer-header">
        <h1 className="peer-title">
          <span className="peer-title-icon">👤</span>
          Patient Eye Examination History
        </h1>
        <p className="peer-subtitle">View examination records for specific patient</p>
      </div>

      <div className="peer-controls">
        <div className="peer-search-wrapper">
          <span className="peer-search-icon">🔍</span>
          <input 
            type="text" 
            placeholder="Search patient records..." 
            className="peer-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select 
          className="peer-filter-select"
          onChange={(e) => setFilterOption(e.target.value)}
          value={filterOption}
        >
          <option value="all">📋 All Records</option>
          <option value="today">📅 Today</option>
          <option value="week">📊 This Week</option>
          <option value="month">📈 This Month</option>
        </select>
      </div>

      {filteredRecords.length === 0 ? (
        <div className="peer-empty-state">
          <div className="peer-empty-icon">📭</div>
          <h3>No examination records found</h3>
          <p>No eye exams have been recorded for this patient yet</p>
        </div>
      ) : (
        <div className="peer-table-wrapper">
          <table className="peer-table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Patient ID</th>
                <th>Date</th>
                <th>Age</th>
                <th>Chief Complaint</th>
                <th>VA (OD/OS)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record) => (
                <tr key={record.id} className="peer-row">
                  <td className="peer-cell-patient">
                    <strong>{record.patientInfo?.name}</strong>
                  </td>
                  <td className="peer-cell-id">{record.patientInfo?.id || '-'}</td>
                  <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
                  <td>{record.patientInfo?.age || '-'}</td>
                  <td className="peer-cell-complaint" title={record.history?.chiefComplaint}>
                    {record.history?.chiefComplaint?.substring(0, 40)}
                    {record.history?.chiefComplaint?.length > 40 ? '...' : ''}
                  </td>
                  <td className="peer-cell-va">
                    <span className="peer-badge-od">{record.visualAcuity?.od_cg || '-'}</span>
                    <span className="peer-badge-sep">/</span>
                    <span className="peer-badge-os">{record.visualAcuity?.os_cg || '-'}</span>
                  </td>
                  <td>
                    <div className="peer-action-buttons">
                      <button 
                        className="peer-btn peer-btn-pdf"
                        onClick={() => generatePatientEyeExam(record)}
                        title="Download PDF Report"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                        </svg>
                        <span>PDF</span>
                      </button>

                          <button
      className="veer-btn veer-btn-delete"
      onClick={() => handleDeleteEyeExam(record.id)}
      title="Delete Record"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3.46-7.12 1.41-1.41L12 11.59l1.12-1.12 1.41 1.41L13.41 13l1.12 1.12-1.41 1.41L12 14.41l-1.12 1.12-1.41-1.41L10.59 13l-1.13-1.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"/>
      </svg>
      <span>Delete</span>
    </button>

                    </div>
                  </td>















                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
)}


{/************************************************* view all eye exam report *************************************************************/}


{selectedOption === "viewEyeExamReport" && (
  <div className="veer-wrapper">
    <div className="veer-container">
      
      <div className="veer-header">
        <h1 className="veer-title">
          <span className="veer-title-icon">👁️</span>
          Eye Examination Records
        </h1>
        <p className="veer-subtitle">View and manage all eye examination reports</p>
      </div>

      <div className="veer-controls">
        <div className="veer-search-wrapper">
          <span className="veer-search-icon">🔍</span>
          <input 
            type="text" 
            placeholder="Search by patient name or ID..." 
            className="veer-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select 
          className="veer-filter-select"
          onChange={(e) => setFilterOption(e.target.value)}
          value={filterOption}
        >
          <option value="all">📋 All Records</option>
          <option value="today">📅 Today</option>
          <option value="week">📊 This Week</option>
          <option value="month">📈 This Month</option>
        </select>
      </div>

      {filteredRecords.length === 0 ? (
        <div className="veer-empty-state">
          <div className="veer-empty-icon">📭</div>
          <h3>No examination records found</h3>
          <p>Try adjusting your search or filter criteria</p>
        </div>
      ) : (
        <div className="veer-table-wrapper">
          <table className="veer-table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Patient ID</th>
                <th>Date</th>
                <th>Age</th>
                <th>Chief Complaint</th>
                <th>VA (OD/OS)</th>
                <th>PD (OD/OS)</th>
                <th>SEG</th>
                <th>Refraction</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record) => (
                <tr key={record.id} className="veer-row">
                  <td className="veer-cell-patient">
                    <strong>{record.patientInfo?.name}</strong>
                  </td>
                  <td className="veer-cell-id">{record.patientInfo?.id || '-'}</td>
                  <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
                  <td>{record.patientInfo?.age || '-'}</td>
                  <td className="veer-cell-complaint" title={record.history?.chiefComplaint}>
                    {record.history?.chiefComplaint?.substring(0, 30)}
                    {record.history?.chiefComplaint?.length > 30 ? '...' : ''}
                  </td>
                  <td className="veer-cell-va">
                    <span className="veer-badge-od">{record.visualAcuity?.od_cg || '-'}</span>
                    <span className="veer-badge-sep">/</span>
                    <span className="veer-badge-os">{record.visualAcuity?.os_cg || '-'}</span>
                  </td>
                  <td>
                    {record.visualAcuity?.od_pd || '-'} / {record.visualAcuity?.os_pd || '-'}
                  </td>
                  <td className="veer-cell-seg">{record.visualAcuity?.seg_va || '-'}</td>
                  <td className="veer-cell-refraction">
                    {record.refraction?.od_sph || '0'} {record.refraction?.od_cyl || '0'} x {record.refraction?.od_axis || '0'}
                  </td>
                  <td>
                    <div className="veer-action-buttons">

                      <button 
                        className="veer-btn veer-btn-view"
                        onClick={() => setSelectedRecord(record)}
                        title="View Details"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                        </svg>
                      </button>

                                            <button 
                        className="veer-btn veer-btn-pdf"
                        onClick={() => generateEyeExamPDF(record)}
                        title="Download PDF Report"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                        </svg>
                        <span>PDF</span>
                      </button>


      <button
      className="veer-btn veer-btn-delete"
      onClick={() => handleDeleteEyeExam(record.id)}
      title="Delete Record"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3.46-7.12 1.41-1.41L12 11.59l1.12-1.12 1.41 1.41L13.41 13l1.12 1.12-1.41 1.41L12 14.41l-1.12 1.12-1.41-1.41L10.59 13l-1.13-1.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"/>
      </svg>
      <span>Delete</span>
    </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Record Detail Modal */}
      {selectedRecord && (
        <div className="veer-modal-overlay" onClick={() => setSelectedRecord(null)}>
          <div className="veer-modal" onClick={(e) => e.stopPropagation()}>
            <button className="veer-modal-close" onClick={() => setSelectedRecord(null)}>×</button>
            
            <div className="veer-modal-header">
              <h2>Eye Examination Details</h2>
              <p>Complete examination report</p>
            </div>

            <div className="veer-modal-content">
              {/* Patient Info Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">👤</span>
                  Patient Information
                </h3>
                <div className="veer-info-grid">
                  <div className="veer-info-item">
                    <label>Patient Name</label>
                    <span>{selectedRecord.patientInfo?.name}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Patient ID</label>
                    <span>{selectedRecord.patientInfo?.id}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Age / Gender</label>
                    <span>{selectedRecord.patientInfo?.age} / {selectedRecord.patientInfo?.gender}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Examination Date</label>
                    <span>{new Date(selectedRecord.patientInfo?.date).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>

              {/* History Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">📜</span>
                  Medical History
                </h3>
                <div className="veer-history-content">
                  <div className="veer-history-item">
                    <label>Chief Complaint</label>
                    <p>{selectedRecord.history?.chiefComplaint || '-'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>HPC</label>
                    <p>{selectedRecord.history?.hpc || '-'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>Past Ocular History</label>
                    <p>{selectedRecord.history?.pastOcularHistory || '-'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>Medical History</label>
                    <p>{selectedRecord.history?.medicalHistory || '-'}</p>
                  </div>
                </div>
              </div>

              {/* Examination Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">🔬</span>
                  Examination Results
                </h3>
                
                <div className="veer-exam-section">
                  <h4>Visual Acuity</h4>
                  <div className="veer-exam-grid">
                    <div className="veer-exam-item">
                      <label>OD (Right)</label>
                      <span>C/C: {selectedRecord.visualAcuity?.od_cg || '-'}</span>
                      <span>S/C: {selectedRecord.visualAcuity?.od_sg || '-'}</span>
                      <span>P/H: {selectedRecord.visualAcuity?.od_ph || '-'}</span>
                      <span>PD: {selectedRecord.visualAcuity?.od_pd || '-'}</span>
                    </div>
                    <div className="veer-exam-item">
                      <label>OS (Left)</label>
                      <span>C/C: {selectedRecord.visualAcuity?.os_cg || '-'}</span>
                      <span>S/C: {selectedRecord.visualAcuity?.os_sg || '-'}</span>
                      <span>P/H: {selectedRecord.visualAcuity?.os_ph || '-'}</span>
                      <span>PD: {selectedRecord.visualAcuity?.os_pd || '-'}</span>
                    </div>
                  </div>
                  <div className="veer-exam-item veer-full-width">
                    <label>SEG</label>
                    <span>{selectedRecord.visualAcuity?.seg_va || '-'}</span>
                  </div>
                </div>

                <div className="veer-exam-section">
                  <h4>Refraction</h4>
                  <div className="veer-exam-grid">
                    <div className="veer-exam-item">
                      <label>OD (Right)</label>
                      <span>Sph: {selectedRecord.refraction?.od_sph || '0'}</span>
                      <span>Cyl: {selectedRecord.refraction?.od_cyl || '0'}</span>
                      <span>Axis: {selectedRecord.refraction?.od_axis || '0'}</span>
                      <span>Vision: {selectedRecord.refraction?.od_vision || '-'}</span>
                    </div>
                    <div className="veer-exam-item">
                      <label>OS (Left)</label>
                      <span>Sph: {selectedRecord.refraction?.os_sph || '0'}</span>
                      <span>Cyl: {selectedRecord.refraction?.os_cyl || '0'}</span>
                      <span>Axis: {selectedRecord.refraction?.os_axis || '0'}</span>
                      <span>Vision: {selectedRecord.refraction?.os_vision || '-'}</span>
                    </div>
                  </div>
                </div>

                {/* External Examination */}
                {selectedRecord.externalExam && (
                  <div className="veer-exam-section">
                    <h4>External Examination</h4>
                    <div className="veer-exam-grid">
                      <div className="veer-exam-item">
                        <label>Left Eye</label>
                        {selectedRecord.externalExam.lidsLeft && <span>Lids: {selectedRecord.externalExam.lidsLeft}</span>}
                        {selectedRecord.externalExam.conjunctivaLeft && <span>Conjunctiva: {selectedRecord.externalExam.conjunctivaLeft}</span>}
                        {selectedRecord.externalExam.corneaLeft && <span>Cornea: {selectedRecord.externalExam.corneaLeft}</span>}
                      </div>
                      <div className="veer-exam-item">
                        <label>Right Eye</label>
                        {selectedRecord.externalExam.lidsRight && <span>Lids: {selectedRecord.externalExam.lidsRight}</span>}
                        {selectedRecord.externalExam.conjunctivaRight && <span>Conjunctiva: {selectedRecord.externalExam.conjunctivaRight}</span>}
                        {selectedRecord.externalExam.corneaRight && <span>Cornea: {selectedRecord.externalExam.corneaRight}</span>}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <button 
                className="veer-btn veer-btn-full"
                onClick={() => generateEyeExamPDF(selectedRecord)}
              >
                <span className="veer-btn-icon">📄</span>
                Generate Complete Report
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
)}



{/************************************************* create eye exam report *************************************************************/}



{selectedOption === "createEyeExamReport" && (
  <div className="eer-wrapper">
    <div className="eer-container">
      
      <div className="eer-header">
        <h1 className="eer-title">
          <span className="eer-title-icon">👁️</span>
          Eye Examination Report
        </h1>
        <p className="eer-subtitle">Comprehensive eye examination form</p>
      </div>

      <form onSubmit={handleEyeExamSubmit} className="eer-form">
        
        {/* Patient Information */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📋</span>
            Patient Information
          </h2>
          
          <div className="eer-form-row">





            <div className="eer-form-group">
              <label className="eer-label">Patient Name <span className="eer-required">*</span></label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Enter patient full name"
                value={patientName}
                onChange={(e) => setPatientName(e.target.value)}
                required
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">Examination Date <span className="eer-required">*</span></label>
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={examDate}
                onChange={(e) => setExamDate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="eer-form-row eer-grid-4">
            <div className="eer-form-group">
              <label className="eer-label">Date of Birth</label>
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
              />
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Age</label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Age"
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Gender</label>
              <select 
                className="eer-select"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <option value="" disabled>Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Contact No</label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Contact number"
                value={contactNo}
                onChange={(e) => setContactNo(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* History Taking */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📜</span>
            History Taking
          </h2>
          
          <div className="eer-form-group">
            <label className="eer-label">Chief Complaint</label>
            <textarea 
              className="eer-textarea"
              value={chiefComplaint}
              onChange={(e) => setChiefComplaint(e.target.value)}
              rows="2"
              placeholder="Enter chief complaint"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">HPC (History of Present Complaint)</label>
            <textarea 
              className="eer-textarea"
              value={hpc}
              onChange={(e) => setHpc(e.target.value)}
              rows="2"
              placeholder="Enter history of present complaint"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Past Ocular History</label>
            <textarea 
              className="eer-textarea"
              value={pastOcularHistory}
              onChange={(e) => setPastOcularHistory(e.target.value)}
              rows="2"
              placeholder="Enter past ocular history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Medical History</label>
            <textarea 
              className="eer-textarea"
              value={medicalHistory}
              onChange={(e) => setMedicalHistory(e.target.value)}
              rows="2"
              placeholder="Enter medical history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Family Ocular History</label>
            <textarea 
              className="eer-textarea"
              value={familyOcularHistory}
              onChange={(e) => setFamilyOcularHistory(e.target.value)}
              rows="2"
              placeholder="Enter family ocular history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Social History</label>
            <textarea 
              className="eer-textarea"
              value={socialHistory}
              onChange={(e) => setSocialHistory(e.target.value)}
              rows="2"
              placeholder="Enter social history"
            />
          </div>
        </div>

        {/* External Examination */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">🔬</span>
            External Examination
          </h2>

          {/* Lids */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Lids</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lidsLeft}
                  onChange={(e) => setLidsLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye lids condition"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lidsRight}
                  onChange={(e) => setLidsRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye lids condition"
                />
              </div>
            </div>
          </div>

          {/* Conjunctiva */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Conjunctiva</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={conjunctivaLeft}
                  onChange={(e) => setConjunctivaLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye conjunctiva"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={conjunctivaRight}
                  onChange={(e) => setConjunctivaRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye conjunctiva"
                />
              </div>
            </div>
          </div>

          {/* Cornea */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Cornea</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={corneaLeft}
                  onChange={(e) => setCorneaLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye cornea"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={corneaRight}
                  onChange={(e) => setCorneaRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye cornea"
                />
              </div>
            </div>
          </div>

          {/* Sclera */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Sclera</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={scleraLeft}
                  onChange={(e) => setScleraLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye sclera"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={scleraRight}
                  onChange={(e) => setScleraRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye sclera"
                />
              </div>
            </div>
          </div>

          {/* Anterior Chamber */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">A/C (Anterior Chamber)</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={acLeft}
                  onChange={(e) => setAcLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye A/C"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={acRight}
                  onChange={(e) => setAcRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye A/C"
                />
              </div>
            </div>
          </div>

          {/* Lens */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Lens</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lensLeft}
                  onChange={(e) => setLensLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye lens"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lensRight}
                  onChange={(e) => setLensRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye lens"
                />
              </div>
            </div>
          </div>

          {/* Vitreous */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Vitreous</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={vitreousLeft}
                  onChange={(e) => setVitreousLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye vitreous"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={vitreousRight}
                  onChange={(e) => setVitreousRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye vitreous"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Family History */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">👪</span>
            Family History
          </h2>
          
          <div className="eer-checkbox-group">
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="poag"
                checked={familyHistory.poag}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx POAG</span>
            </label>
            
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="amd"
                checked={familyHistory.amd}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx AMD</span>
            </label>
            
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="dm"
                checked={familyHistory.dm}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx DM</span>
            </label>
            
            <div className="eer-custom-condition">
              <input 
                type="text" 
                className="eer-input"
                name="other"
                value={familyHistory.other}
                onChange={handleFamilyHistoryChange}
                placeholder="Other family history"
              />
            </div>
          </div>
        </div>

        {/* Visual Acuity */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">👀</span>
            Visual Acuity
          </h2>
          
          <div className="eer-va-grid">
            <div className="eer-va-header">
              <div></div>
              <div>OD (Right)</div>
              <div>OS (Left)</div>
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">C∕C</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_cg"
                value={visualAcuity.od_cg}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_cg"
                value={visualAcuity.os_cg}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">S∕C</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_sg"
                value={visualAcuity.od_sg}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_sg"
                value={visualAcuity.os_sg}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">P∕H</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_ph"
                value={visualAcuity.od_ph}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_ph"
                value={visualAcuity.os_ph}
                onChange={handleVisualAcuityChange}
              />
            </div>

            <div className="eer-va-row">
              <div className="eer-va-label">PD</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_pd"
                value={visualAcuity.od_pd}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_pd"
                value={visualAcuity.os_pd}
                onChange={handleVisualAcuityChange}
              />
            </div>

            <div className="eer-va-row eer-va-single">
              <div className="eer-va-label">SEG</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="seg_va"
                value={visualAcuity.seg_va}
                onChange={handleVisualAcuityChange}
              />
            </div>
          </div>

          <div className="eer-va-additional">
            <div className="eer-form-group">
              <label className="eer-label">CT</label>
              <input 
                type="text" 
                className="eer-input"
                name="ct"
                value={visualAcuity.ct}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">NPC</label>
              <input 
                type="text" 
                className="eer-input"
                name="npc"
                value={visualAcuity.npc}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">OM</label>
              <input 
                type="text" 
                className="eer-input"
                name="om"
                value={visualAcuity.om}
                onChange={handleVisualAcuityChange}
              />
            </div>
          </div>
        </div>

        {/* Fundi */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">🔍</span>
            Fundi
          </h2>
          
          <div className="eer-form-group">
            <label className="eer-label">Description</label>
            <input 
              type="text" 
              className="eer-input"
              value={fundi}
              onChange={(e) => setFundi(e.target.value)}
              placeholder="Enter fundi description"
            />
          </div>
        </div>

        {/* Hb Rx */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📊</span>
            Hb Rx
          </h2>
          
          <div className="eer-refraction-grid">
            <div className="eer-refraction-header">
              <div></div>
              <div>Sph</div>
              <div>Cyl</div>
              <div>Axis</div>
              <div>Vision</div>
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OD</div>
              <input type="text" className="eer-refraction-input" name="hb_od_sph" value={hbrx.hb_od_sph} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_cyl" value={hbrx.hb_od_cyl} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_axis" value={hbrx.hb_od_axis} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_vision" value={hbrx.hb_od_vision} onChange={handleHbrxChange} />
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OS</div>
              <input type="text" className="eer-refraction-input" name="rx_os_sph" value={hbrx.rx_os_sph} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_cyl" value={hbrx.rx_os_cyl} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_axis" value={hbrx.rx_os_axis} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_vision" value={hbrx.rx_os_vision} onChange={handleHbrxChange} />
            </div>
          </div>

                 <div className="eer-refraction-label">Addition (Near)</div> 
                 <input type="text" className="eer-refraction-input" name="add" value={hbrx.add} onChange={handleHbrxChange} />


        </div>

        {/* Refraction */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📐</span>
            Refraction
          </h2>
          
          <div className="eer-refraction-grid">
            <div className="eer-refraction-header">
              <div></div>
              <div>Sph</div>
              <div>Cyl</div>
              <div>Axis</div>
              <div>Vision</div>
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OD</div>
              <input type="text" className="eer-refraction-input" name="od_sph" value={refraction.od_sph} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_cyl" value={refraction.od_cyl} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_axis" value={refraction.od_axis} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_vision" value={refraction.od_vision} onChange={handleRefractionChange} />
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OS</div>
              <input type="text" className="eer-refraction-input" name="os_sph" value={refraction.os_sph} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_cyl" value={refraction.os_cyl} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_axis" value={refraction.os_axis} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_vision" value={refraction.os_vision} onChange={handleRefractionChange} />
            </div>
          </div>
        </div>


      {/* Addition */}
          <div className="eer-form-group">
            <label className="eer-label">Near Vision (ADD)</label>
            <textarea 
              className="eer-textarea"
              value={addition}
              onChange={(e) => setAddition(e.target.value)}
              rows="2"
              placeholder="Enter addition"
            />
          </div>





        {/* Follow Up */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📅</span>
            Follow Up
          </h2>
          
          <div className="eer-form-row">
            <div className="eer-form-group eer-checkbox-group">
              <label className="eer-checkbox">
                <input 
                  type="checkbox" 
                  checked={needsFollowUp}
                  onChange={(e) => setNeedsFollowUp(e.target.checked)}
                />
                <span>Needs Follow Up</span>
              </label>
            </div>

            <div className="eer-form-group">
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={followUpDate}
                onChange={(e) => setFollowUpDate(e.target.value)}
                disabled={!needsFollowUp}
              />
            </div>
          </div>

          <div className="eer-form-group">
            <textarea 
              className="eer-textarea"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              rows={4}
              placeholder="Enter remarks"
            />
          </div>
        </div>

        <div className="eer-actions">
          <button type="submit" className="eer-btn eer-btn-primary">
            <span className="eer-btn-icon">📄</span>
            Generate Eye Exam Report
          </button>
          <button type="button" className="eer-btn eer-btn-secondary">
            <span className="eer-btn-icon">↺</span>
            Reset Form
          </button>
        </div>
      </form>
    </div>
  </div>
)}




{/**************************************************** View purchasing order ********************************************************************/}

{selectedOption === "viewPurchasingOrders" && (
  <div className="view-purchase-container">
    <h2>Purchasing Orders</h2>

    {loadingPO ? (
      <p>Loading...</p>
    ) : purchaseOrders.length === 0 ? (
      <p>No Purchasing Orders Found</p>
    ) : (
      <div className="purchase-orders-wrapper">
        {purchaseOrders.map((po, index) => (
          <div className="purchase-card" key={po.id}>
            <div className="purchase-top">
              <h3>{po.purchaseOrderNo}</h3>
              <span>
                {po.createdAt?.toDate
                  ? po.createdAt.toDate().toLocaleString()
                  : "No Date"}
              </span>
            </div>

            <p>
              <strong>Supplier:</strong> {po.supplierName}
            </p>

            {/* LENS LIST */}
            {po.lensList && po.lensList.length > 0 && (
              <div className="inner-box">
                <h4>Lens Items ({po.lensList.length})</h4>

                <table>
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Sph</th>
                      <th>Add</th>
                      <th>Cyl</th>
                      <th>Axis</th>
                      <th>Model</th>
                      <th>Prog</th>
                      <th>Qty</th>
                    </tr>
                  </thead>

                  <tbody>
                    {po.lensList.map((lens, i) => (
                      <tr key={i}>
                        <td>{lens.itemCode}</td>
                        <td>{lens.sph}</td>
                        <td>{lens.add}</td>
                        <td>{lens.cyl}</td>
                        <td>{lens.axis}</td>
                        <td>{lens.model}</td>
                        <td>{lens.progressive ? "Yes" : "No"}</td>
                        <td>{lens.qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* FRAME LIST */}
            {po.frameList && po.frameList.length > 0 && (
              <div className="inner-box">
                <h4>Frame Items ({po.frameList.length})</h4>

                <table>
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Model</th>
                      <th>Brand</th>
                      <th>Colour</th>
                      <th>Sex</th>
                      <th>Qty</th>
                    </tr>
                  </thead>

                  <tbody>
                    {po.frameList.map((frame, i) => (
                      <tr key={i}>
                        <td>{frame.itemCode}</td>
                        <td>{frame.modelNo}</td>
                        <td>{frame.brand}</td>
                        <td>{frame.colour}</td>
                        <td>{frame.sex}</td>
                        <td>{frame.qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
)}












{/******************************************************** Track spectacles ****************************************************************/}

{selectedOption === "trackSpectacle" && (
  <div className="track-spectacle-container">
    <h1>Track Spectacles</h1>

    {/* FILTERS */}
    <div className="track-filters">
      <input
        type="text"
        placeholder="Search Invoice No"
        value={trackSearchInvoice}
        onChange={(e) => setTrackSearchInvoice(e.target.value)}
      />

      <select
        value={trackFilterStatus}
        onChange={(e) => setTrackFilterStatus(e.target.value)}
      >
        <option value="all">All Status</option>
        <option value="Sent To Lab">Sent To Lab</option>
        <option value="Received From Lab">Received From Lab</option>
        <option value="QC - Team A">QC - Team A</option>
        <option value="QC - Team B">QC - Team B</option>
        <option value="QC - Team C">QC - Team C</option>
        <option value="QC - Team D">QC - Team D</option>

        <option value="QC - Team E">QC - Team E</option>
        <option value="QC - Team F">QC - Team F</option>
        <option value="QC - Team G">QC - Team G</option>
        <option value="QC - Team H">QC - Team H</option>
        <option value="QC - Team I">QC - Team I</option>

        <option value="QC - Team J">QC - Team J</option>
        <option value="QC - Team K">QC - Team K</option>
        <option value="QC - Team L">QC - Team L</option>
        <option value="QC - Team M">QC - Team M</option>
        <option value="QC - Team N">QC - Team N</option>

        <option value="Re-Sent To Lab (QC Failed)">Re-Sent To Lab (QC Failed)</option>
        <option value="Ready">Ready</option>
        {/* <option value="Called & Answered">Called & Answered</option>
        <option value="Called & Not-Answered">Called & Not-Answered</option> */}
        <option value="Delivered To Customer">Delivered To Customer</option>
      </select>






      <input
        type="date"
        value={trackFilterDate}
        onChange={(e) => setTrackFilterDate(e.target.value)}
      />

      <select
        value={trackFilterMonth}
        onChange={(e) => setTrackFilterMonth(e.target.value)}
      >
        <option value="">Month</option>
        {[...Array(12)].map((_, i) => (
          <option key={i} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </select>

      <input
        type="number"
        placeholder="Year"
        value={trackFilterYear}
        onChange={(e) => setTrackFilterYear(e.target.value)}
      />
    </div>

    {/* TABLE */}
    <div className="track-table-wrap">
      <table className="track-table">
        <thead>
          <tr>
            <th>Invoice</th>
            <th>Contact No</th>
            <th>Customer</th>
            <th>Status</th>
            <th>Latest Date</th>
            <th>WhatsApp</th>
            <th>New Status</th>
            <th>Date</th>
            <th>Save</th>
          </tr>
        </thead>

        <tbody>
          {filteredTrackInvoices.map((inv) => {
            const track = trackDataMap[inv.id];

            /* BUILD STATUS HISTORY ARRAY */
            const history = [];

            if (track?.totalSteps) {
              for (let i = 1; i <= track.totalSteps; i++) {
                if (track[`status${i}`]) {
                  history.push({
                    status: ` ${track[`status${i}`]} `,
                    date: ` ${track[`date${i}`]} `,
                  });
                }
              }
            }

            // Function to get color for status
      const getStatusColor = (status) => {
  const trimmedStatus = status.trim();
  
  if (trimmedStatus === "Sent To Lab" || trimmedStatus === "Sent to Lab") {
    return '#FF8C00'; // Orange
  } else if (trimmedStatus === "Ready") {
    return '#0066CC'; // Blue
  } else if (trimmedStatus === "Delivered To Customer") {
    return '#00AA00'; // Green
  }
  
  return '#000000'; // Default black
};

            return (
              <tr key={inv.id}>
                <td>{inv.invoiceNumber}</td>
                <td>{inv.customer?.tpNo || "-"}</td>
                <td>{inv.customer?.fullName}</td>

                {/* SHOW ALL STATUS HISTORY */}
                <td>
                  <div className="status-history-box">
                    {history.length > 0 ? (
                      history.map((item, index) => (
                        <div key={index} className="status-line">
                          <span className="status-count">
                            {index + 1}.
                          </span>

                          <span 
                            className="status-name"
                            style={{ 
                              color: getStatusColor(item.status),
                              fontWeight: 'bold'
                            }}
                          >
                            {item.status}
                          </span>

                          <span className="status-date">
                            {item.date}
                          </span>
                        </div>
                      ))
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                </td>

                {/* LATEST STATUS */}
                <td>{track?.latestDate || "-"}</td>

                <td>
                  {track?.latestStatus === "Ready" ? (
                    <button
                      className="whatsapp-btn"
                      onClick={() => sendWhatsAppMessage(inv)}
                    >
                      WhatsApp
                    </button>
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  <select
  id={`status-${inv.id}`}
  onChange={handleStatusChange}
>
                    <option value="">Select</option>
        <option value="Sent To Lab">Sent To Lab</option>
        <option value="Received From Lab">Received From Lab</option>
        <option value="QC - Team A">QC - Team A</option>
        <option value="QC - Team B">QC - Team B</option>
        <option value="QC - Team C">QC - Team C</option>
        <option value="QC - Team D">QC - Team D</option>

                <option value="QC - Team E">QC - Team E</option>
        <option value="QC - Team F">QC - Team F</option>
        <option value="QC - Team G">QC - Team G</option>
        <option value="QC - Team H">QC - Team H</option>
        <option value="QC - Team I">QC - Team I</option>

        <option value="QC - Team J">QC - Team J</option>
        <option value="QC - Team K">QC - Team K</option>
        <option value="QC - Team L">QC - Team L</option>
        <option value="QC - Team M">QC - Team M</option>
        <option value="QC - Team N">QC - Team N</option>

        <option value="Re-Sent To Lab (QC Failed)">Re-Sent To Lab (QC Failed)</option>
        <option value="Ready">Ready</option>
        {/* <option value="Called & Answered">Called & Answered</option>
        <option value="Called & Not-Answered">Called & Not-Answered</option> */}
                    <option value="Delivered To Customer">
                      Delivered To Customer
                    </option>
                  </select>
                </td>

                <td>
                  <input type="date" id={`date-${inv.id}`} />
                </td>

                <td>
                  <button
                    className="track-save-btn"
                    onClick={() =>
                      saveTrackStatus(
                        inv,
                        document.getElementById(`status-${inv.id}`).value,
                        document.getElementById(`date-${inv.id}`).value
                      )
                    }
                  >
                    Save
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
)}


{/************************************************ view all invoices*************************************************************/}

{selectedOption === "viewInvoice" && (
  <div className="view-invoice-container">
    <div className="view-invoice-header">
      <div>
        <h2>All Invoices</h2>
        <p className="subtitle">View, download, and manage all customer invoices</p>
      </div>
      <button className="btn-export-report" onClick={generateInvoiceSummaryReport}>
        📊 Export Summary Report
      </button>
      {/* <button
        className="btn-export-report"
        onClick={downloadUpinReceiptExcel}
      >
        📥 Download 2nd Frame Report
      </button> */}
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by invoice #, customer, phone..."
            value={invoiceSearchTerm}
            onChange={(e) => setInvoiceSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={invoiceFilterStatus}
            onChange={(e) => setInvoiceFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Payment Method:</label>
          <select
            value={invoiceFilterPaymentMethod}
            onChange={(e) => setInvoiceFilterPaymentMethod(e.target.value)}
            className="filter-select"
          >
   
            <option value="all">All</option>
          <option value="Cash">Cash</option>
          <option value="Card">Card</option>
            <option value="GiftCard">Gift Card</option>
          <option value="Bank Transfer">Bank Transfer</option>
          <option value="Deposit">Deposit</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Eye Camp:</label>
          <select
            value={invoiceFilterEyeCamp}
            onChange={(e) => setInvoiceFilterEyeCamp(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Camps</option>
            {eyeCamps.map((camp) => (
              <option key={camp.id} value={camp.id}>
                {camp.name}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={invoiceDateRange.start}
            onChange={(e) => setInvoiceDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={invoiceDateRange.end}
            onChange={(e) => setInvoiceDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetInvoiceFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllInvoices}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Invoices</div>
        <div className="summary-value">{filteredInvoices.length}</div>
      </div>
  
    </div>

    {/* Invoices Table */}
    {isLoadingInvoices ? (
      <div className="loading-spinner">Loading invoices...</div>
    ) : (
      <div className="invoice-table-container">
        <table className="invoice-table">
          <thead>
            <tr>
              <th>Invoice #</th>
              <th>Eye Camp</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Products</th>
              <th>Total Amount</th>
              {/* <th>Discount</th> */}
              <th>Total Paid</th>
              <th>Balance Due</th>
              <th>Payment Method</th>
              <th>Date</th>
              <th>Status</th>
              <th>2nd Frame</th> 
              <th>Remark</th>  
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.length === 0 ? (
              <tr>
                <td colSpan="13" style={{ textAlign: 'center', padding: '40px' }}>
                  No invoices found
                </td>
              </tr>
            ) : (
              filteredInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td className="invoice-link" onClick={() => viewInvoiceDetails(invoice)}>
                    {invoice.invoiceNumber}
                  </td>
                  <td>{invoice.eyeCamp || '-'}</td>
                  <td>{invoice.customer?.fullName || '-'}</td>
                  <td>{invoice.customer?.tpNo || '-'}</td>
                  <td>
                    <small>
                      Frame: {invoice.products?.frameModel || "-"}
                      <br />
                      Lens: {invoice.products?.highIndexLens
                        ? `${invoice.products?.highIndexLeft?.name || ""}${invoice.products?.highIndexRight?.name ? ` / ${invoice.products.highIndexRight.name}` : ""}`
                        : invoice.products?.lensModel || "-"}
                    </small>
                  </td>
                  <td className="amount">Rs. {(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                  {/* <td className="discount">Rs. {(invoice.financial?.discount || 0).toFixed(2)}</td> */}
                  <td className="paid-amount">
                    Rs. {((invoice.financial?.advancePayment || 0) ).toFixed(2)}
                    {invoice.balancePayments?.length > 0 && (
                      <small className="balance-payments-count">(+{invoice.balancePayments.length} balance payments)</small>
                    )}
                  </td>
                  <td className={`balance-due ${invoice.financial?.balanceDue <= 0 ? 'settled' : ''}`}>
                    Rs. {(invoice.financial?.balanceDue || 0).toFixed(2)}
                  </td>
                  <td>
                    <span className="payment-method-badge">{invoice.financial?.paymentMethod || '-'}</span>
                  </td>
                  <td>
                    <div className="date-cell">
                      <div>{invoice.formattedDate}</div>
                      <small>{invoice.formattedTime}</small>
                    </div>
                  </td>
                  <td>
                    <span 
                      className="status-badge" 
                      style={{ backgroundColor: invoice.statusColor }}
                    >
                      {invoice.financial?.balanceDue <= 0 ? 'Paid' : 'Pending'}
                    </span>
                  </td>
                   <td>{invoice.upinNo || "-"}</td> 
                   <td>{invoice.receiptNo || "-"}</td> 
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-edit"
                        onClick={() => openUpinReceiptEditor(invoice)}
                        title="2nd Frame Note"
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-view"
                        onClick={() => viewInvoiceDetails(invoice)}
                        title="View Details"
                      >
                        👁️
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteInvoice(invoice.id, invoice.invoiceNumber)}
                        title="Delete"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Invoice Details Modal */}
    {showInvoiceDetails && selectedInvoiceDetails && (
      <div className="modal-overlay" onClick={() => setShowInvoiceDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Invoice Details</h3>
            <button className="modal-close" onClick={() => setShowInvoiceDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Invoice Information</h4>
                <div className="detail-item">
                  <label>Invoice #:</label>
                  <span className="value">{selectedInvoiceDetails.invoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Date Created:</label>
                  <span>{selectedInvoiceDetails.formattedDate} at {selectedInvoiceDetails.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Delivery Date:</label>
                  <span>{selectedInvoiceDetails.delivery?.date || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Status:</label>
                  <span className="status-badge" style={{ backgroundColor: selectedInvoiceDetails.statusColor }}>
                    {selectedInvoiceDetails.financial?.balanceDue <= 0 ? 'Paid' : 'Pending'}
                  </span>
                </div>
              </div>

              {/* <div className="details-section">
                <h4>Customer Information</h4>
                <div className="detail-item">
                  <label>Name:</label>
                  <span>{selectedInvoiceDetails.customer?.fullName || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone:</label>
                  <span>{selectedInvoiceDetails.customer?.tpNo || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone No - 2:</label>
                  <span>{selectedInvoiceDetails.customer?.email || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Address:</label>
                  <span>{selectedInvoiceDetails.customer?.address || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Age:</label>
                  <span>{selectedInvoiceDetails.customer?.age || '-'}</span>
                </div>
              </div> */}

              <div className="details-section">
  <h4>Customer Information</h4>
  <div className="detail-item">
    <label>Name:</label>
    <span>{selectedInvoiceDetails.customer?.fullName || '-'}</span>
  </div>
  <div className="detail-item">
    <label>Phone:</label>
    {editingPhone ? (
      <div className="phone-edit-container">
        <input
          type="text"
          value={tempPhoneNumber}
          onChange={(e) => setTempPhoneNumber(e.target.value)}
          className="phone-edit-input"
          placeholder="Enter phone number"
          autoFocus
        />
        <button 
          className="phone-save-btn"
          onClick={handleSavePhone}
        >
          Save
        </button>
        <button 
          className="phone-cancel-btn"
          onClick={handleCancelEditPhone}
        >
          Cancel
        </button>
      </div>
    ) : (
      <span className="phone-display">
        {selectedInvoiceDetails.customer?.tpNo || '-'}
        <button 
          className="phone-edit-icon"
          onClick={handleEditPhone}
          title="Edit phone number"
        >
          ✏️
        </button>
      </span>
    )}
  </div>
  <div className="detail-item">
    <label>Phone No - 2:</label>
    <span>{selectedInvoiceDetails.customer?.email || '-'}</span>
  </div>
  <div className="detail-item">
    <label>Address:</label>
    <span>{selectedInvoiceDetails.customer?.address || '-'}</span>
  </div>
  <div className="detail-item">
    <label>Age:</label>
    <span>{selectedInvoiceDetails.customer?.age || '-'}</span>
  </div>
</div>

              <div className="details-section">
                <h4>Products</h4>
                <div className="detail-item">
                  <label>Frame Model:</label>
                  <span>{selectedInvoiceDetails.products?.frameModel || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Frame Price:</label>
                  <span>Rs. {(selectedInvoiceDetails.products?.framePrice || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Lens Model:</label>
                  <span>{selectedInvoiceDetails.products?.lensModel || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Lens Price:</label>
                  <span>Rs. {(selectedInvoiceDetails.products?.lensPrice || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Brand:</label>
                  <span>{selectedInvoiceDetails.products?.brand || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Colour:</label>
                  <span>{selectedInvoiceDetails.products?.colour || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Payment Details</h4>
                <div className="detail-item">
                  <label>Subtotal:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.subtotal || 0).toFixed(2)}</span>
                </div>
    <div className="detail-item">
                  <label>Discount:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.calculatedDiscount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Total Amount:</label>
                  <span className="paid-amount">Rs. {(selectedInvoiceDetails.financial?.totalAmount || 0).toFixed(2)}</span>
                </div>
                {/* <div className="detail-item">
                  <label>Advance Payment:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.advancePayment || 0).toFixed(2)}</span>
                </div> */}
                {selectedInvoiceDetails.balancePayments?.length > 0 && (
                  <>
                    <div className="detail-item">
                      <label>Balance Payments:</label>
                      <span>Rs. {selectedInvoiceDetails.totalBalancePaid.toFixed(2)}</span>
                    </div>
                    <div className="balance-payments-list">
                      <label>Payment History:</label>
                      {selectedInvoiceDetails.balancePayments.map((payment, idx) => (
                        <div key={idx} className="payment-history-item">
                          <small>{new Date(payment.date).toLocaleDateString()}</small>
                          <small>{payment.method}</small>
                          <small>Rs. {payment.amount.toFixed(2)}</small>
                          <small className="payment-invoice">{payment.invoiceNumber}</small>
                        </div>
                      ))}
                    </div>
                  </>
                )}
                <div className="detail-item">
                  <label>Balance Due:</label>
                  <span className={`remaining ${selectedInvoiceDetails.financial?.balanceDue <= 0 ? 'settled' : ''}`}>
                    Rs. {(selectedInvoiceDetails.financial?.balanceDue || 0).toFixed(2)}
                  </span>
                </div>
                <div className="detail-item">
                  <label>Payment Method:</label>
                  <span>{selectedInvoiceDetails.financial?.paymentMethod || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Prescription</h4>

                <div className="prescription-details">
                  <div className="eye-details">
                    <strong>Right Eye (OD)</strong>
                  
                    <div>SPH: {selectedInvoiceDetails.prescription?.rightEye?.sph || '-'}</div>
                    <div>CYL: {selectedInvoiceDetails.prescription?.rightEye?.cyl || '-'}</div>
                    <div>AXIS: {selectedInvoiceDetails.prescription?.rightEye?.axis || '-'}</div>
                    <div>ADD: {selectedInvoiceDetails.prescription?.rightEye?.add || '-'}</div>
                    <div>R-VA: {selectedInvoiceDetails.prescription?.rightEye?.visualAcuity || '-'}</div>
                    <div>R-PD: {selectedInvoiceDetails.prescription?.pd || '-'}</div>
                    <div>R-SH: {selectedInvoiceDetails.prescription?.sh || '-'}</div>

                  </div>
                  <div className="eye-details">
                    <strong>Left Eye (OS)</strong>
                
                    <div>SPH: {selectedInvoiceDetails.prescription?.leftEye?.sph || '-'}</div>
                    <div>CYL: {selectedInvoiceDetails.prescription?.leftEye?.cyl || '-'}</div>
                    <div>AXIS: {selectedInvoiceDetails.prescription?.leftEye?.axis || '-'}</div>
                    <div>ADD: {selectedInvoiceDetails.prescription?.leftEye?.add || '-'}</div>
                    <div>L-VA: {selectedInvoiceDetails.prescription?.leftEye?.visualAcuity || '-'}</div>
                     <div>L-PD: {selectedInvoiceDetails.prescription?.lpd || '-'}</div>
                      <div>L-SH: {selectedInvoiceDetails.prescription?.lsh || '-'}</div>

                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              className="btn-delete" 
              onClick={() => {
                deleteInvoice(selectedInvoiceDetails.id, selectedInvoiceDetails.invoiceNumber);
                setShowInvoiceDetails(false);
              }}
            >
              🗑️ Delete
            </button>
            <button className="btn-close" onClick={() => setShowInvoiceDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}

    {/* UPIN + RECEIPT MODAL */}
    {showUpinReceiptModal && (
      <div className="modal-overlay" onClick={() => setShowUpinReceiptModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "500px" }}>
          <div className="modal-header">
            <h3>Update 2nd Frame Note & Remark</h3>
            <button className="modal-close" onClick={() => setShowUpinReceiptModal(false)}>×</button>
          </div>

          <div className="modal-body">
            <div className="detail-item">
              <label>Invoice No</label>
              <input
                type="text"
                value={selectedInvoiceForEdit?.invoiceNumber || ""}
                disabled
                className="filter-input"
              />
            </div>

            <div className="detail-item" style={{ marginTop: "15px" }}>
              <label>2nd Frame Note</label>
              <input
                type="text"
                value={upinNo}
                onChange={(e) => setUpinNo(e.target.value)}
                placeholder="2nd Frame Note Here.."
                className="filter-input"
              />
            </div>

            <div className="detail-item" style={{ marginTop: "15px" }}>
              <label>Remark</label>
              <input
                type="text"
                value={receiptNo}
                onChange={(e) => setReceiptNo(e.target.value)}
                placeholder="Remark"
                className="filter-input"
              />
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-download" onClick={saveUpinAndReceipt}>💾 Save</button>
            <button className="btn-close" onClick={() => setShowUpinReceiptModal(false)}>Cancel</button>
          </div>
        </div>
      </div>
    )}
  </div>
)}




{/******************************************************* View All Balance Invoices ********************************************************/}

{selectedOption === "viewBalanceInvoice" && (
  <div className="view-balance-container">
    <div className="view-balance-header">
      <div>
        <h2>Balance Invoices</h2>
        <p className="subtitle">View, download, and manage all balance invoices</p>
      </div>
      <button className="btn-export-report" onClick={generateBalanceSummaryReport}>
        📊 Export Summary Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by invoice #, customer..."
            value={balanceInvoiceSearchTerm}
            onChange={(e) => setBalanceInvoiceSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={balanceInvoiceFilterStatus}
            onChange={(e) => setBalanceInvoiceFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="settled">Settled</option>
            <option value="partial">Partial Payment</option>
          </select>
        </div>

        <button className="btn-reset" onClick={resetBalanceFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllBalanceInvoices}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Balance Invoices</div>
        <div className="summary-value">{filteredBalanceInvoices.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Amount Paid</div>
        <div className="summary-value">
          Rs. {filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.paidAmount || 0), 0).toFixed(2)}
        </div>
      </div>

      <div className="summary-card">
        <div className="summary-title">Settled</div>
        <div className="summary-value">
          {filteredBalanceInvoices.filter(inv => inv.remainingBalance <= 0).length}
        </div>
      </div>
    </div>

    {/* Balance Invoices Table */}
    {isLoadingBalanceInvoices ? (
      <div className="loading-spinner">Loading balance invoices...</div>
    ) : (
      <div className="balance-table-container">
        <table className="balance-table">
          <thead>
            <tr>
              <th>Balance Invoice #</th>
              <th>Original Invoice #</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Paid Amount</th>
              <th>Remaining Balance</th>
              <th>Payment Method</th>
              <th>Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredBalanceInvoices.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                  No balance invoices found
                </td>
              </tr>
            ) : (
              filteredBalanceInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td className="invoice-link" onClick={() => viewBalanceInvoiceDetails(invoice)}>
                    {invoice.balanceInvoiceNumber}
                  </td>
                  <td>{invoice.originalInvoiceNumber}</td>
                  <td>{invoice.customerName || '-'}</td>
                  <td>{invoice.customerPhone || '-'}</td>
                  <td className="amount-paid">Rs. {(invoice.paidAmount || 0).toFixed(2)}</td>
                  <td className={`remaining-amount ${invoice.remainingBalance <= 0 ? 'settled' : ''}`}>
                    Rs. {(invoice.remainingBalance || 0).toFixed(2)}
                  </td>
                  <td>
                    <span className="payment-method-badge">{invoice.paymentMethod}</span>
                  </td>
                  <td>
                    <div className="date-cell">
                      <div>{invoice.formattedDate}</div>
                      <small>{invoice.formattedTime}</small>
                    </div>
                  </td>
                  <td>
                    <span 
                      className="status-badge" 
                      style={{ backgroundColor: invoice.statusColor }}
                    >
                      {invoice.statusText}
                    </span>
                  </td>

                  <td>
                    <div className="action-buttons">

       


                      <button
                        className="btn-view"
                        onClick={() => viewBalanceInvoiceDetails(invoice)}
                        title="View Details"
                      >
                        👁️
                      </button>
                      <button
                        className="btn-download"
                        onClick={() => downloadBalanceInvoicePDF(invoice)} 
                        title="Download PDF"
                      >
                        📄
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteBalanceInvoice(invoice.id, invoice.balanceInvoiceNumber)}
                        title="Delete"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Balance Invoice Details Modal */}
{/* Balance Invoice Details Modal - Add UPIN & Receipt fields */}
    {showBalanceInvoiceDetails && selectedBalanceInvoice && (
      <div className="modal-overlay" onClick={() => setShowBalanceInvoiceDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Balance Invoice Details</h3>
            <button className="modal-close" onClick={() => setShowBalanceInvoiceDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Invoice Information</h4>
                <div className="detail-item">
                  <label>Balance Invoice #:</label>
                  <span className="value">{selectedBalanceInvoice.balanceInvoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Original Invoice #:</label>
                  <span>{selectedBalanceInvoice.originalInvoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Date Created:</label>
                  <span>{selectedBalanceInvoice.formattedDate} at {selectedBalanceInvoice.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Status:</label>
                  <span className="status-badge" style={{ backgroundColor: selectedBalanceInvoice.statusColor }}>
                    {selectedBalanceInvoice.statusText}
                  </span>
                </div>
              </div>

              <div className="details-section">
                <h4>Customer Information</h4>
                <div className="detail-item">
                  <label>Customer Name:</label>
                  <span>{selectedBalanceInvoice.customerName || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone Number:</label>
                  <span>{selectedBalanceInvoice.customerPhone || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Payment Details</h4>
                <div className="detail-item">
                  <label>Original Amount:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalAmount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Previous Advance:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalAdvance || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Previous Balance:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalBalance || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Amount Paid:</label>
                  <span className="paid-amount">Rs. {(selectedBalanceInvoice.paidAmount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Payment Method:</label>
                  <span>{selectedBalanceInvoice.paymentMethod}</span>
                </div>
                <div className="detail-item">
                  <label>Remaining Balance:</label>
                  <span className={`remaining ${selectedBalanceInvoice.remainingBalance <= 0 ? 'settled' : ''}`}>
                    Rs. {(selectedBalanceInvoice.remainingBalance || 0).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              className="btn-download" 
              onClick={() => downloadBalanceInvoicePDF(selectedBalanceInvoice)}
            >
              📄 Download PDF
            </button>
            <button 
              className="btn-delete" 
              onClick={() => {
                deleteBalanceInvoice(selectedBalanceInvoice.id, selectedBalanceInvoice.balanceInvoiceNumber);
                setShowBalanceInvoiceDetails(false);
              }}
            >
              🗑️ Delete
            </button>
            <button className="btn-close" onClick={() => setShowBalanceInvoiceDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}

  </div>
)}









{/***********************************************  view all consultation ********************************************/}


{selectedOption === "viewConsultation" && (
  <div className="consultation-container">
    <div className="consultation-header">
      <div>
        <h2>Consultations</h2>
        <p className="subtitle">View and manage all patient consultations</p>
      </div>
      <button className="btn-export-report" onClick={generateConsultationReportPDF}>
        📊 Export Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by customer name..."
            value={consultationSearchTerm}
            onChange={(e) => setConsultationSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={consultationFilterStatus}
            onChange={(e) => setConsultationFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="completed">Completed</option>
            <option value="pending">Pending</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={consultationDateRange.start}
            onChange={(e) => setConsultationDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={consultationDateRange.end}
            onChange={(e) => setConsultationDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetConsultationFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllConsultations}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Consultations</div>
        <div className="summary-value">{filteredConsultations.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Revenue</div>
        <div className="summary-value">
          Rs. {filteredConsultations.reduce((sum, c) => sum + c.totalAmount, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Completed</div>
        <div className="summary-value">
          {filteredConsultations.filter(c => c.pendingItems === 0 && c.cancelledItems === 0).length}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Pending</div>
        <div className="summary-value">
          {filteredConsultations.filter(c => c.pendingItems > 0).length}
        </div>
      </div>
    </div>

    {/* Consultations Table */}
    {isLoadingConsultations ? (
      <div className="loading-spinner">Loading consultations...</div>
    ) : (
      <div className="consultation-table-container">
        <table className="consultation-table">
          <thead>
            <tr>
              <th>Date & Time</th>
              <th>Customer Name</th>
              <th>Delivery Date</th>
              <th>Items</th>
              <th>Total Amount</th>
              <th>Completed</th>
              <th>Pending</th>
              <th>Cancelled</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredConsultations.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                  No consultations found
                </td>
              </tr>
            ) : (
              filteredConsultations.map((consultation) => {
                const status = getStatusBadge(consultation);
                return (
                  <tr key={consultation.id}>
                    <td>
                      <div className="date-cell">
                        <div>{consultation.formattedDate}</div>
                        <small>{consultation.formattedTime}</small>
                      </div>
                    </td>
                    <td className="customer-name">{consultation.customerName}</td>
                    <td>{consultation.deliveryDate || '-'}</td>
                    <td className="text-center">{consultation.items.length}</td>
                    <td className="amount">Rs. {consultation.totalAmount.toFixed(2)}</td>
                    <td className="text-center completed">{consultation.completedItems}</td>
                    <td className="text-center pending">{consultation.pendingItems}</td>
                    <td className="text-center cancelled">{consultation.cancelledItems}</td>
                    <td>
                      <span className="status-badge" style={{ backgroundColor: status.color }}>
                        {status.text}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn-view"
                          onClick={() => {
                            setSelectedConsultation(consultation);
                            setShowConsultationDetails(true);
                          }}
                          title="View Details"
                        >
                          👁️
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => deleteConsultation(consultation.id, consultation.customerName)}
                          title="Delete"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Consultation Details Modal */}
    {showConsultationDetails && selectedConsultation && (
      <div className="modal-overlay" onClick={() => setShowConsultationDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Consultation Details</h3>
            <button className="modal-close" onClick={() => setShowConsultationDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Consultation Information</h4>
                <div className="detail-item">
                  <label>Customer Name:</label>
                  <span className="value">{selectedConsultation.customerName}</span>
                </div>
                <div className="detail-item">
                  <label>Date:</label>
                  <span>{selectedConsultation.formattedDate}</span>
                </div>
                <div className="detail-item">
                  <label>Time:</label>
                  <span>{selectedConsultation.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Delivery Date:</label>
                  <span>{selectedConsultation.deliveryDate || 'Not specified'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Summary</h4>
                <div className="detail-item">
                  <label>Total Items:</label>
                  <span>{selectedConsultation.items.length}</span>
                </div>
                <div className="detail-item">
                  <label>Total Amount:</label>
                  <span className="amount">Rs. {selectedConsultation.totalAmount.toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Completed:</label>
                  <span className="completed">{selectedConsultation.completedItems}</span>
                </div>
                <div className="detail-item">
                  <label>Pending:</label>
                  <span className="pending">{selectedConsultation.pendingItems}</span>
                </div>
                <div className="detail-item">
                  <label>Cancelled:</label>
                  <span className="cancelled">{selectedConsultation.cancelledItems}</span>
                </div>
              </div>

              <div className="details-section full-width">
                <h4>Consultation Items</h4>
                <div className="items-table-container">
                  <table className="items-table">
                    <thead>
                      <tr>
                        <th>Item Name</th>
                        <th>Price (Rs.)</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedConsultation.items.map((item) => (
                        <tr key={item.id}>
                          <td>{item.name}</td>
                          <td>Rs. {item.price.toFixed(2)}</td>
                          <td>
                            <span className={`status-badge-small ${item.status}`}>
                              {item.status}
                            </span>
                          </td>
                          <td>
                            {item.status === 'pending' && (
                              <div className="status-update-buttons">
                                <button
                                  className="btn-complete"
                                  onClick={() => {
                                    setSelectedItemForStatus(item);
                                    setNewStatus('completed');
                                    setShowUpdateStatusModal(true);
                                  }}
                                >
                                  ✓ Complete
                                </button>
                                <button
                                  className="btn-cancel"
                                  onClick={() => {
                                    setSelectedItemForStatus(item);
                                    setNewStatus('cancelled');
                                    setShowUpdateStatusModal(true);
                                  }}
                                >
                                  ✗ Cancel
                                </button>
                              </div>
                            )}
                            {item.status === 'completed' && (
                              <span className="completed-badge">✓ Completed</span>
                            )}
                            {item.status === 'cancelled' && (
                              <span className="cancelled-badge">✗ Cancelled</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-close" onClick={() => setShowConsultationDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}

    {/* Update Status Modal */}
    {showUpdateStatusModal && selectedItemForStatus && (
      <div className="modal-overlay" onClick={() => setShowUpdateStatusModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Update Item Status</h3>
            <button className="modal-close" onClick={() => setShowUpdateStatusModal(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="detail-item">
              <label>Item:</label>
              <span>{selectedItemForStatus.name}</span>
            </div>
            <div className="detail-item">
              <label>Current Status:</label>
              <span className={`status-badge-small ${selectedItemForStatus.status}`}>
                {selectedItemForStatus.status}
              </span>
            </div>
            <div className="detail-item">
              <label>New Status:</label>
              <span className={`status-badge-small ${newStatus}`}>
                {newStatus}
              </span>
            </div>
            <p className="confirmation-message">
              Are you sure you want to mark this item as {newStatus}?
            </p>
          </div>

          <div className="modal-footer">
            <button className="btn-cancel" onClick={() => setShowUpdateStatusModal(false)}>
              No, Cancel
            </button>
            <button 
              className="btn-confirm"
              onClick={() => updateConsultationItemStatus(
                selectedConsultation.id,
                selectedItemForStatus.id,
                newStatus
              )}
            >
              Yes, Update Status
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}







{/*************************************************************** Add Supplier******************************************************/}
 
 
   {selectedOption === "addSupplier" && (
  <div className="add-supplier-container">
    <div className="add-supplier-card">
      <h2>Add Supplier</h2>

      {/* Supplier Name */}
      <label>Supplier Name *</label>
      <input
        type="text"
        value={supplierName}
        onChange={(e) => setSupplierName(e.target.value)}
        placeholder="Enter supplier name"
      />

      {/* Email */}
      <label>Email</label>
      <input
        type="email"
        value={supplierEmail}
        onChange={(e) => setSupplierEmail(e.target.value)}
        placeholder="Enter email"
      />

      {/* Phone */}
      <label>Phone *</label>
      <input
        type="tel"
        value={supplierPhone}
        onChange={(e) => setSupplierPhone(e.target.value)}
        placeholder="Enter phone number"
      />

      {/* Company */}
      <label>Company *</label>
      <input
        type="text"
        value={supplierCompany}
        onChange={(e) => setSupplierCompany(e.target.value)}
        placeholder="Enter company name"
      />

      {/* Address */}
      <label>Address *</label>
      <textarea
        value={supplierAddress}
        onChange={(e) => setSupplierAddress(e.target.value)}
        placeholder="Enter address"
        rows="3"
      />

      {/* Buttons */}
      <button onClick={handleClearSupplier}>Clear</button>

<button onClick={handleAddSupplier} disabled={addingSupplier}>
  {addingSupplier ? "Adding..." : "Add Supplier"}
</button>

    </div>
  </div>
)}




{/******************************************************* DashBoard  *****************************************************************/}

        {selectedOption === "dashboard" && (
  <div className="dashboard-container">
    {isLoadingDashboard ? (
  <div className="dashboard-skeleton">
    <div className="skeleton-header"></div>
    <div className="skeleton-grid">
      {[1,2,3,4].map(i => <div key={i} className="skeleton-card"></div>)}
    </div>
  </div>
) : (
      <>
        {/* Header with date filters */}
        <div className="dashboard-header">
          <div>
            <h2>Dashboard</h2>
            <p className="subtitle">Welcome back! Here's your business overview</p>
          </div>
          <div className="date-filters">
<select
  value={selectedYear || new Date().getFullYear()}
  onChange={(e) => setSelectedYear(Number(e.target.value))}
  className="filter-select"
>
  <option value={2023}>2023</option>
  <option value={2024}>2024</option>
  <option value={2025}>2025</option>
  <option value={2026}>2026</option>
  <option value={2027}>2027</option>
  <option value={2028}>2028</option>
  <option value={2029}>2029</option>
  <option value={2030}>2030</option>
  <option value={2031}>2031</option>
  <option value={2032}>2032</option>
  <option value={2033}>2033</option>
  <option value={2034}>2034</option>
  <option value={2035}>2035</option>
  <option value={2036}>2036</option>
  <option value={2037}>2037</option>
</select>



<select
  value={selectedMonth || new Date().getMonth() + 1}
  onChange={(e) => setSelectedMonth(Number(e.target.value))}
  className="filter-select"
>
  <option value={1}>January</option>
  <option value={2}>February</option>
  <option value={3}>March</option>
  <option value={4}>April</option>
  <option value={5}>May</option>
  <option value={6}>June</option>
  <option value={7}>July</option>
  <option value={8}>August</option>
  <option value={9}>September</option>
  <option value={10}>October</option>
  <option value={11}>November</option>
  <option value={12}>December</option>
</select>




            <button className="btn-refresh" onClick={fetchDashboardData}>
              🔄 Refresh
            </button>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="kpi-grid">
          <div className="kpi-card revenue">
            <div className="kpi-icon">💰</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Sale</div>
              <div className="kpi-value">{formatCurrency(dashboardStats.totalRevenue)}</div>
              {/* <div className="kpi-trend positive">↑ 12% from last month</div> */}
            </div>
          </div>

                    <div className="kpi-card revenue">
            <div className="kpi-icon">💰</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Received</div>
              <div className="kpi-value">{formatCurrency(dashboardStats.totalReceived)}</div>
              {/* <div className="kpi-trend positive">↑ 12% from last month</div> */}
            </div>
          </div>
          
          <div className="kpi-card invoices">
            <div className="kpi-icon">📄</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Invoices</div>
              <div className="kpi-value">{dashboardStats.totalInvoices}</div>
              <div className="kpi-trend">Avg. {formatCurrency(dashboardStats.averageInvoiceValue)} per invoice</div>
            </div>
          </div>
          
          <div className="kpi-card patients">
            <div className="kpi-icon">👥</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Patients</div>
              <div className="kpi-value">{dashboardStats.totalPatients}</div>
              <div className="kpi-trend">Unique customers served</div>
            </div>
          </div>
          
          <div className="kpi-card pending">
            <div className="kpi-icon">⏳</div>
            <div className="kpi-content">
              <div className="kpi-label">Pending Balance</div>
              <div className="kpi-value">{formatCurrency(dashboardStats.pendingBalance)}</div>
              <div className="kpi-trend negative">Due from customers</div>
            </div>
          </div>
        </div>

        {/* Products Sold Cards */}
        <div className="products-grid">
          <div className="product-card frames">
            <div className="product-icon">👓</div>
            <div className="product-info">
              <div className="product-label">Frames Sold</div>
              <div className="product-value">{dashboardStats.framesSold}</div>
            </div>
          </div>
          {/* <div className="product-card lenses">
            <div className="product-icon">🔍</div>
            <div className="product-info">
              <div className="product-label">Lenses Sold</div>
              <div className="product-value">{dashboardStats.lensesSold}</div>
            </div>
          </div> */}
        </div>



<div className="product-panel">

  {/* HEADER */}
  <div className="product-panel-header">
  
    <h2>Available Products</h2>

    <input
      type="text"
      placeholder="Search by Model, Brand, Code..."
      value={productSearch}
      onChange={(e) => setProductSearch(e.target.value)}
      className="product-search"
    />
  </div>

  {/* TABLE */}
  <div className="product-table-wrapper">

    <table className="product-table">

      <thead>
        <tr>
          <th>Category</th>
          <th>Model / Code</th>
          <th>Brand</th>
          <th>Colour</th>
          <th>Sex</th>
          <th>Available Qty</th>
          <th>Added Qty</th>
          <th>Price</th>
        </tr>
      </thead>

      <tbody>

        {filteredProducts.length === 0 ? (
          <tr>
            <td colSpan="8" className="no-products">
              No products found
            </td>
          </tr>
        ) : (

          filteredProducts.map((p, index) => (

            <tr key={index}>

              <td>
                <span className={`category-badge ${p.category}`}>
                  {p.category}
                </span>
              </td>

              <td>{p.modelNo || p.itemCode}</td>

              <td>{p.brand || "-"}</td>

              <td>{p.colour || "-"}</td>

              <td>{p.sex || "-"}</td>

              <td className="qty-green">
                {p.qty || 0}
              </td>

              <td className="qty-dark">
                {p.supplyQty || 0}
              </td>

              <td className="price-text">
                Rs. {p.sellingPrice || 0}
              </td>

            </tr>

          ))

        )}

      </tbody>

    </table>

  </div>

</div>


        {/* Charts Section */}
        <div className="charts-grid">
          <div className="chart-card large">
            <div className="chart-header">
              <h3>Revenue Overview</h3>
            </div>
            <div className="chart-container">
              <Bar data={revenueChartData} options={revenueChartOptions} />
            </div>
          </div>
          
          <div className="chart-card">
            <div className="chart-header">
              <h3>Payment Methods</h3>
            </div>
            <div className="chart-container small">
              <Doughnut data={paymentMethodChartData} options={paymentMethodOptions} />
            </div>
          </div>
        </div>

        {/* Daily Sales Chart */}
        <div className="chart-card full-width">
          <div className="chart-header">
            <h3>Daily Sales Performance</h3>
            <p className="chart-subtitle">Sales breakdown for {new Date(selectedYear, selectedMonth - 1, 1).toLocaleString('default', { month: 'long' })} {selectedYear}</p>
          </div>
          <div className="chart-container medium">
            <Line data={dailySalesChartData} options={dailySalesOptions} />
          </div>
        </div>

        {/* Top Products & Recent Invoices */}
        <div className="two-column-grid">
          {/* Top Products */}
          <div className="info-card">
            <div className="card-header">
              <h3>🏆 Top Selling Products</h3>
            </div>
            <div className="card-body">
              {dashboardStats.topProducts.length === 0 ? (
                <div className="empty-state">No products sold yet</div>
              ) : (
                <div className="top-products-list">
                  {dashboardStats.topProducts.map((product, index) => (
                    <div key={index} className="product-item">
                      <div className="product-rank">{index + 1}</div>
                      <div className="product-name">{product.name}</div>
                      <div className="product-count">{product.count} units</div>
                      <div className="product-bar">
                        <div 
                          className="product-bar-fill" 
                          style={{ 
                            width: `${(product.count / dashboardStats.topProducts[0].count) * 100}%`,
                            backgroundColor: index === 0 ? '#4CAF50' : index === 1 ? '#2196F3' : '#FF9800'
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Recent Invoices */}
          <div className="info-card">
            <div className="card-header">
              <h3>📋 Recent Invoices</h3>
            </div>
            <div className="card-body">
              {dashboardStats.recentInvoices.length === 0 ? (
                <div className="empty-state">No recent invoices</div>
              ) : (
                <div className="recent-invoices-list">
                  {dashboardStats.recentInvoices.map((invoice, index) => (
                    <div key={index} className="invoice-item">
                      <div className="invoice-info">
                        <div className="invoice-number">{invoice.invoiceNumber}</div>
                        <div className="invoice-customer">{invoice.customerName}</div>
                        <div className="invoice-date">
                          {new Date(invoice.date).toLocaleDateString()}
                        </div>
                      </div>
                      <div className="invoice-amounts">
                        <div className="invoice-total">{formatCurrency(invoice.totalAmount)}</div>
                        <div className="invoice-paid">Paid: {formatCurrency(invoice.paidAmount)}</div>
                        {invoice.balanceDue > 0 && (
                          <div className="invoice-due">Due: {formatCurrency(invoice.balanceDue)}</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Quick Stats Footer */}
        <div className="quick-stats">
          <div className="stat-item">
            <span className="stat-label">Average Invoice Value:</span>
            <span className="stat-value">{formatCurrency(dashboardStats.averageInvoiceValue)}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Collection Rate:</span>
            <span className="stat-value">
              {((dashboardStats.totalRevenue / (dashboardStats.totalRevenue + dashboardStats.pendingBalance)) * 100).toFixed(1)}%
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Revenue per Patient:</span>
            <span className="stat-value">
              {formatCurrency(dashboardStats.totalPatients > 0 ? dashboardStats.totalRevenue / dashboardStats.totalPatients : 0)}
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Monthly Average:</span>
            <span className="stat-value">
              {formatCurrency(dashboardStats.monthlyRevenue.reduce((a, b) => a + b, 0) / 12)}
            </span>
          </div>
        </div>
      </>
    )}
  </div>
)}


{/******************************************************* view patients  *****************************************************************/}



{selectedOption === "viewPatient" && (
  <div className="patient-directory-container">
    <div className="patient-directory-header">
      <div>
        <h2>Patient Directory</h2>
        <p className="subtitle">View and manage all patient records from invoices</p>
      </div>
      <button className="btn-export-report" onClick={generatePatientReportPDF}>
        📊 Export Patient Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by name, phone, email..."
            value={patientSearchTerm}
            onChange={(e) => setPatientSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        {/* <div className="filter-group">
          <label>Age Group:</label>
          <select
            value={patientFilterAge}
            onChange={(e) => setPatientFilterAge(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Ages</option>
            <option value="child">Child (&lt; 18)</option>
            <option value="adult">Adult (18-59)</option>
            <option value="senior">Senior (60+)</option>
          </select>
        </div> */}



        <div className="filter-group">
          <label>Last Visit Range:</label>
          <input
            type="date"
            value={patientDateRange.start}
            onChange={(e) => setPatientDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={patientDateRange.end}
            onChange={(e) => setPatientDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetPatientFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllPatients}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Patients</div>
        <div className="summary-value">{filteredPatients.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Revenue</div>
        <div className="summary-value">
          Rs. {filteredPatients.reduce((sum, p) => sum + p.totalSpent, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Due</div>
        <div className="summary-value">
          Rs. {filteredPatients.reduce((sum, p) => sum + p.totalDue, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Average Spent</div>
        <div className="summary-value">
          Rs. {(filteredPatients.reduce((sum, p) => sum + p.totalSpent, 0) / (filteredPatients.length || 1)).toFixed(2)}
        </div>
      </div>
    </div>

    {/* Patients Table */}
    {isLoadingPatients ? (
      <div className="loading-spinner">Loading patients...</div>
    ) : (
      <div className="patient-table-container">
        <table className="patient-table">
          <thead>
            <tr>
              <th>Invoice No</th>
              <th>Patient Name</th>
              <th>Contact</th>
              <th>Date of Birth</th>
              <th>Total Invoices</th>
              <th>Total Spent</th>
              <th>Balance Due</th>
              <th>Last Visit</th>
              <th>Status</th>
              <th>Spectacle Tracking</th>
              <th>QC By</th>
              <th>Actions</th>
            </tr>
          </thead>
        <tbody>
  {filteredPatients.length === 0 ? (
    <tr>
      <td colSpan="11" style={{ textAlign: "center", padding: "40px" }}>
        No patients found
      </td>
    </tr>
  ) : (
    filteredPatients.map((patient) => {
      const latestInvoice =
        patient.invoices && patient.invoices.length > 0
          ? patient.invoices[patient.invoices.length - 1]
          : null;

      return (
        <tr key={patient.id}>
          <td className="invoice-number">
            {latestInvoice ? latestInvoice.invoiceNumber : "-"}   
          </td>
          <td
            className="patient-name"
            onClick={() => viewPatientDetails(patient)}
          >
            <div className="name-cell">
              <strong>{patient.fullName}</strong>
              {patient.title && <small>({patient.title})</small>}
            </div>
          </td>

          <td>
            <div className="contact-cell">
              <div>{patient.tpNo || "-"}</div>
              <small>{patient.email || "-"}</small>
            </div>
          </td>

<td>
  <div className="age-cell">
    {patient.age
      ? new Date(patient.age).toLocaleDateString("en-GB")
      : "-"}
    <small className="age-group"></small>
  </div>
</td>



          <td className="text-center">{patient.totalInvoices}</td>

          <td className="amount">
            Rs. {patient.totalSpent.toFixed(2)}
          </td>

          <td
            className={`balance-due ${
              patient.totalDue <= 0 ? "settled" : ""
            }`}
          >
            Rs. {patient.totalDue.toFixed(2)}
          </td>

          <td>
            <div className="date-cell">
              <div>
                {new Date(patient.lastVisit).toLocaleDateString()}
              </div>
              <small>
                First: {new Date(patient.firstVisit).toLocaleDateString()}
              </small>
            </div>
          </td>

          <td>
            <span
              className={`status-badge ${
                patient.totalDue <= 0 ? "paid" : "pending"
              }`}
            >
              {patient.totalDue <= 0 ? "Settled" : "Has Due"}
            </span>
          </td>

          {/* ✅ FIXED SPECTACLE TRACKING (NO invoice variable) */}
          <td>
            {latestInvoice?.spectacleTracking ? (
              <div className="tracking-status-cell">
                <span
                  className={`tracking-badge ${
                    latestInvoice.spectacleTracking?.latestStatus
                      ?.toLowerCase()
                      .includes("delivered")
                      ? "delivered"
                      : latestInvoice.spectacleTracking?.latestStatus
                          ?.toLowerCase()
                          .includes("received")
                      ? "received"
                      : "processing"
                  }`}
                >
                  {latestInvoice.spectacleTracking?.latestStatus ||
                    "No Status"}
                </span>

                <small>
                  {latestInvoice.spectacleTracking?.latestDate || "-"}
                </small>
              </div>
            ) : (
              <span className="tracking-none">No Tracking</span>
            )}
          </td>


<td>
  {latestInvoice?.qcData ? (
    <div className="qc-status-cell">
      <span className="qc-badge">
        {latestInvoice.qcData.qcPerson}
      </span>

      <small>
        {latestInvoice.qcData.qcDate} |{" "}
        {latestInvoice.qcData.qcTime}
      </small>
    </div>
  ) : (
    <span className="tracking-none">
      No QC
    </span>
  )}
</td>




<td>
  <div className="action-buttons">
    {/* <button
      className="btn-view"
      onClick={() => viewPatientDetails(patient)}
      title="View Details"
    >
      👁️
    </button> */}

    <button
      className="btn-qc"
      onClick={() => openQCModal(patient)}
      title="Quality Check"
    >
      QC
    </button>
  </div>
</td>
        </tr>
      );
    })
  )}
 </tbody>
        </table>
      </div>
    )}

    {/* Patient Details Modal */}
    {showPatientDetails && selectedPatient && (
      <div className="modal-overlay" onClick={() => setShowPatientDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Patient Details</h3>
            <button className="modal-close" onClick={() => setShowPatientDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Personal Information</h4>
                <div className="detail-item">
                  <label>Full Name:</label>
                  <span className="value">{selectedPatient.fullName}</span>
                </div>
                <div className="detail-item">
                  <label>Age:</label>
                  <span>{selectedPatient.age} years ({getAgeGroup(selectedPatient.age)})</span>
                </div>
                <div className="detail-item">
                  <label>Gender:</label>
                  <span>{selectedPatient.gender || 'Not specified'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone:</label>
                  <span>{selectedPatient.tpNo || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Email:</label>
                  <span>{selectedPatient.email || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Address:</label>
                  <span>{selectedPatient.address || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Financial Summary</h4>
                <div className="detail-item">
                  <label>Total Invoices:</label>
                  <span>{selectedPatient.totalInvoices}</span>
                </div>
                <div className="detail-item">
                  <label>Total Spent:</label>
                  <span className="amount">Rs. {selectedPatient.totalSpent.toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Total Paid:</label>
                  <span className="paid-amount">Rs. {selectedPatient.totalPaid.toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Balance Due:</label>
                  <span className={`balance-due ${selectedPatient.totalDue <= 0 ? 'settled' : ''}`}>
                    Rs. {selectedPatient.totalDue.toFixed(2)}
                  </span>
                </div>
                <div className="detail-item">
                  <label>First Visit:</label>
                  <span>{new Date(selectedPatient.firstVisit).toLocaleDateString()}</span>
                </div>
                <div className="detail-item">
                  <label>Last Visit:</label>
                  <span>{new Date(selectedPatient.lastVisit).toLocaleDateString()}</span>
                </div>
              </div>

              <div className="details-section full-width">
                <h4>Invoice History</h4>
                <div className="invoice-history-table">
                  <table className="mini-table">
                    <thead>
                      <tr>
                        <th>Invoice #</th>
                        <th>Date</th>
                        <th>Frame</th>
                        <th>Lens</th>
                        <th>Total</th>
                        <th>Paid</th>
                        <th>Balance</th>
                        <th>Status</th>
                        <th>Spectacle Tracking</th>
                        <th>QC</th>
                      
                      </tr>
                    </thead>
                    <tbody>
                      {selectedPatient.invoices.map((invoice, idx) => (
                        <tr key={idx}>
                          <td className="invoice-link">{invoice.invoiceNumber}</td>
                          <td>{new Date(invoice.date).toLocaleDateString()}</td>
                          <td>{invoice.products?.frameModel || '-'}</td>
                          <td>{invoice.products?.lensModel || '-'}</td>
                          <td>Rs. {invoice.totalAmount.toFixed(2)}</td>
                          <td>Rs. {invoice.paidAmount.toFixed(2)}</td>
                          <td className={invoice.balanceDue > 0 ? 'balance-due' : 'settled'}>
                            Rs. {invoice.balanceDue.toFixed(2)}
                          </td>
                          <td>
                            <span className={`status-badge ${invoice.status}`}>
                              {invoice.status === 'paid' ? 'Paid' : 'Pending'}
                            </span>
                          </td>


 <td>
  {invoice.spectacleTracking ? (
    <div className="tracking-status-cell">
      <span
        className={`tracking-badge ${
          invoice.spectacleTracking?.latestStatus
            ?.toLowerCase()
            .includes("delivered")
            ? "delivered"
            : invoice.spectacleTracking?.latestStatus
                ?.toLowerCase()
                .includes("received")
            ? "received"
            : "processing"
        }`}
      >
        {invoice.spectacleTracking?.latestStatus || "No Status"}
      </span>

      <small>
        {invoice.spectacleTracking?.latestDate || "-"}
      </small>
    </div>
  ) : (
    <span className="tracking-none">
      No Tracking
    </span>
  )}
 </td>


<td>
  {invoice.qcData ? (
    <div className="qc-status-cell">
      <span className="qc-badge">
        {invoice.qcData.qcPerson}
      </span>

      <small>
        {invoice.qcData.qcDate} | {invoice.qcData.qcTime}
      </small>
    </div>
  ) : (
    <span className="tracking-none">
      No QC
    </span>
  )}
</td>


                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {selectedPatient.prescriptions && selectedPatient.prescriptions.length > 0 && (
                <div className="details-section full-width">
                  <h4>Latest Prescription</h4>
                  <div className="prescription-grid">
                    <div className="eye-prescription">
                      <strong>Right Eye (OD)</strong>
                      <div>VA: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.visualAcuity || '-'}</div>
                      <div>SPH: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.sph || '-'}</div>
                      <div>CYL: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.cyl || '-'}</div>
                      <div>AXIS: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.axis || '-'}</div>
                      <div>ADD: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.add || '-'}</div>
                    </div>
                    <div className="eye-prescription">
                      <strong>Left Eye (OS)</strong>
                      <div>VA: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.visualAcuity || '-'}</div>
                      <div>SPH: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.sph || '-'}</div>
                      <div>CYL: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.cyl || '-'}</div>
                      <div>AXIS: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.axis || '-'}</div>
                      <div>ADD: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.add || '-'}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-close" onClick={() => setShowPatientDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}








{/* QC MODAL */}
{showQCModal && selectedQCPatient && (
  <div
    className="modal-overlay"
    onClick={() => setShowQCModal(false)}
  >
    <div
      className="modal-content qc-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-header">
        <h3>Patient QC Entry</h3>

        <button
          className="modal-close"
          onClick={() => setShowQCModal(false)}
        >
          ×
        </button>
      </div>

      <div className="modal-body">
        <div className="detail-item">
          <label>Patient</label>
          <input
            type="text"
            value={selectedQCPatient.fullName}
            disabled
            className="filter-input"
          />
        </div>

        <div className="detail-item">
          <label>QC By</label>

          <select
            value={qcForm.qcPerson}
            onChange={(e) =>
              setQcForm({
                ...qcForm,
                qcPerson: e.target.value
              })
            }
            className="filter-select"
          >
            


         <option value="">
            Select QC 
          </option>

    <option value="">
      Team A
    </option>


    <option value="Team B">
      Team B
    </option>


    <option value="Team C">
      Team C
    </option>


    <option value="Team D">
      Team D
    </option>

     <option value="Team E">
      Team E
    </option>


    <option value="Team F">
      Team F
    </option>


    <option value="Team G">
      Team G
    </option>


    <option value="Team H">
      Team H
    </option>


    <option value="Team I">
      Team I
    </option>


    <option value="Team J">
      Team J
    </option>


    <option value="Team K">
      Team K
    </option>


    <option value="Team L">
      Team L
    </option>

    <option value="Team M">
      Team M
    </option>


    <option value="Team N">
      Team N
    </option>


          </select>
        </div>

        <div className="detail-item">
          <label>Date</label>

          <input
            type="date"
            value={qcForm.qcDate}
            onChange={(e) =>
              setQcForm({
                ...qcForm,
                qcDate: e.target.value
              })
            }
            className="filter-date"
          />
        </div>

        <div className="detail-item">
          <label>Time</label>

          <input
            type="text"
            value={qcForm.qcTime}
            disabled
            className="filter-input"
          />
        </div>
      </div>

      <div className="modal-footer">
        <button
          className="btn-close"
          onClick={() => setShowQCModal(false)}
        >
          Cancel
        </button>

        <button
        
          className="btn-save"
          onClick={saveQC}
        >
          Save QC
        </button>
      </div>
    </div>
  </div>
)}




  </div>
)}



{/******************************************************* create Invoice *****************************************************************/}


{selectedOption === "createInvoice" && (

    <>
      {showSuccess && (
        <div className="toast-notification">
          ✓ Order saved successfully! Total: ${totalAmount.toFixed(2)}
        </div>
      )}
      
      <div className="invoice-wrap">
        <div className="invoice-header">
          <h2>Create Order Form</h2>
          <p className="invoice-subtitle">Fill in all required fields (*) to generate order</p>
          <div className="invoice-number-display">Next Invoice: {currentInvoiceNumber}</div>
        </div>

        <div className="invoice-content">

{/********************************************select eye camp is involving ***********************************************************/}

<div className="detail-item">
  <label>Select Eye Camp (Optional)</label>
  <select
    value={selectedEyeCamp}
    onChange={(e) => setSelectedEyeCamp(e.target.value)}
    className="form-control"
    style={{ width: '100%' }}
  >
    <option value="-">-- No Eye Camp --</option>
    {eyeCamps.map(camp => (
      <option key={camp.id} value={camp.name}>
        {camp.name} - {camp.city}
      </option>
    ))}
  </select>
</div>




<div style={{ marginTop: "15px" }}>

  <label style={{ marginRight: "10px" }}>
    Sales Person:
  </label>


  <select
    value={selectedSalesPerson}
    onChange={handleSalesPersonSelect}
  >

    <option value="">
      Please select sales person
    </option>


    <option value="Team A">
      Team A
      {verifiedSalesPerson === 'Team A' && ' ✅'}
    </option>


    <option value="Team B">
      Team B
      {verifiedSalesPerson === 'Team B' && ' ✅'}
    </option>


    <option value="Team C">
      Team C
      {verifiedSalesPerson === 'Team C' && ' ✅'}
    </option>


    <option value="Team D">
      Team D
      {verifiedSalesPerson === 'Team D' && ' ✅'}
    </option>

    <option value="Team E">
      Team E
      {verifiedSalesPerson === 'Team E' && ' ✅'}
    </option>


    <option value="Team F">
      Team F
      {verifiedSalesPerson === 'Team F' && ' ✅'}
    </option>


    <option value="Team G">
      Team G
      {verifiedSalesPerson === 'Team G' && ' ✅'}
    </option>


    <option value="Team H">
      Team H
      {verifiedSalesPerson === 'Team H' && ' ✅'}
    </option>


    <option value="Team I">
      Team I
      {verifiedSalesPerson === 'Team I' && ' ✅'}
    </option>


    <option value="Team J">
      Team J
      {verifiedSalesPerson === 'Team J' && ' ✅'}
    </option>


    <option value="Team K">
      Team K
      {verifiedSalesPerson === 'Team K' && ' ✅'}
    </option>


    <option value="Team L">
      Team L
      {verifiedSalesPerson === 'Team L' && ' ✅'}
    </option>

    <option value="Team M">
      Team M
      {verifiedSalesPerson === 'Team M' && ' ✅'}
    </option>


    <option value="Team N">
      Team N
      {verifiedSalesPerson === 'Team N' && ' ✅'}
    </option>

  </select>


  {verifiedSalesPerson && (

    <span
      style={{
        marginLeft: '10px',
        color: 'green',
        fontSize: '14px'
      }}
    >
      ✅ Verified: {verifiedSalesPerson}
    </span>

  )}

</div>


{/* PASSWORD MODAL */}

{isPasswordModalOpen && (

<div
style={{
 position:'fixed',
 top:0,
 left:0,
 right:0,
 bottom:0,
 backgroundColor:'rgba(0,0,0,0.5)',
 display:'flex',
 justifyContent:'center',
 alignItems:'center',
 zIndex:1000
}}
>


<div
style={{
 backgroundColor:'white',
 padding:'30px',
 borderRadius:'10px',
 width:'400px'
}}
>


<h3>
🔐 Verify Password for {modalPerson}
</h3>


<input
type="password"
value={enteredPassword}
onChange={(e)=>setEnteredPassword(e.target.value)}
placeholder="Enter password"

onKeyDown={(e)=>{
 if(e.key==="Enter"){
   handlePasswordSubmit();
 }
}}

style={{
 width:'100%',
 padding:'10px',
 marginBottom:'10px',
 fontSize:'16px'
}}
/>


{passwordError && (

<div
style={{
 color:'red',
 marginBottom:'10px'
}}
>
{passwordError}
</div>

)}


<div
style={{
display:'flex',
gap:'10px'
}}
>


<button
onClick={handlePasswordSubmit}
style={{
flex:1,
padding:'10px',
background:'#4CAF50',
color:'white',
border:'none'
}}
>
✅ Verify
</button>


<button
onClick={handleModalClose}
style={{
flex:1,
padding:'10px',
background:'#f44336',
color:'white',
border:'none'
}}
>
❌ Cancel
</button>


</div>


</div>

</div>

)}




        

<div className="invoice-section">
  <div className="section-header">
    <h3>Customer Information</h3>
    <span className="section-badge">Required</span>
  </div>

  {/* Customer Search Bar */}
  <div className="customer-search-container" style={{ marginBottom: '15px' }}>
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
      <div style={{ flex: 1, minWidth: '200px', position: 'relative' }}>
        <input
          type="text"
          placeholder="🔍 Search existing customer (Name or Phone)"
          value={customerSearchTerm}
          onChange={(e) => {
            setCustomerSearchTerm(e.target.value);
            searchExistingCustomer(e.target.value);
            setShowCustomerSearch(true);
          }}
          onFocus={() => setShowCustomerSearch(true)}
          onBlur={() => {
            // Delay hiding to allow click on results
            setTimeout(() => setShowCustomerSearch(false), 200);
          }}
          style={{
            width: '100%',
            padding: '10px 15px',
            border: '2px solid #d0d8e8',
            borderRadius: '8px',
            fontSize: '14px',
            backgroundColor: '#f8f9fa'
          }}
        />
        {isSearchingCustomer && (
          <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
            ⏳
          </span>
        )}
        
        {/* Search Results Dropdown */}
        {showCustomerSearch && searchResults.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #d0d8e8',
            borderRadius: '8px',
            maxHeight: '200px',
            overflowY: 'auto',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            marginTop: '4px'
          }}>
            {searchResults.map((result, index) => (
              <div
                key={index}
                onMouseDown={(e) => e.preventDefault()} // Prevent blur
                onClick={() => selectExistingCustomer(result)}
                style={{
                  padding: '10px 15px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f0f0f0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                <div>
                  <strong>{result.customer.fullName || `${result.customer.firstName} ${result.customer.lastName}`}</strong>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    📞 {result.customer.tpNo}
                  </div>
                </div>
                <button
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={(e) => {
                    e.stopPropagation();
                    selectExistingCustomer(result);
                  }}
                  style={{
                    padding: '5px 12px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  Select
                </button>
              </div>
            ))}
          </div>
        )}
        
        {showCustomerSearch && customerSearchTerm && searchResults.length === 0 && !isSearchingCustomer && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #d0d8e8',
            borderRadius: '8px',
            padding: '15px',
            textAlign: 'center',
            color: '#666',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            marginTop: '4px'
          }}>
            No existing customer found. Enter new details below.
          </div>
        )}
      </div>
      
      {isEditingCustomer && (
        <button
          onClick={resetCustomerForm}
          style={{
            padding: '8px 16px',
            backgroundColor: '#ff9800',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
            whiteSpace: 'nowrap'
          }}
        >
          ✏️ New Customer
        </button>
      )}
      
      {existingCustomerData && (
        <span style={{
          fontSize: '13px',
          color: '#4CAF50',
          fontWeight: '500',
          backgroundColor: '#e8f5e9',
          padding: '5px 12px',
          borderRadius: '20px',
          whiteSpace: 'nowrap'
        }}>
          ✓ Editing existing customer
        </span>
      )}
    </div>
  </div>

  {/* Customer Form */}
  <div className="form-row">
    <div className="form-group">
      <label>Title</label>
      <select 
        className="form-control"
        name="title"
        value={formData.title}
        onChange={handleInputChange}
      >
        <option value="">Select</option>
        <option value="Mr">Mr.</option>
        <option value="Mrs">Mrs.</option>
        <option value="Ms">Ms.</option>
        <option value="Baby">Baby</option>
        <option value="Baby">Master</option>
        <option value="Dr">Dr.</option>
        <option value="Rev">Rev.</option>
      </select>
    </div>

    <div className="form-group">
      <label>First Name <span className="required-star">*</span></label>
      <input 
        type="text" 
        name="firstName"
        value={formData.firstName}
        onChange={handleInputChange}
        placeholder="Enter first name"
        className={errors.firstName ? 'error-input' : ''}
      />
      {errors.firstName && <span className="error-message">{errors.firstName}</span>}
    </div>
    
    <div className="form-group">
      <label>Last Name <span className="required-star">*</span></label>
      <input 
        type="text" 
        name="lastName"
        value={formData.lastName}
        onChange={handleInputChange}
        placeholder="Enter last name"
        className={errors.lastName ? 'error-input' : ''}
      />
      {errors.lastName && <span className="error-message">{errors.lastName}</span>}
    </div>
  </div>
  
  <div className="form-row">
    <div className="form-group">
      <label>Address <span className="required-star">*</span></label>
      <input 
        type="text" 
        name="address"
        value={formData.address}
        onChange={handleInputChange}
        placeholder="Street, city, postal code"
        className={errors.address ? 'error-input' : ''}
      />
      {errors.address && <span className="error-message">{errors.address}</span>}
    </div>
    
    <div className="form-group">
      <label>TP No <span className="required-star">*</span></label>
      <input 
        type="tel" 
        name="tpNo"
        value={formData.tpNo}
        onChange={handleInputChange}
        placeholder="Phone number"
        className={errors.tpNo ? 'error-input' : ''}
      />
      {errors.tpNo && <span className="error-message">{errors.tpNo}</span>}
    </div>
    
    <div className="form-group">
      <label>TP No 2</label>
      <input 
        type="tel"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        placeholder="Telephone number - 2"
      />
    </div>
    
    <div className="form-group">
      <label>Date of Birth <span className="required-star">*</span></label>
      <input 
        type="date" 
        name="age"
        value={formData.age}
        onChange={handleInputChange}
        className={errors.age ? 'error-input' : ''}
      />
      {errors.age && <span className="error-message">{errors.age}</span>}
    </div>
  </div>
</div>








          {/* Prescription */}
          <div className="invoice-section">
            <div className="section-header">
              <h3>Optical Prescription</h3>
              <span className="section-badge">Eye Details</span>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Date</label>
                <input 
                  type="date" 
                  name="prescriptionDate"
                  value={formData.prescriptionDate}
                  onChange={handleInputChange}
                />
              </div>
              
<div className="form-group">
  <label>Referred By</label>
  <select
    name="referredBy"
    value={formData.referredBy}
    onChange={handleInputChange}
  >
    <option value="">-- Select Referrer --</option>

    <option value="Own">Own</option>
    <option value="Other">Other</option>



  </select>
</div>


              <div className="form-group">
                <label>R - PD:</label>
                  <input
                    type="text"
                    name="pd"
                    value={formData.pd}
                    onChange={handleInputChange}
                    placeholder="PD"
                    required
                  />
                  </div>


              <div className="form-group">
                <label>L - PD:</label>
                  <input
                    type="text"
                    name="lpd"
                    value={formData.lpd}
                    onChange={handleInputChange}
                    placeholder="L-PD"
                    required
                  />
                  </div>




              <div className="form-group">
                <label>R-SH:</label>
                  <input
                    type="text"
                    name="sh"
                    value={formData.sh}
                    onChange={handleInputChange}
                    placeholder="SH"
                    />
                  </div>


           <div className="form-group">
                <label>L-SH:</label>
                  <input
                    type="text"
                    name="lsh"
                    value={formData.lsh}
                    onChange={handleInputChange}
                    placeholder="L-SH"
                    />
                  </div>
               </div>






            <div className="prescription-grid">
              {/* Right Eye */}
              <div className="eye-section">
                <h4>Right Eye (OD)</h4>

                <div className="eye-field-group">
                  <label>Visual Acuity</label>
                  <select 
                    className="form-control"
                    name="rightVisualAcuity"
                    value={formData.rightVisualAcuity}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="6/6">6/6</option>
                    <option value="6/9">6/9</option>
                    <option value="6/12">6/12</option>
                    <option value="6/18">6/18</option>
                    <option value="6/24">6/24</option>
                    <option value="6/36">6/36</option>
                    <option value="6/60">6/60</option>  
                  </select>
                </div>

                <div className="eye-fields">
                  <div className="eye-field-group">
                    <label>Distance</label>
                    <div className="presc-inputs">

  
                      {/* Right SPH */}
                          <input 
                        type="text" 
                        name="rightSph"
                        value={formData.rightSph}
                        onChange={handleInputChange}
                        placeholder="SPH"
                           style={{ width: '100px' }}
                      />


                      {/* Right CYL */}
<div className="eye-field-group">
  <label>CYL</label>
  <select 
    name="rightCyl"
    value={formData.rightCyl}
    onChange={handleInputChange}
    style={{ width: '100px' }}
  >
    <option value="">Select CYL</option>
    {/* Negative values from -6.00 to -0.25 */}
    <option value="-6.00">-6.00</option>
    <option value="-5.75">-5.75</option>
    <option value="-5.50">-5.50</option>
    <option value="-5.25">-5.25</option>
    <option value="-5.00">-5.00</option>
    <option value="-4.75">-4.75</option>
    <option value="-4.50">-4.50</option>
    <option value="-4.25">-4.25</option>
    <option value="-4.00">-4.00</option>
    <option value="-3.75">-3.75</option>
    <option value="-3.50">-3.50</option>
    <option value="-3.25">-3.25</option>
    <option value="-3.00">-3.00</option>
    <option value="-2.75">-2.75</option>
    <option value="-2.50">-2.50</option>
    <option value="-2.25">-2.25</option>
    <option value="-2.00">-2.00</option>
    <option value="-1.75">-1.75</option>
    <option value="-1.50">-1.50</option>
    <option value="-1.25">-1.25</option>
    <option value="-1.00">-1.00</option>
    <option value="-0.75">-0.75</option>
    <option value="-0.50">-0.50</option>
    <option value="-0.25">-0.25</option>
    
    {/* Positive values from +0.25 to +6.00 */}
    <option value="+0.25">+0.25</option>
    <option value="+0.50">+0.50</option>
    <option value="+0.75">+0.75</option>
    <option value="+1.00">+1.00</option>
    <option value="+1.25">+1.25</option>
    <option value="+1.50">+1.50</option>
    <option value="+1.75">+1.75</option>
    <option value="+2.00">+2.00</option>
    <option value="+2.25">+2.25</option>
    <option value="+2.50">+2.50</option>
    <option value="+2.75">+2.75</option>
    <option value="+3.00">+3.00</option>
    <option value="+3.25">+3.25</option>
    <option value="+3.50">+3.50</option>
    <option value="+3.75">+3.75</option>
    <option value="+4.00">+4.00</option>
    <option value="+4.25">+4.25</option>
    <option value="+4.50">+4.50</option>
    <option value="+4.75">+4.75</option>
    <option value="+5.00">+5.00</option>
    <option value="+5.25">+5.25</option>
    <option value="+5.50">+5.50</option>
    <option value="+5.75">+5.75</option>
    <option value="+6.00">+6.00</option>
  </select>
</div>




                      <input 
                        type="text" 
                        name="rightAxis"
                        value={formData.rightAxis}
                        onChange={handleInputChange}
                        placeholder="AXIS"
                         style={{ width: '100px' }}
                      />
                    </div>

                  </div>


                <div className="eye-field-group">
                  <label>Reading</label>
                  <select 
                    name="rightAdd"
                    value={formData.rightAdd}
                    onChange={handleInputChange}
                  >
                    <option value="">Select addition</option>
                    <option value="+1.00">+1.00</option>
                    <option value="+1.25">+1.25</option>
                    <option value="+1.50">+1.50</option>
                    <option value="+1.75">+1.75</option>
                    <option value="+2.00">+2.00</option>
                    <option value="+2.25">+2.25</option>
                    <option value="+2.50">+2.50</option>
                    <option value="+2.75">+2.75</option>
                    <option value="+3.00">+3.00</option>
                    <option value="+3.25">+3.25</option>
                    <option value="+3.50">+3.50</option>
                    <option value="+3.75">+3.75</option>
                    <option value="+4.00">+4.00</option>
                  </select>
                </div>


                  <div className="eye-field-group">
                    <label>Near VA</label>
                    <select 
                      className="form-control"
                      name="rightNearVA"
                      value={formData.rightNearVA}
                      onChange={handleInputChange}
                    >
                      <option value="">Select</option>
                      <option value="N5">N5</option>
                      <option value="N6">N6</option>
                      <option value="N8">N8</option>
                      <option value="N10">N10</option>
                      <option value="N14">N14</option>
                      <option value="N24">N24</option>
                      <option value="N36">N36</option>  
                    </select>
                  </div>
                </div>
              </div>

              {/* Left Eye */}
              <div className="eye-section">
                <h4>Left Eye (OS)</h4>

                <div className="eye-field-group">
                  <label>Visual Acuity</label>
                  <select 
                    className="form-control"
                    name="leftVisualAcuity"
                    value={formData.leftVisualAcuity}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="6/6">6/6</option>
                    <option value="6/9">6/9</option>
                    <option value="6/12">6/12</option>
                    <option value="6/18">6/18</option>
                    <option value="6/24">6/24</option>
                    <option value="6/36">6/36</option>
                    <option value="6/60">6/60</option>  
                  </select>
                </div>

                <div className="eye-fields">
                  <div className="eye-field-group">
                    <label>Distance</label>
                         <div className="presc-inputs">
                      <input 
                        type="text" 
                        name="leftSph"
                        value={formData.leftSph}
                        onChange={handleInputChange}
                        placeholder="SPH"
                           style={{ width: '100px' }}
                      />


<div className="eye-field-group">
  <label>CYL</label>
  <select 
    name="leftCyl"
    value={formData.leftCyl}
    onChange={handleInputChange}
    style={{ width: '100px' }}
  >
    <option value="">Select CYL</option>
    {/* Negative values from -6.00 to -0.25 */}
    <option value="-6.00">-6.00</option>
    <option value="-5.75">-5.75</option>
    <option value="-5.50">-5.50</option>
    <option value="-5.25">-5.25</option>
    <option value="-5.00">-5.00</option>
    <option value="-4.75">-4.75</option>
    <option value="-4.50">-4.50</option>
    <option value="-4.25">-4.25</option>
    <option value="-4.00">-4.00</option>
    <option value="-3.75">-3.75</option>
    <option value="-3.50">-3.50</option>
    <option value="-3.25">-3.25</option>
    <option value="-3.00">-3.00</option>
    <option value="-2.75">-2.75</option>
    <option value="-2.50">-2.50</option>
    <option value="-2.25">-2.25</option>
    <option value="-2.00">-2.00</option>
    <option value="-1.75">-1.75</option>
    <option value="-1.50">-1.50</option>
    <option value="-1.25">-1.25</option>
    <option value="-1.00">-1.00</option>
    <option value="-0.75">-0.75</option>
    <option value="-0.50">-0.50</option>
    <option value="-0.25">-0.25</option>
    
    {/* Positive values from +0.25 to +6.00 */}
    <option value="+0.25">+0.25</option>
    <option value="+0.50">+0.50</option>
    <option value="+0.75">+0.75</option>
    <option value="+1.00">+1.00</option>
    <option value="+1.25">+1.25</option>
    <option value="+1.50">+1.50</option>
    <option value="+1.75">+1.75</option>
    <option value="+2.00">+2.00</option>
    <option value="+2.25">+2.25</option>
    <option value="+2.50">+2.50</option>
    <option value="+2.75">+2.75</option>
    <option value="+3.00">+3.00</option>
    <option value="+3.25">+3.25</option>
    <option value="+3.50">+3.50</option>
    <option value="+3.75">+3.75</option>
    <option value="+4.00">+4.00</option>
    <option value="+4.25">+4.25</option>
    <option value="+4.50">+4.50</option>
    <option value="+4.75">+4.75</option>
    <option value="+5.00">+5.00</option>
    <option value="+5.25">+5.25</option>
    <option value="+5.50">+5.50</option>
    <option value="+5.75">+5.75</option>
    <option value="+6.00">+6.00</option>
  </select>
</div>



                      <input 
                        type="text" 
                        name="leftAxis"
                        value={formData.leftAxis}
                        onChange={handleInputChange}
                        placeholder="AXIS"
                         style={{ width: '100px' }}
                      />

                    </div>

                  </div>




                  <div className="eye-field-group">
                    <label>Reading</label>
                    <select 
                      name="leftAdd"
                      value={formData.leftAdd}
                      onChange={handleInputChange}
                    >
                      <option value="">Select addition</option>
                      <option value="+1.00">+1.00</option>
                      <option value="+1.25">+1.25</option>
                      <option value="+1.50">+1.50</option>
                      <option value="+1.75">+1.75</option>
                      <option value="+2.00">+2.00</option>
                      <option value="+2.25">+2.25</option>
                      <option value="+2.50">+2.50</option>
                      <option value="+2.75">+2.75</option>
                      <option value="+3.00">+3.00</option>
                      <option value="+3.25">+3.25</option>
                      <option value="+3.50">+3.50</option>
                      <option value="+3.75">+3.75</option>
                      <option value="+4.00">+4.00</option>
                    </select>
                  </div>




                  <div className="eye-field-group">
                    <label>Near VA</label>
                    <select 
                      className="form-control"
                      name="leftNearVA"
                      value={formData.leftNearVA}
                      onChange={handleInputChange}
                    >
                      <option value="">Select</option>
                      <option value="N5">N5</option>
                      <option value="N6">N6</option>
                      <option value="N8">N8</option>
                      <option value="N10">N10</option>
                      <option value="N14">N14</option>
                      <option value="N24">N24</option>
                      <option value="N36">N36</option>  
                    </select>
                  </div>
                </div>
              </div>
            </div>











{/* HB Rx Section */}
<div className="hb-rx-section" style={{
  marginTop: '20px',
  padding: '16px',
  border: '2px solid #2563eb',
  borderRadius: '8px',
  backgroundColor: '#f8faff'
}}>
  <h3 style={{
    fontSize: '16px',
    fontWeight: '700',
    color: '#2563eb',
    marginBottom: '12px'
  }}>
    HB Rx
  </h3>

  <div className="prescription-grid">
    {/* Right Eye - HB Rx */}
    <div className="eye-section">
      <h4>Right Eye (OD) - HB Rx</h4>

      <div className="eye-field-group">
        <label>Visual Acuity</label>
        <select 
          className="form-control"
          name="hbRxRightVisualAcuity"
          value={formData.hbRxRightVisualAcuity}
          onChange={handleInputChange}
        >
          <option value="">Select</option>
          <option value="6/6">6/6</option>
          <option value="6/9">6/9</option>
          <option value="6/12">6/12</option>
          <option value="6/18">6/18</option>
          <option value="6/24">6/24</option>
          <option value="6/36">6/36</option>
          <option value="6/60">6/60</option>  
        </select>
      </div>

      <div className="eye-fields">
        <div className="eye-field-group">
          <label>Distance</label>
          <div className="presc-inputs">
            <div className="eye-field-group">
              <label>SPH</label>
               <input 
                type="text" 
                name="hbRxRightSph"
                value={formData.hbRxRightSph}
                onChange={handleInputChange}
                style={{ width: '100px' }}
              />
           
            </div>

            <div className="eye-field-group">
              <label>CYL</label>
              <select 
                name="hbRxRightCyl"
                value={formData.hbRxRightCyl}
                onChange={handleInputChange}
                style={{ width: '100px' }}
              >
                <option value="">Select CYL</option>
                <option value="-0.25">-0.25</option>
                <option value="-0.50">-0.50</option>
                <option value="-0.75">-0.75</option>
                <option value="-1.00">-1.00</option>
                <option value="-1.25">-1.25</option>
                <option value="-1.50">-1.50</option>
                <option value="-1.75">-1.75</option>
                <option value="-2.00">-2.00</option>
                <option value="-2.25">-2.25</option>
                <option value="-2.50">-2.50</option>
                <option value="-2.75">-2.75</option>
                <option value="-3.00">-3.00</option>
                <option value="-3.25">-3.25</option>
                <option value="-3.50">-3.50</option>
                <option value="-3.75">-3.75</option>
                <option value="-4.00">-4.00</option>
                <option value="-4.25">-4.25</option>
                <option value="-4.50">-4.50</option>
                <option value="-4.75">-4.75</option>
                <option value="-5.00">-5.00</option>
                <option value="-5.25">-5.25</option>
                <option value="-5.50">-5.50</option>
                <option value="-5.75">-5.75</option>
                <option value="-6.00">-6.00</option>
              </select>
            </div>

            <input 
              type="text" 
              name="hbRxRightAxis"
              value={formData.hbRxRightAxis}
              onChange={handleInputChange}
              placeholder="AXIS"
              style={{ width: '100px' }}
            />
          </div>
        </div>

        <div className="eye-field-group">
          <label>Reading</label>
          <select 
            name="hbRxRightAdd"
            value={formData.hbRxRightAdd}
            onChange={handleInputChange}
          >
            <option value="">Select addition</option>
            <option value="+1.00">+1.00</option>
            <option value="+1.25">+1.25</option>
            <option value="+1.50">+1.50</option>
            <option value="+1.75">+1.75</option>
            <option value="+2.00">+2.00</option>
            <option value="+2.25">+2.25</option>
            <option value="+2.50">+2.50</option>
            <option value="+2.75">+2.75</option>
            <option value="+3.00">+3.00</option>
            <option value="+3.25">+3.25</option>
            <option value="+3.50">+3.50</option>
            <option value="+3.75">+3.75</option>
            <option value="+4.00">+4.00</option>
          </select>
        </div>

        <div className="eye-field-group">
          <label>Near VA</label>
          <select 
            className="form-control"
            name="hbRxRightNearVA"
            value={formData.hbRxRightNearVA}
            onChange={handleInputChange}
          >
            <option value="">Select</option>
            <option value="N5">N5</option>
            <option value="N6">N6</option>
            <option value="N8">N8</option>
            <option value="N10">N10</option>
            <option value="N14">N14</option>
            <option value="N24">N24</option>
            <option value="N36">N36</option>  
          </select>
        </div>
      </div>
    </div>

    {/* Left Eye - HB Rx */}
    <div className="eye-section">
      <h4>Left Eye (OS) - HB Rx</h4>

      <div className="eye-field-group">
        <label>Visual Acuity</label>
        <select 
          className="form-control"
          name="hbRxLeftVisualAcuity"
          value={formData.hbRxLeftVisualAcuity}
          onChange={handleInputChange}
        >
          <option value="">Select</option>
          <option value="6/6">6/6</option>
          <option value="6/9">6/9</option>
          <option value="6/12">6/12</option>
          <option value="6/18">6/18</option>
          <option value="6/24">6/24</option>
          <option value="6/36">6/36</option>
          <option value="6/60">6/60</option>  
        </select>
      </div>

      <div className="eye-fields">
        <div className="eye-field-group">
          <label>Distance</label>
          <div className="presc-inputs">
            <div className="eye-field-group">
              <label>SPH</label>
               <input 
                type="text" 
                name="hbRxLeftSph"
                value={formData.hbRxLeftSph}
                onChange={handleInputChange}
                style={{ width: '100px' }}
              />

            </div>

            <div className="eye-field-group">
              <label>CYL</label>
              <select 
                name="hbRxLeftCyl"
                value={formData.hbRxLeftCyl}
                onChange={handleInputChange}
                style={{ width: '100px' }}
              >
                <option value="">Select CYL</option>
                <option value="-0.25">-0.25</option>
                <option value="-0.50">-0.50</option>
                <option value="-0.75">-0.75</option>
                <option value="-1.00">-1.00</option>
                <option value="-1.25">-1.25</option>
                <option value="-1.50">-1.50</option>
                <option value="-1.75">-1.75</option>
                <option value="-2.00">-2.00</option>
                <option value="-2.25">-2.25</option>
                <option value="-2.50">-2.50</option>
                <option value="-2.75">-2.75</option>
                <option value="-3.00">-3.00</option>
                <option value="-3.25">-3.25</option>
                <option value="-3.50">-3.50</option>
                <option value="-3.75">-3.75</option>
                <option value="-4.00">-4.00</option>
                <option value="-4.25">-4.25</option>
                <option value="-4.50">-4.50</option>
                <option value="-4.75">-4.75</option>
                <option value="-5.00">-5.00</option>
                <option value="-5.25">-5.25</option>
                <option value="-5.50">-5.50</option>
                <option value="-5.75">-5.75</option>
                <option value="-6.00">-6.00</option>
              </select>
            </div>

            <input 
              type="text" 
              name="hbRxLeftAxis"
              value={formData.hbRxLeftAxis}
              onChange={handleInputChange}
              placeholder="AXIS"
              style={{ width: '100px' }}
            />
          </div>
        </div>

        <div className="eye-field-group">
          <label>Reading</label>
          <select 
            name="hbRxLeftAdd"
            value={formData.hbRxLeftAdd}
            onChange={handleInputChange}
          >
            <option value="">Select addition</option>
            <option value="+1">+1</option>
            <option value="+1.25">+1.25</option>
            <option value="+1.5">+1.5</option>
            <option value="+1.75">+1.75</option>
            <option value="+2">+2</option>
            <option value="+2.25">+2.25</option>
            <option value="+2.5">+2.5</option>
            <option value="+2.75">+2.75</option>
            <option value="+3">+3</option>
            <option value="+3.25">+3.25</option>
            <option value="+3.5">+3.5</option>
            <option value="+3.75">+3.75</option>
            <option value="+4">+4</option>
          </select>
        </div>

        <div className="eye-field-group">
          <label>Near VA</label>
          <select 
            className="form-control"
            name="hbRxLeftNearVA"
            value={formData.hbRxLeftNearVA}
            onChange={handleInputChange}
          >
            <option value="">Select</option>
            <option value="N5">N5</option>
            <option value="N6">N6</option>
            <option value="N8">N8</option>
            <option value="N10">N10</option>
            <option value="N14">N14</option>
            <option value="N24">N24</option>
            <option value="N36">N36</option>  
          </select>
        </div>
      </div>
    </div>
  </div>
</div>



          </div>










          {/* Lens & Frame */}
          <div className="invoice-section">
            <div className="section-header">
              <h3>Lens & Frame Details</h3>
              <span className="section-badge">Products</span>
            </div>
            
{/************************* lens section **************************/}
{/* =====================================================
   LENS SELECTION
===================================================== */}

<div className="high-index-toggle">
  <label>
    <input
      type="checkbox"
      checked={isHighIndexLens}
      onChange={(e) => setIsHighIndexLens(e.target.checked)}
    />
    Generic Lens
  </label>
</div>





{isHighIndexLens && (
  <div className="high-index-panel">

    <div className="high-index-header">
      <h2>Generic Lens Details</h2>
      <p>Enter individual lens information and pricing</p>
    </div>

    <div className="high-index-grid">

     

      {/* Right Lens */}
      <div className="high-index-card">
        <h3>Right Lens</h3>

        <input
          type="text"
          placeholder="Brand"
          value={highIndexRightBrand}
          onChange={(e) => setHighIndexRightBrand(e.target.value)}
        />

        <input
          type="text"
          placeholder="Lens Type"
          value={highIndexRightType}
          onChange={(e) => setHighIndexRightType(e.target.value)}
        />

        <input
          type="text"
          placeholder="Lens Name"
          value={highIndexRightName}
          onChange={(e) => setHighIndexRightName(e.target.value)}
        />

        <input
          type="number"
          placeholder="Price (Rs.)"
          value={highIndexRightPrice}
          onChange={(e) => setHighIndexRightPrice(e.target.value)}
        />
      </div>


       {/* Left Lens */}
      <div className="high-index-card">
        <h3>Left Lens</h3>

        <input
          type="text"
          placeholder="Brand"
          value={highIndexLeftBrand}
          onChange={(e) => setHighIndexLeftBrand(e.target.value)}
        />

        <input
          type="text"
          placeholder="Lens Type"
          value={highIndexLeftType}
          onChange={(e) => setHighIndexLeftType(e.target.value)}
        />

        <input
          type="text"
          placeholder="Lens Name"
          value={highIndexLeftName}
          onChange={(e) => setHighIndexLeftName(e.target.value)}
        />

        <input
          type="number"
          placeholder="Price (Rs.)"
          value={highIndexLeftPrice}
          onChange={(e) => setHighIndexLeftPrice(e.target.value)}
        />
      </div>

    </div>

    <div className="high-index-total">
      Total Lens Price : Rs.
      {(Number(highIndexLeftPrice || 0) +
        Number(highIndexRightPrice || 0)).toFixed(2)}
    </div>

  </div>
)}
















<div className="invoice-section">
  <div className="section-header">
    <h3>Lens Selection</h3>
    <span className="section-badge">Left & Right Eye</span>
  </div>

  {/* Add this checkbox before the lens selection grid */}
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: '10px', 
    marginBottom: '15px',
    padding: '10px',
    backgroundColor: '#f0f4ff',
    borderRadius: '8px',
    border: '1px solid #d0d8e8'
  }}>
    <input
      type="checkbox"
      id="sameLensCheckbox"
      checked={isSameLens}
      onChange={(e) => {
        setIsSameLens(e.target.checked);
        // If checked, auto-copy right lens to left
        if (e.target.checked && rightLens) {
          setLeftLensBrand(rightLensBrand);
          setLeftLensType(rightLensType);
          setLeftLens(rightLens);
        }
      }}
      style={{ width: '18px', height: '18px', cursor: 'pointer' }}
    />
    <label htmlFor="sameLensCheckbox" style={{ 
      fontSize: '14px', 
      fontWeight: '600',
      color: '#1a237e',
      cursor: 'pointer'
    }}>
      Same lens for both eyes
    </label>
    {isSameLens && (
      <span style={{ 
        fontSize: '12px', 
        color: '#4CAF50',
        fontWeight: '500'
      }}>
        ✓ Auto-sync enabled
      </span>
    )}
  </div>

  <div
    className="lens-selection-container"
    style={{
      opacity: isHighIndexLens ? 0.5 : 1,
      pointerEvents: isHighIndexLens ? "none" : "auto"
    }}
  >
    <div className="lens-selection-grid">
      {/* =====================================================
         RIGHT EYE
      ===================================================== */}
      <div className="lens-side-card">
        <div className="lens-card-header">
          <h4>Right Eye Lens</h4>
        </div>
        <div className="lens-card-body">
          {/* BRAND */}
          <div className="form-group">
            <label>Brand</label>
            <select
              value={rightLensBrand}
              onChange={(e) => {
                setRightLensBrand(e.target.value);
                setRightLensType("");
                setRightLens(null);
                
                // If sync is enabled, clear left lens too
                if (isSameLens) {
                  setLeftLensBrand("");
                  setLeftLensType("");
                  setLeftLens(null);
                }
              }}
            >
              <option value="">Select Brand</option>
              <option value="STANDARD">STANDARD</option>
              <option value="ESSILOR">ESSILOR</option>
              <option value="NEOFORM">NEOFORM</option>
              <option value="HOYA">HOYA</option>
               <option value="NOVAR">NOVAR</option>
            </select>
          </div>

          {/* TYPE */}
          <div className="form-group">
            <label>Lens Type</label>
            <select
              value={rightLensType}
              onChange={(e) => {
                setRightLensType(e.target.value);
                setRightLens(null);
                
                // If sync is enabled, clear left lens too
                if (isSameLens) {
                  setLeftLensType("");
                  setLeftLens(null);
                }
              }}
            >
              <option value="">Select Type</option>
              <option value="SV">SV</option>
              <option value="BF">BF</option>
              <option value="PAL">PAL</option>
            </select>
          </div>

          {/* LENS */}
          <div className="form-group">
            <label>Lens</label>
            <select
              value={rightLens?.name || ""}
              onChange={(e) => {
                const selected =
                  lensData[rightLensBrand]?.[rightLensType]
                    ?.find(lens => lens.name === e.target.value);
                setRightLens(selected);

                // AUTO-SYNC: If checkbox is checked, copy to left eye
                if (isSameLens && selected) {
                  setLeftLensBrand(rightLensBrand);
                  setLeftLensType(rightLensType);
                  setLeftLens(selected);
                }
              }}
            >
              <option value="">Select Lens</option>
              {rightLensBrand &&
                rightLensType &&
                lensData[rightLensBrand]?.[rightLensType]
                  ?.map((lens, index) => (
                    <option key={index} value={lens.name}>
                      {lens.name} - Rs.{lens.pairPrice}
                    </option>
                  ))}
            </select>
          </div>

          {/* PRICE */}
          <div className="lens-price-box">
            <span>Right Lens Price</span>
            <strong>
              Rs.{rightLens ? (rightLens.pairPrice / 2).toFixed(2) : "0.00"}
            </strong>
          </div>
        </div>
      </div>

      {/* =====================================================
         LEFT EYE
      ===================================================== */}
      <div className="lens-side-card" style={{
        opacity: isSameLens && rightLens ? 0.7 : 1,
        pointerEvents: isSameLens && rightLens ? "none" : "auto"
      }}>
        <div className="lens-card-header">
          <h4>Left Eye Lens</h4>
          {isSameLens && rightLens && (
            <span style={{
              fontSize: '11px',
              color: '#4CAF50',
              fontWeight: '600',
              backgroundColor: '#e8f5e9',
              padding: '2px 8px',
              borderRadius: '4px'
            }}>
              Synced
            </span>
          )}
        </div>
        <div className="lens-card-body">
          {/* BRAND */}
          <div className="form-group">
            <label>Brand</label>
            <select
              value={leftLensBrand}
              onChange={(e) => {
                setLeftLensBrand(e.target.value);
                setLeftLensType("");
                setLeftLens(null);
              }}
              disabled={isSameLens && rightLens}
            >
              <option value="">Select Brand</option>
              <option value="STANDARD">STANDARD</option>
              <option value="ESSILOR">ESSILOR</option>
              <option value="NEOFORM">NEOFORM</option>
              <option value="HOYA">HOYA</option>
              <option value="NOVAR">NOVAR</option>
            </select>
          </div>

          {/* TYPE */}
          <div className="form-group">
            <label>Lens Type</label>
            <select
              value={leftLensType}
              onChange={(e) => {
                setLeftLensType(e.target.value);
                setLeftLens(null);
              }}
              disabled={isSameLens && rightLens}
            >
              <option value="">Select Type</option>
              <option value="SV">SV</option>
              <option value="BF">BF</option>
              <option value="PAL">PAL</option>
            </select>
          </div>

          {/* LENS */}
          <div className="form-group">
            <label>Lens</label>
            <select
              value={leftLens?.name || ""}
              onChange={(e) => {
                const selected =
                  lensData[leftLensBrand]?.[leftLensType]
                    ?.find(lens => lens.name === e.target.value);
                setLeftLens(selected);
              }}
              disabled={isSameLens && rightLens}
            >
              <option value="">Select Lens</option>
              {leftLensBrand &&
                leftLensType &&
                lensData[leftLensBrand]?.[leftLensType]
                  ?.map((lens, index) => (
                    <option key={index} value={lens.name}>
                      {lens.name} - Rs.{lens.pairPrice}
                    </option>
                  ))}
            </select>
          </div>

          {/* PRICE */}
          <div className="lens-price-box">
            <span>Left Lens Price</span>
            <strong>
              Rs.{leftLens ? (leftLens.pairPrice / 2).toFixed(2) : "0.00"}
            </strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>






<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "30px",
    flexWrap: "wrap",
    marginTop: "10px",
  }}
>
  <div className="form-group">
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
      }}
    >
      <input
        type="checkbox"
        checked={bluecut === "Yes"}
        onChange={(e) => setBluecut(e.target.checked ? "Yes" : "No")}
        style={{ width: "18px", height: "18px" }}
      />
      <span style={{ fontWeight: "bold" }}>Blue Cut</span>
    </label>
  </div>

  <div className="form-group">
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
      }}
    >
      <input
        type="checkbox"
        checked={photochromic === "Yes"}
        onChange={(e) =>
          setPhotochromic(e.target.checked ? "Yes" : "No")
        }
        style={{ width: "18px", height: "18px" }}
      />
      <span style={{ fontWeight: "bold" }}>Photochromic</span>
    </label>
  </div>
</div>











              <div className="form-row">
                {/* Own Frame Checkbox - MOVED TO TOP */}
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={isOwnFrame}
                      onChange={handleOwnFrameToggle}
                      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                    />
                    <b style={{ fontSize: '14px' }}>Own Frame</b>
                  </label>
                </div>

                {/* Frame Model - Disabled when Own Frame is checked */}
                <div className="form-group">
                  <label>Frame Model <span className="required-star"></span></label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      name="frameModel"
                      value={isOwnFrame ? 'Own Frame' : frameSearchTerm}
                      onChange={(e) => {
                        if (!isOwnFrame) {
                          handleFrameSearch(e.target.value);
                        }
                      }}
                      onFocus={() => {
                        if (!isOwnFrame && frameSearchTerm.length >= 2) {
                          setShowFrameSuggestions(true);
                        }
                      }}
                      placeholder={isOwnFrame ? "Own Frame selected" : "Type frame model..."}
                      className={errors.frameModel ? 'error-input' : ''}
                      disabled={isOwnFrame}
                      style={{
                        backgroundColor: isOwnFrame ? '#f0f0f0' : 'white',
                        cursor: isOwnFrame ? 'not-allowed' : 'text'
                      }}
                    />
                  
                    {!isOwnFrame && showFrameSuggestions && frameSuggestions.length > 0 && (() => {
                      const groupedFrames = Object.values(
                        frameSuggestions.reduce((acc, frame) => {
                          const key = `${frame.modelNo}-${frame.colour}-${frame.size}-${frame.ftype}-${frame.sellingPrice}`;
                          if (!acc[key]) {
                            acc[key] = {
                              ...frame,
                              totalQty: 0,
                            };
                          }
                          acc[key].totalQty += parseInt(frame.qty || 0);
                          return acc;
                        }, {})
                      );

                      return (
                        <div className="suggestions-dropdown">
                          {groupedFrames.map((frame, index) => (
                            <div
                              key={index}
                              className="suggestion-item"
                              onClick={() => selectFrame(frame)}
                            >
                              <strong>{frame.modelNo}</strong>
                              <div className="suggestion-details">
                                {frame.brand} | {frame.colour} | {frame.size} | {frame.ftype} | Rs{frame.sellingPrice}
                                <span className="stock-badge">
                                  Total Stock: {frame.totalQty}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                </div>
                
                <div className="form-group">
                  <label>Brand</label>
                  <input 
                    type="text" 
                    name="brand"
                    value={isOwnFrame ? 'Own Frame' : formData.brand}
                    readOnly
                    className="readonly-field"
                    placeholder={isOwnFrame ? "Own Frame" : "Auto-filled from frame"}
                  />
                </div>
                
                <div className="form-group">
                  <label>Colour</label>
                  <input 
                    type="text" 
                    name="colour"
                    value={isOwnFrame ? 'Own Frame' : formData.colour}
                    readOnly
                    className="readonly-field"
                    placeholder={isOwnFrame ? "Own Frame" : "Auto-filled from frame"}
                  />
                </div>

                <div className="form-group">
                  <label>Size</label>
                  <input 
                    type="text" 
                    name="size"
                    value={isOwnFrame ? 'Own Frame' : formData.size}
                    readOnly
                    className="readonly-field"
                    placeholder={isOwnFrame ? "Own Frame" : "Auto-filled from frame"}
                  />
                </div>

                                <div className="form-group">
                  <label>Frame Type</label>
                  <input 
                    type="text" 
                    name="ftype"
                    value={isOwnFrame ? 'Own Frame' : formData.ftype}
                    readOnly
                    className="readonly-field"
                    placeholder={isOwnFrame ? "Own Frame" : "Auto-filled from frame"}
                  />
                </div>

                <div className="form-group">
                  <label><b>Note</b></label>
                  <textarea 
                    name="note"
                    value={formData.note}
                    onChange={handleInputChange}
                    placeholder="Type here"
                    rows={4}
                    cols={50}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>





        {/* Product Search Section */}
        <div className="invoice-section">
          <div className="section-header">
            <h3>BOX</h3>
            <span className="section-badge">Add Items</span>
          </div>

          <div className="form-group">
            <label>Search Box</label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                value={directSaleSearch}
                onChange={(e) => handleDirectSaleSearch(e.target.value)}
                placeholder="Search by model no / brand / colour"
              />

              {showDirectSaleSuggestions && directSaleSuggestions.length > 0 && (
                <div className="suggestions-dropdown">
                  {directSaleSuggestions.map((item, index) => (
                    <div
                      key={index}
                      className="suggestion-item"
                      onClick={() => selectDirectProduct(item)}
                    >
                      <strong>{item.modelNo}</strong>
                      <div className="suggestion-details">
                        {item.brand} | {item.colour} | Rs.{item.sellingPrice}
                        <span className="stock-badge">Stock: {item.qty}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Cart */}
          {directSaleItems.length > 0 && (
            <div className="direct-sale-cart">
              <table className="direct-sale-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Model</th>
                    <th>Brand</th>
                    <th>Colour</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Total</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {directSaleItems.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.modelNo}</td>
                      <td>{item.brand}</td>
                      <td>{item.colour}</td>
                      <td>Rs.{Number(item.sellingPrice).toFixed(2)}</td>
                      <td>
                        <input
                          type="number"
                          min="1"
                          max={item.stockQty}
                          value={item.qty}
                          className="qty-input"
                          onChange={(e) => {
                            let value = Number(e.target.value);
                            if (e.target.value === '') value = 1;
                            if (value < 1) value = 1;
                            if (value > item.stockQty) value = item.stockQty;
                            updateDirectSaleQty(index, value);
                          }}
                        />
                        <small className="stock-text">Available Stock: {item.stockQty}</small>
                      </td>
                      <td className="item-total">Rs.{Number(item.total).toFixed(2)}</td>
                      <td>
                        <button className="btn-delete-item" onClick={() => removeDirectSaleItem(index)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>






          </div>



          {/* Delivery & Pricing */}
          <div className="invoice-section">
            <div className="section-header">
              <h3>Pricing & Delivery</h3>
              <span className="section-badge">Financial</span>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Delivery Date</label>
                <input 
                  type="date" 
                  name="deliveryDate"
                  value={formData.deliveryDate}
                  onChange={handleInputChange}
                />
              </div>



              {/* <div className="form-group vat-checkbox-group">
  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
    <input
      type="checkbox"
      checked={applyTint}
      onChange={(e) => setApplyTint(e.target.checked)}
      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
    />
    <span style={{ fontWeight: 'bold' }}>Tint Charges</span>
  </label>
  {applyTint && (
    <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
      Tint Charges (Rs.1000) will be added to the subtotal
    </div>
  )}
</div> */}


{/* VAT Checkbox - Add this in the Pricing & Delivery section */}
<div className="form-group vat-checkbox-group">
  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
    <input
      type="checkbox"
      checked={applyVAT}
      onChange={(e) => setApplyVAT(e.target.checked)}
      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
    />
    <span style={{ fontWeight: 'bold' }}>Apply 18% VAT</span>
  </label>
  {applyVAT && (
    <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
      VAT (18%) will be added to the subtotal
    </div>
  )}
</div>



              
      
              
<div className="form-group">

  <label>Lens Price (Rs.)</label>

  <input
    type="number"
    name="lensPrice"
    value={formData.lensPrice}
    readOnly
    placeholder="0.00"
  />

</div>






<div className="form-group">
  <label>Frame Price (Rs.)</label>
<input
  type="number"
  name="framePrice"
  value={formData.framePrice}
  onChange={(e) => {
    // Allow any typing, including Backspace
    setFormData((prev) => ({
      ...prev,
      framePrice: e.target.value,
    }));
  }}
  onBlur={() => {
    const value = Number(formData.framePrice);

    if (value < selectedFramePrice) {
      alert(`Frame price cannot be less than Rs. ${selectedFramePrice}`);

      // Reset to original fetched price
      setFormData((prev) => ({
        ...prev,
        framePrice: selectedFramePrice,
      }));
    }
  }}
  placeholder="Enter Frame Price"
/>
</div>







<div className="form-group total-group">
  <label>Discount</label>
  <div style={{ display: "flex", gap: "8px" }}>
    <input
      type="number"
      name="discount"
      value={formData.discount}
      onChange={handleInputChange}
      placeholder="0"
      style={{ flex: 1 }}
    />

<select
  name="discountType" 
  value={formData.discountType || 'amount'}  
  onChange={handleInputChange}
>
  <option value="amount">Rs.</option>
  <option value="percentage">%</option>
</select>

  </div>
  {parseFloat(formData.discount) > 0 && (
    <small style={{ color: '#666', display: 'block', marginTop: '4px' }}>
      {formData.discountType === 'percentage' 
        ? `Discount: ${formData.discount}% (Rs. ${discountAmount.toFixed(2)})` 
        : `Discount: Rs. ${discountAmount.toFixed(2)}`}
    </small>
  )}
</div>













              <div className="form-group total-group">
                <label>Advance Payment (Rs.)</label>
                <input 
                  type="number"
                  name="advancePayment"
                  value={formData.advancePayment}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  step="0.01"
                />
              </div>

              <div className="form-group total-group">
                <label>Total Amount (Rs.)</label>
                <input 
                  type="text" 
                  value={`Rs ${totalAmount.toFixed(2)}`}
                  readOnly
                  className="total-input"
                />
              </div>
            </div>

            <div className="form-row">
              {/* <div className="eye-field-group">
                <label>Bill Description</label>

                <input 
                  type="text"
                  name="billDescription"
                  value={formData.billDescription}
                  onChange={handleInputChange}
                  placeholder="Remark"
                  
                />


           
              </div> */}

              <div className="eye-field-group">
                <label>Payment Method</label>
                <select 
                  className="form-control"
                  name="paymentMethod"
                  value={formData.paymentMethod}
                  onChange={handleInputChange}
                >
          <option value="Cash">Cash</option>
          <option value="Card">Card</option>
            <option value="GiftCard">Gift Card</option>
          <option value="Bank Transfer">Bank Transfer</option>
          <option value="Deposit">Deposit</option>
                </select>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="invoice-actions">
            <button className="btn-save" onClick={handleSaveOrder} disabled={isLoading}>
              {isLoading ? '⏳ Saving...' : '💾 Save Order'}
            </button>
            <button className="btn-clear" onClick={handleResetForm}>
              🗑️ Clear Form
            </button>
          </div>
        </div>
      </div>
    </>
)}








{/***************************************************** create blance invoice *********************************************************/}

{/* {selectedOption === "createBalanceInvoice" && (
   <div className="balance-invoice-container">
      <div className="balance-header">
        <h2>Create Balance Invoice</h2>
        <p className="subtitle">Manage pending payments and create balance invoices</p>
      </div>

     
      <div className="search-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by invoice number..."
            value={searchInvoiceNo}
            onChange={(e) => setSearchInvoiceNo(e.target.value)}
            className="search-input"
          />
          <button onClick={handleInvoiceSearch} className="btn-search">
            🔍 Search
          </button>
          <button onClick={() => {
            setSearchInvoiceNo('');
            setFilteredInvoices(balanceInvoices);
          }} className="btn-reset">
            Reset
          </button>
        </div>
      </div>

      <div className="summary-cards">
        <div className="summary-card">
          <div className="summary-title">Pending Invoices</div>
          <div className="summary-value">{balanceInvoices.length}</div>
        </div>
        <div className="summary-card">
          <div className="summary-title">Total Balance Due</div>
          <div className="summary-value">
            Rs. {balanceInvoices.reduce((sum, inv) => sum + (inv.balanceDue || 0), 0).toFixed(2)}
          </div>
        </div>
        <div className="summary-card">
          <div className="summary-title">Partially Paid</div>
          <div className="summary-value">
            {balanceInvoices.filter(inv => inv.hasBalanceInvoices).length}
          </div>
        </div>
      </div>

    
      {isLoadingInvoices ? (
        <div className="loading-spinner">Loading invoices...</div>
      ) : (
        <div className="invoices-table-container">
          <table className="invoices-table">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Customer Name</th>
                <th>Phone</th>
                <th>Total Amount</th>
                <th>Advance Paid</th>
                <th>Balance Due</th>
                <th>Balance Payments</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredInvoices.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center' }}>
                    No pending invoices found
                  </td>
                </tr>
              ) : (
                filteredInvoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td className="invoice-number">{invoice.invoiceNumber}</td>
                    <td>{invoice.customer?.fullName}</td>
                    <td>{invoice.customer?.tpNo}</td>
                    <td>Rs. {(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                    <td>Rs. {(invoice.financial?.advancePayment || 0).toFixed(2)}</td>
                    <td className="balance-due">
                      Rs. {(invoice.balanceDue || 0).toFixed(2)}
                    </td>
                    <td>
                      {invoice.hasBalanceInvoices && (
                        <div className="balance-payments-list">
                          {invoice.balanceRecords?.map((record, idx) => (
                            <div key={idx} className="payment-record">
                              {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                              ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                            </div>
                          ))}
                        </div>
                      )}
                    </td>
                    <td>
                      {invoice.balanceDue <= 0 ? (
                        <span className="status-badge paid">Paid</span>
                      ) : invoice.hasBalanceInvoices ? (
                        <span className="status-badge partial">Partial</span>
                      ) : (
                        <span className="status-badge pending">Pending</span>
                      )}
                    </td>
                    <td>
                      <button
                        className="btn-create-balance"
                        onClick={() => openBalanceModal(invoice)}
                        disabled={invoice.balanceDue <= 0}
                      >
                        {invoice.balanceDue <= 0 ? 'Settled' : 'Create Balance'}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

    
      {showBalanceModal && selectedInvoice && (
        <div className="modal-overlay" onClick={() => setShowBalanceModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Create Balance Invoice</h3>
              <button className="modal-close" onClick={() => setShowBalanceModal(false)}>×</button>
            </div>
            
            <div className="modal-body">
              <div className="invoice-details">
                <h4>Original Invoice Details</h4>
                <div className="detail-row">
                  <span>Invoice Number:</span>
                  <strong>{selectedInvoice.invoiceNumber}</strong>
                </div>
                <div className="detail-row">
                  <span>Customer:</span>
                  <strong>{selectedInvoice.customer?.fullName}</strong>
                </div>
                <div className="detail-row">
                  <span>Phone:</span>
                  <strong>{selectedInvoice.customer?.tpNo}</strong>
                </div>
                <div className="detail-row">
                  <span>Total Amount:</span>
                  <strong>Rs. {(selectedInvoice.financial?.totalAmount || 0).toFixed(2)}</strong>
                </div>
                <div className="detail-row">
                  <span>Already Paid:</span>
                  <strong>Rs. {(selectedInvoice.financial?.advancePayment || 0).toFixed(2)}</strong>
                </div>
                <div className="detail-row highlight">
                  <span>Balance Due:</span>
                  <strong>Rs. {(selectedInvoice.balanceDue || 0).toFixed(2)}</strong>
                </div>
                {selectedInvoice.hasBalanceInvoices && (
                  <div className="detail-row">
                    <span>Previous Balance Payments:</span>
                    <div className="previous-payments">
                      {selectedInvoice.balanceRecords?.map((record, idx) => (
                        <div key={idx}>
                          {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                          ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="payment-details">
                <h4>Payment Information</h4>
                <div className="form-group">
                  <label>Next Balance Invoice Number:</label>
                  <input
                    type="text"
                    // value={`${selectedInvoice.invoiceNumber}-${(selectedInvoice.balanceRecords?.length || 0) + 1}`}
                    value={nextBalanceInvoiceNo}
                    readOnly
                    className="form-control readonly"
                  />
                </div>

                <div className="form-group">
                  <label>Payment Date <span className="required-star">*</span></label>
                  <input
                    type="date"
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Amount to Pay (Rs.) <span className="required-star">*</span></label>
<input
  type="number"
  value={balancePaidAmount}
  onChange={(e) => setBalancePaidAmount(e.target.value)}
  placeholder="Enter amount"
  max={selectedInvoice.balanceDue}
  className="form-control"

  // PREVENT SCROLL VALUE CHANGE
  onWheel={(e) => e.target.blur()}
/>
                  <small>Maximum: Rs. {selectedInvoice.balanceDue.toFixed(2)}</small>
                </div>

                <div className="form-group">
                  <label>Payment Method</label>
                  <select
                    value={balancePaymentMethod}
                    onChange={(e) => setBalancePaymentMethod(e.target.value)}
                    className="form-control"
                  >
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Deposit">Deposit</option>
                  </select>
                </div>

                <div className="payment-summary">
                  <div className="summary-row">
                    <span>New Balance After Payment:</span>
                    <strong className={selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0) <= 0 ? 'text-success' : 'text-warning'}>
                      Rs. {(selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0)).toFixed(2)}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <div>
            </div>

            <div className="modal-footer">
              <button className="btn-cancel" onClick={() => setShowBalanceModal(false)}>
                Cancel
              </button>
              <button 
                className="btn-create" 
                onClick={handleCreateBalanceInvoice}
                disabled={isLoading || !balancePaidAmount || parseFloat(balancePaidAmount) <= 0 || !paymentDate}
              >
                {isLoading ? 'Creating...' : 'Create Balance Invoice'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
)} */}

{selectedOption === "createBalanceInvoice" && (
  <div className="balance-invoice-container">
    <div className="balance-header">
      <h2>Create Balance Invoice</h2>
      <p className="subtitle">Manage pending payments and create balance invoices</p>
    </div>

    {/* Search Section */}
    <div className="search-section">
      <div className="search-box">
        <input
          type="text"
          placeholder="Search by invoice number..."
          value={searchInvoiceNo}
          onChange={(e) => setSearchInvoiceNo(e.target.value)}
          className="search-input"
        />
        <button onClick={handleInvoiceSearch} className="btn-search">
          🔍 Search
        </button>
        <button onClick={() => {
          setSearchInvoiceNo('');
          setFilteredInvoices(balanceInvoices);
        }} className="btn-reset">
          Reset
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Pending Invoices</div>
        <div className="summary-value">{balanceInvoices.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Balance Due</div>
        <div className="summary-value">
          Rs. {balanceInvoices.reduce((sum, inv) => sum + (inv.balanceDue || 0), 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Partially Paid</div>
        <div className="summary-value">
          {balanceInvoices.filter(inv => inv.hasBalanceInvoices).length}
        </div>
      </div>
    </div>

    {/* Invoices Table */}
    {isLoadingInvoices ? (
      <div className="loading-spinner">Loading invoices...</div>
    ) : (
      <div className="invoices-table-container">
        <table className="invoices-table">
          <thead>
            <tr>
              <th>Invoice No</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Total Amount</th>
              <th>Total Paid</th>
              <th>Balance Due</th>
              <th>Balance Payments</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.length === 0 ? (
              <tr>
                <td colSpan="9" style={{ textAlign: 'center' }}>
                  No pending invoices found
                </td>
              </tr>
            ) : (
              filteredInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td className="invoice-number">{invoice.invoiceNumber}</td>
                  <td>{invoice.customer?.fullName}</td>
                  <td>{invoice.customer?.tpNo}</td>
                  <td>Rs. {(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                  <td>Rs. {(invoice.financial?.advancePayment || 0).toFixed(2)}</td>
                  <td className="balance-due">
                    Rs. {(invoice.balanceDue || 0).toFixed(2)}
                   </td>
                  <td>
                    {invoice.hasBalanceInvoices && (
                      <div className="balance-payments-list">
                        {invoice.balanceRecords?.map((record, idx) => (
                          <div key={idx} className="payment-record">
                            {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                            ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                          </div>
                        ))}
                      </div>
                    )}
                   </td>
                  <td>
                    {invoice.balanceDue <= 0 ? (
                      <span className="status-badge paid">Paid</span>
                    ) : invoice.hasBalanceInvoices ? (
                      <span className="status-badge partial">Partial</span>
                    ) : (
                      <span className="status-badge pending">Pending</span>
                    )}
                   </td>
                  <td>
                    <button
                      className="btn-create-balance"
                      onClick={() => openBalanceModal(invoice)}
                      disabled={invoice.balanceDue <= 0}
                    >
                      {invoice.balanceDue <= 0 ? 'Settled' : 'Create Balance'}
                    </button>
                   </td>
                 </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Balance Invoice Modal */}
    {showBalanceModal && selectedInvoice && (
      <div className="modal-overlay" onClick={() => setShowBalanceModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Create Balance Invoice</h3>
            <button className="modal-close" onClick={() => setShowBalanceModal(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="invoice-details">
              <h4>Original Invoice Details</h4>
              <div className="detail-row">
                <span>Invoice Number:</span>
                <strong>{selectedInvoice.invoiceNumber}</strong>
              </div>
              <div className="detail-row">
                <span>Customer:</span>
                <strong>{selectedInvoice.customer?.fullName}</strong>
              </div>
              <div className="detail-row">
                <span>Phone:</span>
                <strong>{selectedInvoice.customer?.tpNo}</strong>
              </div>
              <div className="detail-row">
                <span>Total Amount:</span>
                <strong>Rs. {(selectedInvoice.financial?.totalAmount || 0).toFixed(2)}</strong>
              </div>
              <div className="detail-row">
                <span>Already Paid:</span>
                <strong>Rs. {(selectedInvoice.financial?.advancePayment || 0).toFixed(2)}</strong>
              </div>
              <div className="detail-row highlight">
                <span>Balance Due:</span>
                <strong>Rs. {(selectedInvoice.balanceDue || 0).toFixed(2)}</strong>
              </div>
              {selectedInvoice.hasBalanceInvoices && (
                <div className="detail-row">
                  <span>Previous Balance Payments:</span>
                  <div className="previous-payments">
                    {selectedInvoice.balanceRecords?.map((record, idx) => (
                      <div key={idx}>
                        {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                        ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="payment-details">
              <h4>Payment Information</h4>
              <div className="form-group">
                <label>Next Balance Invoice Number:</label>
                <input
                  type="text"
                  value={nextBalanceInvoiceNo}
                  readOnly
                  className="form-control readonly"
                />
              </div>

              <div className="form-group">
                <label>Payment Date <span className="required-star">*</span></label>
                <input
                  type="date"
                  value={paymentDate}
                  onChange={(e) => setPaymentDate(e.target.value)}
                  className="form-control"
                  required
                />
              </div>

              <div className="form-group">
                <label>Amount to Pay (Rs.) <span className="required-star">*</span></label>
                <input
                  type="number"
                  value={balancePaidAmount}
                  onChange={(e) => setBalancePaidAmount(e.target.value)}
                  placeholder="Enter amount"
                  max={selectedInvoice.balanceDue}
                  className="form-control"
                  onWheel={(e) => e.target.blur()}
                />
                <small>Maximum: Rs. {selectedInvoice.balanceDue.toFixed(2)}</small>
              </div>

              <div className="form-group">
                <label>Payment Method</label>
                <select
                  value={balancePaymentMethod}
                  onChange={(e) => setBalancePaymentMethod(e.target.value)}
                  className="form-control"
                >
          <option value="Cash">Cash</option>
          <option value="Card">Card</option>
            <option value="GiftCard">Gift Card</option>
          <option value="Bank Transfer">Bank Transfer</option>
          <option value="Deposit">Deposit</option>
                </select>
              </div>

              <div className="payment-summary">
                <div className="summary-row">
                  <span>New Balance After Payment:</span>
                  <strong className={selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0) <= 0 ? 'text-success' : 'text-warning'}>
                    Rs. {(selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0)).toFixed(2)}
                  </strong>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-cancel" onClick={() => setShowBalanceModal(false)}>
              Cancel
            </button>
            <button 
              className="btn-create" 
              onClick={handleCreateBalanceInvoice}
              disabled={isLoading || !balancePaidAmount || parseFloat(balancePaidAmount) <= 0 || !paymentDate}
            >
              {isLoading ? 'Creating...' : 'Create Balance Invoice'}
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}





{/**************************************************** stock history report *******************************************/}

{selectedOption === "StockHistory" && (
  <div className="stock-history-wrap">
    <div className="history-header">
      <h2>Stock History</h2>
      <button onClick={exportToExcel} className="export-excel-btn">
        📊 Export to Excel
      </button>
    </div>

    {/* Category Selection Buttons with Counts */}
    <div className="history-category-buttons">
      <button 
        onClick={() => setHistoryCategory("lens")}
        className={`category-btn ${historyCategory === "lens" ? "active" : ""}`}
      >
        Lens History <span className="count-badge">{lensTotalQty}</span>
      </button>
      <button 
        onClick={() => setHistoryCategory("frame")}
        className={`category-btn ${historyCategory === "frame" ? "active" : ""}`}
      >
        Frame History <span className="count-badge">{frameTotalQty}</span>
      </button>
      <button 
        onClick={() => setHistoryCategory("sunglass")}
        className={`category-btn ${historyCategory === "sunglass" ? "active" : ""}`}
      >
        Sunglass History <span className="count-badge">{sunglassTotalQty}</span>
      </button>
      <button 
        onClick={() => setHistoryCategory("other")}
        className={`category-btn ${historyCategory === "other" ? "active" : ""}`}
      >
        Other History <span className="count-badge">{otherTotalQty}</span>
      </button>
    </div>

    {/* Filter Section */}
    <div className="filter-section">
      <div className="filter-controls">
        <label>Filter by Date:</label>
        <select 
          value={filterType} 
          onChange={(e) => {
            setFilterType(e.target.value);
            if (e.target.value === "all") setFilterValue("");
          }}
          className="filter-select"
        >
          <option value="all">All Records</option>
          <option value="day">Specific Day</option>
          <option value="month">Specific Month</option>
          <option value="year">Specific Year</option>
        </select>
        
        {filterType === "day" && (
          <input 
            type="date" 
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
          />
        )}
        
        {filterType === "month" && (
          <input 
            type="month" 
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
          />
        )}
        
        {filterType === "year" && (
          <input 
            type="number" 
            placeholder="Enter year (e.g., 2024)"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
            min="2000"
            max="2100"
          />
        )}
        
        {(filterType !== "all" && filterValue) && (
          <button onClick={resetStockHistoryFilters} className="reset-filter-btn">
            Clear Filter
          </button>
        )}
      </div>
      
      {/* Filter Info Display */}
      {filterType !== "all" && filterValue && (
        <div className="filter-info">
          Showing data for: {
            filterType === "day" ? new Date(filterValue).toLocaleDateString() :
            filterType === "month" ? new Date(filterValue).toLocaleString('default', { month: 'long', year: 'numeric' }) :
            `Year ${filterValue}`
          }
          {frameTypeFilter !== "all" && historyCategory === "frame" && (
            <span className="filter-tag" style={{ marginLeft: '10px', background: '#007bff', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' }}>
              Frame Type: {frameTypeFilter}
            </span>
          )}
          <span className="record-count">
            ({historyCategory === "lens" ? filteredLensHistory.reduce((total, stock) => total + (stock.items?.length || 0), 0) : 
              historyCategory === "frame" ? filteredFrameHistory.reduce((total, stock) => total + (stock.items?.length || 0), 0) : 
              historyCategory === "sunglass" ? filteredSunglassHistory.reduce((total, stock) => total + (stock.items?.length || 0), 0) :
              filteredOtherHistory.reduce((total, stock) => total + (stock.items?.length || 0), 0)} records)
          </span>
        </div>
      )}
    </div>

    <div className="history-search">
      <input
        type="text"
        placeholder="Search by Brand, Model or Colour..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        className="search-input"
      />
    </div>

    {/* Frame Type Filter - Only show when frame category is selected */}
    {historyCategory === "frame" && (
      <div className="frame-type-filter">
        <label>Filter by Frame Type:</label>
        <select 
          value={frameTypeFilter} 
          onChange={(e) => setFrameTypeFilter(e.target.value)}
          className="filter-select"
        >
          <option value="all">All Frame Types</option>
          {uniqueFrameTypes.map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
        {frameTypeFilter !== "all" && (
          <button 
            onClick={() => setFrameTypeFilter("all")} 
            className="reset-filter-btn"
            style={{ marginLeft: '10px' }}
          >
            Clear Frame Type Filter
          </button>
        )}
      </div>
    )}

    {/* Loading State */}
    {loading && <div className="loading">Loading...</div>}

    {/* ======================================== */}
    {/* LENS STOCK HISTORY TABLE */}
    {/* ======================================== */}
    {historyCategory === "lens" && !loading && (
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <button 
            onClick={() => exportStockToPDF("Lens", filteredLensHistory)}
            className="export-pdf-btn"
            style={{
              background: '#dc2626',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            📄 Export PDF (Available Only)
          </button>
        </div>
        <div className="history-table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Purchase Order No</th>
                <th>Supplier Name</th>
                <th>Stock Added Date</th>
                <th>Sph</th>
                <th>Add</th>
                <th>Cyl</th>
                <th>Axis</th>
                <th>Model</th>
                <th>Available Qty</th>
                <th>Added Qty</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredLensHistory.length > 0 ? (
                filteredLensHistory.map((stock, index) => (
                  stock.items?.map((item, itemIndex) => (
                    <tr key={`${stock.id}-${itemIndex}`} style={item.qty === 0 ? { opacity: 0.5, backgroundColor: '#fef2f2' } : {}}>
                      <td>{stock.purchaseOrderNo}</td>
                      <td>{stock.supplierName}</td>
                      <td>{stock.purchaseDate}</td>
                      <td>{item.sph}</td>
                      <td>{item.add}</td>
                      <td>{item.cyl}</td>
                      <td>{item.axis}</td>
                      <td>{item.model}</td>
                      <td style={{ color: item.qty === 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                        {item.qty}
                        {item.qty === 0 && ' (Out of Stock)'}
                      </td>
                      <td>{item.supplyQty || 0}</td>
                      <td>
                        <button
                          className="edit-btn"
                          onClick={() => handleEditStock(stock, item, itemIndex)}
                          style={{ marginRight: '8px' }}
                        >
                          ✏️
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDeleteStock(stock.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ))
              ) : (
                <tr>
                  <td colSpan="14" className="no-data-cell">
                    No lens stock history found for the selected filter
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )}

    {/* ======================================== */}
    {/* FRAME STOCK HISTORY TABLE */}
    {/* ======================================== */}
    {historyCategory === "frame" && !loading && (
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <button 
            onClick={() => exportStockToPDF("Frame", filteredFrameHistory)}
            className="export-pdf-btn"
            style={{
              background: '#dc2626',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            📄 Export PDF (Available Only)
          </button>
        </div>
        <div className="history-table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Purchase Order No</th>
                <th>Supplier Name</th>
                <th>Stock Added Date</th>
                <th>Model No</th>
                <th>Brand</th>
                <th>Frame Type</th>
                <th>Colour</th>
                <th>Size</th>
                <th>Sex</th>
                <th>Selling Price</th>
                <th>Available Qty</th>
                <th>Added Qty</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredFrameHistory.length > 0 ? (
                filteredFrameHistory.map((stock, index) => (
                  stock.items?.map((item, itemIndex) => (
                    <tr key={`${stock.id}-${itemIndex}`} style={item.qty === 0 ? { opacity: 0.5, backgroundColor: '#fef2f2' } : {}}>
                      <td>{stock.purchaseOrderNo}</td>
                      <td>{stock.supplierName}</td>
                      <td>{stock.purchaseDate}</td>
                      <td>{item.modelNo}</td>
                      <td>{item.brand}</td>
                      <td>{item.ftype}</td>
                      <td>{item.colour}</td>
                      <td>{item.size}</td>
                      <td>{item.sex}</td>
                      <td>{item.sellingPrice}</td>
                      <td style={{ color: item.qty === 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                        {item.qty}
                        {item.qty === 0 && ' (Out of Stock)'}
                      </td>
                      <td>{item.supplyQty || 0}</td>
                      <td>
                        <button
                          className="edit-btn"
                          onClick={() => handleEditStock(stock, item, itemIndex)}
                          style={{ marginRight: '8px' }}
                        >
                          ✏️
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDeleteStock(stock.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="no-data-cell">
                    No frame stock history found for the selected filter
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )}

    {/* ======================================== */}
    {/* SUNGLASS STOCK HISTORY TABLE */}
    {/* ======================================== */}
    {historyCategory === "sunglass" && !loading && (
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <button 
            onClick={() => exportStockToPDF("Sunglass", filteredSunglassHistory)}
            className="export-pdf-btn"
            style={{
              background: '#dc2626',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            📄 Export PDF (Available Only)
          </button>
        </div>
        <div className="history-table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Purchase Order No</th>
                <th>Supplier Name</th>
                <th>Stock Added Date</th>
                <th>Model No</th>
                <th>Brand</th>
                <th>Colour</th>
                <th>Size</th>
                <th>Sex</th>
                <th>Selling Price</th>
                <th>Available Qty</th>
                <th>Added Qty</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredSunglassHistory.length > 0 ? (
                filteredSunglassHistory.map((stock) => (
                  stock.items?.map((item, itemIndex) => (
                    <tr key={`${stock.id}-${itemIndex}`} style={item.qty === 0 ? { opacity: 0.5, backgroundColor: '#fef2f2' } : {}}>
                      <td>{stock.purchaseOrderNo}</td>
                      <td>{stock.supplierName}</td>
                      <td>{stock.purchaseDate}</td>
                      <td>{item.modelNo}</td>
                      <td>{item.brand}</td>
                      <td>{item.colour}</td>
                      <td>{item.size}</td>
                      <td>{item.sex}</td>
                      <td>{item.sellingPrice}</td>
                      <td style={{ color: item.qty === 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                        {item.qty}
                        {item.qty === 0 && ' (Out of Stock)'}
                      </td>
                      <td>{item.supplyQty || 0}</td>
                      <td>
                        <button
                          className="edit-btn"
                          onClick={() => handleEditStock(stock, item, itemIndex)}
                          style={{ marginRight: '8px' }}
                        >
                          ✏️
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDeleteStock(stock.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="no-data-cell">
                    No sunglass stock history found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )}

    {/* ======================================== */}
    {/* OTHER STOCK HISTORY TABLE */}
    {/* ======================================== */}
    {historyCategory === "other" && !loading && (
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <button 
            onClick={() => exportStockToPDF("Other", filteredOtherHistory)}
            className="export-pdf-btn"
            style={{
              background: '#dc2626',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            📄 Export PDF (Available Only)
          </button>
        </div>
        <div className="history-table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Purchase Order No</th>
                <th>Supplier Name</th>
                <th>Stock Added Date</th>
                <th>Model No</th>
                <th>Brand</th>
                <th>Colour</th>
                <th>DM</th>
                <th>Base Curve</th>
                <th>Sex</th>
                <th>Selling Price</th>
                <th>Available Qty</th>
                <th>Added Qty</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredOtherHistory.length > 0 ? (
                filteredOtherHistory.map((stock) => (
                  stock.items?.map((item, itemIndex) => (
                    <tr key={`${stock.id}-${itemIndex}`} style={item.qty === 0 ? { opacity: 0.5, backgroundColor: '#fef2f2' } : {}}>
                      <td>{stock.purchaseOrderNo}</td>
                      <td>{stock.supplierName}</td>
                      <td>{stock.purchaseDate}</td>
                      <td>{item.modelNo}</td>
                      <td>{item.brand}</td>
                      <td>{item.colour}</td>
                      <td>{item.dm}</td>
                      <td>{item.bc}</td>
                      <td>{item.sex}</td>
                      <td>{item.sellingPrice}</td>
                      <td style={{ color: item.qty === 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                        {item.qty}
                        {item.qty === 0 && ' (Out of Stock)'}
                      </td>
                      <td>{item.supplyQty || 0}</td>
                      <td>
                        <button
                          className="edit-btn"
                          onClick={() => handleEditStock(stock, item, itemIndex)}
                          style={{ marginRight: '8px' }}
                        >
                          ✏️
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDeleteStock(stock.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="no-data-cell">
                    No other stock history found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )}

    {/* ======================================== */}
    {/* EDIT MODAL */}
    {/* ======================================== */}
    {showEditModal && editingStock && editingItem && (
      <div className="modal-overlay" onClick={handleCancelEdit}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Edit Stock Item</h3>
            <button className="modal-close-btn" onClick={handleCancelEdit}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="edit-form">
              {/* Purchase Order No - Read Only */}
              <div className="form-group full-width">
                <label>Purchase Order No</label>
                <input 
                  type="text" 
                  value={editingStock.purchaseOrderNo || ''} 
                  disabled
                  className="form-input disabled"
                />
              </div>

              {/* Supplier Name - Read Only */}
              <div className="form-group full-width">
                <label>Supplier Name</label>
                <input 
                  type="text" 
                  value={editingStock.supplierName || ''} 
                  disabled
                  className="form-input disabled"
                />
              </div>

              {/* Purchase Date - Read Only */}
              <div className="form-group full-width">
                <label>Purchase Date</label>
                <input 
                  type="text" 
                  value={editingStock.purchaseDate || ''} 
                  disabled
                  className="form-input disabled"
                />
              </div>

              {/* Dynamic fields based on category */}
              {editingStock.category === 'lens' && (
                <>
                  <div className="form-group">
                    <label>SPH</label>
                    <input 
                      type="text" 
                      name="sph"
                      value={editFormData.sph || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>ADD</label>
                    <input 
                      type="text" 
                      name="add"
                      value={editFormData.add || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>CYL</label>
                    <input 
                      type="text" 
                      name="cyl"
                      value={editFormData.cyl || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Axis</label>
                    <input 
                      type="text" 
                      name="axis"
                      value={editFormData.axis || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Model</label>
                    <input 
                      type="text" 
                      name="model"
                      value={editFormData.model || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Progressive</label>
                    <select 
                      name="progressive"
                      value={editFormData.progressive || false} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    >
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </div>
                </>
              )}

              {editingStock.category === 'frame' && (
                <>
                  <div className="form-group">
                    <label>Model No</label>
                    <input 
                      type="text" 
                      name="modelNo"
                      value={editFormData.modelNo || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Brand</label>
                    <input 
                      type="text" 
                      name="brand"
                      value={editFormData.brand || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Frame Type</label>
                    <input 
                      type="text" 
                      name="ftype"
                      value={editFormData.ftype || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Colour</label>
                    <input 
                      type="text" 
                      name="colour"
                      value={editFormData.colour || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Size</label>
                    <input 
                      type="number" 
                      name="size"
                      value={editFormData.size || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Sex</label>
                    <select 
                      name="sex"
                      value={editFormData.sex || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </div>
                </>
              )}

              {editingStock.category === 'sunglass' && (
                <>
                  <div className="form-group">
                    <label>Model No</label>
                    <input 
                      type="text" 
                      name="modelNo"
                      value={editFormData.modelNo || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Brand</label>
                    <input 
                      type="text" 
                      name="brand"
                      value={editFormData.brand || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Colour</label>
                    <input 
                      type="text" 
                      name="colour"
                      value={editFormData.colour || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Size</label>
                    <input 
                      type="number" 
                      name="size"
                      value={editFormData.size || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Sex</label>
                    <select 
                      name="sex"
                      value={editFormData.sex || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </div>
                </>
              )}

              {editingStock.category === 'other' && (
                <>
                  <div className="form-group">
                    <label>Model No</label>
                    <input 
                      type="text" 
                      name="modelNo"
                      value={editFormData.modelNo || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Brand</label>
                    <input 
                      type="text" 
                      name="brand"
                      value={editFormData.brand || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Colour</label>
                    <input 
                      type="text" 
                      name="colour"
                      value={editFormData.colour || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>DM</label>
                    <input 
                      type="text" 
                      name="dm"
                      value={editFormData.dm || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Base Curve</label>
                    <input 
                      type="text" 
                      name="bc"
                      value={editFormData.bc || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Sex</label>
                    <select 
                      name="sex"
                      value={editFormData.sex || ''} 
                      onChange={handleEditInputChange}
                      className="form-input"
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </div>
                </>
              )}

              {/* Common fields for all categories */}
              <div className="form-group">
                <label>Available Quantity</label>
                <input 
                  type="number" 
                  name="qty"
                  value={editFormData.qty || ''} 
                  onChange={handleEditInputChange}
                  className="form-input"
                  min="0"
                  required
                />
              </div>

              <div className="form-group">
                <label>Added Quantity</label>
                <input 
                  type="number" 
                  name="supplyQty"
                  value={editFormData.supplyQty || ''} 
                  onChange={handleEditInputChange}
                  className="form-input"
                  min="0"
                  required
                />
              </div>

              <div className="form-group">
                <label>Selling Price</label>
                <input 
                  type="number" 
                  name="sellingPrice"
                  value={editFormData.sellingPrice || ''} 
                  onChange={handleEditInputChange}
                  className="form-input"
                  min="0"
                  step="0.01"
                  required
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="cancel-btn" onClick={handleCancelEdit}>
              Cancel
            </button>
            <button className="save-btn" onClick={handleSaveEdit}>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}



{/******************************************************* View Supplier *****************************************************************/}

        {selectedOption === "viewSupplier" && (
          <div className="sup-wrap">
      <h2>Supplier Management</h2>

      {/* TOP BAR */}
      <div className="sup-topbar">
        <input
          type="text"
          placeholder="Search supplier..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select onChange={(e) => setSortType(e.target.value)}>
          <option value="newest">Newest</option>
          <option value="az">A - Z</option>
        </select>
      </div>

      {/* TABLE */}
      <table className="sup-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Company</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItems.map((s) => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.phone}</td>
              <td>{s.email}</td>
              <td>{s.company}</td>
              <td>
                <button onClick={() => setEditData(s)}>Edit</button>
                <button onClick={() => handleDelete(s.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div className="sup-pagination">
        {[...Array(totalPages)].map((_, i) => (
          <button key={i} onClick={() => setCurrentPage(i + 1)}>
            {i + 1}
          </button>
        ))}
      </div>

      {/* EDIT MODAL */}
      {editData && (
        <div className="sup-modal">
          <div className="sup-modal-box">
            <h3>Edit Supplier</h3>

            <input
              value={editData.name}
              onChange={(e) =>
                setEditData({ ...editData, name: e.target.value })
              }
            />
            <input
              value={editData.phone}
              onChange={(e) =>
                setEditData({ ...editData, phone: e.target.value })
              }
            />
            <input
              value={editData.email}
              onChange={(e) =>
                setEditData({ ...editData, email: e.target.value })
              }
            />
            <input
              value={editData.company}
              onChange={(e) =>
                setEditData({ ...editData, company: e.target.value })
              }
            />
            <textarea
              value={editData.address}
              onChange={(e) =>
                setEditData({ ...editData, address: e.target.value })
              }
            />

            <div className="sup-modal-actions">
              <button onClick={handleUpdate}>Update</button>
              <button onClick={() => setEditData(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
)}




{/******************************************************* Report Section *****************************************************************/}


        {selectedOption === "reports" && <h2>Reports Section</h2>}


{/******************************************************* Purchasing Order *****************************************************************/}


{selectedOption === "purchasingOrder" && (
  <div className="purchase-container">
    <h2>Purchasing Order</h2>

    {/* HEADER */}
    <div className="po-header">
      <div className="po-field">
        <label>Purchase Order No:</label>
        <input
          value={purchaseOrderNo}
          readOnly
        />
      </div>

      <div className="po-field">
        <label>Supplier Name:</label>
        <select
          value={supplierName}
          onChange={(e) => setSupplierName(e.target.value)}
          style={{ maxHeight: "120px", overflowY: "auto" }} // scroll
        >
          <option value="">-- Select Supplier --</option>

          {suppliers.map((s) => (
            <option key={s.id} value={s.name}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* LENS SECTION */}
    <div className="section-box">
      <h3>Lens Detail</h3>

      <table>
        <thead>
          <tr>
            <th>Item Code</th>
            <th>Sph</th>
            <th>Add</th>
            <th>Cyl</th>
            <th>Axis</th>
            <th>Model</th>
            <th>Is Progressive</th>
            <th>Qty</th>
          </tr>
        </thead>

        <tbody>
          {lensList.map((l, i) => (
            <tr key={i}>
              <td>{l.itemCode}</td>
              <td>{l.sph}</td>
              <td>{l.add}</td>
              <td>{l.cyl}</td>
              <td>{l.axis}</td>
              <td>{l.model}</td>
              <td>{l.progressive ? "true" : "false"}</td>
              <td>{l.qty}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="lens-form">
        <input
          placeholder="Item Code"
          value={lensForm.itemCode}
          onChange={(e) =>
            setLensForm({ ...lensForm, itemCode: e.target.value })
          }
        />
        <input
          placeholder="Sph"
          value={lensForm.sph}
          onChange={(e) => setLensForm({ ...lensForm, sph: e.target.value })}
        />
        <input
          placeholder="Add"
          value={lensForm.add}
          onChange={(e) => setLensForm({ ...lensForm, add: e.target.value })}
        />
        <input
          placeholder="Cyl"
          value={lensForm.cyl}
          onChange={(e) => setLensForm({ ...lensForm, cyl: e.target.value })}
        />
        <input
          placeholder="Axis"
          value={lensForm.axis}
          onChange={(e) => setLensForm({ ...lensForm, axis: e.target.value })}
        />

        <select
          value={lensForm.model}
          onChange={(e) => setLensForm({ ...lensForm, model: e.target.value })}
        >
          <option value="CR39">CR39</option>
          <option value="CR39 S/V">CR39 S/V</option>
        </select>

        <label className="checkbox-row">
          <input
            type="checkbox"
            checked={lensForm.progressive}
            onChange={(e) =>
              setLensForm({ ...lensForm, progressive: e.target.checked })
            }
          />
          Is Progressive
        </label>

        <input
          placeholder="Qty"
          value={lensForm.qty}
          onChange={(e) => setLensForm({ ...lensForm, qty: e.target.value })}
        />

        <button onClick={handleLensAdd}>Add to List</button>
        <button onClick={() => setLensList([])}>Clear All</button>
      </div>
    </div>

    {/* FRAME SECTION */}
    <div className="section-box">
      <h3>Frame Detail</h3>

      <table>
        <thead>
          <tr>
            <th>Item Code</th>
            <th>Model No</th>
            <th>Brand</th>
            <th>Colour</th>
            <th>Sex</th>
            <th>Qty</th>
          </tr>
        </thead>

        <tbody>
          {frameList.map((f, i) => (
            <tr key={i}>
              <td>{f.itemCode}</td>
              <td>{f.modelNo}</td>
              <td>{f.brand}</td>
              <td>{f.colour}</td>
              <td>{f.sex}</td>
              <td>{f.qty}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="frame-form">
        <input
          placeholder="Item Code"
          value={frameForm.itemCode}
          onChange={(e) =>
            setFrameForm({ ...frameForm, itemCode: e.target.value })
          }
        />
        <input
          placeholder="Model No"
          value={frameForm.modelNo}
          onChange={(e) =>
            setFrameForm({ ...frameForm, modelNo: e.target.value })
          }
        />
        <input
          placeholder="Brand"
          value={frameForm.brand}
          onChange={(e) =>
            setFrameForm({ ...frameForm, brand: e.target.value })
          }
        />
        <input
          placeholder="Colour"
          value={frameForm.colour}
          onChange={(e) =>
            setFrameForm({ ...frameForm, colour: e.target.value })
          }
        />
        <input
          placeholder="Sex"
          value={frameForm.sex}
          onChange={(e) =>
            setFrameForm({ ...frameForm, sex: e.target.value })
          }
        />

        <input
          placeholder="Qty"
          value={frameForm.qty}
          onChange={(e) =>
            setFrameForm({ ...frameForm, qty: e.target.value })
          }
        />

        <button onClick={handleFrameAdd}>Add to List</button>
        <button onClick={() => setFrameList([])}>Clear All</button>
      </div>
    </div>

    {/* CREATE BUTTON */}
    <button className="create-btn" onClick={handleCreatePurchaseOrder}>
      Create
    </button>
  </div>
)}



{/************************************** view stock - out *****************************************************/}

{selectedOption === "viewStockOut" && (
  <div className="stock-out-container">
    <div className="stock-out-header">
      <h2>Stock Out History</h2>
      <button 
        className="btn-export" 
        onClick={generateStockOutReportPDF}
        disabled={filteredStockOut.length === 0}
      >
        📄 Export to PDF
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by model, brand, customer, invoice..."
            value={stockOutSearchTerm}
            onChange={(e) => setStockOutSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Product Type:</label>
          <select
            value={stockOutFilterType}
            onChange={(e) => setStockOutFilterType(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Types</option>
            <option value="frame">Frames</option>
            <option value="lens">Lenses</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={stockOutDateRange.start}
            onChange={(e) => setStockOutDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={stockOutDateRange.end}
            onChange={(e) => setStockOutDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetStockOutFilters}>
          🔄 Reset Filters
        </button>
        <button className="btn-refresh" onClick={fetchStockOutHistory}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Items Sold</div>
        <div className="summary-value">{getStockOutSummary().totalItems}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Value</div>
        <div className="summary-value">Rs. {getStockOutSummary().totalValue.toFixed(2)}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Frames Sold</div>
        <div className="summary-value">{getStockOutSummary().frameTotal}</div>
      </div>
      {/* <div className="summary-card">
        <div className="summary-title">Lenses Sold</div>
        <div className="summary-value">{getStockOutSummary().lensTotal}</div>
      </div> */}
    </div>

    {/* Stock Out Table */}
    {isLoadingStockOut ? (
      <div className="loading-spinner">Loading stock-out history...</div>
    ) : (
      <>
        <div className="stock-out-table-container">
          <table className="stock-out-table">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Date</th>
                <th>Time</th>
                <th>Type</th>
                <th>Model</th>
                <th>Brand</th>
                <th>Frame Type</th>
                <th>Colour</th>
                <th>Size</th>
                <th>Customer Name</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total</th>
                <th>Remaining Stock</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredStockOut.length === 0 ? (
                <tr>
                  <td colSpan="13" style={{ textAlign: 'center' }}>
                    No stock-out records found
                  </td>
                </tr>
              ) : (
                filteredStockOut.map((record) => (
                  <tr key={record.id}>
                    <td>
                      <strong>{record.invoiceNumber || '-'}</strong>
                    </td>
                    <td>{record.dateFormatted}</td>
                    <td><small>{record.timeFormatted}</small></td>
                    <td>
                      <span className={`product-type-badge ${record.productType}`}>
                        {record.productType}
                      </span>
                    </td>
                    <td><strong>{record.productModel}</strong></td>
                    <td>{record.brand || '-'}</td>
                    <td>{record.ftype || '-'}</td>
                    <td>{record.colour || '-'}</td>
                    <td>{record.size || '-'}</td>
                    <td>{record.customerName}</td>
                    <td className="text-center">{record.quantity}</td>
                    <td>Rs. {(record.price || 0).toFixed(2)}</td>
                    <td>Rs. {((record.price || 0) * (record.quantity || 0)).toFixed(2)}</td>
                    <td className="text-center">
                      <span className={`stock-badge ${record.remainingStock <= 5 ? 'low-stock' : ''}`}>
                        {record.remainingStock}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn-delete-small"
                        title="Delete record"
                        onClick={() => {
                          const password = prompt("Enter authorization password");
                          if (password !== "Hov@355") {
                            alert("Invalid password");
                            return;
                          }
                          const confirmDelete = window.confirm("Are you sure you want to delete this record?");
                          if (!confirmDelete) return;
                          deleteStockOutRecord(record.id);
                        }}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        <div className="stock-out-footer">
          <div className="records-count">
            Showing {filteredStockOut.length} of {stockOutRecords.length} records
          </div>
        </div>
      </>
    )}
  </div>
)}







{/******************************************************* Add Stock *****************************************************************/}

    {selectedOption === "addStock" && (
 <div className="stock-wrap">
  <h2>Add Stock</h2>

  {/* Select Category */}
  <label>Category:</label>
  <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}>
    <option value="">-- Select --</option>
    <option value="lens">Lens</option>
    <option value="frame">Frame</option>
  </select>

  {/* Purchase Order */}
  <label>Purchase Order No:</label>
  <select value={purchaseOrderNo} onChange={e => setPurchaseOrderNo(e.target.value)}>
    <option value="">-- Select Order --</option>
    {purchaseOrders.map(po => (
      <option key={po.id} value={po.purchaseOrderNo}>{po.purchaseOrderNo}</option>
    ))}
  </select>
  <button onClick={handleLoad}>Load</button>

  <label>Supplier Name:</label>
  <input type="text" value={supplierName} readOnly />

  <label>Purchase Date:</label>
  <input type="date" value={purchaseDate} readOnly />

  {/* Dynamic Table */}
  <div className="stock-items">
    <table>
      <thead>
        <tr>
          {selectedCategory === "lens" ? (
            <>
             
              <th>Sph</th>
              <th>Add</th>
              <th>Cyl</th>
              <th>Axis</th>
              <th>Model</th>
              <th>Is Progressive</th>
              <th>Qty</th>
              <th>Supply Qty</th>
            </>
          ) : selectedCategory === "frame" ? (
            <>
            
              <th>Model No</th>
              <th>Brand</th>
              <th>Colour</th>
              <th>Sex</th>
              <th>Qty</th>
              <th>Supply Qty</th>
            </>
          ) : null}
        </tr>
      </thead>

      <tbody>
        {items.map((item, i) => (
          <tr key={i}>
            {selectedCategory === "lens" ? (
              <>
                
                <td>{item.sph}</td>
                <td>{item.add}</td>
                <td>{item.cyl}</td>
                <td>{item.axis}</td>
                <td>{item.model}</td>
                <td>{item.progressive ? "true" : "false"}</td>
                <td>{item.qty}</td>
                <td>
                  <input
                    type="number"
                    value={item.supplyQty}
                    onChange={e => handleSupplyQtyChange(i, e.target.value)}
                  />
                </td>
              </>
            ) : selectedCategory === "frame" ? (
              <>
               
                <td>{item.modelNo}</td>
                <td>{item.brand}</td>
                <td>{item.colour}</td>
                <td>{item.sex}</td>
                <td>{item.qty}</td>
                <td>
                  <input
                    type="number"
                    value={item.supplyQty}
                    onChange={e => handleSupplyQtyChange(i, e.target.value)}
                  />
                </td>
              </>
            ) : null}
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Actions */}
  <button onClick={handleClear}>Clear</button>
  <button onClick={handleAddItems}>Add Items</button>
</div>
)}




{/***************************************************** quick add stock*************************************************************/}

{selectedOption === "quickAdd" && (
  <div className="quick-add-container">
    <h2>Add Stock</h2>

    {/* Select Category */}
    <label>Category:</label>
    <select value={quickSelectedCategory} onChange={e => setQuickSelectedCategory(e.target.value)}>
      <option value="">-- Select --</option>
      <option value="lens">Lens</option>
      <option value="frame">Frame</option>
      <option value="sunglass">Sunglass</option>
      <option value="other">Other</option>
    </select>

    {/* Supplier Name */}
    <label>Supplier Name *</label>
    <select value={quickSupplierName} onChange={e => setQuickSupplierName(e.target.value)}>
      <option value="">-- Select Supplier --</option>
      {suppliersList.map(supplier => (
        <option key={supplier.id} value={supplier.name}>
          {supplier.name} - {supplier.company}
        </option>
      ))}
    </select>

    {/* Purchase Date */}
    <label>Stock-In Date *</label>
    <input 
      type="date" 
      value={quickPurchaseDate} 
      onChange={e => setQuickPurchaseDate(e.target.value)}
    />

    {/* Dynamic Table for Items */}
    <div className="stock-items">
      <table>
        <thead>
          <tr>
            {quickSelectedCategory === "lens" ? (
              <>
                <th>Lens Description</th>
                <th>Sph</th>
                <th>Cyl</th>
                <th>Axis</th>
                <th>Add</th>
                {/* <th>Is Progressive</th> */}
                {/* <th>Buying Price</th> */}
                <th>Selling Price</th>
                <th>Qty</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>
            ) : quickSelectedCategory === "frame" ? (
              <>
       
                <th>Model No</th>
                <th>Brand</th>
                <th>Type</th>
                <th>Colour</th>
                <th>Size</th>
                <th>Sex</th>
                <th>Qty</th>
                {/* <th>Buying Price</th> */}
                <th>Selling Price</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>

                          ) : quickSelectedCategory === "sunglass" ? (
              <>
       
                <th>Model No</th>
                <th>Brand</th>
                <th>Colour</th>
                <th>Size</th>
                <th>Sex</th>
                <th>Qty</th>
                {/* <th>Buying Price</th> */}
                <th>Selling Price</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>


            ) : quickSelectedCategory === "other" ? (
              <>
       
                <th>Model No</th>
                <th>Brand</th>
                <th>Colour</th>
                <th>DM</th>
                <th>Base Curve</th>
                <th>Sex</th>
                <th>Qty</th>
                {/* <th>Buying Price</th> */}
                <th>Selling Price</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>


            ) : null}
          </tr>
        </thead>
        <tbody>
          {quickItems.map((item, i) => (
            <tr key={i}>
              {quickSelectedCategory === "lens" ? (
                <>
                  <td>
                    <input 
                      type="text" 
                      value={item.model} 
                      onChange={e => handleQuickItemChange(i, 'model', e.target.value)}
                      placeholder="Lens Description"
                    />
                  </td>

                  <td>
                    <input 
                      type="text" 
                      value={item.sph} 
                      onChange={e => handleQuickItemChange(i, 'sph', e.target.value)}
                      placeholder="Sph"
                    />
                  </td>

                  <td>
                    <input 
                      type="text" 
                      value={item.cyl} 
                      onChange={e => handleQuickItemChange(i, 'cyl', e.target.value)}
                      placeholder="Cyl"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.axis} 
                      onChange={e => handleQuickItemChange(i, 'axis', e.target.value)}
                      placeholder="Axis"
                    />
                  </td>

                  <td>
                    <input 
                      type="text" 
                      value={item.add} 
                      onChange={e => handleQuickItemChange(i, 'add', e.target.value)}
                      placeholder="Add"
                    />
                  </td>



                  {/* <td>
                    <input 
                      type="number" 
                      value={item.buyingPrice} 
                      onChange={e => handleQuickItemChange(i, 'buyingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Buying Price"
                    />
                  </td> */}


                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value))}
                      placeholder="Selling Price"
                    />
                  </td>


                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value))}
                      placeholder="Qty"
                    />
                  </td>
                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value))}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>
              ) : quickSelectedCategory === "frame" ? (
                <>

                  <td>
                    <input 
                      type="text" 
                      value={item.modelNo} 
                      onChange={e => handleQuickItemChange(i, 'modelNo', e.target.value)}
                      placeholder="Model No"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.brand} 
                      onChange={e => handleQuickItemChange(i, 'brand', e.target.value)}
                      placeholder="Brand"
                    />
                  </td>


     <td>
  <select
    value={item.ftype}
    onChange={(e) => handleQuickItemChange(i, 'ftype', e.target.value)}
  >
    <option value="">Select Type</option>
    <option value="Plastic">Plastic</option>
    <option value="Metal">Metal</option>
    <option value="Rimless">Rimless</option>
  </select>
</td>

                  <td>
                    <input 
                      type="text" 
                      value={item.colour} 
                      onChange={e => handleQuickItemChange(i, 'colour', e.target.value)}
                      placeholder="Colour"
                    />
                  </td>



                  <td>
                    <input 
                      type="text" 
                      value={item.size} 
                      onChange={e => handleQuickItemChange(i, 'size', e.target.value)}
                      placeholder="Size"
                    />
                  </td>

   

                  <td>
                    <select 
                      value={item.sex} 
                      onChange={e => handleQuickItemChange(i, 'sex', e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </td>
                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value))}
                      placeholder="Qty"
                    />
                  </td>


                  {/* <td>
                    <input 
                      type="number" 
                      value={item.buyingPrice} 
                      onChange={e => handleQuickItemChange(i, 'buyingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Buying Price"
                    />
                  </td> */}


                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value))}
                      placeholder="Selling Price"
                    />
                  </td>



                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value))}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>




   ) : quickSelectedCategory === "sunglass" ? (
                <>

                  <td>
                    <input 
                      type="text" 
                      value={item.modelNo} 
                      onChange={e => handleQuickItemChange(i, 'modelNo', e.target.value)}
                      placeholder="Model No"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.brand} 
                      onChange={e => handleQuickItemChange(i, 'brand', e.target.value)}
                      placeholder="Brand"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.colour} 
                      onChange={e => handleQuickItemChange(i, 'colour', e.target.value)}
                      placeholder="Colour"
                    />
                  </td>


                                    <td>
                    <input 
                      type="text" 
                      value={item.size} 
                      onChange={e => handleQuickItemChange(i, 'size', e.target.value)}
                      placeholder="Size"
                    />
                  </td>


                  <td>
                    <select 
                      value={item.sex} 
                      onChange={e => handleQuickItemChange(i, 'sex', e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </td>
                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value))}
                      placeholder="Qty"
                    />
                  </td>


                  {/* <td>
                    <input 
                      type="number" 
                      value={item.buyingPrice} 
                      onChange={e => handleQuickItemChange(i, 'buyingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Buying Price"
                    />
                  </td> */}


                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value))}
                      placeholder="Selling Price"
                    />
                  </td>



                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value))}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>




   ) : quickSelectedCategory === "other" ? (
                <>

                  <td>
                    <input 
                      type="text" 
                      value={item.modelNo} 
                      onChange={e => handleQuickItemChange(i, 'modelNo', e.target.value)}
                      placeholder="Model No"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.brand} 
                      onChange={e => handleQuickItemChange(i, 'brand', e.target.value)}
                      placeholder="Brand"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.colour} 
                      onChange={e => handleQuickItemChange(i, 'colour', e.target.value)}
                      placeholder="Colour"
                    />
                  </td>


                  <td>
                    <input 
                      type="number" 
                      value={item.dm} 
                      onChange={e => handleQuickItemChange(i, 'dm', e.target.value)}
                      placeholder="dm"
                    />
                  </td>


                <td>
                    <input 
                      type="number" 
                      value={item.bc} 
                      onChange={e => handleQuickItemChange(i, 'bc', e.target.value)}
                      placeholder="Bace Curve"
                    />
                  </td>


                  <td>
                    <select 
                      value={item.sex} 
                      onChange={e => handleQuickItemChange(i, 'sex', e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </td>
                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value))}
                      placeholder="Qty"
                    />
                  </td>


                  {/* <td>
                    <input 
                      type="number" 
                      value={item.buyingPrice} 
                      onChange={e => handleQuickItemChange(i, 'buyingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Buying Price"
                    />
                  </td> */}


                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value))}
                      placeholder="Selling Price"
                    />
                  </td>



                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value))}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>





              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Add Row Button */}
    <button className="btn-add-row" onClick={handleAddQuickItemRow}>
      + Add Item
    </button>

    {/* Actions */}
    <div className="quick-actions">
      <button onClick={handleClearQuickForm}>Clear</button>

<button
  onClick={handleQuickAddStock}
  disabled={isAddingStock}
  style={{
    opacity: isAddingStock ? 0.6 : 1,
    cursor: isAddingStock ? "not-allowed" : "pointer"
  }}
>
  {isAddingStock ? "Adding..." : "Add to Stock"}
</button>

    </div>
  </div>
)}


{/******************************************************* Search *****************************************************************/}


        {selectedOption === "about" && <h2>About</h2>}





{/******************************************************* Sales report *****************************************************************/}




{selectedOption === "salesReport" && (
        <div className="sales-report-container">
          <h2>Sales Overview</h2>

          <div style={{ marginBottom: "15px" }}>
            <button onClick={downloadExcel} className="btn-excel">📊 Download Excel</button>
            <button onClick={downloadPDF} style={{ marginLeft: "10px" }} className="btn-pdf">📄 Download PDF</button>
            <button onClick={resetSalesFilters} style={{ marginLeft: "10px" }} className="btn-reset">🔄 Reset Filters</button>
          </div>

          {/* FILTER SECTION */}
          <div style={{ marginBottom: "20px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
            <div style={{ marginBottom: "10px" }}>
              <label style={{ marginRight: "15px" }}>
                <input
                  type="radio"
                  value="month"
                  checked={dateFilterType === "month"}
                  onChange={(e) => setDateFilterType(e.target.value)}
                /> Filter by Month/Year
              </label>
              <label>
                <input
                  type="radio"
                  value="range"
                  checked={dateFilterType === "range"}
                  onChange={(e) => setDateFilterType(e.target.value)}
                /> Filter by Date Range
              </label>
            </div>

            {dateFilterType === "month" ? (
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                  <option value="all">All Months</option>
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>

                <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                  <option value="all">All Years</option>
                  {getAvailableYears().map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>
            ) : (
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
                <div>
                  <label>From Date: </label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    style={{ padding: "5px", marginLeft: "5px" }}
                  />
                </div>
                <div>
                  <label>To Date: </label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{ padding: "5px", marginLeft: "5px" }}
                  />
                </div>
              </div>
            )}

            {/* Payment Method Filter */}
            <div style={{ marginTop: "15px" }}>
              <label style={{ marginRight: "10px" }}>Payment Method:</label>
              <select value={selectedPaymentMethod} onChange={(e) => setSelectedPaymentMethod(e.target.value)}>
                <option value="all">All Methods</option>
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                  <option value="GiftCard">Gift Card</option>
                <option value="Bank Transfer">Bank Transfer</option>
                <option value="Deposit">Deposit</option>
              </select>
            </div>

            {/* Sales Person Filter */}
            <div style={{ marginTop: "15px" }}>
              <label style={{ marginRight: "10px" }}>Sales Person:</label>
              <select value={selectedSalesPerson} onChange={(e) => setSelectedSalesPerson(e.target.value)}>
                <option value="all">All Sales Persons</option>
    <option value="Team A">
      Team A
    </option>


    <option value="Team B">
      Team B
    </option>


    <option value="Team C">
      Team C
    </option>


    <option value="Team D">
      Team D
    </option>

<option value="Team E">
      Team E
    </option>


    <option value="Team F">
      Team F
    </option>


    <option value="Team G">
      Team G
    </option>


    <option value="Team H">
      Team H
    </option>


    <option value="Team I">
      Team I
    </option>


    <option value="Team J">
      Team J
    </option>


    <option value="Team K">
      Team K
    </option>


    <option value="Team L">
      Team L
    </option>

    <option value="Team M">
      Team M
    </option>


    <option value="Team N">
      Team N
    </option>


              </select>
            </div>

            {/* Eye Camp Filter */}
            <div style={{ marginTop: "15px" }}>
              <label style={{ marginRight: "10px" }}>Eye Camp</label>
              <select value={selectedEyeCamp} onChange={(e) => setSelectedEyeCamp(e.target.value)}>
                <option value="all">All Eye Camps</option>
                {eyeCampsList.map(camp => (
                  <option key={camp.id} value={camp.name}>
                    {camp.name}
                  </option>
                ))}
              </select>
            </div>
          </div>










          {/* SUMMARY CARDS */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px", marginBottom: "20px" }}>
            <div style={{ padding: "15px", backgroundColor: "#e3f2fd", borderRadius: "8px" }}>
              <h4>Total Sales</h4>
              <h3>Rs. {salesSummary.totalSales.toLocaleString()}</h3>
            </div>

            <div style={{ padding: "15px", backgroundColor: "#e8f5e9", borderRadius: "8px" }}>
              <h4>Total Received</h4>
              <h3>Rs. {salesSummary.totalReceived.toLocaleString()}</h3>
              
              <div style={{ 
                marginTop: "10px", 
                paddingTop: "10px", 
                borderTop: "1px solid #c8e6c9",
                fontSize: "12px",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "4px 15px"
              }}>
                {(() => {
                  const breakdown = getPaymentMethodBreakdown(filteredReport);
                  return (
                    <>
                      <div><span style={{ fontWeight: "bold" }}>Cash:</span> Rs. {breakdown.cash.toLocaleString()}</div>
                      <div><span style={{ fontWeight: "bold" }}>Card:</span> Rs. {breakdown.card.toLocaleString()}</div>
                      <div><span style={{ fontWeight: "bold" }}>Gift Card:</span> Rs. {breakdown.GiftCard.toLocaleString()}</div>
                      <div><span style={{ fontWeight: "bold" }}>Bank Transfer:</span> Rs. {breakdown.bankTransfer.toLocaleString()}</div>
                      <div><span style={{ fontWeight: "bold" }}>Deposit:</span> Rs. {breakdown.deposit.toLocaleString()}</div>
                    </>
                  );
                })()}
              </div>
            </div>

            <div style={{ padding: "15px", backgroundColor: "#fff3e0", borderRadius: "8px" }}>
              <h4>Pending Amount</h4>
              <h3>Rs. {salesSummary.totalPending.toLocaleString()}</h3>
            </div>
          </div>




          {/* TABLE */}
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table border="1" cellPadding="10" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead style={{ backgroundColor: "#0f172a", color: "white" }}>
                  <tr>
                    <th>Invoice</th>
                    <th>Customer</th>
                    <th>Sales Person</th>
                    <th>Eye Camp</th>
                    <th>Payment Method</th>
                    <th>Payment Type</th>
                    <th>Date</th>
                    <th>Total Amount (Rs.)</th>
                    <th>Received (Rs.)</th>
                    <th>Balance Paid (Rs.)</th>
                    <th>Advance (Rs.)</th>
                    <th>Remaining (Rs.)</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredReport.length === 0 ? (
                    <tr>
                      <td colSpan="12" style={{ textAlign: "center" }}>No data available</td>
                    </tr>
                  ) : (
                    filteredReport.map((r, i) => (
                      <tr key={i} style={r.received === 0 && r.paymentType === "Invoice Created (No Payment)" ? { backgroundColor: '#fff3e0' } : {}}>
                        <td>{r.invoiceNumber}</td>
                        <td>{r.customer}</td>
                        <td>{r.salePerson || "-"}</td>
                        <td>{r.eyeCamp || "-"}</td>
                        <td>{r.paymentMethod}</td>
                        <td>{r.paymentType}</td>
                        <td>{r.date ? r.date.toLocaleDateString() : "-"}</td>
                        <td style={{ textAlign: "right" }}>{r.totalAmount.toLocaleString()}</td>
                        <td style={{ textAlign: "right", fontWeight: r.received === 0 ? 'bold' : 'normal', color: r.received === 0 ? '#e65100' : 'inherit' }}>
                          {r.advancePaid.toLocaleString()}
                        </td>
                        <td style={{ textAlign: "right" }}>{r.laterPayments.toLocaleString()}</td>
<td style={{ textAlign: "right" }}>
  {(r.totalAmount - (r.laterPayments + r.remaining)).toLocaleString()}
</td>                        <td style={{ textAlign: "right" }}>{r.remaining.toLocaleString()}</td> 
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}



{/******************************************************* Log Out *****************************************************************/}


        {selectedOption === "logout" && <h2>Logging Out…</h2>}
      </div>
    </>
  );
}

export default SuperAdminPanel;